
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire948c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire948c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5aRSq", function(module, exports) {
"use strict";

module.exports = (parcelRequire("hi5z5"));

});
parcelRegister("hi5z5", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $c9686f2ae6fd93b8$export$ffb0004e005737fa; }, function (v) { return $c9686f2ae6fd93b8$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $c9686f2ae6fd93b8$export$34b9dba7ce09269b; }, function (v) { return $c9686f2ae6fd93b8$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $c9686f2ae6fd93b8$export$25062201e9e25d76; }, function (v) { return $c9686f2ae6fd93b8$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9686f2ae6fd93b8$export$ffb0004e005737fa;
var $c9686f2ae6fd93b8$export$34b9dba7ce09269b;
var $c9686f2ae6fd93b8$export$25062201e9e25d76;
"use strict";

var $4Iuzv = parcelRequire("4Iuzv");
var $c9686f2ae6fd93b8$var$k = Symbol.for("react.element"), $c9686f2ae6fd93b8$var$l = Symbol.for("react.fragment"), $c9686f2ae6fd93b8$var$m = Object.prototype.hasOwnProperty, $c9686f2ae6fd93b8$var$n = $4Iuzv.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $c9686f2ae6fd93b8$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c9686f2ae6fd93b8$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$c9686f2ae6fd93b8$var$m.call(a, b) && !$c9686f2ae6fd93b8$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $c9686f2ae6fd93b8$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $c9686f2ae6fd93b8$var$n.current
    };
}
$c9686f2ae6fd93b8$export$ffb0004e005737fa = $c9686f2ae6fd93b8$var$l;
$c9686f2ae6fd93b8$export$34b9dba7ce09269b = $c9686f2ae6fd93b8$var$q;
$c9686f2ae6fd93b8$export$25062201e9e25d76 = $c9686f2ae6fd93b8$var$q;

});
parcelRegister("4Iuzv", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ip19S"));

});
parcelRegister("ip19S", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $d65b75cac4e2d5f6$export$dca3b0875bd9a954; }, function (v) { return $d65b75cac4e2d5f6$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $d65b75cac4e2d5f6$export$16fa2f45be04daa8; }, function (v) { return $d65b75cac4e2d5f6$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $d65b75cac4e2d5f6$export$ffb0004e005737fa; }, function (v) { return $d65b75cac4e2d5f6$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $d65b75cac4e2d5f6$export$e2c29f18771995cb; }, function (v) { return $d65b75cac4e2d5f6$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $d65b75cac4e2d5f6$export$221d75b3f55bb0bd; }, function (v) { return $d65b75cac4e2d5f6$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $d65b75cac4e2d5f6$export$5f8d39834fd61797; }, function (v) { return $d65b75cac4e2d5f6$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $d65b75cac4e2d5f6$export$74bf444e3cd11ea5; }, function (v) { return $d65b75cac4e2d5f6$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $d65b75cac4e2d5f6$export$ae55be85d98224ed; }, function (v) { return $d65b75cac4e2d5f6$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $d65b75cac4e2d5f6$export$3ba232387fd5d6dd; }, function (v) { return $d65b75cac4e2d5f6$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $d65b75cac4e2d5f6$export$e530037191fcd5d7; }, function (v) { return $d65b75cac4e2d5f6$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $d65b75cac4e2d5f6$export$fd42f52fd3ae1109; }, function (v) { return $d65b75cac4e2d5f6$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $d65b75cac4e2d5f6$export$c8a8987d4410bf2d; }, function (v) { return $d65b75cac4e2d5f6$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $d65b75cac4e2d5f6$export$d38cd72104c1f0e9; }, function (v) { return $d65b75cac4e2d5f6$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $d65b75cac4e2d5f6$export$7d1e3a5e95ceca43; }, function (v) { return $d65b75cac4e2d5f6$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $d65b75cac4e2d5f6$export$257a8862b851cb5b; }, function (v) { return $d65b75cac4e2d5f6$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $d65b75cac4e2d5f6$export$a8257692ac88316c; }, function (v) { return $d65b75cac4e2d5f6$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $d65b75cac4e2d5f6$export$488013bae63b21da; }, function (v) { return $d65b75cac4e2d5f6$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $d65b75cac4e2d5f6$export$7c73462e0d25e514; }, function (v) { return $d65b75cac4e2d5f6$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $d65b75cac4e2d5f6$export$7568632d0d33d16d; }, function (v) { return $d65b75cac4e2d5f6$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $d65b75cac4e2d5f6$export$88948ce120ea2619; }, function (v) { return $d65b75cac4e2d5f6$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $d65b75cac4e2d5f6$export$35808ee640e87ca7; }, function (v) { return $d65b75cac4e2d5f6$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $d65b75cac4e2d5f6$export$fae74005e78b1a27; }, function (v) { return $d65b75cac4e2d5f6$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $d65b75cac4e2d5f6$export$dc8fbce3eb94dc1e; }, function (v) { return $d65b75cac4e2d5f6$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $d65b75cac4e2d5f6$export$6a7bc4e911dc01cf; }, function (v) { return $d65b75cac4e2d5f6$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $d65b75cac4e2d5f6$export$6d9c69b0de29b591; }, function (v) { return $d65b75cac4e2d5f6$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $d65b75cac4e2d5f6$export$f680877a34711e37; }, function (v) { return $d65b75cac4e2d5f6$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $d65b75cac4e2d5f6$export$d5a552a76deda3c2; }, function (v) { return $d65b75cac4e2d5f6$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $d65b75cac4e2d5f6$export$aaabe4eda9ed9969; }, function (v) { return $d65b75cac4e2d5f6$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $d65b75cac4e2d5f6$export$e5c5a5f917a5871c; }, function (v) { return $d65b75cac4e2d5f6$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $d65b75cac4e2d5f6$export$1538c33de8887b59; }, function (v) { return $d65b75cac4e2d5f6$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $d65b75cac4e2d5f6$export$13e3392192263954; }, function (v) { return $d65b75cac4e2d5f6$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $d65b75cac4e2d5f6$export$b8f5890fc79d6aca; }, function (v) { return $d65b75cac4e2d5f6$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $d65b75cac4e2d5f6$export$60241385465d0a34; }, function (v) { return $d65b75cac4e2d5f6$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $d65b75cac4e2d5f6$export$306c0aa65ff9ec16; }, function (v) { return $d65b75cac4e2d5f6$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $d65b75cac4e2d5f6$export$7b286972b8d8ccbf; }, function (v) { return $d65b75cac4e2d5f6$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $d65b75cac4e2d5f6$export$83d89fbfd8236492; }, function (v) { return $d65b75cac4e2d5f6$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d65b75cac4e2d5f6$export$dca3b0875bd9a954;
var $d65b75cac4e2d5f6$export$16fa2f45be04daa8;
var $d65b75cac4e2d5f6$export$ffb0004e005737fa;
var $d65b75cac4e2d5f6$export$e2c29f18771995cb;
var $d65b75cac4e2d5f6$export$221d75b3f55bb0bd;
var $d65b75cac4e2d5f6$export$5f8d39834fd61797;
var $d65b75cac4e2d5f6$export$74bf444e3cd11ea5;
var $d65b75cac4e2d5f6$export$ae55be85d98224ed;
var $d65b75cac4e2d5f6$export$3ba232387fd5d6dd;
var $d65b75cac4e2d5f6$export$e530037191fcd5d7;
var $d65b75cac4e2d5f6$export$fd42f52fd3ae1109;
var $d65b75cac4e2d5f6$export$c8a8987d4410bf2d;
var $d65b75cac4e2d5f6$export$d38cd72104c1f0e9;
var $d65b75cac4e2d5f6$export$7d1e3a5e95ceca43;
var $d65b75cac4e2d5f6$export$257a8862b851cb5b;
var $d65b75cac4e2d5f6$export$a8257692ac88316c;
var $d65b75cac4e2d5f6$export$488013bae63b21da;
var $d65b75cac4e2d5f6$export$7c73462e0d25e514;
var $d65b75cac4e2d5f6$export$7568632d0d33d16d;
var $d65b75cac4e2d5f6$export$88948ce120ea2619;
var $d65b75cac4e2d5f6$export$35808ee640e87ca7;
var $d65b75cac4e2d5f6$export$fae74005e78b1a27;
var $d65b75cac4e2d5f6$export$dc8fbce3eb94dc1e;
var $d65b75cac4e2d5f6$export$6a7bc4e911dc01cf;
var $d65b75cac4e2d5f6$export$6d9c69b0de29b591;
var $d65b75cac4e2d5f6$export$f680877a34711e37;
var $d65b75cac4e2d5f6$export$d5a552a76deda3c2;
var $d65b75cac4e2d5f6$export$aaabe4eda9ed9969;
var $d65b75cac4e2d5f6$export$e5c5a5f917a5871c;
var $d65b75cac4e2d5f6$export$1538c33de8887b59;
var $d65b75cac4e2d5f6$export$13e3392192263954;
var $d65b75cac4e2d5f6$export$b8f5890fc79d6aca;
var $d65b75cac4e2d5f6$export$60241385465d0a34;
var $d65b75cac4e2d5f6$export$306c0aa65ff9ec16;
var $d65b75cac4e2d5f6$export$7b286972b8d8ccbf;
var $d65b75cac4e2d5f6$export$83d89fbfd8236492;
"use strict";
var $d65b75cac4e2d5f6$var$l = Symbol.for("react.element"), $d65b75cac4e2d5f6$var$n = Symbol.for("react.portal"), $d65b75cac4e2d5f6$var$p = Symbol.for("react.fragment"), $d65b75cac4e2d5f6$var$q = Symbol.for("react.strict_mode"), $d65b75cac4e2d5f6$var$r = Symbol.for("react.profiler"), $d65b75cac4e2d5f6$var$t = Symbol.for("react.provider"), $d65b75cac4e2d5f6$var$u = Symbol.for("react.context"), $d65b75cac4e2d5f6$var$v = Symbol.for("react.forward_ref"), $d65b75cac4e2d5f6$var$w = Symbol.for("react.suspense"), $d65b75cac4e2d5f6$var$x = Symbol.for("react.memo"), $d65b75cac4e2d5f6$var$y = Symbol.for("react.lazy"), $d65b75cac4e2d5f6$var$z = Symbol.iterator;
function $d65b75cac4e2d5f6$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $d65b75cac4e2d5f6$var$z && a[$d65b75cac4e2d5f6$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $d65b75cac4e2d5f6$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $d65b75cac4e2d5f6$var$C = Object.assign, $d65b75cac4e2d5f6$var$D = {};
function $d65b75cac4e2d5f6$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $d65b75cac4e2d5f6$var$D;
    this.updater = e || $d65b75cac4e2d5f6$var$B;
}
$d65b75cac4e2d5f6$var$E.prototype.isReactComponent = {};
$d65b75cac4e2d5f6$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$d65b75cac4e2d5f6$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $d65b75cac4e2d5f6$var$F() {}
$d65b75cac4e2d5f6$var$F.prototype = $d65b75cac4e2d5f6$var$E.prototype;
function $d65b75cac4e2d5f6$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $d65b75cac4e2d5f6$var$D;
    this.updater = e || $d65b75cac4e2d5f6$var$B;
}
var $d65b75cac4e2d5f6$var$H = $d65b75cac4e2d5f6$var$G.prototype = new $d65b75cac4e2d5f6$var$F;
$d65b75cac4e2d5f6$var$H.constructor = $d65b75cac4e2d5f6$var$G;
$d65b75cac4e2d5f6$var$C($d65b75cac4e2d5f6$var$H, $d65b75cac4e2d5f6$var$E.prototype);
$d65b75cac4e2d5f6$var$H.isPureReactComponent = !0;
var $d65b75cac4e2d5f6$var$I = Array.isArray, $d65b75cac4e2d5f6$var$J = Object.prototype.hasOwnProperty, $d65b75cac4e2d5f6$var$K = {
    current: null
}, $d65b75cac4e2d5f6$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $d65b75cac4e2d5f6$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$d65b75cac4e2d5f6$var$J.call(b, d) && !$d65b75cac4e2d5f6$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $d65b75cac4e2d5f6$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $d65b75cac4e2d5f6$var$K.current
    };
}
function $d65b75cac4e2d5f6$var$N(a, b) {
    return {
        $$typeof: $d65b75cac4e2d5f6$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $d65b75cac4e2d5f6$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $d65b75cac4e2d5f6$var$l;
}
function $d65b75cac4e2d5f6$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $d65b75cac4e2d5f6$var$P = /\/+/g;
function $d65b75cac4e2d5f6$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $d65b75cac4e2d5f6$var$escape("" + a.key) : b.toString(36);
}
function $d65b75cac4e2d5f6$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $d65b75cac4e2d5f6$var$l:
                case $d65b75cac4e2d5f6$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $d65b75cac4e2d5f6$var$Q(h, 0) : d, $d65b75cac4e2d5f6$var$I(c) ? (e = "", null != a && (e = a.replace($d65b75cac4e2d5f6$var$P, "$&/") + "/"), $d65b75cac4e2d5f6$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($d65b75cac4e2d5f6$var$O(c) && (c = $d65b75cac4e2d5f6$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($d65b75cac4e2d5f6$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($d65b75cac4e2d5f6$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $d65b75cac4e2d5f6$var$Q(k, g);
        h += $d65b75cac4e2d5f6$var$R(k, b, e, f, c);
    }
    else if (f = $d65b75cac4e2d5f6$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $d65b75cac4e2d5f6$var$Q(k, g++), h += $d65b75cac4e2d5f6$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $d65b75cac4e2d5f6$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $d65b75cac4e2d5f6$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $d65b75cac4e2d5f6$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $d65b75cac4e2d5f6$var$U = {
    current: null
}, $d65b75cac4e2d5f6$var$V = {
    transition: null
}, $d65b75cac4e2d5f6$var$W = {
    ReactCurrentDispatcher: $d65b75cac4e2d5f6$var$U,
    ReactCurrentBatchConfig: $d65b75cac4e2d5f6$var$V,
    ReactCurrentOwner: $d65b75cac4e2d5f6$var$K
};
function $d65b75cac4e2d5f6$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$d65b75cac4e2d5f6$export$dca3b0875bd9a954 = {
    map: $d65b75cac4e2d5f6$var$S,
    forEach: function(a, b, e) {
        $d65b75cac4e2d5f6$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $d65b75cac4e2d5f6$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $d65b75cac4e2d5f6$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$d65b75cac4e2d5f6$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$d65b75cac4e2d5f6$export$16fa2f45be04daa8 = $d65b75cac4e2d5f6$var$E;
$d65b75cac4e2d5f6$export$ffb0004e005737fa = $d65b75cac4e2d5f6$var$p;
$d65b75cac4e2d5f6$export$e2c29f18771995cb = $d65b75cac4e2d5f6$var$r;
$d65b75cac4e2d5f6$export$221d75b3f55bb0bd = $d65b75cac4e2d5f6$var$G;
$d65b75cac4e2d5f6$export$5f8d39834fd61797 = $d65b75cac4e2d5f6$var$q;
$d65b75cac4e2d5f6$export$74bf444e3cd11ea5 = $d65b75cac4e2d5f6$var$w;
$d65b75cac4e2d5f6$export$ae55be85d98224ed = $d65b75cac4e2d5f6$var$W;
$d65b75cac4e2d5f6$export$3ba232387fd5d6dd = $d65b75cac4e2d5f6$var$X;
$d65b75cac4e2d5f6$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $d65b75cac4e2d5f6$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $d65b75cac4e2d5f6$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$d65b75cac4e2d5f6$var$J.call(b, f) && !$d65b75cac4e2d5f6$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $d65b75cac4e2d5f6$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$d65b75cac4e2d5f6$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $d65b75cac4e2d5f6$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $d65b75cac4e2d5f6$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$d65b75cac4e2d5f6$export$c8a8987d4410bf2d = $d65b75cac4e2d5f6$var$M;
$d65b75cac4e2d5f6$export$d38cd72104c1f0e9 = function(a) {
    var b = $d65b75cac4e2d5f6$var$M.bind(null, a);
    b.type = a;
    return b;
};
$d65b75cac4e2d5f6$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$d65b75cac4e2d5f6$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $d65b75cac4e2d5f6$var$v,
        render: a
    };
};
$d65b75cac4e2d5f6$export$a8257692ac88316c = $d65b75cac4e2d5f6$var$O;
$d65b75cac4e2d5f6$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $d65b75cac4e2d5f6$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $d65b75cac4e2d5f6$var$T
    };
};
$d65b75cac4e2d5f6$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $d65b75cac4e2d5f6$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$d65b75cac4e2d5f6$export$7568632d0d33d16d = function(a) {
    var b = $d65b75cac4e2d5f6$var$V.transition;
    $d65b75cac4e2d5f6$var$V.transition = {};
    try {
        a();
    } finally{
        $d65b75cac4e2d5f6$var$V.transition = b;
    }
};
$d65b75cac4e2d5f6$export$88948ce120ea2619 = $d65b75cac4e2d5f6$var$X;
$d65b75cac4e2d5f6$export$35808ee640e87ca7 = function(a, b) {
    return $d65b75cac4e2d5f6$var$U.current.useCallback(a, b);
};
$d65b75cac4e2d5f6$export$fae74005e78b1a27 = function(a) {
    return $d65b75cac4e2d5f6$var$U.current.useContext(a);
};
$d65b75cac4e2d5f6$export$dc8fbce3eb94dc1e = function() {};
$d65b75cac4e2d5f6$export$6a7bc4e911dc01cf = function(a) {
    return $d65b75cac4e2d5f6$var$U.current.useDeferredValue(a);
};
$d65b75cac4e2d5f6$export$6d9c69b0de29b591 = function(a, b) {
    return $d65b75cac4e2d5f6$var$U.current.useEffect(a, b);
};
$d65b75cac4e2d5f6$export$f680877a34711e37 = function() {
    return $d65b75cac4e2d5f6$var$U.current.useId();
};
$d65b75cac4e2d5f6$export$d5a552a76deda3c2 = function(a, b, e) {
    return $d65b75cac4e2d5f6$var$U.current.useImperativeHandle(a, b, e);
};
$d65b75cac4e2d5f6$export$aaabe4eda9ed9969 = function(a, b) {
    return $d65b75cac4e2d5f6$var$U.current.useInsertionEffect(a, b);
};
$d65b75cac4e2d5f6$export$e5c5a5f917a5871c = function(a, b) {
    return $d65b75cac4e2d5f6$var$U.current.useLayoutEffect(a, b);
};
$d65b75cac4e2d5f6$export$1538c33de8887b59 = function(a, b) {
    return $d65b75cac4e2d5f6$var$U.current.useMemo(a, b);
};
$d65b75cac4e2d5f6$export$13e3392192263954 = function(a, b, e) {
    return $d65b75cac4e2d5f6$var$U.current.useReducer(a, b, e);
};
$d65b75cac4e2d5f6$export$b8f5890fc79d6aca = function(a) {
    return $d65b75cac4e2d5f6$var$U.current.useRef(a);
};
$d65b75cac4e2d5f6$export$60241385465d0a34 = function(a) {
    return $d65b75cac4e2d5f6$var$U.current.useState(a);
};
$d65b75cac4e2d5f6$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $d65b75cac4e2d5f6$var$U.current.useSyncExternalStore(a, b, e);
};
$d65b75cac4e2d5f6$export$7b286972b8d8ccbf = function() {
    return $d65b75cac4e2d5f6$var$U.current.useTransition();
};
$d65b75cac4e2d5f6$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("68oCn", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $477696120c5741dc$export$ae55be85d98224ed; }, function (v) { return $477696120c5741dc$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $477696120c5741dc$export$d39a5bbd09211389; }, function (v) { return $477696120c5741dc$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $477696120c5741dc$export$882461b6382ed46c; }, function (v) { return $477696120c5741dc$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $477696120c5741dc$export$466bfc07425424d5; }, function (v) { return $477696120c5741dc$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $477696120c5741dc$export$cd75ccfd720a3cd4; }, function (v) { return $477696120c5741dc$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $477696120c5741dc$export$fa8d919ba61d84db; }, function (v) { return $477696120c5741dc$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $477696120c5741dc$export$757ceba2d55c277e; }, function (v) { return $477696120c5741dc$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $477696120c5741dc$export$b3890eb0ae9dca99; }, function (v) { return $477696120c5741dc$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $477696120c5741dc$export$502457920280e6be; }, function (v) { return $477696120c5741dc$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $477696120c5741dc$export$c78a37762a8d58e1; }, function (v) { return $477696120c5741dc$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $477696120c5741dc$export$dc54d992c10e8a18; }, function (v) { return $477696120c5741dc$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $477696120c5741dc$export$83d89fbfd8236492; }, function (v) { return $477696120c5741dc$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $477696120c5741dc$export$ae55be85d98224ed;
var $477696120c5741dc$export$d39a5bbd09211389;
var $477696120c5741dc$export$882461b6382ed46c;
var $477696120c5741dc$export$466bfc07425424d5;
var $477696120c5741dc$export$cd75ccfd720a3cd4;
var $477696120c5741dc$export$fa8d919ba61d84db;
var $477696120c5741dc$export$757ceba2d55c277e;
var $477696120c5741dc$export$b3890eb0ae9dca99;
var $477696120c5741dc$export$502457920280e6be;
var $477696120c5741dc$export$c78a37762a8d58e1;
var $477696120c5741dc$export$dc54d992c10e8a18;
var $477696120c5741dc$export$83d89fbfd8236492;
"use strict";

var $4Iuzv = parcelRequire("4Iuzv");

var $1c3ne = parcelRequire("1c3ne");
function $477696120c5741dc$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $477696120c5741dc$var$da = new Set, $477696120c5741dc$var$ea = {};
function $477696120c5741dc$var$fa(a, b) {
    $477696120c5741dc$var$ha(a, b);
    $477696120c5741dc$var$ha(a + "Capture", b);
}
function $477696120c5741dc$var$ha(a, b) {
    $477696120c5741dc$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$477696120c5741dc$var$da.add(b[a]);
}
var $477696120c5741dc$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $477696120c5741dc$var$ja = Object.prototype.hasOwnProperty, $477696120c5741dc$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $477696120c5741dc$var$la = {}, $477696120c5741dc$var$ma = {};
function $477696120c5741dc$var$oa(a) {
    if ($477696120c5741dc$var$ja.call($477696120c5741dc$var$ma, a)) return !0;
    if ($477696120c5741dc$var$ja.call($477696120c5741dc$var$la, a)) return !1;
    if ($477696120c5741dc$var$ka.test(a)) return $477696120c5741dc$var$ma[a] = !0;
    $477696120c5741dc$var$la[a] = !0;
    return !1;
}
function $477696120c5741dc$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $477696120c5741dc$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $477696120c5741dc$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $477696120c5741dc$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $477696120c5741dc$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $477696120c5741dc$var$z[b] = new $477696120c5741dc$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $477696120c5741dc$var$ra = /[\-:]([a-z])/g;
function $477696120c5741dc$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($477696120c5741dc$var$ra, $477696120c5741dc$var$sa);
    $477696120c5741dc$var$z[b] = new $477696120c5741dc$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($477696120c5741dc$var$ra, $477696120c5741dc$var$sa);
    $477696120c5741dc$var$z[b] = new $477696120c5741dc$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($477696120c5741dc$var$ra, $477696120c5741dc$var$sa);
    $477696120c5741dc$var$z[b] = new $477696120c5741dc$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$477696120c5741dc$var$z.xlinkHref = new $477696120c5741dc$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $477696120c5741dc$var$ta(a, b, c, d) {
    var e = $477696120c5741dc$var$z.hasOwnProperty(b) ? $477696120c5741dc$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $477696120c5741dc$var$qa(b, c, e, d) && (c = null), d || null === e ? $477696120c5741dc$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $477696120c5741dc$var$ua = $4Iuzv.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $477696120c5741dc$var$va = Symbol.for("react.element"), $477696120c5741dc$var$wa = Symbol.for("react.portal"), $477696120c5741dc$var$ya = Symbol.for("react.fragment"), $477696120c5741dc$var$za = Symbol.for("react.strict_mode"), $477696120c5741dc$var$Aa = Symbol.for("react.profiler"), $477696120c5741dc$var$Ba = Symbol.for("react.provider"), $477696120c5741dc$var$Ca = Symbol.for("react.context"), $477696120c5741dc$var$Da = Symbol.for("react.forward_ref"), $477696120c5741dc$var$Ea = Symbol.for("react.suspense"), $477696120c5741dc$var$Fa = Symbol.for("react.suspense_list"), $477696120c5741dc$var$Ga = Symbol.for("react.memo"), $477696120c5741dc$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $477696120c5741dc$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $477696120c5741dc$var$Ja = Symbol.iterator;
function $477696120c5741dc$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $477696120c5741dc$var$Ja && a[$477696120c5741dc$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $477696120c5741dc$var$A = Object.assign, $477696120c5741dc$var$La;
function $477696120c5741dc$var$Ma(a) {
    if (void 0 === $477696120c5741dc$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $477696120c5741dc$var$La = b && b[1] || "";
    }
    return "\n" + $477696120c5741dc$var$La + a;
}
var $477696120c5741dc$var$Na = !1;
function $477696120c5741dc$var$Oa(a, b) {
    if (!a || $477696120c5741dc$var$Na) return "";
    $477696120c5741dc$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $477696120c5741dc$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $477696120c5741dc$var$Ma(a) : "";
}
function $477696120c5741dc$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $477696120c5741dc$var$Ma(a.type);
        case 16:
            return $477696120c5741dc$var$Ma("Lazy");
        case 13:
            return $477696120c5741dc$var$Ma("Suspense");
        case 19:
            return $477696120c5741dc$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $477696120c5741dc$var$Oa(a.type, !1), a;
        case 11:
            return a = $477696120c5741dc$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $477696120c5741dc$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $477696120c5741dc$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $477696120c5741dc$var$ya:
            return "Fragment";
        case $477696120c5741dc$var$wa:
            return "Portal";
        case $477696120c5741dc$var$Aa:
            return "Profiler";
        case $477696120c5741dc$var$za:
            return "StrictMode";
        case $477696120c5741dc$var$Ea:
            return "Suspense";
        case $477696120c5741dc$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $477696120c5741dc$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $477696120c5741dc$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $477696120c5741dc$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $477696120c5741dc$var$Ga:
            return b = a.displayName || null, null !== b ? b : $477696120c5741dc$var$Qa(a.type) || "Memo";
        case $477696120c5741dc$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $477696120c5741dc$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $477696120c5741dc$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $477696120c5741dc$var$Qa(b);
        case 8:
            return b === $477696120c5741dc$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $477696120c5741dc$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $477696120c5741dc$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $477696120c5741dc$var$Ua(a) {
    var b = $477696120c5741dc$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $477696120c5741dc$var$Va(a) {
    a._valueTracker || (a._valueTracker = $477696120c5741dc$var$Ua(a));
}
function $477696120c5741dc$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $477696120c5741dc$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $477696120c5741dc$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $477696120c5741dc$var$Ya(a, b) {
    var c = b.checked;
    return $477696120c5741dc$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $477696120c5741dc$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $477696120c5741dc$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $477696120c5741dc$var$ab(a, b) {
    b = b.checked;
    null != b && $477696120c5741dc$var$ta(a, "checked", b, !1);
}
function $477696120c5741dc$var$bb(a, b) {
    $477696120c5741dc$var$ab(a, b);
    var c = $477696120c5741dc$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $477696120c5741dc$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $477696120c5741dc$var$cb(a, b.type, $477696120c5741dc$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $477696120c5741dc$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $477696120c5741dc$var$cb(a, b, c) {
    if ("number" !== b || $477696120c5741dc$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $477696120c5741dc$var$eb = Array.isArray;
function $477696120c5741dc$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $477696120c5741dc$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $477696120c5741dc$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($477696120c5741dc$var$p(91));
    return $477696120c5741dc$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $477696120c5741dc$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($477696120c5741dc$var$p(92));
            if ($477696120c5741dc$var$eb(c)) {
                if (1 < c.length) throw Error($477696120c5741dc$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $477696120c5741dc$var$Sa(c)
    };
}
function $477696120c5741dc$var$ib(a, b) {
    var c = $477696120c5741dc$var$Sa(b.value), d = $477696120c5741dc$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $477696120c5741dc$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $477696120c5741dc$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $477696120c5741dc$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $477696120c5741dc$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $477696120c5741dc$var$mb, $477696120c5741dc$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $477696120c5741dc$var$mb = $477696120c5741dc$var$mb || document.createElement("div");
        $477696120c5741dc$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $477696120c5741dc$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $477696120c5741dc$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $477696120c5741dc$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $477696120c5741dc$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($477696120c5741dc$var$pb).forEach(function(a) {
    $477696120c5741dc$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $477696120c5741dc$var$pb[b] = $477696120c5741dc$var$pb[a];
    });
});
function $477696120c5741dc$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $477696120c5741dc$var$pb.hasOwnProperty(a) && $477696120c5741dc$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $477696120c5741dc$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $477696120c5741dc$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $477696120c5741dc$var$tb = $477696120c5741dc$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $477696120c5741dc$var$ub(a, b) {
    if (b) {
        if ($477696120c5741dc$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($477696120c5741dc$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($477696120c5741dc$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($477696120c5741dc$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($477696120c5741dc$var$p(62));
    }
}
function $477696120c5741dc$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $477696120c5741dc$var$wb = null;
function $477696120c5741dc$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $477696120c5741dc$var$yb = null, $477696120c5741dc$var$zb = null, $477696120c5741dc$var$Ab = null;
function $477696120c5741dc$var$Bb(a) {
    if (a = $477696120c5741dc$var$Cb(a)) {
        if ("function" !== typeof $477696120c5741dc$var$yb) throw Error($477696120c5741dc$var$p(280));
        var b = a.stateNode;
        b && (b = $477696120c5741dc$var$Db(b), $477696120c5741dc$var$yb(a.stateNode, a.type, b));
    }
}
function $477696120c5741dc$var$Eb(a) {
    $477696120c5741dc$var$zb ? $477696120c5741dc$var$Ab ? $477696120c5741dc$var$Ab.push(a) : $477696120c5741dc$var$Ab = [
        a
    ] : $477696120c5741dc$var$zb = a;
}
function $477696120c5741dc$var$Fb() {
    if ($477696120c5741dc$var$zb) {
        var a = $477696120c5741dc$var$zb, b = $477696120c5741dc$var$Ab;
        $477696120c5741dc$var$Ab = $477696120c5741dc$var$zb = null;
        $477696120c5741dc$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$477696120c5741dc$var$Bb(b[a]);
    }
}
function $477696120c5741dc$var$Gb(a, b) {
    return a(b);
}
function $477696120c5741dc$var$Hb() {}
var $477696120c5741dc$var$Ib = !1;
function $477696120c5741dc$var$Jb(a, b, c) {
    if ($477696120c5741dc$var$Ib) return a(b, c);
    $477696120c5741dc$var$Ib = !0;
    try {
        return $477696120c5741dc$var$Gb(a, b, c);
    } finally{
        if ($477696120c5741dc$var$Ib = !1, null !== $477696120c5741dc$var$zb || null !== $477696120c5741dc$var$Ab) $477696120c5741dc$var$Hb(), $477696120c5741dc$var$Fb();
    }
}
function $477696120c5741dc$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $477696120c5741dc$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($477696120c5741dc$var$p(231, b, typeof c));
    return c;
}
var $477696120c5741dc$var$Lb = !1;
if ($477696120c5741dc$var$ia) try {
    var $477696120c5741dc$var$Mb = {};
    Object.defineProperty($477696120c5741dc$var$Mb, "passive", {
        get: function() {
            $477696120c5741dc$var$Lb = !0;
        }
    });
    window.addEventListener("test", $477696120c5741dc$var$Mb, $477696120c5741dc$var$Mb);
    window.removeEventListener("test", $477696120c5741dc$var$Mb, $477696120c5741dc$var$Mb);
} catch (a) {
    $477696120c5741dc$var$Lb = !1;
}
function $477696120c5741dc$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $477696120c5741dc$var$Ob = !1, $477696120c5741dc$var$Pb = null, $477696120c5741dc$var$Qb = !1, $477696120c5741dc$var$Rb = null, $477696120c5741dc$var$Sb = {
    onError: function(a) {
        $477696120c5741dc$var$Ob = !0;
        $477696120c5741dc$var$Pb = a;
    }
};
function $477696120c5741dc$var$Tb(a, b, c, d, e, f, g, h, k) {
    $477696120c5741dc$var$Ob = !1;
    $477696120c5741dc$var$Pb = null;
    $477696120c5741dc$var$Nb.apply($477696120c5741dc$var$Sb, arguments);
}
function $477696120c5741dc$var$Ub(a, b, c, d, e, f, g, h, k) {
    $477696120c5741dc$var$Tb.apply(this, arguments);
    if ($477696120c5741dc$var$Ob) {
        if ($477696120c5741dc$var$Ob) {
            var l = $477696120c5741dc$var$Pb;
            $477696120c5741dc$var$Ob = !1;
            $477696120c5741dc$var$Pb = null;
        } else throw Error($477696120c5741dc$var$p(198));
        $477696120c5741dc$var$Qb || ($477696120c5741dc$var$Qb = !0, $477696120c5741dc$var$Rb = l);
    }
}
function $477696120c5741dc$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $477696120c5741dc$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $477696120c5741dc$var$Xb(a) {
    if ($477696120c5741dc$var$Vb(a) !== a) throw Error($477696120c5741dc$var$p(188));
}
function $477696120c5741dc$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $477696120c5741dc$var$Vb(a);
        if (null === b) throw Error($477696120c5741dc$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $477696120c5741dc$var$Xb(e), a;
                if (f === d) return $477696120c5741dc$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($477696120c5741dc$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($477696120c5741dc$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($477696120c5741dc$var$p(190));
    }
    if (3 !== c.tag) throw Error($477696120c5741dc$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $477696120c5741dc$var$Zb(a) {
    a = $477696120c5741dc$var$Yb(a);
    return null !== a ? $477696120c5741dc$var$$b(a) : null;
}
function $477696120c5741dc$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $477696120c5741dc$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $477696120c5741dc$var$ac = $1c3ne.unstable_scheduleCallback, $477696120c5741dc$var$bc = $1c3ne.unstable_cancelCallback, $477696120c5741dc$var$cc = $1c3ne.unstable_shouldYield, $477696120c5741dc$var$dc = $1c3ne.unstable_requestPaint, $477696120c5741dc$var$B = $1c3ne.unstable_now, $477696120c5741dc$var$ec = $1c3ne.unstable_getCurrentPriorityLevel, $477696120c5741dc$var$fc = $1c3ne.unstable_ImmediatePriority, $477696120c5741dc$var$gc = $1c3ne.unstable_UserBlockingPriority, $477696120c5741dc$var$hc = $1c3ne.unstable_NormalPriority, $477696120c5741dc$var$ic = $1c3ne.unstable_LowPriority, $477696120c5741dc$var$jc = $1c3ne.unstable_IdlePriority, $477696120c5741dc$var$kc = null, $477696120c5741dc$var$lc = null;
function $477696120c5741dc$var$mc(a) {
    if ($477696120c5741dc$var$lc && "function" === typeof $477696120c5741dc$var$lc.onCommitFiberRoot) try {
        $477696120c5741dc$var$lc.onCommitFiberRoot($477696120c5741dc$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $477696120c5741dc$var$oc = Math.clz32 ? Math.clz32 : $477696120c5741dc$var$nc, $477696120c5741dc$var$pc = Math.log, $477696120c5741dc$var$qc = Math.LN2;
function $477696120c5741dc$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($477696120c5741dc$var$pc(a) / $477696120c5741dc$var$qc | 0) | 0;
}
var $477696120c5741dc$var$rc = 64, $477696120c5741dc$var$sc = 4194304;
function $477696120c5741dc$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $477696120c5741dc$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $477696120c5741dc$var$tc(h) : (f &= g, 0 !== f && (d = $477696120c5741dc$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $477696120c5741dc$var$tc(g) : 0 !== f && (d = $477696120c5741dc$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $477696120c5741dc$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $477696120c5741dc$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $477696120c5741dc$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $477696120c5741dc$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $477696120c5741dc$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $477696120c5741dc$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $477696120c5741dc$var$yc() {
    var a = $477696120c5741dc$var$rc;
    $477696120c5741dc$var$rc <<= 1;
    0 === ($477696120c5741dc$var$rc & 4194240) && ($477696120c5741dc$var$rc = 64);
    return a;
}
function $477696120c5741dc$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $477696120c5741dc$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $477696120c5741dc$var$oc(b);
    a[b] = c;
}
function $477696120c5741dc$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $477696120c5741dc$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $477696120c5741dc$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $477696120c5741dc$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $477696120c5741dc$var$C = 0;
function $477696120c5741dc$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $477696120c5741dc$var$Ec, $477696120c5741dc$var$Fc, $477696120c5741dc$var$Gc, $477696120c5741dc$var$Hc, $477696120c5741dc$var$Ic, $477696120c5741dc$var$Jc = !1, $477696120c5741dc$var$Kc = [], $477696120c5741dc$var$Lc = null, $477696120c5741dc$var$Mc = null, $477696120c5741dc$var$Nc = null, $477696120c5741dc$var$Oc = new Map, $477696120c5741dc$var$Pc = new Map, $477696120c5741dc$var$Qc = [], $477696120c5741dc$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $477696120c5741dc$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $477696120c5741dc$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $477696120c5741dc$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $477696120c5741dc$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $477696120c5741dc$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $477696120c5741dc$var$Pc.delete(b.pointerId);
    }
}
function $477696120c5741dc$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $477696120c5741dc$var$Cb(b), null !== b && $477696120c5741dc$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $477696120c5741dc$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $477696120c5741dc$var$Lc = $477696120c5741dc$var$Tc($477696120c5741dc$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $477696120c5741dc$var$Mc = $477696120c5741dc$var$Tc($477696120c5741dc$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $477696120c5741dc$var$Nc = $477696120c5741dc$var$Tc($477696120c5741dc$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $477696120c5741dc$var$Oc.set(f, $477696120c5741dc$var$Tc($477696120c5741dc$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $477696120c5741dc$var$Pc.set(f, $477696120c5741dc$var$Tc($477696120c5741dc$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $477696120c5741dc$var$Vc(a) {
    var b = $477696120c5741dc$var$Wc(a.target);
    if (null !== b) {
        var c = $477696120c5741dc$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $477696120c5741dc$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $477696120c5741dc$var$Ic(a.priority, function() {
                        $477696120c5741dc$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $477696120c5741dc$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $477696120c5741dc$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $477696120c5741dc$var$wb = d;
            c.target.dispatchEvent(d);
            $477696120c5741dc$var$wb = null;
        } else return b = $477696120c5741dc$var$Cb(c), null !== b && $477696120c5741dc$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $477696120c5741dc$var$Zc(a, b, c) {
    $477696120c5741dc$var$Xc(a) && c.delete(b);
}
function $477696120c5741dc$var$$c() {
    $477696120c5741dc$var$Jc = !1;
    null !== $477696120c5741dc$var$Lc && $477696120c5741dc$var$Xc($477696120c5741dc$var$Lc) && ($477696120c5741dc$var$Lc = null);
    null !== $477696120c5741dc$var$Mc && $477696120c5741dc$var$Xc($477696120c5741dc$var$Mc) && ($477696120c5741dc$var$Mc = null);
    null !== $477696120c5741dc$var$Nc && $477696120c5741dc$var$Xc($477696120c5741dc$var$Nc) && ($477696120c5741dc$var$Nc = null);
    $477696120c5741dc$var$Oc.forEach($477696120c5741dc$var$Zc);
    $477696120c5741dc$var$Pc.forEach($477696120c5741dc$var$Zc);
}
function $477696120c5741dc$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $477696120c5741dc$var$Jc || ($477696120c5741dc$var$Jc = !0, $1c3ne.unstable_scheduleCallback($1c3ne.unstable_NormalPriority, $477696120c5741dc$var$$c)));
}
function $477696120c5741dc$var$bd(a) {
    function b(b) {
        return $477696120c5741dc$var$ad(b, a);
    }
    if (0 < $477696120c5741dc$var$Kc.length) {
        $477696120c5741dc$var$ad($477696120c5741dc$var$Kc[0], a);
        for(var c = 1; c < $477696120c5741dc$var$Kc.length; c++){
            var d = $477696120c5741dc$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $477696120c5741dc$var$Lc && $477696120c5741dc$var$ad($477696120c5741dc$var$Lc, a);
    null !== $477696120c5741dc$var$Mc && $477696120c5741dc$var$ad($477696120c5741dc$var$Mc, a);
    null !== $477696120c5741dc$var$Nc && $477696120c5741dc$var$ad($477696120c5741dc$var$Nc, a);
    $477696120c5741dc$var$Oc.forEach(b);
    $477696120c5741dc$var$Pc.forEach(b);
    for(c = 0; c < $477696120c5741dc$var$Qc.length; c++)d = $477696120c5741dc$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $477696120c5741dc$var$Qc.length && (c = $477696120c5741dc$var$Qc[0], null === c.blockedOn);)$477696120c5741dc$var$Vc(c), null === c.blockedOn && $477696120c5741dc$var$Qc.shift();
}
var $477696120c5741dc$var$cd = $477696120c5741dc$var$ua.ReactCurrentBatchConfig, $477696120c5741dc$var$dd = !0;
function $477696120c5741dc$var$ed(a, b, c, d) {
    var e = $477696120c5741dc$var$C, f = $477696120c5741dc$var$cd.transition;
    $477696120c5741dc$var$cd.transition = null;
    try {
        $477696120c5741dc$var$C = 1, $477696120c5741dc$var$fd(a, b, c, d);
    } finally{
        $477696120c5741dc$var$C = e, $477696120c5741dc$var$cd.transition = f;
    }
}
function $477696120c5741dc$var$gd(a, b, c, d) {
    var e = $477696120c5741dc$var$C, f = $477696120c5741dc$var$cd.transition;
    $477696120c5741dc$var$cd.transition = null;
    try {
        $477696120c5741dc$var$C = 4, $477696120c5741dc$var$fd(a, b, c, d);
    } finally{
        $477696120c5741dc$var$C = e, $477696120c5741dc$var$cd.transition = f;
    }
}
function $477696120c5741dc$var$fd(a, b, c, d) {
    if ($477696120c5741dc$var$dd) {
        var e = $477696120c5741dc$var$Yc(a, b, c, d);
        if (null === e) $477696120c5741dc$var$hd(a, b, d, $477696120c5741dc$var$id, c), $477696120c5741dc$var$Sc(a, d);
        else if ($477696120c5741dc$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($477696120c5741dc$var$Sc(a, d), b & 4 && -1 < $477696120c5741dc$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $477696120c5741dc$var$Cb(e);
                null !== f && $477696120c5741dc$var$Ec(f);
                f = $477696120c5741dc$var$Yc(a, b, c, d);
                null === f && $477696120c5741dc$var$hd(a, b, d, $477696120c5741dc$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $477696120c5741dc$var$hd(a, b, d, null, c);
    }
}
var $477696120c5741dc$var$id = null;
function $477696120c5741dc$var$Yc(a, b, c, d) {
    $477696120c5741dc$var$id = null;
    a = $477696120c5741dc$var$xb(d);
    a = $477696120c5741dc$var$Wc(a);
    if (null !== a) {
        if (b = $477696120c5741dc$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $477696120c5741dc$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $477696120c5741dc$var$id = a;
    return null;
}
function $477696120c5741dc$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($477696120c5741dc$var$ec()){
                case $477696120c5741dc$var$fc:
                    return 1;
                case $477696120c5741dc$var$gc:
                    return 4;
                case $477696120c5741dc$var$hc:
                case $477696120c5741dc$var$ic:
                    return 16;
                case $477696120c5741dc$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $477696120c5741dc$var$kd = null, $477696120c5741dc$var$ld = null, $477696120c5741dc$var$md = null;
function $477696120c5741dc$var$nd() {
    if ($477696120c5741dc$var$md) return $477696120c5741dc$var$md;
    var a, b = $477696120c5741dc$var$ld, c = b.length, d, e = "value" in $477696120c5741dc$var$kd ? $477696120c5741dc$var$kd.value : $477696120c5741dc$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $477696120c5741dc$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $477696120c5741dc$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $477696120c5741dc$var$pd() {
    return !0;
}
function $477696120c5741dc$var$qd() {
    return !1;
}
function $477696120c5741dc$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $477696120c5741dc$var$pd : $477696120c5741dc$var$qd;
        this.isPropagationStopped = $477696120c5741dc$var$qd;
        return this;
    }
    $477696120c5741dc$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $477696120c5741dc$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $477696120c5741dc$var$pd);
        },
        persist: function() {},
        isPersistent: $477696120c5741dc$var$pd
    });
    return b;
}
var $477696120c5741dc$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $477696120c5741dc$var$td = $477696120c5741dc$var$rd($477696120c5741dc$var$sd), $477696120c5741dc$var$ud = $477696120c5741dc$var$A({}, $477696120c5741dc$var$sd, {
    view: 0,
    detail: 0
}), $477696120c5741dc$var$vd = $477696120c5741dc$var$rd($477696120c5741dc$var$ud), $477696120c5741dc$var$wd, $477696120c5741dc$var$xd, $477696120c5741dc$var$yd, $477696120c5741dc$var$Ad = $477696120c5741dc$var$A({}, $477696120c5741dc$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $477696120c5741dc$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $477696120c5741dc$var$yd && ($477696120c5741dc$var$yd && "mousemove" === a.type ? ($477696120c5741dc$var$wd = a.screenX - $477696120c5741dc$var$yd.screenX, $477696120c5741dc$var$xd = a.screenY - $477696120c5741dc$var$yd.screenY) : $477696120c5741dc$var$xd = $477696120c5741dc$var$wd = 0, $477696120c5741dc$var$yd = a);
        return $477696120c5741dc$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $477696120c5741dc$var$xd;
    }
}), $477696120c5741dc$var$Bd = $477696120c5741dc$var$rd($477696120c5741dc$var$Ad), $477696120c5741dc$var$Cd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$Ad, {
    dataTransfer: 0
}), $477696120c5741dc$var$Dd = $477696120c5741dc$var$rd($477696120c5741dc$var$Cd), $477696120c5741dc$var$Ed = $477696120c5741dc$var$A({}, $477696120c5741dc$var$ud, {
    relatedTarget: 0
}), $477696120c5741dc$var$Fd = $477696120c5741dc$var$rd($477696120c5741dc$var$Ed), $477696120c5741dc$var$Gd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $477696120c5741dc$var$Hd = $477696120c5741dc$var$rd($477696120c5741dc$var$Gd), $477696120c5741dc$var$Id = $477696120c5741dc$var$A({}, $477696120c5741dc$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $477696120c5741dc$var$Jd = $477696120c5741dc$var$rd($477696120c5741dc$var$Id), $477696120c5741dc$var$Kd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$sd, {
    data: 0
}), $477696120c5741dc$var$Ld = $477696120c5741dc$var$rd($477696120c5741dc$var$Kd), $477696120c5741dc$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $477696120c5741dc$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $477696120c5741dc$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $477696120c5741dc$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $477696120c5741dc$var$Od[a]) ? !!b[a] : !1;
}
function $477696120c5741dc$var$zd() {
    return $477696120c5741dc$var$Pd;
}
var $477696120c5741dc$var$Qd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $477696120c5741dc$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $477696120c5741dc$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $477696120c5741dc$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $477696120c5741dc$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $477696120c5741dc$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $477696120c5741dc$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $477696120c5741dc$var$Rd = $477696120c5741dc$var$rd($477696120c5741dc$var$Qd), $477696120c5741dc$var$Sd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $477696120c5741dc$var$Td = $477696120c5741dc$var$rd($477696120c5741dc$var$Sd), $477696120c5741dc$var$Ud = $477696120c5741dc$var$A({}, $477696120c5741dc$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $477696120c5741dc$var$zd
}), $477696120c5741dc$var$Vd = $477696120c5741dc$var$rd($477696120c5741dc$var$Ud), $477696120c5741dc$var$Wd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $477696120c5741dc$var$Xd = $477696120c5741dc$var$rd($477696120c5741dc$var$Wd), $477696120c5741dc$var$Yd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $477696120c5741dc$var$Zd = $477696120c5741dc$var$rd($477696120c5741dc$var$Yd), $477696120c5741dc$var$$d = [
    9,
    13,
    27,
    32
], $477696120c5741dc$var$ae = $477696120c5741dc$var$ia && "CompositionEvent" in window, $477696120c5741dc$var$be = null;
$477696120c5741dc$var$ia && "documentMode" in document && ($477696120c5741dc$var$be = document.documentMode);
var $477696120c5741dc$var$ce = $477696120c5741dc$var$ia && "TextEvent" in window && !$477696120c5741dc$var$be, $477696120c5741dc$var$de = $477696120c5741dc$var$ia && (!$477696120c5741dc$var$ae || $477696120c5741dc$var$be && 8 < $477696120c5741dc$var$be && 11 >= $477696120c5741dc$var$be), $477696120c5741dc$var$ee = String.fromCharCode(32), $477696120c5741dc$var$fe = !1;
function $477696120c5741dc$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $477696120c5741dc$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $477696120c5741dc$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $477696120c5741dc$var$ie = !1;
function $477696120c5741dc$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $477696120c5741dc$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $477696120c5741dc$var$fe = !0;
            return $477696120c5741dc$var$ee;
        case "textInput":
            return a = b.data, a === $477696120c5741dc$var$ee && $477696120c5741dc$var$fe ? null : a;
        default:
            return null;
    }
}
function $477696120c5741dc$var$ke(a, b) {
    if ($477696120c5741dc$var$ie) return "compositionend" === a || !$477696120c5741dc$var$ae && $477696120c5741dc$var$ge(a, b) ? (a = $477696120c5741dc$var$nd(), $477696120c5741dc$var$md = $477696120c5741dc$var$ld = $477696120c5741dc$var$kd = null, $477696120c5741dc$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $477696120c5741dc$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $477696120c5741dc$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $477696120c5741dc$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$477696120c5741dc$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $477696120c5741dc$var$ne(a, b, c, d) {
    $477696120c5741dc$var$Eb(d);
    b = $477696120c5741dc$var$oe(b, "onChange");
    0 < b.length && (c = new $477696120c5741dc$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $477696120c5741dc$var$pe = null, $477696120c5741dc$var$qe = null;
function $477696120c5741dc$var$re(a) {
    $477696120c5741dc$var$se(a, 0);
}
function $477696120c5741dc$var$te(a) {
    var b = $477696120c5741dc$var$ue(a);
    if ($477696120c5741dc$var$Wa(b)) return a;
}
function $477696120c5741dc$var$ve(a, b) {
    if ("change" === a) return b;
}
var $477696120c5741dc$var$we = !1;
if ($477696120c5741dc$var$ia) {
    var $477696120c5741dc$var$xe;
    if ($477696120c5741dc$var$ia) {
        var $477696120c5741dc$var$ye = "oninput" in document;
        if (!$477696120c5741dc$var$ye) {
            var $477696120c5741dc$var$ze = document.createElement("div");
            $477696120c5741dc$var$ze.setAttribute("oninput", "return;");
            $477696120c5741dc$var$ye = "function" === typeof $477696120c5741dc$var$ze.oninput;
        }
        $477696120c5741dc$var$xe = $477696120c5741dc$var$ye;
    } else $477696120c5741dc$var$xe = !1;
    $477696120c5741dc$var$we = $477696120c5741dc$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $477696120c5741dc$var$Ae() {
    $477696120c5741dc$var$pe && ($477696120c5741dc$var$pe.detachEvent("onpropertychange", $477696120c5741dc$var$Be), $477696120c5741dc$var$qe = $477696120c5741dc$var$pe = null);
}
function $477696120c5741dc$var$Be(a) {
    if ("value" === a.propertyName && $477696120c5741dc$var$te($477696120c5741dc$var$qe)) {
        var b = [];
        $477696120c5741dc$var$ne(b, $477696120c5741dc$var$qe, a, $477696120c5741dc$var$xb(a));
        $477696120c5741dc$var$Jb($477696120c5741dc$var$re, b);
    }
}
function $477696120c5741dc$var$Ce(a, b, c) {
    "focusin" === a ? ($477696120c5741dc$var$Ae(), $477696120c5741dc$var$pe = b, $477696120c5741dc$var$qe = c, $477696120c5741dc$var$pe.attachEvent("onpropertychange", $477696120c5741dc$var$Be)) : "focusout" === a && $477696120c5741dc$var$Ae();
}
function $477696120c5741dc$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $477696120c5741dc$var$te($477696120c5741dc$var$qe);
}
function $477696120c5741dc$var$Ee(a, b) {
    if ("click" === a) return $477696120c5741dc$var$te(b);
}
function $477696120c5741dc$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $477696120c5741dc$var$te(b);
}
function $477696120c5741dc$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $477696120c5741dc$var$He = "function" === typeof Object.is ? Object.is : $477696120c5741dc$var$Ge;
function $477696120c5741dc$var$Ie(a, b) {
    if ($477696120c5741dc$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$477696120c5741dc$var$ja.call(b, e) || !$477696120c5741dc$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $477696120c5741dc$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $477696120c5741dc$var$Ke(a, b) {
    var c = $477696120c5741dc$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $477696120c5741dc$var$Je(c);
    }
}
function $477696120c5741dc$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $477696120c5741dc$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $477696120c5741dc$var$Me() {
    for(var a = window, b = $477696120c5741dc$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $477696120c5741dc$var$Xa(a.document);
    }
    return b;
}
function $477696120c5741dc$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $477696120c5741dc$var$Oe(a) {
    var b = $477696120c5741dc$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $477696120c5741dc$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $477696120c5741dc$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $477696120c5741dc$var$Ke(c, f);
                var g = $477696120c5741dc$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $477696120c5741dc$var$Pe = $477696120c5741dc$var$ia && "documentMode" in document && 11 >= document.documentMode, $477696120c5741dc$var$Qe = null, $477696120c5741dc$var$Re = null, $477696120c5741dc$var$Se = null, $477696120c5741dc$var$Te = !1;
function $477696120c5741dc$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $477696120c5741dc$var$Te || null == $477696120c5741dc$var$Qe || $477696120c5741dc$var$Qe !== $477696120c5741dc$var$Xa(d) || (d = $477696120c5741dc$var$Qe, "selectionStart" in d && $477696120c5741dc$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $477696120c5741dc$var$Se && $477696120c5741dc$var$Ie($477696120c5741dc$var$Se, d) || ($477696120c5741dc$var$Se = d, d = $477696120c5741dc$var$oe($477696120c5741dc$var$Re, "onSelect"), 0 < d.length && (b = new $477696120c5741dc$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $477696120c5741dc$var$Qe)));
}
function $477696120c5741dc$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $477696120c5741dc$var$We = {
    animationend: $477696120c5741dc$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $477696120c5741dc$var$Ve("Animation", "AnimationIteration"),
    animationstart: $477696120c5741dc$var$Ve("Animation", "AnimationStart"),
    transitionend: $477696120c5741dc$var$Ve("Transition", "TransitionEnd")
}, $477696120c5741dc$var$Xe = {}, $477696120c5741dc$var$Ye = {};
$477696120c5741dc$var$ia && ($477696120c5741dc$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $477696120c5741dc$var$We.animationend.animation, delete $477696120c5741dc$var$We.animationiteration.animation, delete $477696120c5741dc$var$We.animationstart.animation), "TransitionEvent" in window || delete $477696120c5741dc$var$We.transitionend.transition);
function $477696120c5741dc$var$Ze(a) {
    if ($477696120c5741dc$var$Xe[a]) return $477696120c5741dc$var$Xe[a];
    if (!$477696120c5741dc$var$We[a]) return a;
    var b = $477696120c5741dc$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $477696120c5741dc$var$Ye) return $477696120c5741dc$var$Xe[a] = b[c];
    return a;
}
var $477696120c5741dc$var$$e = $477696120c5741dc$var$Ze("animationend"), $477696120c5741dc$var$af = $477696120c5741dc$var$Ze("animationiteration"), $477696120c5741dc$var$bf = $477696120c5741dc$var$Ze("animationstart"), $477696120c5741dc$var$cf = $477696120c5741dc$var$Ze("transitionend"), $477696120c5741dc$var$df = new Map, $477696120c5741dc$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $477696120c5741dc$var$ff(a, b) {
    $477696120c5741dc$var$df.set(a, b);
    $477696120c5741dc$var$fa(b, [
        a
    ]);
}
for(var $477696120c5741dc$var$gf = 0; $477696120c5741dc$var$gf < $477696120c5741dc$var$ef.length; $477696120c5741dc$var$gf++){
    var $477696120c5741dc$var$hf = $477696120c5741dc$var$ef[$477696120c5741dc$var$gf], $477696120c5741dc$var$jf = $477696120c5741dc$var$hf.toLowerCase(), $477696120c5741dc$var$kf = $477696120c5741dc$var$hf[0].toUpperCase() + $477696120c5741dc$var$hf.slice(1);
    $477696120c5741dc$var$ff($477696120c5741dc$var$jf, "on" + $477696120c5741dc$var$kf);
}
$477696120c5741dc$var$ff($477696120c5741dc$var$$e, "onAnimationEnd");
$477696120c5741dc$var$ff($477696120c5741dc$var$af, "onAnimationIteration");
$477696120c5741dc$var$ff($477696120c5741dc$var$bf, "onAnimationStart");
$477696120c5741dc$var$ff("dblclick", "onDoubleClick");
$477696120c5741dc$var$ff("focusin", "onFocus");
$477696120c5741dc$var$ff("focusout", "onBlur");
$477696120c5741dc$var$ff($477696120c5741dc$var$cf, "onTransitionEnd");
$477696120c5741dc$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$477696120c5741dc$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$477696120c5741dc$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$477696120c5741dc$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$477696120c5741dc$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$477696120c5741dc$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$477696120c5741dc$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$477696120c5741dc$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$477696120c5741dc$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$477696120c5741dc$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $477696120c5741dc$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $477696120c5741dc$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($477696120c5741dc$var$lf));
function $477696120c5741dc$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $477696120c5741dc$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $477696120c5741dc$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $477696120c5741dc$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $477696120c5741dc$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($477696120c5741dc$var$Qb) throw a = $477696120c5741dc$var$Rb, $477696120c5741dc$var$Qb = !1, $477696120c5741dc$var$Rb = null, a;
}
function $477696120c5741dc$var$D(a, b) {
    var c = b[$477696120c5741dc$var$of];
    void 0 === c && (c = b[$477696120c5741dc$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($477696120c5741dc$var$pf(b, a, 2, !1), c.add(d));
}
function $477696120c5741dc$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $477696120c5741dc$var$pf(c, a, d, b);
}
var $477696120c5741dc$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $477696120c5741dc$var$sf(a) {
    if (!a[$477696120c5741dc$var$rf]) {
        a[$477696120c5741dc$var$rf] = !0;
        $477696120c5741dc$var$da.forEach(function(b) {
            "selectionchange" !== b && ($477696120c5741dc$var$mf.has(b) || $477696120c5741dc$var$qf(b, !1, a), $477696120c5741dc$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$477696120c5741dc$var$rf] || (b[$477696120c5741dc$var$rf] = !0, $477696120c5741dc$var$qf("selectionchange", !1, b));
    }
}
function $477696120c5741dc$var$pf(a, b, c, d) {
    switch($477696120c5741dc$var$jd(b)){
        case 1:
            var e = $477696120c5741dc$var$ed;
            break;
        case 4:
            e = $477696120c5741dc$var$gd;
            break;
        default:
            e = $477696120c5741dc$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$477696120c5741dc$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $477696120c5741dc$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $477696120c5741dc$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $477696120c5741dc$var$Jb(function() {
        var d = f, e = $477696120c5741dc$var$xb(c), g = [];
        a: {
            var h = $477696120c5741dc$var$df.get(a);
            if (void 0 !== h) {
                var k = $477696120c5741dc$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $477696120c5741dc$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $477696120c5741dc$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $477696120c5741dc$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $477696120c5741dc$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $477696120c5741dc$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $477696120c5741dc$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $477696120c5741dc$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $477696120c5741dc$var$Vd;
                        break;
                    case $477696120c5741dc$var$$e:
                    case $477696120c5741dc$var$af:
                    case $477696120c5741dc$var$bf:
                        k = $477696120c5741dc$var$Hd;
                        break;
                    case $477696120c5741dc$var$cf:
                        k = $477696120c5741dc$var$Xd;
                        break;
                    case "scroll":
                        k = $477696120c5741dc$var$vd;
                        break;
                    case "wheel":
                        k = $477696120c5741dc$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $477696120c5741dc$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $477696120c5741dc$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $477696120c5741dc$var$Kb(w, x), null != F && t.push($477696120c5741dc$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $477696120c5741dc$var$wb && (n = c.relatedTarget || c.fromElement) && ($477696120c5741dc$var$Wc(n) || n[$477696120c5741dc$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $477696120c5741dc$var$Wc(n) : null, null !== n && (J = $477696120c5741dc$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $477696120c5741dc$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $477696120c5741dc$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $477696120c5741dc$var$ue(k);
                        u = null == n ? h : $477696120c5741dc$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $477696120c5741dc$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $477696120c5741dc$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $477696120c5741dc$var$vf(F))u++;
                            for(; 0 < w - u;)t = $477696120c5741dc$var$vf(t), w--;
                            for(; 0 < u - w;)x = $477696120c5741dc$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $477696120c5741dc$var$vf(t);
                                x = $477696120c5741dc$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $477696120c5741dc$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $477696120c5741dc$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $477696120c5741dc$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $477696120c5741dc$var$ve;
                else if ($477696120c5741dc$var$me(h)) {
                    if ($477696120c5741dc$var$we) na = $477696120c5741dc$var$Fe;
                    else {
                        na = $477696120c5741dc$var$De;
                        var xa = $477696120c5741dc$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $477696120c5741dc$var$Ee);
                if (na && (na = na(a, d))) {
                    $477696120c5741dc$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $477696120c5741dc$var$cb(h, "number", h.value);
            }
            xa = d ? $477696120c5741dc$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($477696120c5741dc$var$me(xa) || "true" === xa.contentEditable) $477696120c5741dc$var$Qe = xa, $477696120c5741dc$var$Re = d, $477696120c5741dc$var$Se = null;
                    break;
                case "focusout":
                    $477696120c5741dc$var$Se = $477696120c5741dc$var$Re = $477696120c5741dc$var$Qe = null;
                    break;
                case "mousedown":
                    $477696120c5741dc$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $477696120c5741dc$var$Te = !1;
                    $477696120c5741dc$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($477696120c5741dc$var$Pe) break;
                case "keydown":
                case "keyup":
                    $477696120c5741dc$var$Ue(g, c, e);
            }
            var $a;
            if ($477696120c5741dc$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $477696120c5741dc$var$ie ? $477696120c5741dc$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($477696120c5741dc$var$de && "ko" !== c.locale && ($477696120c5741dc$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $477696120c5741dc$var$ie && ($a = $477696120c5741dc$var$nd()) : ($477696120c5741dc$var$kd = e, $477696120c5741dc$var$ld = "value" in $477696120c5741dc$var$kd ? $477696120c5741dc$var$kd.value : $477696120c5741dc$var$kd.textContent, $477696120c5741dc$var$ie = !0)), xa = $477696120c5741dc$var$oe(d, ba), 0 < xa.length && (ba = new $477696120c5741dc$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $477696120c5741dc$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $477696120c5741dc$var$ce ? $477696120c5741dc$var$je(a, c) : $477696120c5741dc$var$ke(a, c)) d = $477696120c5741dc$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $477696120c5741dc$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $477696120c5741dc$var$se(g, b);
    });
}
function $477696120c5741dc$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $477696120c5741dc$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $477696120c5741dc$var$Kb(a, c), null != f && d.unshift($477696120c5741dc$var$tf(a, f, e)), f = $477696120c5741dc$var$Kb(a, b), null != f && d.push($477696120c5741dc$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $477696120c5741dc$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $477696120c5741dc$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $477696120c5741dc$var$Kb(c, f), null != k && g.unshift($477696120c5741dc$var$tf(c, k, h))) : e || (k = $477696120c5741dc$var$Kb(c, f), null != k && g.push($477696120c5741dc$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $477696120c5741dc$var$xf = /\r\n?/g, $477696120c5741dc$var$yf = /\u0000|\uFFFD/g;
function $477696120c5741dc$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($477696120c5741dc$var$xf, "\n").replace($477696120c5741dc$var$yf, "");
}
function $477696120c5741dc$var$Af(a, b, c) {
    b = $477696120c5741dc$var$zf(b);
    if ($477696120c5741dc$var$zf(a) !== b && c) throw Error($477696120c5741dc$var$p(425));
}
function $477696120c5741dc$var$Bf() {}
var $477696120c5741dc$var$Cf = null, $477696120c5741dc$var$Df = null;
function $477696120c5741dc$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $477696120c5741dc$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $477696120c5741dc$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $477696120c5741dc$var$Hf = "function" === typeof Promise ? Promise : void 0, $477696120c5741dc$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $477696120c5741dc$var$Hf ? function(a) {
    return $477696120c5741dc$var$Hf.resolve(null).then(a).catch($477696120c5741dc$var$If);
} : $477696120c5741dc$var$Ff;
function $477696120c5741dc$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $477696120c5741dc$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $477696120c5741dc$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $477696120c5741dc$var$bd(b);
}
function $477696120c5741dc$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $477696120c5741dc$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $477696120c5741dc$var$Nf = Math.random().toString(36).slice(2), $477696120c5741dc$var$Of = "__reactFiber$" + $477696120c5741dc$var$Nf, $477696120c5741dc$var$Pf = "__reactProps$" + $477696120c5741dc$var$Nf, $477696120c5741dc$var$uf = "__reactContainer$" + $477696120c5741dc$var$Nf, $477696120c5741dc$var$of = "__reactEvents$" + $477696120c5741dc$var$Nf, $477696120c5741dc$var$Qf = "__reactListeners$" + $477696120c5741dc$var$Nf, $477696120c5741dc$var$Rf = "__reactHandles$" + $477696120c5741dc$var$Nf;
function $477696120c5741dc$var$Wc(a) {
    var b = a[$477696120c5741dc$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$477696120c5741dc$var$uf] || c[$477696120c5741dc$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $477696120c5741dc$var$Mf(a); null !== a;){
                if (c = a[$477696120c5741dc$var$Of]) return c;
                a = $477696120c5741dc$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $477696120c5741dc$var$Cb(a) {
    a = a[$477696120c5741dc$var$Of] || a[$477696120c5741dc$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $477696120c5741dc$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($477696120c5741dc$var$p(33));
}
function $477696120c5741dc$var$Db(a) {
    return a[$477696120c5741dc$var$Pf] || null;
}
var $477696120c5741dc$var$Sf = [], $477696120c5741dc$var$Tf = -1;
function $477696120c5741dc$var$Uf(a) {
    return {
        current: a
    };
}
function $477696120c5741dc$var$E(a) {
    0 > $477696120c5741dc$var$Tf || (a.current = $477696120c5741dc$var$Sf[$477696120c5741dc$var$Tf], $477696120c5741dc$var$Sf[$477696120c5741dc$var$Tf] = null, $477696120c5741dc$var$Tf--);
}
function $477696120c5741dc$var$G(a, b) {
    $477696120c5741dc$var$Tf++;
    $477696120c5741dc$var$Sf[$477696120c5741dc$var$Tf] = a.current;
    a.current = b;
}
var $477696120c5741dc$var$Vf = {}, $477696120c5741dc$var$H = $477696120c5741dc$var$Uf($477696120c5741dc$var$Vf), $477696120c5741dc$var$Wf = $477696120c5741dc$var$Uf(!1), $477696120c5741dc$var$Xf = $477696120c5741dc$var$Vf;
function $477696120c5741dc$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $477696120c5741dc$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $477696120c5741dc$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $477696120c5741dc$var$$f() {
    $477696120c5741dc$var$E($477696120c5741dc$var$Wf);
    $477696120c5741dc$var$E($477696120c5741dc$var$H);
}
function $477696120c5741dc$var$ag(a, b, c) {
    if ($477696120c5741dc$var$H.current !== $477696120c5741dc$var$Vf) throw Error($477696120c5741dc$var$p(168));
    $477696120c5741dc$var$G($477696120c5741dc$var$H, b);
    $477696120c5741dc$var$G($477696120c5741dc$var$Wf, c);
}
function $477696120c5741dc$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($477696120c5741dc$var$p(108, $477696120c5741dc$var$Ra(a) || "Unknown", e));
    return $477696120c5741dc$var$A({}, c, d);
}
function $477696120c5741dc$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $477696120c5741dc$var$Vf;
    $477696120c5741dc$var$Xf = $477696120c5741dc$var$H.current;
    $477696120c5741dc$var$G($477696120c5741dc$var$H, a);
    $477696120c5741dc$var$G($477696120c5741dc$var$Wf, $477696120c5741dc$var$Wf.current);
    return !0;
}
function $477696120c5741dc$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($477696120c5741dc$var$p(169));
    c ? (a = $477696120c5741dc$var$bg(a, b, $477696120c5741dc$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $477696120c5741dc$var$E($477696120c5741dc$var$Wf), $477696120c5741dc$var$E($477696120c5741dc$var$H), $477696120c5741dc$var$G($477696120c5741dc$var$H, a)) : $477696120c5741dc$var$E($477696120c5741dc$var$Wf);
    $477696120c5741dc$var$G($477696120c5741dc$var$Wf, c);
}
var $477696120c5741dc$var$eg = null, $477696120c5741dc$var$fg = !1, $477696120c5741dc$var$gg = !1;
function $477696120c5741dc$var$hg(a) {
    null === $477696120c5741dc$var$eg ? $477696120c5741dc$var$eg = [
        a
    ] : $477696120c5741dc$var$eg.push(a);
}
function $477696120c5741dc$var$ig(a) {
    $477696120c5741dc$var$fg = !0;
    $477696120c5741dc$var$hg(a);
}
function $477696120c5741dc$var$jg() {
    if (!$477696120c5741dc$var$gg && null !== $477696120c5741dc$var$eg) {
        $477696120c5741dc$var$gg = !0;
        var a = 0, b = $477696120c5741dc$var$C;
        try {
            var c = $477696120c5741dc$var$eg;
            for($477696120c5741dc$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $477696120c5741dc$var$eg = null;
            $477696120c5741dc$var$fg = !1;
        } catch (e) {
            throw null !== $477696120c5741dc$var$eg && ($477696120c5741dc$var$eg = $477696120c5741dc$var$eg.slice(a + 1)), $477696120c5741dc$var$ac($477696120c5741dc$var$fc, $477696120c5741dc$var$jg), e;
        } finally{
            $477696120c5741dc$var$C = b, $477696120c5741dc$var$gg = !1;
        }
    }
    return null;
}
var $477696120c5741dc$var$kg = [], $477696120c5741dc$var$lg = 0, $477696120c5741dc$var$mg = null, $477696120c5741dc$var$ng = 0, $477696120c5741dc$var$og = [], $477696120c5741dc$var$pg = 0, $477696120c5741dc$var$qg = null, $477696120c5741dc$var$rg = 1, $477696120c5741dc$var$sg = "";
function $477696120c5741dc$var$tg(a, b) {
    $477696120c5741dc$var$kg[$477696120c5741dc$var$lg++] = $477696120c5741dc$var$ng;
    $477696120c5741dc$var$kg[$477696120c5741dc$var$lg++] = $477696120c5741dc$var$mg;
    $477696120c5741dc$var$mg = a;
    $477696120c5741dc$var$ng = b;
}
function $477696120c5741dc$var$ug(a, b, c) {
    $477696120c5741dc$var$og[$477696120c5741dc$var$pg++] = $477696120c5741dc$var$rg;
    $477696120c5741dc$var$og[$477696120c5741dc$var$pg++] = $477696120c5741dc$var$sg;
    $477696120c5741dc$var$og[$477696120c5741dc$var$pg++] = $477696120c5741dc$var$qg;
    $477696120c5741dc$var$qg = a;
    var d = $477696120c5741dc$var$rg;
    a = $477696120c5741dc$var$sg;
    var e = 32 - $477696120c5741dc$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $477696120c5741dc$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $477696120c5741dc$var$rg = 1 << 32 - $477696120c5741dc$var$oc(b) + e | c << e | d;
        $477696120c5741dc$var$sg = f + a;
    } else $477696120c5741dc$var$rg = 1 << f | c << e | d, $477696120c5741dc$var$sg = a;
}
function $477696120c5741dc$var$vg(a) {
    null !== a.return && ($477696120c5741dc$var$tg(a, 1), $477696120c5741dc$var$ug(a, 1, 0));
}
function $477696120c5741dc$var$wg(a) {
    for(; a === $477696120c5741dc$var$mg;)$477696120c5741dc$var$mg = $477696120c5741dc$var$kg[--$477696120c5741dc$var$lg], $477696120c5741dc$var$kg[$477696120c5741dc$var$lg] = null, $477696120c5741dc$var$ng = $477696120c5741dc$var$kg[--$477696120c5741dc$var$lg], $477696120c5741dc$var$kg[$477696120c5741dc$var$lg] = null;
    for(; a === $477696120c5741dc$var$qg;)$477696120c5741dc$var$qg = $477696120c5741dc$var$og[--$477696120c5741dc$var$pg], $477696120c5741dc$var$og[$477696120c5741dc$var$pg] = null, $477696120c5741dc$var$sg = $477696120c5741dc$var$og[--$477696120c5741dc$var$pg], $477696120c5741dc$var$og[$477696120c5741dc$var$pg] = null, $477696120c5741dc$var$rg = $477696120c5741dc$var$og[--$477696120c5741dc$var$pg], $477696120c5741dc$var$og[$477696120c5741dc$var$pg] = null;
}
var $477696120c5741dc$var$xg = null, $477696120c5741dc$var$yg = null, $477696120c5741dc$var$I = !1, $477696120c5741dc$var$zg = null;
function $477696120c5741dc$var$Ag(a, b) {
    var c = $477696120c5741dc$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $477696120c5741dc$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $477696120c5741dc$var$xg = a, $477696120c5741dc$var$yg = $477696120c5741dc$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $477696120c5741dc$var$xg = a, $477696120c5741dc$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $477696120c5741dc$var$qg ? {
                id: $477696120c5741dc$var$rg,
                overflow: $477696120c5741dc$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $477696120c5741dc$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $477696120c5741dc$var$xg = a, $477696120c5741dc$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $477696120c5741dc$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $477696120c5741dc$var$Eg(a) {
    if ($477696120c5741dc$var$I) {
        var b = $477696120c5741dc$var$yg;
        if (b) {
            var c = b;
            if (!$477696120c5741dc$var$Cg(a, b)) {
                if ($477696120c5741dc$var$Dg(a)) throw Error($477696120c5741dc$var$p(418));
                b = $477696120c5741dc$var$Lf(c.nextSibling);
                var d = $477696120c5741dc$var$xg;
                b && $477696120c5741dc$var$Cg(a, b) ? $477696120c5741dc$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $477696120c5741dc$var$I = !1, $477696120c5741dc$var$xg = a);
            }
        } else {
            if ($477696120c5741dc$var$Dg(a)) throw Error($477696120c5741dc$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $477696120c5741dc$var$I = !1;
            $477696120c5741dc$var$xg = a;
        }
    }
}
function $477696120c5741dc$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $477696120c5741dc$var$xg = a;
}
function $477696120c5741dc$var$Gg(a) {
    if (a !== $477696120c5741dc$var$xg) return !1;
    if (!$477696120c5741dc$var$I) return $477696120c5741dc$var$Fg(a), $477696120c5741dc$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$477696120c5741dc$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $477696120c5741dc$var$yg)) {
        if ($477696120c5741dc$var$Dg(a)) throw $477696120c5741dc$var$Hg(), Error($477696120c5741dc$var$p(418));
        for(; b;)$477696120c5741dc$var$Ag(a, b), b = $477696120c5741dc$var$Lf(b.nextSibling);
    }
    $477696120c5741dc$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($477696120c5741dc$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $477696120c5741dc$var$yg = $477696120c5741dc$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $477696120c5741dc$var$yg = null;
        }
    } else $477696120c5741dc$var$yg = $477696120c5741dc$var$xg ? $477696120c5741dc$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $477696120c5741dc$var$Hg() {
    for(var a = $477696120c5741dc$var$yg; a;)a = $477696120c5741dc$var$Lf(a.nextSibling);
}
function $477696120c5741dc$var$Ig() {
    $477696120c5741dc$var$yg = $477696120c5741dc$var$xg = null;
    $477696120c5741dc$var$I = !1;
}
function $477696120c5741dc$var$Jg(a) {
    null === $477696120c5741dc$var$zg ? $477696120c5741dc$var$zg = [
        a
    ] : $477696120c5741dc$var$zg.push(a);
}
var $477696120c5741dc$var$Kg = $477696120c5741dc$var$ua.ReactCurrentBatchConfig;
function $477696120c5741dc$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($477696120c5741dc$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($477696120c5741dc$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($477696120c5741dc$var$p(284));
        if (!c._owner) throw Error($477696120c5741dc$var$p(290, a));
    }
    return a;
}
function $477696120c5741dc$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($477696120c5741dc$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $477696120c5741dc$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $477696120c5741dc$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $477696120c5741dc$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $477696120c5741dc$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $477696120c5741dc$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $477696120c5741dc$var$Ha && $477696120c5741dc$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $477696120c5741dc$var$Lg(a, b, c), d.return = a, d;
        d = $477696120c5741dc$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $477696120c5741dc$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $477696120c5741dc$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $477696120c5741dc$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $477696120c5741dc$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $477696120c5741dc$var$va:
                    return c = $477696120c5741dc$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $477696120c5741dc$var$Lg(a, null, b), c.return = a, c;
                case $477696120c5741dc$var$wa:
                    return b = $477696120c5741dc$var$Sg(b, a.mode, c), b.return = a, b;
                case $477696120c5741dc$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($477696120c5741dc$var$eb(b) || $477696120c5741dc$var$Ka(b)) return b = $477696120c5741dc$var$Tg(b, a.mode, c, null), b.return = a, b;
            $477696120c5741dc$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $477696120c5741dc$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $477696120c5741dc$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $477696120c5741dc$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($477696120c5741dc$var$eb(c) || $477696120c5741dc$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $477696120c5741dc$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $477696120c5741dc$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $477696120c5741dc$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $477696120c5741dc$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($477696120c5741dc$var$eb(d) || $477696120c5741dc$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $477696120c5741dc$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $477696120c5741dc$var$I && $477696120c5741dc$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $477696120c5741dc$var$I && $477696120c5741dc$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $477696120c5741dc$var$I && $477696120c5741dc$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $477696120c5741dc$var$Ka(h);
        if ("function" !== typeof l) throw Error($477696120c5741dc$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($477696120c5741dc$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $477696120c5741dc$var$I && $477696120c5741dc$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $477696120c5741dc$var$I && $477696120c5741dc$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $477696120c5741dc$var$I && $477696120c5741dc$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $477696120c5741dc$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $477696120c5741dc$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $477696120c5741dc$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $477696120c5741dc$var$Ha && $477696120c5741dc$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $477696120c5741dc$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $477696120c5741dc$var$ya ? (d = $477696120c5741dc$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $477696120c5741dc$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $477696120c5741dc$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $477696120c5741dc$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $477696120c5741dc$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $477696120c5741dc$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($477696120c5741dc$var$eb(f)) return n(a, d, f, h);
            if ($477696120c5741dc$var$Ka(f)) return t(a, d, f, h);
            $477696120c5741dc$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $477696120c5741dc$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $477696120c5741dc$var$Ug = $477696120c5741dc$var$Og(!0), $477696120c5741dc$var$Vg = $477696120c5741dc$var$Og(!1), $477696120c5741dc$var$Wg = $477696120c5741dc$var$Uf(null), $477696120c5741dc$var$Xg = null, $477696120c5741dc$var$Yg = null, $477696120c5741dc$var$Zg = null;
function $477696120c5741dc$var$$g() {
    $477696120c5741dc$var$Zg = $477696120c5741dc$var$Yg = $477696120c5741dc$var$Xg = null;
}
function $477696120c5741dc$var$ah(a) {
    var b = $477696120c5741dc$var$Wg.current;
    $477696120c5741dc$var$E($477696120c5741dc$var$Wg);
    a._currentValue = b;
}
function $477696120c5741dc$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $477696120c5741dc$var$ch(a, b) {
    $477696120c5741dc$var$Xg = a;
    $477696120c5741dc$var$Zg = $477696120c5741dc$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($477696120c5741dc$var$dh = !0), a.firstContext = null);
}
function $477696120c5741dc$var$eh(a) {
    var b = a._currentValue;
    if ($477696120c5741dc$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $477696120c5741dc$var$Yg) {
            if (null === $477696120c5741dc$var$Xg) throw Error($477696120c5741dc$var$p(308));
            $477696120c5741dc$var$Yg = a;
            $477696120c5741dc$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $477696120c5741dc$var$Yg = $477696120c5741dc$var$Yg.next = a;
    }
    return b;
}
var $477696120c5741dc$var$fh = null;
function $477696120c5741dc$var$gh(a) {
    null === $477696120c5741dc$var$fh ? $477696120c5741dc$var$fh = [
        a
    ] : $477696120c5741dc$var$fh.push(a);
}
function $477696120c5741dc$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $477696120c5741dc$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $477696120c5741dc$var$ih(a, d);
}
function $477696120c5741dc$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $477696120c5741dc$var$jh = !1;
function $477696120c5741dc$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $477696120c5741dc$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $477696120c5741dc$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $477696120c5741dc$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($477696120c5741dc$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $477696120c5741dc$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $477696120c5741dc$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $477696120c5741dc$var$ih(a, c);
}
function $477696120c5741dc$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $477696120c5741dc$var$Cc(a, c);
    }
}
function $477696120c5741dc$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $477696120c5741dc$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $477696120c5741dc$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $477696120c5741dc$var$A({}, q, r);
                            break a;
                        case 2:
                            $477696120c5741dc$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $477696120c5741dc$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $477696120c5741dc$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($477696120c5741dc$var$p(191, e));
            e.call(d);
        }
    }
}
var $477696120c5741dc$var$th = {}, $477696120c5741dc$var$uh = $477696120c5741dc$var$Uf($477696120c5741dc$var$th), $477696120c5741dc$var$vh = $477696120c5741dc$var$Uf($477696120c5741dc$var$th), $477696120c5741dc$var$wh = $477696120c5741dc$var$Uf($477696120c5741dc$var$th);
function $477696120c5741dc$var$xh(a) {
    if (a === $477696120c5741dc$var$th) throw Error($477696120c5741dc$var$p(174));
    return a;
}
function $477696120c5741dc$var$yh(a, b) {
    $477696120c5741dc$var$G($477696120c5741dc$var$wh, b);
    $477696120c5741dc$var$G($477696120c5741dc$var$vh, a);
    $477696120c5741dc$var$G($477696120c5741dc$var$uh, $477696120c5741dc$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $477696120c5741dc$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $477696120c5741dc$var$lb(b, a);
    }
    $477696120c5741dc$var$E($477696120c5741dc$var$uh);
    $477696120c5741dc$var$G($477696120c5741dc$var$uh, b);
}
function $477696120c5741dc$var$zh() {
    $477696120c5741dc$var$E($477696120c5741dc$var$uh);
    $477696120c5741dc$var$E($477696120c5741dc$var$vh);
    $477696120c5741dc$var$E($477696120c5741dc$var$wh);
}
function $477696120c5741dc$var$Ah(a) {
    $477696120c5741dc$var$xh($477696120c5741dc$var$wh.current);
    var b = $477696120c5741dc$var$xh($477696120c5741dc$var$uh.current);
    var c = $477696120c5741dc$var$lb(b, a.type);
    b !== c && ($477696120c5741dc$var$G($477696120c5741dc$var$vh, a), $477696120c5741dc$var$G($477696120c5741dc$var$uh, c));
}
function $477696120c5741dc$var$Bh(a) {
    $477696120c5741dc$var$vh.current === a && ($477696120c5741dc$var$E($477696120c5741dc$var$uh), $477696120c5741dc$var$E($477696120c5741dc$var$vh));
}
var $477696120c5741dc$var$L = $477696120c5741dc$var$Uf(0);
function $477696120c5741dc$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $477696120c5741dc$var$Dh = [];
function $477696120c5741dc$var$Eh() {
    for(var a = 0; a < $477696120c5741dc$var$Dh.length; a++)$477696120c5741dc$var$Dh[a]._workInProgressVersionPrimary = null;
    $477696120c5741dc$var$Dh.length = 0;
}
var $477696120c5741dc$var$Fh = $477696120c5741dc$var$ua.ReactCurrentDispatcher, $477696120c5741dc$var$Gh = $477696120c5741dc$var$ua.ReactCurrentBatchConfig, $477696120c5741dc$var$Hh = 0, $477696120c5741dc$var$M = null, $477696120c5741dc$var$N = null, $477696120c5741dc$var$O = null, $477696120c5741dc$var$Ih = !1, $477696120c5741dc$var$Jh = !1, $477696120c5741dc$var$Kh = 0, $477696120c5741dc$var$Lh = 0;
function $477696120c5741dc$var$P() {
    throw Error($477696120c5741dc$var$p(321));
}
function $477696120c5741dc$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$477696120c5741dc$var$He(a[c], b[c])) return !1;
    return !0;
}
function $477696120c5741dc$var$Nh(a, b, c, d, e, f) {
    $477696120c5741dc$var$Hh = f;
    $477696120c5741dc$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $477696120c5741dc$var$Fh.current = null === a || null === a.memoizedState ? $477696120c5741dc$var$Oh : $477696120c5741dc$var$Ph;
    a = c(d, e);
    if ($477696120c5741dc$var$Jh) {
        f = 0;
        do {
            $477696120c5741dc$var$Jh = !1;
            $477696120c5741dc$var$Kh = 0;
            if (25 <= f) throw Error($477696120c5741dc$var$p(301));
            f += 1;
            $477696120c5741dc$var$O = $477696120c5741dc$var$N = null;
            b.updateQueue = null;
            $477696120c5741dc$var$Fh.current = $477696120c5741dc$var$Qh;
            a = c(d, e);
        }while ($477696120c5741dc$var$Jh);
    }
    $477696120c5741dc$var$Fh.current = $477696120c5741dc$var$Rh;
    b = null !== $477696120c5741dc$var$N && null !== $477696120c5741dc$var$N.next;
    $477696120c5741dc$var$Hh = 0;
    $477696120c5741dc$var$O = $477696120c5741dc$var$N = $477696120c5741dc$var$M = null;
    $477696120c5741dc$var$Ih = !1;
    if (b) throw Error($477696120c5741dc$var$p(300));
    return a;
}
function $477696120c5741dc$var$Sh() {
    var a = 0 !== $477696120c5741dc$var$Kh;
    $477696120c5741dc$var$Kh = 0;
    return a;
}
function $477696120c5741dc$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $477696120c5741dc$var$O ? $477696120c5741dc$var$M.memoizedState = $477696120c5741dc$var$O = a : $477696120c5741dc$var$O = $477696120c5741dc$var$O.next = a;
    return $477696120c5741dc$var$O;
}
function $477696120c5741dc$var$Uh() {
    if (null === $477696120c5741dc$var$N) {
        var a = $477696120c5741dc$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $477696120c5741dc$var$N.next;
    var b = null === $477696120c5741dc$var$O ? $477696120c5741dc$var$M.memoizedState : $477696120c5741dc$var$O.next;
    if (null !== b) $477696120c5741dc$var$O = b, $477696120c5741dc$var$N = a;
    else {
        if (null === a) throw Error($477696120c5741dc$var$p(310));
        $477696120c5741dc$var$N = a;
        a = {
            memoizedState: $477696120c5741dc$var$N.memoizedState,
            baseState: $477696120c5741dc$var$N.baseState,
            baseQueue: $477696120c5741dc$var$N.baseQueue,
            queue: $477696120c5741dc$var$N.queue,
            next: null
        };
        null === $477696120c5741dc$var$O ? $477696120c5741dc$var$M.memoizedState = $477696120c5741dc$var$O = a : $477696120c5741dc$var$O = $477696120c5741dc$var$O.next = a;
    }
    return $477696120c5741dc$var$O;
}
function $477696120c5741dc$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $477696120c5741dc$var$Wh(a) {
    var b = $477696120c5741dc$var$Uh(), c = b.queue;
    if (null === c) throw Error($477696120c5741dc$var$p(311));
    c.lastRenderedReducer = a;
    var d = $477696120c5741dc$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($477696120c5741dc$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $477696120c5741dc$var$M.lanes |= m;
                $477696120c5741dc$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $477696120c5741dc$var$He(d, b.memoizedState) || ($477696120c5741dc$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $477696120c5741dc$var$M.lanes |= f, $477696120c5741dc$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $477696120c5741dc$var$Xh(a) {
    var b = $477696120c5741dc$var$Uh(), c = b.queue;
    if (null === c) throw Error($477696120c5741dc$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $477696120c5741dc$var$He(f, b.memoizedState) || ($477696120c5741dc$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $477696120c5741dc$var$Yh() {}
function $477696120c5741dc$var$Zh(a, b) {
    var c = $477696120c5741dc$var$M, d = $477696120c5741dc$var$Uh(), e = b(), f = !$477696120c5741dc$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $477696120c5741dc$var$dh = !0);
    d = d.queue;
    $477696120c5741dc$var$$h($477696120c5741dc$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $477696120c5741dc$var$O && $477696120c5741dc$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $477696120c5741dc$var$bi(9, $477696120c5741dc$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $477696120c5741dc$var$Q) throw Error($477696120c5741dc$var$p(349));
        0 !== ($477696120c5741dc$var$Hh & 30) || $477696120c5741dc$var$di(c, b, e);
    }
    return e;
}
function $477696120c5741dc$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $477696120c5741dc$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $477696120c5741dc$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $477696120c5741dc$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $477696120c5741dc$var$ei(b) && $477696120c5741dc$var$fi(a);
}
function $477696120c5741dc$var$ai(a, b, c) {
    return c(function() {
        $477696120c5741dc$var$ei(b) && $477696120c5741dc$var$fi(a);
    });
}
function $477696120c5741dc$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$477696120c5741dc$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $477696120c5741dc$var$fi(a) {
    var b = $477696120c5741dc$var$ih(a, 1);
    null !== b && $477696120c5741dc$var$gi(b, a, 1, -1);
}
function $477696120c5741dc$var$hi(a) {
    var b = $477696120c5741dc$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $477696120c5741dc$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $477696120c5741dc$var$ii.bind(null, $477696120c5741dc$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $477696120c5741dc$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $477696120c5741dc$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $477696120c5741dc$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $477696120c5741dc$var$ji() {
    return $477696120c5741dc$var$Uh().memoizedState;
}
function $477696120c5741dc$var$ki(a, b, c, d) {
    var e = $477696120c5741dc$var$Th();
    $477696120c5741dc$var$M.flags |= a;
    e.memoizedState = $477696120c5741dc$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $477696120c5741dc$var$li(a, b, c, d) {
    var e = $477696120c5741dc$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $477696120c5741dc$var$N) {
        var g = $477696120c5741dc$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $477696120c5741dc$var$Mh(d, g.deps)) {
            e.memoizedState = $477696120c5741dc$var$bi(b, c, f, d);
            return;
        }
    }
    $477696120c5741dc$var$M.flags |= a;
    e.memoizedState = $477696120c5741dc$var$bi(1 | b, c, f, d);
}
function $477696120c5741dc$var$mi(a, b) {
    return $477696120c5741dc$var$ki(8390656, 8, a, b);
}
function $477696120c5741dc$var$$h(a, b) {
    return $477696120c5741dc$var$li(2048, 8, a, b);
}
function $477696120c5741dc$var$ni(a, b) {
    return $477696120c5741dc$var$li(4, 2, a, b);
}
function $477696120c5741dc$var$oi(a, b) {
    return $477696120c5741dc$var$li(4, 4, a, b);
}
function $477696120c5741dc$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $477696120c5741dc$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $477696120c5741dc$var$li(4, 4, $477696120c5741dc$var$pi.bind(null, b, a), c);
}
function $477696120c5741dc$var$ri() {}
function $477696120c5741dc$var$si(a, b) {
    var c = $477696120c5741dc$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $477696120c5741dc$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $477696120c5741dc$var$ti(a, b) {
    var c = $477696120c5741dc$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $477696120c5741dc$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $477696120c5741dc$var$ui(a, b, c) {
    if (0 === ($477696120c5741dc$var$Hh & 21)) return a.baseState && (a.baseState = !1, $477696120c5741dc$var$dh = !0), a.memoizedState = c;
    $477696120c5741dc$var$He(c, b) || (c = $477696120c5741dc$var$yc(), $477696120c5741dc$var$M.lanes |= c, $477696120c5741dc$var$rh |= c, a.baseState = !0);
    return b;
}
function $477696120c5741dc$var$vi(a, b) {
    var c = $477696120c5741dc$var$C;
    $477696120c5741dc$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $477696120c5741dc$var$Gh.transition;
    $477696120c5741dc$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $477696120c5741dc$var$C = c, $477696120c5741dc$var$Gh.transition = d;
    }
}
function $477696120c5741dc$var$wi() {
    return $477696120c5741dc$var$Uh().memoizedState;
}
function $477696120c5741dc$var$xi(a, b, c) {
    var d = $477696120c5741dc$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($477696120c5741dc$var$zi(a)) $477696120c5741dc$var$Ai(b, c);
    else if (c = $477696120c5741dc$var$hh(a, b, c, d), null !== c) {
        var e = $477696120c5741dc$var$R();
        $477696120c5741dc$var$gi(c, a, d, e);
        $477696120c5741dc$var$Bi(c, b, d);
    }
}
function $477696120c5741dc$var$ii(a, b, c) {
    var d = $477696120c5741dc$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($477696120c5741dc$var$zi(a)) $477696120c5741dc$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($477696120c5741dc$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $477696120c5741dc$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $477696120c5741dc$var$hh(a, b, e, d);
        null !== c && (e = $477696120c5741dc$var$R(), $477696120c5741dc$var$gi(c, a, d, e), $477696120c5741dc$var$Bi(c, b, d));
    }
}
function $477696120c5741dc$var$zi(a) {
    var b = a.alternate;
    return a === $477696120c5741dc$var$M || null !== b && b === $477696120c5741dc$var$M;
}
function $477696120c5741dc$var$Ai(a, b) {
    $477696120c5741dc$var$Jh = $477696120c5741dc$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $477696120c5741dc$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $477696120c5741dc$var$Cc(a, c);
    }
}
var $477696120c5741dc$var$Rh = {
    readContext: $477696120c5741dc$var$eh,
    useCallback: $477696120c5741dc$var$P,
    useContext: $477696120c5741dc$var$P,
    useEffect: $477696120c5741dc$var$P,
    useImperativeHandle: $477696120c5741dc$var$P,
    useInsertionEffect: $477696120c5741dc$var$P,
    useLayoutEffect: $477696120c5741dc$var$P,
    useMemo: $477696120c5741dc$var$P,
    useReducer: $477696120c5741dc$var$P,
    useRef: $477696120c5741dc$var$P,
    useState: $477696120c5741dc$var$P,
    useDebugValue: $477696120c5741dc$var$P,
    useDeferredValue: $477696120c5741dc$var$P,
    useTransition: $477696120c5741dc$var$P,
    useMutableSource: $477696120c5741dc$var$P,
    useSyncExternalStore: $477696120c5741dc$var$P,
    useId: $477696120c5741dc$var$P,
    unstable_isNewReconciler: !1
}, $477696120c5741dc$var$Oh = {
    readContext: $477696120c5741dc$var$eh,
    useCallback: function(a, b) {
        $477696120c5741dc$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $477696120c5741dc$var$eh,
    useEffect: $477696120c5741dc$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $477696120c5741dc$var$ki(4194308, 4, $477696120c5741dc$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $477696120c5741dc$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $477696120c5741dc$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $477696120c5741dc$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $477696120c5741dc$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $477696120c5741dc$var$xi.bind(null, $477696120c5741dc$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $477696120c5741dc$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $477696120c5741dc$var$hi,
    useDebugValue: $477696120c5741dc$var$ri,
    useDeferredValue: function(a) {
        return $477696120c5741dc$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $477696120c5741dc$var$hi(!1), b = a[0];
        a = $477696120c5741dc$var$vi.bind(null, a[1]);
        $477696120c5741dc$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $477696120c5741dc$var$M, e = $477696120c5741dc$var$Th();
        if ($477696120c5741dc$var$I) {
            if (void 0 === c) throw Error($477696120c5741dc$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $477696120c5741dc$var$Q) throw Error($477696120c5741dc$var$p(349));
            0 !== ($477696120c5741dc$var$Hh & 30) || $477696120c5741dc$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $477696120c5741dc$var$mi($477696120c5741dc$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $477696120c5741dc$var$bi(9, $477696120c5741dc$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $477696120c5741dc$var$Th(), b = $477696120c5741dc$var$Q.identifierPrefix;
        if ($477696120c5741dc$var$I) {
            var c = $477696120c5741dc$var$sg;
            var d = $477696120c5741dc$var$rg;
            c = (d & ~(1 << 32 - $477696120c5741dc$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $477696120c5741dc$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $477696120c5741dc$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $477696120c5741dc$var$Ph = {
    readContext: $477696120c5741dc$var$eh,
    useCallback: $477696120c5741dc$var$si,
    useContext: $477696120c5741dc$var$eh,
    useEffect: $477696120c5741dc$var$$h,
    useImperativeHandle: $477696120c5741dc$var$qi,
    useInsertionEffect: $477696120c5741dc$var$ni,
    useLayoutEffect: $477696120c5741dc$var$oi,
    useMemo: $477696120c5741dc$var$ti,
    useReducer: $477696120c5741dc$var$Wh,
    useRef: $477696120c5741dc$var$ji,
    useState: function() {
        return $477696120c5741dc$var$Wh($477696120c5741dc$var$Vh);
    },
    useDebugValue: $477696120c5741dc$var$ri,
    useDeferredValue: function(a) {
        var b = $477696120c5741dc$var$Uh();
        return $477696120c5741dc$var$ui(b, $477696120c5741dc$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $477696120c5741dc$var$Wh($477696120c5741dc$var$Vh)[0], b = $477696120c5741dc$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $477696120c5741dc$var$Yh,
    useSyncExternalStore: $477696120c5741dc$var$Zh,
    useId: $477696120c5741dc$var$wi,
    unstable_isNewReconciler: !1
}, $477696120c5741dc$var$Qh = {
    readContext: $477696120c5741dc$var$eh,
    useCallback: $477696120c5741dc$var$si,
    useContext: $477696120c5741dc$var$eh,
    useEffect: $477696120c5741dc$var$$h,
    useImperativeHandle: $477696120c5741dc$var$qi,
    useInsertionEffect: $477696120c5741dc$var$ni,
    useLayoutEffect: $477696120c5741dc$var$oi,
    useMemo: $477696120c5741dc$var$ti,
    useReducer: $477696120c5741dc$var$Xh,
    useRef: $477696120c5741dc$var$ji,
    useState: function() {
        return $477696120c5741dc$var$Xh($477696120c5741dc$var$Vh);
    },
    useDebugValue: $477696120c5741dc$var$ri,
    useDeferredValue: function(a) {
        var b = $477696120c5741dc$var$Uh();
        return null === $477696120c5741dc$var$N ? b.memoizedState = a : $477696120c5741dc$var$ui(b, $477696120c5741dc$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $477696120c5741dc$var$Xh($477696120c5741dc$var$Vh)[0], b = $477696120c5741dc$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $477696120c5741dc$var$Yh,
    useSyncExternalStore: $477696120c5741dc$var$Zh,
    useId: $477696120c5741dc$var$wi,
    unstable_isNewReconciler: !1
};
function $477696120c5741dc$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $477696120c5741dc$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $477696120c5741dc$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $477696120c5741dc$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $477696120c5741dc$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $477696120c5741dc$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $477696120c5741dc$var$R(), e = $477696120c5741dc$var$yi(a), f = $477696120c5741dc$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $477696120c5741dc$var$nh(a, f, e);
        null !== b && ($477696120c5741dc$var$gi(b, a, e, d), $477696120c5741dc$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $477696120c5741dc$var$R(), e = $477696120c5741dc$var$yi(a), f = $477696120c5741dc$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $477696120c5741dc$var$nh(a, f, e);
        null !== b && ($477696120c5741dc$var$gi(b, a, e, d), $477696120c5741dc$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $477696120c5741dc$var$R(), d = $477696120c5741dc$var$yi(a), e = $477696120c5741dc$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $477696120c5741dc$var$nh(a, e, d);
        null !== b && ($477696120c5741dc$var$gi(b, a, d, c), $477696120c5741dc$var$oh(b, a, d));
    }
};
function $477696120c5741dc$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$477696120c5741dc$var$Ie(c, d) || !$477696120c5741dc$var$Ie(e, f) : !0;
}
function $477696120c5741dc$var$Gi(a, b, c) {
    var d = !1, e = $477696120c5741dc$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $477696120c5741dc$var$eh(f) : (e = $477696120c5741dc$var$Zf(b) ? $477696120c5741dc$var$Xf : $477696120c5741dc$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $477696120c5741dc$var$Yf(a, e) : $477696120c5741dc$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $477696120c5741dc$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $477696120c5741dc$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $477696120c5741dc$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $477696120c5741dc$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $477696120c5741dc$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $477696120c5741dc$var$eh(f) : (f = $477696120c5741dc$var$Zf(b) ? $477696120c5741dc$var$Xf : $477696120c5741dc$var$H.current, e.context = $477696120c5741dc$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($477696120c5741dc$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $477696120c5741dc$var$Ei.enqueueReplaceState(e, e.state, null), $477696120c5741dc$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $477696120c5741dc$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $477696120c5741dc$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $477696120c5741dc$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $477696120c5741dc$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $477696120c5741dc$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $477696120c5741dc$var$Ni(a, b, c) {
    c = $477696120c5741dc$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $477696120c5741dc$var$Oi || ($477696120c5741dc$var$Oi = !0, $477696120c5741dc$var$Pi = d);
        $477696120c5741dc$var$Li(a, b);
    };
    return c;
}
function $477696120c5741dc$var$Qi(a, b, c) {
    c = $477696120c5741dc$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $477696120c5741dc$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $477696120c5741dc$var$Li(a, b);
        "function" !== typeof d && (null === $477696120c5741dc$var$Ri ? $477696120c5741dc$var$Ri = new Set([
            this
        ]) : $477696120c5741dc$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $477696120c5741dc$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $477696120c5741dc$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $477696120c5741dc$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $477696120c5741dc$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $477696120c5741dc$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $477696120c5741dc$var$mh(-1, 1), b.tag = 2, $477696120c5741dc$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $477696120c5741dc$var$Wi = $477696120c5741dc$var$ua.ReactCurrentOwner, $477696120c5741dc$var$dh = !1;
function $477696120c5741dc$var$Xi(a, b, c, d) {
    b.child = null === a ? $477696120c5741dc$var$Vg(b, null, c, d) : $477696120c5741dc$var$Ug(b, a.child, c, d);
}
function $477696120c5741dc$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $477696120c5741dc$var$ch(b, e);
    d = $477696120c5741dc$var$Nh(a, b, c, d, f, e);
    c = $477696120c5741dc$var$Sh();
    if (null !== a && !$477696120c5741dc$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $477696120c5741dc$var$Zi(a, b, e);
    $477696120c5741dc$var$I && c && $477696120c5741dc$var$vg(b);
    b.flags |= 1;
    $477696120c5741dc$var$Xi(a, b, d, e);
    return b.child;
}
function $477696120c5741dc$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$477696120c5741dc$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $477696120c5741dc$var$bj(a, b, f, d, e);
        a = $477696120c5741dc$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $477696120c5741dc$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $477696120c5741dc$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $477696120c5741dc$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $477696120c5741dc$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($477696120c5741dc$var$Ie(f, d) && a.ref === b.ref) {
            if ($477696120c5741dc$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($477696120c5741dc$var$dh = !0);
            else return b.lanes = a.lanes, $477696120c5741dc$var$Zi(a, b, e);
        }
    }
    return $477696120c5741dc$var$cj(a, b, c, d, e);
}
function $477696120c5741dc$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $477696120c5741dc$var$G($477696120c5741dc$var$ej, $477696120c5741dc$var$fj), $477696120c5741dc$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $477696120c5741dc$var$G($477696120c5741dc$var$ej, $477696120c5741dc$var$fj), $477696120c5741dc$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $477696120c5741dc$var$G($477696120c5741dc$var$ej, $477696120c5741dc$var$fj);
            $477696120c5741dc$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $477696120c5741dc$var$G($477696120c5741dc$var$ej, $477696120c5741dc$var$fj), $477696120c5741dc$var$fj |= d;
    $477696120c5741dc$var$Xi(a, b, e, c);
    return b.child;
}
function $477696120c5741dc$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $477696120c5741dc$var$cj(a, b, c, d, e) {
    var f = $477696120c5741dc$var$Zf(c) ? $477696120c5741dc$var$Xf : $477696120c5741dc$var$H.current;
    f = $477696120c5741dc$var$Yf(b, f);
    $477696120c5741dc$var$ch(b, e);
    c = $477696120c5741dc$var$Nh(a, b, c, d, f, e);
    d = $477696120c5741dc$var$Sh();
    if (null !== a && !$477696120c5741dc$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $477696120c5741dc$var$Zi(a, b, e);
    $477696120c5741dc$var$I && d && $477696120c5741dc$var$vg(b);
    b.flags |= 1;
    $477696120c5741dc$var$Xi(a, b, c, e);
    return b.child;
}
function $477696120c5741dc$var$hj(a, b, c, d, e) {
    if ($477696120c5741dc$var$Zf(c)) {
        var f = !0;
        $477696120c5741dc$var$cg(b);
    } else f = !1;
    $477696120c5741dc$var$ch(b, e);
    if (null === b.stateNode) $477696120c5741dc$var$ij(a, b), $477696120c5741dc$var$Gi(b, c, d), $477696120c5741dc$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $477696120c5741dc$var$eh(l) : (l = $477696120c5741dc$var$Zf(c) ? $477696120c5741dc$var$Xf : $477696120c5741dc$var$H.current, l = $477696120c5741dc$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $477696120c5741dc$var$Hi(b, g, d, l);
        $477696120c5741dc$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $477696120c5741dc$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $477696120c5741dc$var$Wf.current || $477696120c5741dc$var$jh ? ("function" === typeof m && ($477696120c5741dc$var$Di(b, c, m, d), k = b.memoizedState), (h = $477696120c5741dc$var$jh || $477696120c5741dc$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $477696120c5741dc$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $477696120c5741dc$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $477696120c5741dc$var$eh(k) : (k = $477696120c5741dc$var$Zf(c) ? $477696120c5741dc$var$Xf : $477696120c5741dc$var$H.current, k = $477696120c5741dc$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $477696120c5741dc$var$Hi(b, g, d, k);
        $477696120c5741dc$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $477696120c5741dc$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $477696120c5741dc$var$Wf.current || $477696120c5741dc$var$jh ? ("function" === typeof y && ($477696120c5741dc$var$Di(b, c, y, d), n = b.memoizedState), (l = $477696120c5741dc$var$jh || $477696120c5741dc$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $477696120c5741dc$var$jj(a, b, c, d, f, e);
}
function $477696120c5741dc$var$jj(a, b, c, d, e, f) {
    $477696120c5741dc$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $477696120c5741dc$var$dg(b, c, !1), $477696120c5741dc$var$Zi(a, b, f);
    d = b.stateNode;
    $477696120c5741dc$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $477696120c5741dc$var$Ug(b, a.child, null, f), b.child = $477696120c5741dc$var$Ug(b, null, h, f)) : $477696120c5741dc$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $477696120c5741dc$var$dg(b, c, !0);
    return b.child;
}
function $477696120c5741dc$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $477696120c5741dc$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $477696120c5741dc$var$ag(a, b.context, !1);
    $477696120c5741dc$var$yh(a, b.containerInfo);
}
function $477696120c5741dc$var$lj(a, b, c, d, e) {
    $477696120c5741dc$var$Ig();
    $477696120c5741dc$var$Jg(e);
    b.flags |= 256;
    $477696120c5741dc$var$Xi(a, b, c, d);
    return b.child;
}
var $477696120c5741dc$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $477696120c5741dc$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $477696120c5741dc$var$oj(a, b, c) {
    var d = b.pendingProps, e = $477696120c5741dc$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $477696120c5741dc$var$G($477696120c5741dc$var$L, e & 1);
    if (null === a) {
        $477696120c5741dc$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $477696120c5741dc$var$pj(g, d, 0, null), a = $477696120c5741dc$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $477696120c5741dc$var$nj(c), b.memoizedState = $477696120c5741dc$var$mj, a) : $477696120c5741dc$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $477696120c5741dc$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $477696120c5741dc$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $477696120c5741dc$var$Pg(h, f) : (f = $477696120c5741dc$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $477696120c5741dc$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $477696120c5741dc$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $477696120c5741dc$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $477696120c5741dc$var$qj(a, b) {
    b = $477696120c5741dc$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $477696120c5741dc$var$sj(a, b, c, d) {
    null !== d && $477696120c5741dc$var$Jg(d);
    $477696120c5741dc$var$Ug(b, a.child, null, c);
    a = $477696120c5741dc$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $477696120c5741dc$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $477696120c5741dc$var$Ki(Error($477696120c5741dc$var$p(422))), $477696120c5741dc$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $477696120c5741dc$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $477696120c5741dc$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $477696120c5741dc$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $477696120c5741dc$var$nj(g);
        b.memoizedState = $477696120c5741dc$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $477696120c5741dc$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($477696120c5741dc$var$p(419));
        d = $477696120c5741dc$var$Ki(f, d, void 0);
        return $477696120c5741dc$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($477696120c5741dc$var$dh || h) {
        d = $477696120c5741dc$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $477696120c5741dc$var$ih(a, e), $477696120c5741dc$var$gi(d, a, e, -1));
        }
        $477696120c5741dc$var$tj();
        d = $477696120c5741dc$var$Ki(Error($477696120c5741dc$var$p(421)));
        return $477696120c5741dc$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $477696120c5741dc$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $477696120c5741dc$var$yg = $477696120c5741dc$var$Lf(e.nextSibling);
    $477696120c5741dc$var$xg = b;
    $477696120c5741dc$var$I = !0;
    $477696120c5741dc$var$zg = null;
    null !== a && ($477696120c5741dc$var$og[$477696120c5741dc$var$pg++] = $477696120c5741dc$var$rg, $477696120c5741dc$var$og[$477696120c5741dc$var$pg++] = $477696120c5741dc$var$sg, $477696120c5741dc$var$og[$477696120c5741dc$var$pg++] = $477696120c5741dc$var$qg, $477696120c5741dc$var$rg = a.id, $477696120c5741dc$var$sg = a.overflow, $477696120c5741dc$var$qg = b);
    b = $477696120c5741dc$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $477696120c5741dc$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $477696120c5741dc$var$bh(a.return, b, c);
}
function $477696120c5741dc$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $477696120c5741dc$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $477696120c5741dc$var$Xi(a, b, d.children, c);
    d = $477696120c5741dc$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $477696120c5741dc$var$vj(a, c, b);
            else if (19 === a.tag) $477696120c5741dc$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $477696120c5741dc$var$G($477696120c5741dc$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $477696120c5741dc$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $477696120c5741dc$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $477696120c5741dc$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $477696120c5741dc$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $477696120c5741dc$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $477696120c5741dc$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $477696120c5741dc$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $477696120c5741dc$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($477696120c5741dc$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $477696120c5741dc$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $477696120c5741dc$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $477696120c5741dc$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $477696120c5741dc$var$kj(b);
            $477696120c5741dc$var$Ig();
            break;
        case 5:
            $477696120c5741dc$var$Ah(b);
            break;
        case 1:
            $477696120c5741dc$var$Zf(b.type) && $477696120c5741dc$var$cg(b);
            break;
        case 4:
            $477696120c5741dc$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $477696120c5741dc$var$G($477696120c5741dc$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $477696120c5741dc$var$G($477696120c5741dc$var$L, $477696120c5741dc$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $477696120c5741dc$var$oj(a, b, c);
                $477696120c5741dc$var$G($477696120c5741dc$var$L, $477696120c5741dc$var$L.current & 1);
                a = $477696120c5741dc$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $477696120c5741dc$var$G($477696120c5741dc$var$L, $477696120c5741dc$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $477696120c5741dc$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $477696120c5741dc$var$G($477696120c5741dc$var$L, $477696120c5741dc$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $477696120c5741dc$var$dj(a, b, c);
    }
    return $477696120c5741dc$var$Zi(a, b, c);
}
var $477696120c5741dc$var$zj, $477696120c5741dc$var$Aj, $477696120c5741dc$var$Bj, $477696120c5741dc$var$Cj;
$477696120c5741dc$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$477696120c5741dc$var$Aj = function() {};
$477696120c5741dc$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $477696120c5741dc$var$xh($477696120c5741dc$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $477696120c5741dc$var$Ya(a, e);
                d = $477696120c5741dc$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $477696120c5741dc$var$A({}, e, {
                    value: void 0
                });
                d = $477696120c5741dc$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $477696120c5741dc$var$gb(a, e);
                d = $477696120c5741dc$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $477696120c5741dc$var$Bf);
        }
        $477696120c5741dc$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($477696120c5741dc$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($477696120c5741dc$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $477696120c5741dc$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$477696120c5741dc$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $477696120c5741dc$var$Dj(a, b) {
    if (!$477696120c5741dc$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $477696120c5741dc$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $477696120c5741dc$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $477696120c5741dc$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $477696120c5741dc$var$S(b), null;
        case 1:
            return $477696120c5741dc$var$Zf(b.type) && $477696120c5741dc$var$$f(), $477696120c5741dc$var$S(b), null;
        case 3:
            d = b.stateNode;
            $477696120c5741dc$var$zh();
            $477696120c5741dc$var$E($477696120c5741dc$var$Wf);
            $477696120c5741dc$var$E($477696120c5741dc$var$H);
            $477696120c5741dc$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $477696120c5741dc$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $477696120c5741dc$var$zg && ($477696120c5741dc$var$Fj($477696120c5741dc$var$zg), $477696120c5741dc$var$zg = null));
            $477696120c5741dc$var$Aj(a, b);
            $477696120c5741dc$var$S(b);
            return null;
        case 5:
            $477696120c5741dc$var$Bh(b);
            var e = $477696120c5741dc$var$xh($477696120c5741dc$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $477696120c5741dc$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($477696120c5741dc$var$p(166));
                    $477696120c5741dc$var$S(b);
                    return null;
                }
                a = $477696120c5741dc$var$xh($477696120c5741dc$var$uh.current);
                if ($477696120c5741dc$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$477696120c5741dc$var$Of] = b;
                    d[$477696120c5741dc$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $477696120c5741dc$var$D("cancel", d);
                            $477696120c5741dc$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $477696120c5741dc$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $477696120c5741dc$var$lf.length; e++)$477696120c5741dc$var$D($477696120c5741dc$var$lf[e], d);
                            break;
                        case "source":
                            $477696120c5741dc$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $477696120c5741dc$var$D("error", d);
                            $477696120c5741dc$var$D("load", d);
                            break;
                        case "details":
                            $477696120c5741dc$var$D("toggle", d);
                            break;
                        case "input":
                            $477696120c5741dc$var$Za(d, f);
                            $477696120c5741dc$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $477696120c5741dc$var$D("invalid", d);
                            break;
                        case "textarea":
                            $477696120c5741dc$var$hb(d, f), $477696120c5741dc$var$D("invalid", d);
                    }
                    $477696120c5741dc$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $477696120c5741dc$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $477696120c5741dc$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $477696120c5741dc$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $477696120c5741dc$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $477696120c5741dc$var$Va(d);
                            $477696120c5741dc$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $477696120c5741dc$var$Va(d);
                            $477696120c5741dc$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $477696120c5741dc$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $477696120c5741dc$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$477696120c5741dc$var$Of] = b;
                    a[$477696120c5741dc$var$Pf] = d;
                    $477696120c5741dc$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $477696120c5741dc$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $477696120c5741dc$var$D("cancel", a);
                                $477696120c5741dc$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $477696120c5741dc$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $477696120c5741dc$var$lf.length; e++)$477696120c5741dc$var$D($477696120c5741dc$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $477696120c5741dc$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $477696120c5741dc$var$D("error", a);
                                $477696120c5741dc$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $477696120c5741dc$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $477696120c5741dc$var$Za(a, d);
                                e = $477696120c5741dc$var$Ya(a, d);
                                $477696120c5741dc$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $477696120c5741dc$var$A({}, d, {
                                    value: void 0
                                });
                                $477696120c5741dc$var$D("invalid", a);
                                break;
                            case "textarea":
                                $477696120c5741dc$var$hb(a, d);
                                e = $477696120c5741dc$var$gb(a, d);
                                $477696120c5741dc$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $477696120c5741dc$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $477696120c5741dc$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $477696120c5741dc$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $477696120c5741dc$var$ob(a, k) : "number" === typeof k && $477696120c5741dc$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($477696120c5741dc$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $477696120c5741dc$var$D("scroll", a) : null != k && $477696120c5741dc$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $477696120c5741dc$var$Va(a);
                                $477696120c5741dc$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $477696120c5741dc$var$Va(a);
                                $477696120c5741dc$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $477696120c5741dc$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $477696120c5741dc$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $477696120c5741dc$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $477696120c5741dc$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $477696120c5741dc$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $477696120c5741dc$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($477696120c5741dc$var$p(166));
                c = $477696120c5741dc$var$xh($477696120c5741dc$var$wh.current);
                $477696120c5741dc$var$xh($477696120c5741dc$var$uh.current);
                if ($477696120c5741dc$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$477696120c5741dc$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $477696120c5741dc$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $477696120c5741dc$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $477696120c5741dc$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$477696120c5741dc$var$Of] = b, b.stateNode = d;
            }
            $477696120c5741dc$var$S(b);
            return null;
        case 13:
            $477696120c5741dc$var$E($477696120c5741dc$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($477696120c5741dc$var$I && null !== $477696120c5741dc$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $477696120c5741dc$var$Hg(), $477696120c5741dc$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $477696120c5741dc$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($477696120c5741dc$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($477696120c5741dc$var$p(317));
                        f[$477696120c5741dc$var$Of] = b;
                    } else $477696120c5741dc$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $477696120c5741dc$var$S(b);
                    f = !1;
                } else null !== $477696120c5741dc$var$zg && ($477696120c5741dc$var$Fj($477696120c5741dc$var$zg), $477696120c5741dc$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($477696120c5741dc$var$L.current & 1) ? 0 === $477696120c5741dc$var$T && ($477696120c5741dc$var$T = 3) : $477696120c5741dc$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $477696120c5741dc$var$S(b);
            return null;
        case 4:
            return $477696120c5741dc$var$zh(), $477696120c5741dc$var$Aj(a, b), null === a && $477696120c5741dc$var$sf(b.stateNode.containerInfo), $477696120c5741dc$var$S(b), null;
        case 10:
            return $477696120c5741dc$var$ah(b.type._context), $477696120c5741dc$var$S(b), null;
        case 17:
            return $477696120c5741dc$var$Zf(b.type) && $477696120c5741dc$var$$f(), $477696120c5741dc$var$S(b), null;
        case 19:
            $477696120c5741dc$var$E($477696120c5741dc$var$L);
            f = b.memoizedState;
            if (null === f) return $477696120c5741dc$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $477696120c5741dc$var$Dj(f, !1);
                else {
                    if (0 !== $477696120c5741dc$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $477696120c5741dc$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $477696120c5741dc$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $477696120c5741dc$var$G($477696120c5741dc$var$L, $477696120c5741dc$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $477696120c5741dc$var$B() > $477696120c5741dc$var$Gj && (b.flags |= 128, d = !0, $477696120c5741dc$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $477696120c5741dc$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $477696120c5741dc$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$477696120c5741dc$var$I) return $477696120c5741dc$var$S(b), null;
                    } else 2 * $477696120c5741dc$var$B() - f.renderingStartTime > $477696120c5741dc$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $477696120c5741dc$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $477696120c5741dc$var$B(), b.sibling = null, c = $477696120c5741dc$var$L.current, $477696120c5741dc$var$G($477696120c5741dc$var$L, d ? c & 1 | 2 : c & 1), b;
            $477696120c5741dc$var$S(b);
            return null;
        case 22:
        case 23:
            return $477696120c5741dc$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($477696120c5741dc$var$fj & 1073741824) && ($477696120c5741dc$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $477696120c5741dc$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($477696120c5741dc$var$p(156, b.tag));
}
function $477696120c5741dc$var$Ij(a, b) {
    $477696120c5741dc$var$wg(b);
    switch(b.tag){
        case 1:
            return $477696120c5741dc$var$Zf(b.type) && $477696120c5741dc$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $477696120c5741dc$var$zh(), $477696120c5741dc$var$E($477696120c5741dc$var$Wf), $477696120c5741dc$var$E($477696120c5741dc$var$H), $477696120c5741dc$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $477696120c5741dc$var$Bh(b), null;
        case 13:
            $477696120c5741dc$var$E($477696120c5741dc$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($477696120c5741dc$var$p(340));
                $477696120c5741dc$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $477696120c5741dc$var$E($477696120c5741dc$var$L), null;
        case 4:
            return $477696120c5741dc$var$zh(), null;
        case 10:
            return $477696120c5741dc$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $477696120c5741dc$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $477696120c5741dc$var$Jj = !1, $477696120c5741dc$var$U = !1, $477696120c5741dc$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $477696120c5741dc$var$V = null;
function $477696120c5741dc$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $477696120c5741dc$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $477696120c5741dc$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $477696120c5741dc$var$W(a, b, d);
    }
}
var $477696120c5741dc$var$Nj = !1;
function $477696120c5741dc$var$Oj(a, b) {
    $477696120c5741dc$var$Cf = $477696120c5741dc$var$dd;
    a = $477696120c5741dc$var$Me();
    if ($477696120c5741dc$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $477696120c5741dc$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $477696120c5741dc$var$dd = !1;
    for($477696120c5741dc$var$V = b; null !== $477696120c5741dc$var$V;)if (b = $477696120c5741dc$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $477696120c5741dc$var$V = a;
    else for(; null !== $477696120c5741dc$var$V;){
        b = $477696120c5741dc$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $477696120c5741dc$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($477696120c5741dc$var$p(163));
            }
        } catch (F) {
            $477696120c5741dc$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $477696120c5741dc$var$V = a;
            break;
        }
        $477696120c5741dc$var$V = b.return;
    }
    n = $477696120c5741dc$var$Nj;
    $477696120c5741dc$var$Nj = !1;
    return n;
}
function $477696120c5741dc$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $477696120c5741dc$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $477696120c5741dc$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $477696120c5741dc$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $477696120c5741dc$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $477696120c5741dc$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$477696120c5741dc$var$Of], delete b[$477696120c5741dc$var$Pf], delete b[$477696120c5741dc$var$of], delete b[$477696120c5741dc$var$Qf], delete b[$477696120c5741dc$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $477696120c5741dc$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $477696120c5741dc$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $477696120c5741dc$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $477696120c5741dc$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $477696120c5741dc$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($477696120c5741dc$var$Vj(a, b, c), a = a.sibling; null !== a;)$477696120c5741dc$var$Vj(a, b, c), a = a.sibling;
}
function $477696120c5741dc$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($477696120c5741dc$var$Wj(a, b, c), a = a.sibling; null !== a;)$477696120c5741dc$var$Wj(a, b, c), a = a.sibling;
}
var $477696120c5741dc$var$X = null, $477696120c5741dc$var$Xj = !1;
function $477696120c5741dc$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$477696120c5741dc$var$Zj(a, b, c), c = c.sibling;
}
function $477696120c5741dc$var$Zj(a, b, c) {
    if ($477696120c5741dc$var$lc && "function" === typeof $477696120c5741dc$var$lc.onCommitFiberUnmount) try {
        $477696120c5741dc$var$lc.onCommitFiberUnmount($477696120c5741dc$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $477696120c5741dc$var$U || $477696120c5741dc$var$Lj(c, b);
        case 6:
            var d = $477696120c5741dc$var$X, e = $477696120c5741dc$var$Xj;
            $477696120c5741dc$var$X = null;
            $477696120c5741dc$var$Yj(a, b, c);
            $477696120c5741dc$var$X = d;
            $477696120c5741dc$var$Xj = e;
            null !== $477696120c5741dc$var$X && ($477696120c5741dc$var$Xj ? (a = $477696120c5741dc$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $477696120c5741dc$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $477696120c5741dc$var$X && ($477696120c5741dc$var$Xj ? (a = $477696120c5741dc$var$X, c = c.stateNode, 8 === a.nodeType ? $477696120c5741dc$var$Kf(a.parentNode, c) : 1 === a.nodeType && $477696120c5741dc$var$Kf(a, c), $477696120c5741dc$var$bd(a)) : $477696120c5741dc$var$Kf($477696120c5741dc$var$X, c.stateNode));
            break;
        case 4:
            d = $477696120c5741dc$var$X;
            e = $477696120c5741dc$var$Xj;
            $477696120c5741dc$var$X = c.stateNode.containerInfo;
            $477696120c5741dc$var$Xj = !0;
            $477696120c5741dc$var$Yj(a, b, c);
            $477696120c5741dc$var$X = d;
            $477696120c5741dc$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$477696120c5741dc$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $477696120c5741dc$var$Mj(c, b, g) : 0 !== (f & 4) && $477696120c5741dc$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $477696120c5741dc$var$Yj(a, b, c);
            break;
        case 1:
            if (!$477696120c5741dc$var$U && ($477696120c5741dc$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $477696120c5741dc$var$W(c, b, h);
            }
            $477696120c5741dc$var$Yj(a, b, c);
            break;
        case 21:
            $477696120c5741dc$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($477696120c5741dc$var$U = (d = $477696120c5741dc$var$U) || null !== c.memoizedState, $477696120c5741dc$var$Yj(a, b, c), $477696120c5741dc$var$U = d) : $477696120c5741dc$var$Yj(a, b, c);
            break;
        default:
            $477696120c5741dc$var$Yj(a, b, c);
    }
}
function $477696120c5741dc$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $477696120c5741dc$var$Kj);
        b.forEach(function(b) {
            var d = $477696120c5741dc$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $477696120c5741dc$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $477696120c5741dc$var$X = h.stateNode;
                        $477696120c5741dc$var$Xj = !1;
                        break a;
                    case 3:
                        $477696120c5741dc$var$X = h.stateNode.containerInfo;
                        $477696120c5741dc$var$Xj = !0;
                        break a;
                    case 4:
                        $477696120c5741dc$var$X = h.stateNode.containerInfo;
                        $477696120c5741dc$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $477696120c5741dc$var$X) throw Error($477696120c5741dc$var$p(160));
            $477696120c5741dc$var$Zj(f, g, e);
            $477696120c5741dc$var$X = null;
            $477696120c5741dc$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $477696120c5741dc$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$477696120c5741dc$var$dk(b, a), b = b.sibling;
}
function $477696120c5741dc$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $477696120c5741dc$var$ck(b, a);
            $477696120c5741dc$var$ek(a);
            if (d & 4) {
                try {
                    $477696120c5741dc$var$Pj(3, a, a.return), $477696120c5741dc$var$Qj(3, a);
                } catch (t) {
                    $477696120c5741dc$var$W(a, a.return, t);
                }
                try {
                    $477696120c5741dc$var$Pj(5, a, a.return);
                } catch (t) {
                    $477696120c5741dc$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $477696120c5741dc$var$ck(b, a);
            $477696120c5741dc$var$ek(a);
            d & 512 && null !== c && $477696120c5741dc$var$Lj(c, c.return);
            break;
        case 5:
            $477696120c5741dc$var$ck(b, a);
            $477696120c5741dc$var$ek(a);
            d & 512 && null !== c && $477696120c5741dc$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $477696120c5741dc$var$ob(e, "");
                } catch (t) {
                    $477696120c5741dc$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $477696120c5741dc$var$ab(e, f);
                    $477696120c5741dc$var$vb(h, g);
                    var l = $477696120c5741dc$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $477696120c5741dc$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $477696120c5741dc$var$nb(e, q) : "children" === m ? $477696120c5741dc$var$ob(e, q) : $477696120c5741dc$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $477696120c5741dc$var$bb(e, f);
                            break;
                        case "textarea":
                            $477696120c5741dc$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $477696120c5741dc$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $477696120c5741dc$var$fb(e, !!f.multiple, f.defaultValue, !0) : $477696120c5741dc$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$477696120c5741dc$var$Pf] = f;
                } catch (t) {
                    $477696120c5741dc$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $477696120c5741dc$var$ck(b, a);
            $477696120c5741dc$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($477696120c5741dc$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $477696120c5741dc$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $477696120c5741dc$var$ck(b, a);
            $477696120c5741dc$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $477696120c5741dc$var$bd(b.containerInfo);
            } catch (t) {
                $477696120c5741dc$var$W(a, a.return, t);
            }
            break;
        case 4:
            $477696120c5741dc$var$ck(b, a);
            $477696120c5741dc$var$ek(a);
            break;
        case 13:
            $477696120c5741dc$var$ck(b, a);
            $477696120c5741dc$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($477696120c5741dc$var$fk = $477696120c5741dc$var$B()));
            d & 4 && $477696120c5741dc$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($477696120c5741dc$var$U = (l = $477696120c5741dc$var$U) || m, $477696120c5741dc$var$ck(b, a), $477696120c5741dc$var$U = l) : $477696120c5741dc$var$ck(b, a);
            $477696120c5741dc$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($477696120c5741dc$var$V = a, m = a.child; null !== m;){
                    for(q = $477696120c5741dc$var$V = m; null !== $477696120c5741dc$var$V;){
                        r = $477696120c5741dc$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $477696120c5741dc$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $477696120c5741dc$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $477696120c5741dc$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $477696120c5741dc$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $477696120c5741dc$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $477696120c5741dc$var$V = y) : $477696120c5741dc$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $477696120c5741dc$var$rb("display", g));
                            } catch (t) {
                                $477696120c5741dc$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $477696120c5741dc$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $477696120c5741dc$var$ck(b, a);
            $477696120c5741dc$var$ek(a);
            d & 4 && $477696120c5741dc$var$ak(a);
            break;
        case 21:
            break;
        default:
            $477696120c5741dc$var$ck(b, a), $477696120c5741dc$var$ek(a);
    }
}
function $477696120c5741dc$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($477696120c5741dc$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($477696120c5741dc$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($477696120c5741dc$var$ob(e, ""), d.flags &= -33);
                    var f = $477696120c5741dc$var$Uj(a);
                    $477696120c5741dc$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $477696120c5741dc$var$Uj(a);
                    $477696120c5741dc$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($477696120c5741dc$var$p(161));
            }
        } catch (k) {
            $477696120c5741dc$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $477696120c5741dc$var$hk(a, b, c) {
    $477696120c5741dc$var$V = a;
    $477696120c5741dc$var$ik(a, b, c);
}
function $477696120c5741dc$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $477696120c5741dc$var$V;){
        var e = $477696120c5741dc$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $477696120c5741dc$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $477696120c5741dc$var$U;
                h = $477696120c5741dc$var$Jj;
                var l = $477696120c5741dc$var$U;
                $477696120c5741dc$var$Jj = g;
                if (($477696120c5741dc$var$U = k) && !l) for($477696120c5741dc$var$V = e; null !== $477696120c5741dc$var$V;)g = $477696120c5741dc$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $477696120c5741dc$var$jk(e) : null !== k ? (k.return = g, $477696120c5741dc$var$V = k) : $477696120c5741dc$var$jk(e);
                for(; null !== f;)$477696120c5741dc$var$V = f, $477696120c5741dc$var$ik(f, b, c), f = f.sibling;
                $477696120c5741dc$var$V = e;
                $477696120c5741dc$var$Jj = h;
                $477696120c5741dc$var$U = l;
            }
            $477696120c5741dc$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $477696120c5741dc$var$V = f) : $477696120c5741dc$var$kk(a, b, c);
    }
}
function $477696120c5741dc$var$kk(a) {
    for(; null !== $477696120c5741dc$var$V;){
        var b = $477696120c5741dc$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $477696120c5741dc$var$U || $477696120c5741dc$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$477696120c5741dc$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $477696120c5741dc$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $477696120c5741dc$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $477696120c5741dc$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $477696120c5741dc$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($477696120c5741dc$var$p(163));
                }
                $477696120c5741dc$var$U || b.flags & 512 && $477696120c5741dc$var$Rj(b);
            } catch (r) {
                $477696120c5741dc$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $477696120c5741dc$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $477696120c5741dc$var$V = c;
            break;
        }
        $477696120c5741dc$var$V = b.return;
    }
}
function $477696120c5741dc$var$gk(a) {
    for(; null !== $477696120c5741dc$var$V;){
        var b = $477696120c5741dc$var$V;
        if (b === a) {
            $477696120c5741dc$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $477696120c5741dc$var$V = c;
            break;
        }
        $477696120c5741dc$var$V = b.return;
    }
}
function $477696120c5741dc$var$jk(a) {
    for(; null !== $477696120c5741dc$var$V;){
        var b = $477696120c5741dc$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $477696120c5741dc$var$Qj(4, b);
                    } catch (k) {
                        $477696120c5741dc$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $477696120c5741dc$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $477696120c5741dc$var$Rj(b);
                    } catch (k) {
                        $477696120c5741dc$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $477696120c5741dc$var$Rj(b);
                    } catch (k) {
                        $477696120c5741dc$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $477696120c5741dc$var$W(b, b.return, k);
        }
        if (b === a) {
            $477696120c5741dc$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $477696120c5741dc$var$V = h;
            break;
        }
        $477696120c5741dc$var$V = b.return;
    }
}
var $477696120c5741dc$var$lk = Math.ceil, $477696120c5741dc$var$mk = $477696120c5741dc$var$ua.ReactCurrentDispatcher, $477696120c5741dc$var$nk = $477696120c5741dc$var$ua.ReactCurrentOwner, $477696120c5741dc$var$ok = $477696120c5741dc$var$ua.ReactCurrentBatchConfig, $477696120c5741dc$var$K = 0, $477696120c5741dc$var$Q = null, $477696120c5741dc$var$Y = null, $477696120c5741dc$var$Z = 0, $477696120c5741dc$var$fj = 0, $477696120c5741dc$var$ej = $477696120c5741dc$var$Uf(0), $477696120c5741dc$var$T = 0, $477696120c5741dc$var$pk = null, $477696120c5741dc$var$rh = 0, $477696120c5741dc$var$qk = 0, $477696120c5741dc$var$rk = 0, $477696120c5741dc$var$sk = null, $477696120c5741dc$var$tk = null, $477696120c5741dc$var$fk = 0, $477696120c5741dc$var$Gj = Infinity, $477696120c5741dc$var$uk = null, $477696120c5741dc$var$Oi = !1, $477696120c5741dc$var$Pi = null, $477696120c5741dc$var$Ri = null, $477696120c5741dc$var$vk = !1, $477696120c5741dc$var$wk = null, $477696120c5741dc$var$xk = 0, $477696120c5741dc$var$yk = 0, $477696120c5741dc$var$zk = null, $477696120c5741dc$var$Ak = -1, $477696120c5741dc$var$Bk = 0;
function $477696120c5741dc$var$R() {
    return 0 !== ($477696120c5741dc$var$K & 6) ? $477696120c5741dc$var$B() : -1 !== $477696120c5741dc$var$Ak ? $477696120c5741dc$var$Ak : $477696120c5741dc$var$Ak = $477696120c5741dc$var$B();
}
function $477696120c5741dc$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($477696120c5741dc$var$K & 2) && 0 !== $477696120c5741dc$var$Z) return $477696120c5741dc$var$Z & -$477696120c5741dc$var$Z;
    if (null !== $477696120c5741dc$var$Kg.transition) return 0 === $477696120c5741dc$var$Bk && ($477696120c5741dc$var$Bk = $477696120c5741dc$var$yc()), $477696120c5741dc$var$Bk;
    a = $477696120c5741dc$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $477696120c5741dc$var$jd(a.type);
    return a;
}
function $477696120c5741dc$var$gi(a, b, c, d) {
    if (50 < $477696120c5741dc$var$yk) throw $477696120c5741dc$var$yk = 0, $477696120c5741dc$var$zk = null, Error($477696120c5741dc$var$p(185));
    $477696120c5741dc$var$Ac(a, c, d);
    if (0 === ($477696120c5741dc$var$K & 2) || a !== $477696120c5741dc$var$Q) a === $477696120c5741dc$var$Q && (0 === ($477696120c5741dc$var$K & 2) && ($477696120c5741dc$var$qk |= c), 4 === $477696120c5741dc$var$T && $477696120c5741dc$var$Ck(a, $477696120c5741dc$var$Z)), $477696120c5741dc$var$Dk(a, d), 1 === c && 0 === $477696120c5741dc$var$K && 0 === (b.mode & 1) && ($477696120c5741dc$var$Gj = $477696120c5741dc$var$B() + 500, $477696120c5741dc$var$fg && $477696120c5741dc$var$jg());
}
function $477696120c5741dc$var$Dk(a, b) {
    var c = a.callbackNode;
    $477696120c5741dc$var$wc(a, b);
    var d = $477696120c5741dc$var$uc(a, a === $477696120c5741dc$var$Q ? $477696120c5741dc$var$Z : 0);
    if (0 === d) null !== c && $477696120c5741dc$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $477696120c5741dc$var$bc(c);
        if (1 === b) 0 === a.tag ? $477696120c5741dc$var$ig($477696120c5741dc$var$Ek.bind(null, a)) : $477696120c5741dc$var$hg($477696120c5741dc$var$Ek.bind(null, a)), $477696120c5741dc$var$Jf(function() {
            0 === ($477696120c5741dc$var$K & 6) && $477696120c5741dc$var$jg();
        }), c = null;
        else {
            switch($477696120c5741dc$var$Dc(d)){
                case 1:
                    c = $477696120c5741dc$var$fc;
                    break;
                case 4:
                    c = $477696120c5741dc$var$gc;
                    break;
                case 16:
                    c = $477696120c5741dc$var$hc;
                    break;
                case 536870912:
                    c = $477696120c5741dc$var$jc;
                    break;
                default:
                    c = $477696120c5741dc$var$hc;
            }
            c = $477696120c5741dc$var$Fk(c, $477696120c5741dc$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $477696120c5741dc$var$Gk(a, b) {
    $477696120c5741dc$var$Ak = -1;
    $477696120c5741dc$var$Bk = 0;
    if (0 !== ($477696120c5741dc$var$K & 6)) throw Error($477696120c5741dc$var$p(327));
    var c = a.callbackNode;
    if ($477696120c5741dc$var$Hk() && a.callbackNode !== c) return null;
    var d = $477696120c5741dc$var$uc(a, a === $477696120c5741dc$var$Q ? $477696120c5741dc$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $477696120c5741dc$var$Ik(a, d);
    else {
        b = d;
        var e = $477696120c5741dc$var$K;
        $477696120c5741dc$var$K |= 2;
        var f = $477696120c5741dc$var$Jk();
        if ($477696120c5741dc$var$Q !== a || $477696120c5741dc$var$Z !== b) $477696120c5741dc$var$uk = null, $477696120c5741dc$var$Gj = $477696120c5741dc$var$B() + 500, $477696120c5741dc$var$Kk(a, b);
        for(;;)try {
            $477696120c5741dc$var$Lk();
            break;
        } catch (h) {
            $477696120c5741dc$var$Mk(a, h);
        }
        $477696120c5741dc$var$$g();
        $477696120c5741dc$var$mk.current = f;
        $477696120c5741dc$var$K = e;
        null !== $477696120c5741dc$var$Y ? b = 0 : ($477696120c5741dc$var$Q = null, $477696120c5741dc$var$Z = 0, b = $477696120c5741dc$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $477696120c5741dc$var$xc(a), 0 !== e && (d = e, b = $477696120c5741dc$var$Nk(a, e)));
        if (1 === b) throw c = $477696120c5741dc$var$pk, $477696120c5741dc$var$Kk(a, 0), $477696120c5741dc$var$Ck(a, d), $477696120c5741dc$var$Dk(a, $477696120c5741dc$var$B()), c;
        if (6 === b) $477696120c5741dc$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$477696120c5741dc$var$Ok(e) && (b = $477696120c5741dc$var$Ik(a, d), 2 === b && (f = $477696120c5741dc$var$xc(a), 0 !== f && (d = f, b = $477696120c5741dc$var$Nk(a, f))), 1 === b)) throw c = $477696120c5741dc$var$pk, $477696120c5741dc$var$Kk(a, 0), $477696120c5741dc$var$Ck(a, d), $477696120c5741dc$var$Dk(a, $477696120c5741dc$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($477696120c5741dc$var$p(345));
                case 2:
                    $477696120c5741dc$var$Pk(a, $477696120c5741dc$var$tk, $477696120c5741dc$var$uk);
                    break;
                case 3:
                    $477696120c5741dc$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $477696120c5741dc$var$fk + 500 - $477696120c5741dc$var$B(), 10 < b)) {
                        if (0 !== $477696120c5741dc$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $477696120c5741dc$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $477696120c5741dc$var$Ff($477696120c5741dc$var$Pk.bind(null, a, $477696120c5741dc$var$tk, $477696120c5741dc$var$uk), b);
                        break;
                    }
                    $477696120c5741dc$var$Pk(a, $477696120c5741dc$var$tk, $477696120c5741dc$var$uk);
                    break;
                case 4:
                    $477696120c5741dc$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $477696120c5741dc$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $477696120c5741dc$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $477696120c5741dc$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $477696120c5741dc$var$Ff($477696120c5741dc$var$Pk.bind(null, a, $477696120c5741dc$var$tk, $477696120c5741dc$var$uk), d);
                        break;
                    }
                    $477696120c5741dc$var$Pk(a, $477696120c5741dc$var$tk, $477696120c5741dc$var$uk);
                    break;
                case 5:
                    $477696120c5741dc$var$Pk(a, $477696120c5741dc$var$tk, $477696120c5741dc$var$uk);
                    break;
                default:
                    throw Error($477696120c5741dc$var$p(329));
            }
        }
    }
    $477696120c5741dc$var$Dk(a, $477696120c5741dc$var$B());
    return a.callbackNode === c ? $477696120c5741dc$var$Gk.bind(null, a) : null;
}
function $477696120c5741dc$var$Nk(a, b) {
    var c = $477696120c5741dc$var$sk;
    a.current.memoizedState.isDehydrated && ($477696120c5741dc$var$Kk(a, b).flags |= 256);
    a = $477696120c5741dc$var$Ik(a, b);
    2 !== a && (b = $477696120c5741dc$var$tk, $477696120c5741dc$var$tk = c, null !== b && $477696120c5741dc$var$Fj(b));
    return a;
}
function $477696120c5741dc$var$Fj(a) {
    null === $477696120c5741dc$var$tk ? $477696120c5741dc$var$tk = a : $477696120c5741dc$var$tk.push.apply($477696120c5741dc$var$tk, a);
}
function $477696120c5741dc$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$477696120c5741dc$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $477696120c5741dc$var$Ck(a, b) {
    b &= ~$477696120c5741dc$var$rk;
    b &= ~$477696120c5741dc$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $477696120c5741dc$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $477696120c5741dc$var$Ek(a) {
    if (0 !== ($477696120c5741dc$var$K & 6)) throw Error($477696120c5741dc$var$p(327));
    $477696120c5741dc$var$Hk();
    var b = $477696120c5741dc$var$uc(a, 0);
    if (0 === (b & 1)) return $477696120c5741dc$var$Dk(a, $477696120c5741dc$var$B()), null;
    var c = $477696120c5741dc$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $477696120c5741dc$var$xc(a);
        0 !== d && (b = d, c = $477696120c5741dc$var$Nk(a, d));
    }
    if (1 === c) throw c = $477696120c5741dc$var$pk, $477696120c5741dc$var$Kk(a, 0), $477696120c5741dc$var$Ck(a, b), $477696120c5741dc$var$Dk(a, $477696120c5741dc$var$B()), c;
    if (6 === c) throw Error($477696120c5741dc$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $477696120c5741dc$var$Pk(a, $477696120c5741dc$var$tk, $477696120c5741dc$var$uk);
    $477696120c5741dc$var$Dk(a, $477696120c5741dc$var$B());
    return null;
}
function $477696120c5741dc$var$Qk(a, b) {
    var c = $477696120c5741dc$var$K;
    $477696120c5741dc$var$K |= 1;
    try {
        return a(b);
    } finally{
        $477696120c5741dc$var$K = c, 0 === $477696120c5741dc$var$K && ($477696120c5741dc$var$Gj = $477696120c5741dc$var$B() + 500, $477696120c5741dc$var$fg && $477696120c5741dc$var$jg());
    }
}
function $477696120c5741dc$var$Rk(a) {
    null !== $477696120c5741dc$var$wk && 0 === $477696120c5741dc$var$wk.tag && 0 === ($477696120c5741dc$var$K & 6) && $477696120c5741dc$var$Hk();
    var b = $477696120c5741dc$var$K;
    $477696120c5741dc$var$K |= 1;
    var c = $477696120c5741dc$var$ok.transition, d = $477696120c5741dc$var$C;
    try {
        if ($477696120c5741dc$var$ok.transition = null, $477696120c5741dc$var$C = 1, a) return a();
    } finally{
        $477696120c5741dc$var$C = d, $477696120c5741dc$var$ok.transition = c, $477696120c5741dc$var$K = b, 0 === ($477696120c5741dc$var$K & 6) && $477696120c5741dc$var$jg();
    }
}
function $477696120c5741dc$var$Hj() {
    $477696120c5741dc$var$fj = $477696120c5741dc$var$ej.current;
    $477696120c5741dc$var$E($477696120c5741dc$var$ej);
}
function $477696120c5741dc$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $477696120c5741dc$var$Gf(c));
    if (null !== $477696120c5741dc$var$Y) for(c = $477696120c5741dc$var$Y.return; null !== c;){
        var d = c;
        $477696120c5741dc$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $477696120c5741dc$var$$f();
                break;
            case 3:
                $477696120c5741dc$var$zh();
                $477696120c5741dc$var$E($477696120c5741dc$var$Wf);
                $477696120c5741dc$var$E($477696120c5741dc$var$H);
                $477696120c5741dc$var$Eh();
                break;
            case 5:
                $477696120c5741dc$var$Bh(d);
                break;
            case 4:
                $477696120c5741dc$var$zh();
                break;
            case 13:
                $477696120c5741dc$var$E($477696120c5741dc$var$L);
                break;
            case 19:
                $477696120c5741dc$var$E($477696120c5741dc$var$L);
                break;
            case 10:
                $477696120c5741dc$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $477696120c5741dc$var$Hj();
        }
        c = c.return;
    }
    $477696120c5741dc$var$Q = a;
    $477696120c5741dc$var$Y = a = $477696120c5741dc$var$Pg(a.current, null);
    $477696120c5741dc$var$Z = $477696120c5741dc$var$fj = b;
    $477696120c5741dc$var$T = 0;
    $477696120c5741dc$var$pk = null;
    $477696120c5741dc$var$rk = $477696120c5741dc$var$qk = $477696120c5741dc$var$rh = 0;
    $477696120c5741dc$var$tk = $477696120c5741dc$var$sk = null;
    if (null !== $477696120c5741dc$var$fh) {
        for(b = 0; b < $477696120c5741dc$var$fh.length; b++)if (c = $477696120c5741dc$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $477696120c5741dc$var$fh = null;
    }
    return a;
}
function $477696120c5741dc$var$Mk(a, b) {
    do {
        var c = $477696120c5741dc$var$Y;
        try {
            $477696120c5741dc$var$$g();
            $477696120c5741dc$var$Fh.current = $477696120c5741dc$var$Rh;
            if ($477696120c5741dc$var$Ih) {
                for(var d = $477696120c5741dc$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $477696120c5741dc$var$Ih = !1;
            }
            $477696120c5741dc$var$Hh = 0;
            $477696120c5741dc$var$O = $477696120c5741dc$var$N = $477696120c5741dc$var$M = null;
            $477696120c5741dc$var$Jh = !1;
            $477696120c5741dc$var$Kh = 0;
            $477696120c5741dc$var$nk.current = null;
            if (null === c || null === c.return) {
                $477696120c5741dc$var$T = 1;
                $477696120c5741dc$var$pk = b;
                $477696120c5741dc$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $477696120c5741dc$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $477696120c5741dc$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $477696120c5741dc$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $477696120c5741dc$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $477696120c5741dc$var$Si(f, l, b);
                            $477696120c5741dc$var$tj();
                            break a;
                        }
                        k = Error($477696120c5741dc$var$p(426));
                    }
                } else if ($477696120c5741dc$var$I && h.mode & 1) {
                    var J = $477696120c5741dc$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $477696120c5741dc$var$Vi(J, g, h, f, b);
                        $477696120c5741dc$var$Jg($477696120c5741dc$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $477696120c5741dc$var$Ji(k, h);
                4 !== $477696120c5741dc$var$T && ($477696120c5741dc$var$T = 2);
                null === $477696120c5741dc$var$sk ? $477696120c5741dc$var$sk = [
                    f
                ] : $477696120c5741dc$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $477696120c5741dc$var$Ni(f, k, b);
                            $477696120c5741dc$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $477696120c5741dc$var$Ri || !$477696120c5741dc$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $477696120c5741dc$var$Qi(f, h, b);
                                $477696120c5741dc$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $477696120c5741dc$var$Sk(c);
        } catch (na) {
            b = na;
            $477696120c5741dc$var$Y === c && null !== c && ($477696120c5741dc$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $477696120c5741dc$var$Jk() {
    var a = $477696120c5741dc$var$mk.current;
    $477696120c5741dc$var$mk.current = $477696120c5741dc$var$Rh;
    return null === a ? $477696120c5741dc$var$Rh : a;
}
function $477696120c5741dc$var$tj() {
    if (0 === $477696120c5741dc$var$T || 3 === $477696120c5741dc$var$T || 2 === $477696120c5741dc$var$T) $477696120c5741dc$var$T = 4;
    null === $477696120c5741dc$var$Q || 0 === ($477696120c5741dc$var$rh & 268435455) && 0 === ($477696120c5741dc$var$qk & 268435455) || $477696120c5741dc$var$Ck($477696120c5741dc$var$Q, $477696120c5741dc$var$Z);
}
function $477696120c5741dc$var$Ik(a, b) {
    var c = $477696120c5741dc$var$K;
    $477696120c5741dc$var$K |= 2;
    var d = $477696120c5741dc$var$Jk();
    if ($477696120c5741dc$var$Q !== a || $477696120c5741dc$var$Z !== b) $477696120c5741dc$var$uk = null, $477696120c5741dc$var$Kk(a, b);
    for(;;)try {
        $477696120c5741dc$var$Tk();
        break;
    } catch (e) {
        $477696120c5741dc$var$Mk(a, e);
    }
    $477696120c5741dc$var$$g();
    $477696120c5741dc$var$K = c;
    $477696120c5741dc$var$mk.current = d;
    if (null !== $477696120c5741dc$var$Y) throw Error($477696120c5741dc$var$p(261));
    $477696120c5741dc$var$Q = null;
    $477696120c5741dc$var$Z = 0;
    return $477696120c5741dc$var$T;
}
function $477696120c5741dc$var$Tk() {
    for(; null !== $477696120c5741dc$var$Y;)$477696120c5741dc$var$Uk($477696120c5741dc$var$Y);
}
function $477696120c5741dc$var$Lk() {
    for(; null !== $477696120c5741dc$var$Y && !$477696120c5741dc$var$cc();)$477696120c5741dc$var$Uk($477696120c5741dc$var$Y);
}
function $477696120c5741dc$var$Uk(a) {
    var b = $477696120c5741dc$var$Vk(a.alternate, a, $477696120c5741dc$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $477696120c5741dc$var$Sk(a) : $477696120c5741dc$var$Y = b;
    $477696120c5741dc$var$nk.current = null;
}
function $477696120c5741dc$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $477696120c5741dc$var$Ej(c, b, $477696120c5741dc$var$fj), null !== c) {
                $477696120c5741dc$var$Y = c;
                return;
            }
        } else {
            c = $477696120c5741dc$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $477696120c5741dc$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $477696120c5741dc$var$T = 6;
                $477696120c5741dc$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $477696120c5741dc$var$Y = b;
            return;
        }
        $477696120c5741dc$var$Y = b = a;
    }while (null !== b);
    0 === $477696120c5741dc$var$T && ($477696120c5741dc$var$T = 5);
}
function $477696120c5741dc$var$Pk(a, b, c) {
    var d = $477696120c5741dc$var$C, e = $477696120c5741dc$var$ok.transition;
    try {
        $477696120c5741dc$var$ok.transition = null, $477696120c5741dc$var$C = 1, $477696120c5741dc$var$Wk(a, b, c, d);
    } finally{
        $477696120c5741dc$var$ok.transition = e, $477696120c5741dc$var$C = d;
    }
    return null;
}
function $477696120c5741dc$var$Wk(a, b, c, d) {
    do $477696120c5741dc$var$Hk();
    while (null !== $477696120c5741dc$var$wk);
    if (0 !== ($477696120c5741dc$var$K & 6)) throw Error($477696120c5741dc$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($477696120c5741dc$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $477696120c5741dc$var$Bc(a, f);
    a === $477696120c5741dc$var$Q && ($477696120c5741dc$var$Y = $477696120c5741dc$var$Q = null, $477696120c5741dc$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $477696120c5741dc$var$vk || ($477696120c5741dc$var$vk = !0, $477696120c5741dc$var$Fk($477696120c5741dc$var$hc, function() {
        $477696120c5741dc$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $477696120c5741dc$var$ok.transition;
        $477696120c5741dc$var$ok.transition = null;
        var g = $477696120c5741dc$var$C;
        $477696120c5741dc$var$C = 1;
        var h = $477696120c5741dc$var$K;
        $477696120c5741dc$var$K |= 4;
        $477696120c5741dc$var$nk.current = null;
        $477696120c5741dc$var$Oj(a, c);
        $477696120c5741dc$var$dk(c, a);
        $477696120c5741dc$var$Oe($477696120c5741dc$var$Df);
        $477696120c5741dc$var$dd = !!$477696120c5741dc$var$Cf;
        $477696120c5741dc$var$Df = $477696120c5741dc$var$Cf = null;
        a.current = c;
        $477696120c5741dc$var$hk(c, a, e);
        $477696120c5741dc$var$dc();
        $477696120c5741dc$var$K = h;
        $477696120c5741dc$var$C = g;
        $477696120c5741dc$var$ok.transition = f;
    } else a.current = c;
    $477696120c5741dc$var$vk && ($477696120c5741dc$var$vk = !1, $477696120c5741dc$var$wk = a, $477696120c5741dc$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($477696120c5741dc$var$Ri = null);
    $477696120c5741dc$var$mc(c.stateNode, d);
    $477696120c5741dc$var$Dk(a, $477696120c5741dc$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($477696120c5741dc$var$Oi) throw $477696120c5741dc$var$Oi = !1, a = $477696120c5741dc$var$Pi, $477696120c5741dc$var$Pi = null, a;
    0 !== ($477696120c5741dc$var$xk & 1) && 0 !== a.tag && $477696120c5741dc$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $477696120c5741dc$var$zk ? $477696120c5741dc$var$yk++ : ($477696120c5741dc$var$yk = 0, $477696120c5741dc$var$zk = a) : $477696120c5741dc$var$yk = 0;
    $477696120c5741dc$var$jg();
    return null;
}
function $477696120c5741dc$var$Hk() {
    if (null !== $477696120c5741dc$var$wk) {
        var a = $477696120c5741dc$var$Dc($477696120c5741dc$var$xk), b = $477696120c5741dc$var$ok.transition, c = $477696120c5741dc$var$C;
        try {
            $477696120c5741dc$var$ok.transition = null;
            $477696120c5741dc$var$C = 16 > a ? 16 : a;
            if (null === $477696120c5741dc$var$wk) var d = !1;
            else {
                a = $477696120c5741dc$var$wk;
                $477696120c5741dc$var$wk = null;
                $477696120c5741dc$var$xk = 0;
                if (0 !== ($477696120c5741dc$var$K & 6)) throw Error($477696120c5741dc$var$p(331));
                var e = $477696120c5741dc$var$K;
                $477696120c5741dc$var$K |= 4;
                for($477696120c5741dc$var$V = a.current; null !== $477696120c5741dc$var$V;){
                    var f = $477696120c5741dc$var$V, g = f.child;
                    if (0 !== ($477696120c5741dc$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($477696120c5741dc$var$V = l; null !== $477696120c5741dc$var$V;){
                                    var m = $477696120c5741dc$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $477696120c5741dc$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $477696120c5741dc$var$V = q;
                                    else for(; null !== $477696120c5741dc$var$V;){
                                        m = $477696120c5741dc$var$V;
                                        var r = m.sibling, y = m.return;
                                        $477696120c5741dc$var$Sj(m);
                                        if (m === l) {
                                            $477696120c5741dc$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $477696120c5741dc$var$V = r;
                                            break;
                                        }
                                        $477696120c5741dc$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $477696120c5741dc$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $477696120c5741dc$var$V = g;
                    else b: for(; null !== $477696120c5741dc$var$V;){
                        f = $477696120c5741dc$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $477696120c5741dc$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $477696120c5741dc$var$V = x;
                            break b;
                        }
                        $477696120c5741dc$var$V = f.return;
                    }
                }
                var w = a.current;
                for($477696120c5741dc$var$V = w; null !== $477696120c5741dc$var$V;){
                    g = $477696120c5741dc$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $477696120c5741dc$var$V = u;
                    else b: for(g = w; null !== $477696120c5741dc$var$V;){
                        h = $477696120c5741dc$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $477696120c5741dc$var$Qj(9, h);
                            }
                        } catch (na) {
                            $477696120c5741dc$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $477696120c5741dc$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $477696120c5741dc$var$V = F;
                            break b;
                        }
                        $477696120c5741dc$var$V = h.return;
                    }
                }
                $477696120c5741dc$var$K = e;
                $477696120c5741dc$var$jg();
                if ($477696120c5741dc$var$lc && "function" === typeof $477696120c5741dc$var$lc.onPostCommitFiberRoot) try {
                    $477696120c5741dc$var$lc.onPostCommitFiberRoot($477696120c5741dc$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $477696120c5741dc$var$C = c, $477696120c5741dc$var$ok.transition = b;
        }
    }
    return !1;
}
function $477696120c5741dc$var$Xk(a, b, c) {
    b = $477696120c5741dc$var$Ji(c, b);
    b = $477696120c5741dc$var$Ni(a, b, 1);
    a = $477696120c5741dc$var$nh(a, b, 1);
    b = $477696120c5741dc$var$R();
    null !== a && ($477696120c5741dc$var$Ac(a, 1, b), $477696120c5741dc$var$Dk(a, b));
}
function $477696120c5741dc$var$W(a, b, c) {
    if (3 === a.tag) $477696120c5741dc$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $477696120c5741dc$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $477696120c5741dc$var$Ri || !$477696120c5741dc$var$Ri.has(d))) {
                a = $477696120c5741dc$var$Ji(c, a);
                a = $477696120c5741dc$var$Qi(b, a, 1);
                b = $477696120c5741dc$var$nh(b, a, 1);
                a = $477696120c5741dc$var$R();
                null !== b && ($477696120c5741dc$var$Ac(b, 1, a), $477696120c5741dc$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $477696120c5741dc$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $477696120c5741dc$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $477696120c5741dc$var$Q === a && ($477696120c5741dc$var$Z & c) === c && (4 === $477696120c5741dc$var$T || 3 === $477696120c5741dc$var$T && ($477696120c5741dc$var$Z & 130023424) === $477696120c5741dc$var$Z && 500 > $477696120c5741dc$var$B() - $477696120c5741dc$var$fk ? $477696120c5741dc$var$Kk(a, 0) : $477696120c5741dc$var$rk |= c);
    $477696120c5741dc$var$Dk(a, b);
}
function $477696120c5741dc$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $477696120c5741dc$var$sc, $477696120c5741dc$var$sc <<= 1, 0 === ($477696120c5741dc$var$sc & 130023424) && ($477696120c5741dc$var$sc = 4194304)));
    var c = $477696120c5741dc$var$R();
    a = $477696120c5741dc$var$ih(a, b);
    null !== a && ($477696120c5741dc$var$Ac(a, b, c), $477696120c5741dc$var$Dk(a, c));
}
function $477696120c5741dc$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $477696120c5741dc$var$Yk(a, c);
}
function $477696120c5741dc$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($477696120c5741dc$var$p(314));
    }
    null !== d && d.delete(b);
    $477696120c5741dc$var$Yk(a, c);
}
var $477696120c5741dc$var$Vk;
$477696120c5741dc$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $477696120c5741dc$var$Wf.current) $477696120c5741dc$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $477696120c5741dc$var$dh = !1, $477696120c5741dc$var$yj(a, b, c);
            $477696120c5741dc$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $477696120c5741dc$var$dh = !1, $477696120c5741dc$var$I && 0 !== (b.flags & 1048576) && $477696120c5741dc$var$ug(b, $477696120c5741dc$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $477696120c5741dc$var$ij(a, b);
            a = b.pendingProps;
            var e = $477696120c5741dc$var$Yf(b, $477696120c5741dc$var$H.current);
            $477696120c5741dc$var$ch(b, c);
            e = $477696120c5741dc$var$Nh(null, b, d, a, e, c);
            var f = $477696120c5741dc$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $477696120c5741dc$var$Zf(d) ? (f = !0, $477696120c5741dc$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $477696120c5741dc$var$kh(b), e.updater = $477696120c5741dc$var$Ei, b.stateNode = e, e._reactInternals = b, $477696120c5741dc$var$Ii(b, d, a, c), b = $477696120c5741dc$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $477696120c5741dc$var$I && f && $477696120c5741dc$var$vg(b), $477696120c5741dc$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $477696120c5741dc$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $477696120c5741dc$var$Zk(d);
                a = $477696120c5741dc$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $477696120c5741dc$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $477696120c5741dc$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $477696120c5741dc$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $477696120c5741dc$var$$i(null, b, d, $477696120c5741dc$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($477696120c5741dc$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $477696120c5741dc$var$Ci(d, e), $477696120c5741dc$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $477696120c5741dc$var$Ci(d, e), $477696120c5741dc$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $477696120c5741dc$var$kj(b);
                if (null === a) throw Error($477696120c5741dc$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $477696120c5741dc$var$lh(a, b);
                $477696120c5741dc$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $477696120c5741dc$var$Ji(Error($477696120c5741dc$var$p(423)), b);
                        b = $477696120c5741dc$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $477696120c5741dc$var$Ji(Error($477696120c5741dc$var$p(424)), b);
                        b = $477696120c5741dc$var$lj(a, b, d, c, e);
                        break a;
                    } else for($477696120c5741dc$var$yg = $477696120c5741dc$var$Lf(b.stateNode.containerInfo.firstChild), $477696120c5741dc$var$xg = b, $477696120c5741dc$var$I = !0, $477696120c5741dc$var$zg = null, c = $477696120c5741dc$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $477696120c5741dc$var$Ig();
                    if (d === e) {
                        b = $477696120c5741dc$var$Zi(a, b, c);
                        break a;
                    }
                    $477696120c5741dc$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $477696120c5741dc$var$Ah(b), null === a && $477696120c5741dc$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $477696120c5741dc$var$Ef(d, e) ? g = null : null !== f && $477696120c5741dc$var$Ef(d, f) && (b.flags |= 32), $477696120c5741dc$var$gj(a, b), $477696120c5741dc$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $477696120c5741dc$var$Eg(b), null;
        case 13:
            return $477696120c5741dc$var$oj(a, b, c);
        case 4:
            return $477696120c5741dc$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $477696120c5741dc$var$Ug(b, null, d, c) : $477696120c5741dc$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $477696120c5741dc$var$Ci(d, e), $477696120c5741dc$var$Yi(a, b, d, e, c);
        case 7:
            return $477696120c5741dc$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $477696120c5741dc$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $477696120c5741dc$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $477696120c5741dc$var$G($477696120c5741dc$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($477696120c5741dc$var$He(f.value, g)) {
                        if (f.children === e.children && !$477696120c5741dc$var$Wf.current) {
                            b = $477696120c5741dc$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $477696120c5741dc$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $477696120c5741dc$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($477696120c5741dc$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $477696120c5741dc$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $477696120c5741dc$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $477696120c5741dc$var$ch(b, c), e = $477696120c5741dc$var$eh(e), d = d(e), b.flags |= 1, $477696120c5741dc$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $477696120c5741dc$var$Ci(d, b.pendingProps), e = $477696120c5741dc$var$Ci(d.type, e), $477696120c5741dc$var$$i(a, b, d, e, c);
        case 15:
            return $477696120c5741dc$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $477696120c5741dc$var$Ci(d, e), $477696120c5741dc$var$ij(a, b), b.tag = 1, $477696120c5741dc$var$Zf(d) ? (a = !0, $477696120c5741dc$var$cg(b)) : a = !1, $477696120c5741dc$var$ch(b, c), $477696120c5741dc$var$Gi(b, d, e), $477696120c5741dc$var$Ii(b, d, e, c), $477696120c5741dc$var$jj(null, b, d, !0, a, c);
        case 19:
            return $477696120c5741dc$var$xj(a, b, c);
        case 22:
            return $477696120c5741dc$var$dj(a, b, c);
    }
    throw Error($477696120c5741dc$var$p(156, b.tag));
};
function $477696120c5741dc$var$Fk(a, b) {
    return $477696120c5741dc$var$ac(a, b);
}
function $477696120c5741dc$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $477696120c5741dc$var$Bg(a, b, c, d) {
    return new $477696120c5741dc$var$$k(a, b, c, d);
}
function $477696120c5741dc$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $477696120c5741dc$var$Zk(a) {
    if ("function" === typeof a) return $477696120c5741dc$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $477696120c5741dc$var$Da) return 11;
        if (a === $477696120c5741dc$var$Ga) return 14;
    }
    return 2;
}
function $477696120c5741dc$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $477696120c5741dc$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $477696120c5741dc$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $477696120c5741dc$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $477696120c5741dc$var$ya:
            return $477696120c5741dc$var$Tg(c.children, e, f, b);
        case $477696120c5741dc$var$za:
            g = 8;
            e |= 8;
            break;
        case $477696120c5741dc$var$Aa:
            return a = $477696120c5741dc$var$Bg(12, c, b, e | 2), a.elementType = $477696120c5741dc$var$Aa, a.lanes = f, a;
        case $477696120c5741dc$var$Ea:
            return a = $477696120c5741dc$var$Bg(13, c, b, e), a.elementType = $477696120c5741dc$var$Ea, a.lanes = f, a;
        case $477696120c5741dc$var$Fa:
            return a = $477696120c5741dc$var$Bg(19, c, b, e), a.elementType = $477696120c5741dc$var$Fa, a.lanes = f, a;
        case $477696120c5741dc$var$Ia:
            return $477696120c5741dc$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $477696120c5741dc$var$Ba:
                    g = 10;
                    break a;
                case $477696120c5741dc$var$Ca:
                    g = 9;
                    break a;
                case $477696120c5741dc$var$Da:
                    g = 11;
                    break a;
                case $477696120c5741dc$var$Ga:
                    g = 14;
                    break a;
                case $477696120c5741dc$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($477696120c5741dc$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $477696120c5741dc$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $477696120c5741dc$var$Tg(a, b, c, d) {
    a = $477696120c5741dc$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $477696120c5741dc$var$pj(a, b, c, d) {
    a = $477696120c5741dc$var$Bg(22, a, d, b);
    a.elementType = $477696120c5741dc$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $477696120c5741dc$var$Qg(a, b, c) {
    a = $477696120c5741dc$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $477696120c5741dc$var$Sg(a, b, c) {
    b = $477696120c5741dc$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $477696120c5741dc$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $477696120c5741dc$var$zc(0);
    this.expirationTimes = $477696120c5741dc$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $477696120c5741dc$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $477696120c5741dc$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $477696120c5741dc$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $477696120c5741dc$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $477696120c5741dc$var$kh(f);
    return a;
}
function $477696120c5741dc$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $477696120c5741dc$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $477696120c5741dc$var$dl(a) {
    if (!a) return $477696120c5741dc$var$Vf;
    a = a._reactInternals;
    a: {
        if ($477696120c5741dc$var$Vb(a) !== a || 1 !== a.tag) throw Error($477696120c5741dc$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($477696120c5741dc$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($477696120c5741dc$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($477696120c5741dc$var$Zf(c)) return $477696120c5741dc$var$bg(a, c, b);
    }
    return b;
}
function $477696120c5741dc$var$el(a, b, c, d, e, f, g, h, k) {
    a = $477696120c5741dc$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $477696120c5741dc$var$dl(null);
    c = a.current;
    d = $477696120c5741dc$var$R();
    e = $477696120c5741dc$var$yi(c);
    f = $477696120c5741dc$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $477696120c5741dc$var$nh(c, f, e);
    a.current.lanes = e;
    $477696120c5741dc$var$Ac(a, e, d);
    $477696120c5741dc$var$Dk(a, d);
    return a;
}
function $477696120c5741dc$var$fl(a, b, c, d) {
    var e = b.current, f = $477696120c5741dc$var$R(), g = $477696120c5741dc$var$yi(e);
    c = $477696120c5741dc$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $477696120c5741dc$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $477696120c5741dc$var$nh(e, b, g);
    null !== a && ($477696120c5741dc$var$gi(a, e, g, f), $477696120c5741dc$var$oh(a, e, g));
    return g;
}
function $477696120c5741dc$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $477696120c5741dc$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $477696120c5741dc$var$il(a, b) {
    $477696120c5741dc$var$hl(a, b);
    (a = a.alternate) && $477696120c5741dc$var$hl(a, b);
}
function $477696120c5741dc$var$jl() {
    return null;
}
var $477696120c5741dc$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $477696120c5741dc$var$ll(a) {
    this._internalRoot = a;
}
$477696120c5741dc$var$ml.prototype.render = $477696120c5741dc$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($477696120c5741dc$var$p(409));
    $477696120c5741dc$var$fl(a, b, null, null);
};
$477696120c5741dc$var$ml.prototype.unmount = $477696120c5741dc$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $477696120c5741dc$var$Rk(function() {
            $477696120c5741dc$var$fl(null, a, null, null);
        });
        b[$477696120c5741dc$var$uf] = null;
    }
};
function $477696120c5741dc$var$ml(a) {
    this._internalRoot = a;
}
$477696120c5741dc$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $477696120c5741dc$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $477696120c5741dc$var$Qc.length && 0 !== b && b < $477696120c5741dc$var$Qc[c].priority; c++);
        $477696120c5741dc$var$Qc.splice(c, 0, a);
        0 === c && $477696120c5741dc$var$Vc(a);
    }
};
function $477696120c5741dc$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $477696120c5741dc$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $477696120c5741dc$var$pl() {}
function $477696120c5741dc$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $477696120c5741dc$var$gl(g);
                f.call(a);
            };
        }
        var g = $477696120c5741dc$var$el(b, d, a, 0, null, !1, !1, "", $477696120c5741dc$var$pl);
        a._reactRootContainer = g;
        a[$477696120c5741dc$var$uf] = g.current;
        $477696120c5741dc$var$sf(8 === a.nodeType ? a.parentNode : a);
        $477696120c5741dc$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $477696120c5741dc$var$gl(k);
            h.call(a);
        };
    }
    var k = $477696120c5741dc$var$bl(a, 0, !1, null, null, !1, !1, "", $477696120c5741dc$var$pl);
    a._reactRootContainer = k;
    a[$477696120c5741dc$var$uf] = k.current;
    $477696120c5741dc$var$sf(8 === a.nodeType ? a.parentNode : a);
    $477696120c5741dc$var$Rk(function() {
        $477696120c5741dc$var$fl(b, k, c, d);
    });
    return k;
}
function $477696120c5741dc$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $477696120c5741dc$var$gl(g);
                h.call(a);
            };
        }
        $477696120c5741dc$var$fl(b, g, a, e);
    } else g = $477696120c5741dc$var$ql(c, b, a, e, d);
    return $477696120c5741dc$var$gl(g);
}
$477696120c5741dc$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $477696120c5741dc$var$tc(b.pendingLanes);
                0 !== c && ($477696120c5741dc$var$Cc(b, c | 1), $477696120c5741dc$var$Dk(b, $477696120c5741dc$var$B()), 0 === ($477696120c5741dc$var$K & 6) && ($477696120c5741dc$var$Gj = $477696120c5741dc$var$B() + 500, $477696120c5741dc$var$jg()));
            }
            break;
        case 13:
            $477696120c5741dc$var$Rk(function() {
                var b = $477696120c5741dc$var$ih(a, 1);
                if (null !== b) {
                    var c = $477696120c5741dc$var$R();
                    $477696120c5741dc$var$gi(b, a, 1, c);
                }
            }), $477696120c5741dc$var$il(a, 1);
    }
};
$477696120c5741dc$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $477696120c5741dc$var$ih(a, 134217728);
        if (null !== b) {
            var c = $477696120c5741dc$var$R();
            $477696120c5741dc$var$gi(b, a, 134217728, c);
        }
        $477696120c5741dc$var$il(a, 134217728);
    }
};
$477696120c5741dc$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $477696120c5741dc$var$yi(a), c = $477696120c5741dc$var$ih(a, b);
        if (null !== c) {
            var d = $477696120c5741dc$var$R();
            $477696120c5741dc$var$gi(c, a, b, d);
        }
        $477696120c5741dc$var$il(a, b);
    }
};
$477696120c5741dc$var$Hc = function() {
    return $477696120c5741dc$var$C;
};
$477696120c5741dc$var$Ic = function(a, b) {
    var c = $477696120c5741dc$var$C;
    try {
        return $477696120c5741dc$var$C = a, b();
    } finally{
        $477696120c5741dc$var$C = c;
    }
};
$477696120c5741dc$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $477696120c5741dc$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $477696120c5741dc$var$Db(d);
                        if (!e) throw Error($477696120c5741dc$var$p(90));
                        $477696120c5741dc$var$Wa(d);
                        $477696120c5741dc$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $477696120c5741dc$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $477696120c5741dc$var$fb(a, !!c.multiple, b, !1);
    }
};
$477696120c5741dc$var$Gb = $477696120c5741dc$var$Qk;
$477696120c5741dc$var$Hb = $477696120c5741dc$var$Rk;
var $477696120c5741dc$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $477696120c5741dc$var$Cb,
        $477696120c5741dc$var$ue,
        $477696120c5741dc$var$Db,
        $477696120c5741dc$var$Eb,
        $477696120c5741dc$var$Fb,
        $477696120c5741dc$var$Qk
    ]
}, $477696120c5741dc$var$tl = {
    findFiberByHostInstance: $477696120c5741dc$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $477696120c5741dc$var$ul = {
    bundleType: $477696120c5741dc$var$tl.bundleType,
    version: $477696120c5741dc$var$tl.version,
    rendererPackageName: $477696120c5741dc$var$tl.rendererPackageName,
    rendererConfig: $477696120c5741dc$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $477696120c5741dc$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $477696120c5741dc$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $477696120c5741dc$var$tl.findFiberByHostInstance || $477696120c5741dc$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $477696120c5741dc$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$477696120c5741dc$var$vl.isDisabled && $477696120c5741dc$var$vl.supportsFiber) try {
        $477696120c5741dc$var$kc = $477696120c5741dc$var$vl.inject($477696120c5741dc$var$ul), $477696120c5741dc$var$lc = $477696120c5741dc$var$vl;
    } catch (a) {}
}
$477696120c5741dc$export$ae55be85d98224ed = $477696120c5741dc$var$sl;
$477696120c5741dc$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$477696120c5741dc$var$nl(b)) throw Error($477696120c5741dc$var$p(200));
    return $477696120c5741dc$var$cl(a, b, null, c);
};
$477696120c5741dc$export$882461b6382ed46c = function(a, b) {
    if (!$477696120c5741dc$var$nl(a)) throw Error($477696120c5741dc$var$p(299));
    var c = !1, d = "", e = $477696120c5741dc$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $477696120c5741dc$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$477696120c5741dc$var$uf] = b.current;
    $477696120c5741dc$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $477696120c5741dc$var$ll(b);
};
$477696120c5741dc$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($477696120c5741dc$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($477696120c5741dc$var$p(268, a));
    }
    a = $477696120c5741dc$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$477696120c5741dc$export$cd75ccfd720a3cd4 = function(a) {
    return $477696120c5741dc$var$Rk(a);
};
$477696120c5741dc$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$477696120c5741dc$var$ol(b)) throw Error($477696120c5741dc$var$p(200));
    return $477696120c5741dc$var$rl(null, a, b, !0, c);
};
$477696120c5741dc$export$757ceba2d55c277e = function(a, b, c) {
    if (!$477696120c5741dc$var$nl(a)) throw Error($477696120c5741dc$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $477696120c5741dc$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $477696120c5741dc$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$477696120c5741dc$var$uf] = b.current;
    $477696120c5741dc$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $477696120c5741dc$var$ml(b);
};
$477696120c5741dc$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$477696120c5741dc$var$ol(b)) throw Error($477696120c5741dc$var$p(200));
    return $477696120c5741dc$var$rl(null, a, b, !1, c);
};
$477696120c5741dc$export$502457920280e6be = function(a) {
    if (!$477696120c5741dc$var$ol(a)) throw Error($477696120c5741dc$var$p(40));
    return a._reactRootContainer ? ($477696120c5741dc$var$Rk(function() {
        $477696120c5741dc$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$477696120c5741dc$var$uf] = null;
        });
    }), !0) : !1;
};
$477696120c5741dc$export$c78a37762a8d58e1 = $477696120c5741dc$var$Qk;
$477696120c5741dc$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$477696120c5741dc$var$ol(c)) throw Error($477696120c5741dc$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($477696120c5741dc$var$p(38));
    return $477696120c5741dc$var$rl(a, b, c, !1, d);
};
$477696120c5741dc$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("1c3ne", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ecVue"));

});
parcelRegister("ecVue", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $a57ec74d8a366a12$export$c4744153514ff05d; }, function (v) { return $a57ec74d8a366a12$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $a57ec74d8a366a12$export$3e506c1ccc9cc1a7; }, function (v) { return $a57ec74d8a366a12$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $a57ec74d8a366a12$export$e26fe2ed2fa76875; }, function (v) { return $a57ec74d8a366a12$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $a57ec74d8a366a12$export$502329bbf4b505b1; }, function (v) { return $a57ec74d8a366a12$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $a57ec74d8a366a12$export$6e3807111c4874c4; }, function (v) { return $a57ec74d8a366a12$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $a57ec74d8a366a12$export$c27134553091fb3a; }, function (v) { return $a57ec74d8a366a12$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $a57ec74d8a366a12$export$33ee1acdc04fd2a2; }, function (v) { return $a57ec74d8a366a12$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $a57ec74d8a366a12$export$b00a404bbd5edef2; }, function (v) { return $a57ec74d8a366a12$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $a57ec74d8a366a12$export$8352ce38b91d0c62; }, function (v) { return $a57ec74d8a366a12$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $a57ec74d8a366a12$export$d66a1c1c77bd778b; }, function (v) { return $a57ec74d8a366a12$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $a57ec74d8a366a12$export$d3dfb8e4810cb555; }, function (v) { return $a57ec74d8a366a12$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $a57ec74d8a366a12$export$839f9183b0465a69; }, function (v) { return $a57ec74d8a366a12$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $a57ec74d8a366a12$export$72fdf0e06517287b; }, function (v) { return $a57ec74d8a366a12$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $a57ec74d8a366a12$export$4b844e58a3e414b4; }, function (v) { return $a57ec74d8a366a12$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $a57ec74d8a366a12$export$816d2913ae6b83b1; }, function (v) { return $a57ec74d8a366a12$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $a57ec74d8a366a12$export$61bcfe829111a1d0; }, function (v) { return $a57ec74d8a366a12$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $a57ec74d8a366a12$export$7ee8c9beb337bc3f; }, function (v) { return $a57ec74d8a366a12$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $a57ec74d8a366a12$export$b5836b71941fa3ed; }, function (v) { return $a57ec74d8a366a12$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $a57ec74d8a366a12$export$cf845f2c119da08a; }, function (v) { return $a57ec74d8a366a12$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a57ec74d8a366a12$export$c4744153514ff05d;
var $a57ec74d8a366a12$export$3e506c1ccc9cc1a7;
var $a57ec74d8a366a12$export$e26fe2ed2fa76875;
var $a57ec74d8a366a12$export$502329bbf4b505b1;
var $a57ec74d8a366a12$export$6e3807111c4874c4;
var $a57ec74d8a366a12$export$c27134553091fb3a;
var $a57ec74d8a366a12$export$33ee1acdc04fd2a2;
var $a57ec74d8a366a12$export$b00a404bbd5edef2;
var $a57ec74d8a366a12$export$8352ce38b91d0c62;
var $a57ec74d8a366a12$export$d66a1c1c77bd778b;
var $a57ec74d8a366a12$export$d3dfb8e4810cb555;
var $a57ec74d8a366a12$export$839f9183b0465a69;
var $a57ec74d8a366a12$export$72fdf0e06517287b;
var $a57ec74d8a366a12$export$4b844e58a3e414b4;
var $a57ec74d8a366a12$export$816d2913ae6b83b1;
var $a57ec74d8a366a12$export$61bcfe829111a1d0;
var $a57ec74d8a366a12$export$7ee8c9beb337bc3f;
var $a57ec74d8a366a12$export$b5836b71941fa3ed;
var $a57ec74d8a366a12$export$cf845f2c119da08a;
"use strict";
function $a57ec74d8a366a12$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $a57ec74d8a366a12$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $a57ec74d8a366a12$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $a57ec74d8a366a12$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $a57ec74d8a366a12$var$g(C, c)) n < e && 0 > $a57ec74d8a366a12$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $a57ec74d8a366a12$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $a57ec74d8a366a12$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $a57ec74d8a366a12$var$l = performance;
    $a57ec74d8a366a12$export$c4744153514ff05d = function() {
        return $a57ec74d8a366a12$var$l.now();
    };
} else {
    var $a57ec74d8a366a12$var$p = Date, $a57ec74d8a366a12$var$q = $a57ec74d8a366a12$var$p.now();
    $a57ec74d8a366a12$export$c4744153514ff05d = function() {
        return $a57ec74d8a366a12$var$p.now() - $a57ec74d8a366a12$var$q;
    };
}
var $a57ec74d8a366a12$var$r = [], $a57ec74d8a366a12$var$t = [], $a57ec74d8a366a12$var$u = 1, $a57ec74d8a366a12$var$v = null, $a57ec74d8a366a12$var$y = 3, $a57ec74d8a366a12$var$z = !1, $a57ec74d8a366a12$var$A = !1, $a57ec74d8a366a12$var$B = !1, $a57ec74d8a366a12$var$D = "function" === typeof setTimeout ? setTimeout : null, $a57ec74d8a366a12$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $a57ec74d8a366a12$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $a57ec74d8a366a12$var$G(a) {
    for(var b = $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$t); null !== b;){
        if (null === b.callback) $a57ec74d8a366a12$var$k($a57ec74d8a366a12$var$t);
        else if (b.startTime <= a) $a57ec74d8a366a12$var$k($a57ec74d8a366a12$var$t), b.sortIndex = b.expirationTime, $a57ec74d8a366a12$var$f($a57ec74d8a366a12$var$r, b);
        else break;
        b = $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$t);
    }
}
function $a57ec74d8a366a12$var$H(a) {
    $a57ec74d8a366a12$var$B = !1;
    $a57ec74d8a366a12$var$G(a);
    if (!$a57ec74d8a366a12$var$A) {
        if (null !== $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$r)) $a57ec74d8a366a12$var$A = !0, $a57ec74d8a366a12$var$I($a57ec74d8a366a12$var$J);
        else {
            var b = $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$t);
            null !== b && $a57ec74d8a366a12$var$K($a57ec74d8a366a12$var$H, b.startTime - a);
        }
    }
}
function $a57ec74d8a366a12$var$J(a, b) {
    $a57ec74d8a366a12$var$A = !1;
    $a57ec74d8a366a12$var$B && ($a57ec74d8a366a12$var$B = !1, $a57ec74d8a366a12$var$E($a57ec74d8a366a12$var$L), $a57ec74d8a366a12$var$L = -1);
    $a57ec74d8a366a12$var$z = !0;
    var c = $a57ec74d8a366a12$var$y;
    try {
        $a57ec74d8a366a12$var$G(b);
        for($a57ec74d8a366a12$var$v = $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$r); null !== $a57ec74d8a366a12$var$v && (!($a57ec74d8a366a12$var$v.expirationTime > b) || a && !$a57ec74d8a366a12$var$M());){
            var d = $a57ec74d8a366a12$var$v.callback;
            if ("function" === typeof d) {
                $a57ec74d8a366a12$var$v.callback = null;
                $a57ec74d8a366a12$var$y = $a57ec74d8a366a12$var$v.priorityLevel;
                var e = d($a57ec74d8a366a12$var$v.expirationTime <= b);
                b = $a57ec74d8a366a12$export$c4744153514ff05d();
                "function" === typeof e ? $a57ec74d8a366a12$var$v.callback = e : $a57ec74d8a366a12$var$v === $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$r) && $a57ec74d8a366a12$var$k($a57ec74d8a366a12$var$r);
                $a57ec74d8a366a12$var$G(b);
            } else $a57ec74d8a366a12$var$k($a57ec74d8a366a12$var$r);
            $a57ec74d8a366a12$var$v = $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$r);
        }
        if (null !== $a57ec74d8a366a12$var$v) var w = !0;
        else {
            var m = $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$t);
            null !== m && $a57ec74d8a366a12$var$K($a57ec74d8a366a12$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $a57ec74d8a366a12$var$v = null, $a57ec74d8a366a12$var$y = c, $a57ec74d8a366a12$var$z = !1;
    }
}
var $a57ec74d8a366a12$var$N = !1, $a57ec74d8a366a12$var$O = null, $a57ec74d8a366a12$var$L = -1, $a57ec74d8a366a12$var$P = 5, $a57ec74d8a366a12$var$Q = -1;
function $a57ec74d8a366a12$var$M() {
    return $a57ec74d8a366a12$export$c4744153514ff05d() - $a57ec74d8a366a12$var$Q < $a57ec74d8a366a12$var$P ? !1 : !0;
}
function $a57ec74d8a366a12$var$R() {
    if (null !== $a57ec74d8a366a12$var$O) {
        var a = $a57ec74d8a366a12$export$c4744153514ff05d();
        $a57ec74d8a366a12$var$Q = a;
        var b = !0;
        try {
            b = $a57ec74d8a366a12$var$O(!0, a);
        } finally{
            b ? $a57ec74d8a366a12$var$S() : ($a57ec74d8a366a12$var$N = !1, $a57ec74d8a366a12$var$O = null);
        }
    } else $a57ec74d8a366a12$var$N = !1;
}
var $a57ec74d8a366a12$var$S;
if ("function" === typeof $a57ec74d8a366a12$var$F) $a57ec74d8a366a12$var$S = function() {
    $a57ec74d8a366a12$var$F($a57ec74d8a366a12$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $a57ec74d8a366a12$var$T = new MessageChannel, $a57ec74d8a366a12$var$U = $a57ec74d8a366a12$var$T.port2;
    $a57ec74d8a366a12$var$T.port1.onmessage = $a57ec74d8a366a12$var$R;
    $a57ec74d8a366a12$var$S = function() {
        $a57ec74d8a366a12$var$U.postMessage(null);
    };
} else $a57ec74d8a366a12$var$S = function() {
    $a57ec74d8a366a12$var$D($a57ec74d8a366a12$var$R, 0);
};
function $a57ec74d8a366a12$var$I(a) {
    $a57ec74d8a366a12$var$O = a;
    $a57ec74d8a366a12$var$N || ($a57ec74d8a366a12$var$N = !0, $a57ec74d8a366a12$var$S());
}
function $a57ec74d8a366a12$var$K(a, b) {
    $a57ec74d8a366a12$var$L = $a57ec74d8a366a12$var$D(function() {
        a($a57ec74d8a366a12$export$c4744153514ff05d());
    }, b);
}
$a57ec74d8a366a12$export$3e506c1ccc9cc1a7 = 5;
$a57ec74d8a366a12$export$e26fe2ed2fa76875 = 1;
$a57ec74d8a366a12$export$502329bbf4b505b1 = 4;
$a57ec74d8a366a12$export$6e3807111c4874c4 = 3;
$a57ec74d8a366a12$export$c27134553091fb3a = null;
$a57ec74d8a366a12$export$33ee1acdc04fd2a2 = 2;
$a57ec74d8a366a12$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$a57ec74d8a366a12$export$8352ce38b91d0c62 = function() {
    $a57ec74d8a366a12$var$A || $a57ec74d8a366a12$var$z || ($a57ec74d8a366a12$var$A = !0, $a57ec74d8a366a12$var$I($a57ec74d8a366a12$var$J));
};
$a57ec74d8a366a12$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $a57ec74d8a366a12$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$a57ec74d8a366a12$export$d3dfb8e4810cb555 = function() {
    return $a57ec74d8a366a12$var$y;
};
$a57ec74d8a366a12$export$839f9183b0465a69 = function() {
    return $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$r);
};
$a57ec74d8a366a12$export$72fdf0e06517287b = function(a) {
    switch($a57ec74d8a366a12$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $a57ec74d8a366a12$var$y;
    }
    var c = $a57ec74d8a366a12$var$y;
    $a57ec74d8a366a12$var$y = b;
    try {
        return a();
    } finally{
        $a57ec74d8a366a12$var$y = c;
    }
};
$a57ec74d8a366a12$export$4b844e58a3e414b4 = function() {};
$a57ec74d8a366a12$export$816d2913ae6b83b1 = function() {};
$a57ec74d8a366a12$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $a57ec74d8a366a12$var$y;
    $a57ec74d8a366a12$var$y = a;
    try {
        return b();
    } finally{
        $a57ec74d8a366a12$var$y = c;
    }
};
$a57ec74d8a366a12$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $a57ec74d8a366a12$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $a57ec74d8a366a12$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $a57ec74d8a366a12$var$f($a57ec74d8a366a12$var$t, a), null === $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$r) && a === $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$t) && ($a57ec74d8a366a12$var$B ? ($a57ec74d8a366a12$var$E($a57ec74d8a366a12$var$L), $a57ec74d8a366a12$var$L = -1) : $a57ec74d8a366a12$var$B = !0, $a57ec74d8a366a12$var$K($a57ec74d8a366a12$var$H, c - d))) : (a.sortIndex = e, $a57ec74d8a366a12$var$f($a57ec74d8a366a12$var$r, a), $a57ec74d8a366a12$var$A || $a57ec74d8a366a12$var$z || ($a57ec74d8a366a12$var$A = !0, $a57ec74d8a366a12$var$I($a57ec74d8a366a12$var$J)));
    return a;
};
$a57ec74d8a366a12$export$b5836b71941fa3ed = $a57ec74d8a366a12$var$M;
$a57ec74d8a366a12$export$cf845f2c119da08a = function(a) {
    var b = $a57ec74d8a366a12$var$y;
    return function() {
        var c = $a57ec74d8a366a12$var$y;
        $a57ec74d8a366a12$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $a57ec74d8a366a12$var$y = c;
        }
    };
};

});



parcelRegister("fmRNI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b302a4cdaf1c8188$export$2e2bcd8739ae039; });

var $4Iuzv = parcelRequire("4Iuzv");
const $b302a4cdaf1c8188$var$UserContext = /*#__PURE__*/ (0, $4Iuzv.createContext)({
    loggedInUser: "default user"
});
var $b302a4cdaf1c8188$export$2e2bcd8739ae039 = $b302a4cdaf1c8188$var$UserContext;

});

parcelRegister("agd5q", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $77858cb85dfbcb17$export$bf730a2d8bf68b42; }, function (v) { return $77858cb85dfbcb17$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $77858cb85dfbcb17$export$bf730a2d8bf68b42;
"use strict";

var $4Iuzv = parcelRequire("4Iuzv");
function $77858cb85dfbcb17$var$n(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $77858cb85dfbcb17$var$p = "function" === typeof Object.is ? Object.is : $77858cb85dfbcb17$var$n, $77858cb85dfbcb17$var$q = $4Iuzv.useSyncExternalStore, $77858cb85dfbcb17$var$r = $4Iuzv.useRef, $77858cb85dfbcb17$var$t = $4Iuzv.useEffect, $77858cb85dfbcb17$var$u = $4Iuzv.useMemo, $77858cb85dfbcb17$var$v = $4Iuzv.useDebugValue;
$77858cb85dfbcb17$export$bf730a2d8bf68b42 = function(a, b, e, l, h) {
    var c = $77858cb85dfbcb17$var$r(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $77858cb85dfbcb17$var$u(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== h && f.hasValue) {
                    var b = f.value;
                    if (h(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($77858cb85dfbcb17$var$p(d, a)) return b;
            var e = l(a);
            if (void 0 !== h && h(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        h
    ]);
    var d = $77858cb85dfbcb17$var$q(a, c[0], c[1]);
    $77858cb85dfbcb17$var$t(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $77858cb85dfbcb17$var$v(d);
    return d;
};

});

parcelRegister("eHry9", function(module, exports) {

var $dIRJU = parcelRequire("dIRJU");


module.exports = Promise.all([
    (parcelRequire("bDFcw"))((parcelRequire("giU2u")).resolve("8xwem")),
    $dIRJU("egjK0")
]).then(()=>parcelRequire("gLepd"));

});
parcelRegister("dIRJU", function(module, exports) {
"use strict";

function $9fd911f5bde9abf3$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("giU2u")).resolve(id));
}
module.exports = $9fd911f5bde9abf3$var$load;

});

parcelRegister("bDFcw", function(module, exports) {
"use strict";

var $9hhhr = parcelRequire("9hhhr");
module.exports = $9hhhr(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});
parcelRegister("9hhhr", function(module, exports) {
"use strict";
var $6c131b1349c24314$var$cachedBundles = {};
var $6c131b1349c24314$var$cachedPreloads = {};
var $6c131b1349c24314$var$cachedPrefetches = {};
function $6c131b1349c24314$var$getCache(type) {
    switch(type){
        case "preload":
            return $6c131b1349c24314$var$cachedPreloads;
        case "prefetch":
            return $6c131b1349c24314$var$cachedPrefetches;
        default:
            return $6c131b1349c24314$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $6c131b1349c24314$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




var $5aRSq = parcelRequire("5aRSq");

var $4Iuzv = parcelRequire("4Iuzv");
var $21fa618cfc67d6ae$exports = {};

$parcel$export($21fa618cfc67d6ae$exports, "createRoot", function () { return $21fa618cfc67d6ae$export$882461b6382ed46c; }, function (v) { return $21fa618cfc67d6ae$export$882461b6382ed46c = v; });
$parcel$export($21fa618cfc67d6ae$exports, "hydrateRoot", function () { return $21fa618cfc67d6ae$export$757ceba2d55c277e; }, function (v) { return $21fa618cfc67d6ae$export$757ceba2d55c277e = v; });
var $21fa618cfc67d6ae$export$882461b6382ed46c;
var $21fa618cfc67d6ae$export$757ceba2d55c277e;
"use strict";
var $d0525dc7624af49b$exports = {};
"use strict";
function $d0525dc7624af49b$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($d0525dc7624af49b$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$d0525dc7624af49b$var$checkDCE();

$d0525dc7624af49b$exports = (parcelRequire("68oCn"));


var $21fa618cfc67d6ae$var$i;
$21fa618cfc67d6ae$export$882461b6382ed46c = $d0525dc7624af49b$exports.createRoot;
$21fa618cfc67d6ae$export$757ceba2d55c277e = $d0525dc7624af49b$exports.hydrateRoot;



var $5aRSq = parcelRequire("5aRSq");

var $4Iuzv = parcelRequire("4Iuzv");
/**
 * React Router DOM v6.26.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $4Iuzv = parcelRequire("4Iuzv");

/**
 * @remix-run/router v1.19.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $f29acb16f05b6a44$var$_extends() {
    $f29acb16f05b6a44$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f29acb16f05b6a44$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $f29acb16f05b6a44$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($f29acb16f05b6a44$export$e19cd5f9376f8cee || ($f29acb16f05b6a44$export$e19cd5f9376f8cee = {}));
const $f29acb16f05b6a44$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $f29acb16f05b6a44$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $f29acb16f05b6a44$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $f29acb16f05b6a44$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $f29acb16f05b6a44$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $f29acb16f05b6a44$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $f29acb16f05b6a44$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $f29acb16f05b6a44$export$fe53371bee54353d(to);
    }
    return $f29acb16f05b6a44$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $f29acb16f05b6a44$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $f29acb16f05b6a44$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $f29acb16f05b6a44$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $f29acb16f05b6a44$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $f29acb16f05b6a44$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $f29acb16f05b6a44$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $f29acb16f05b6a44$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $f29acb16f05b6a44$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $f29acb16f05b6a44$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $f29acb16f05b6a44$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $f29acb16f05b6a44$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $f29acb16f05b6a44$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $f29acb16f05b6a44$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $f29acb16f05b6a44$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $f29acb16f05b6a44$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $f29acb16f05b6a44$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($f29acb16f05b6a44$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Push;
        let location = $f29acb16f05b6a44$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $f29acb16f05b6a44$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Replace;
        let location = $f29acb16f05b6a44$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $f29acb16f05b6a44$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $f29acb16f05b6a44$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $f29acb16f05b6a44$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($f29acb16f05b6a44$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($f29acb16f05b6a44$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $f29acb16f05b6a44$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($f29acb16f05b6a44$var$ResultType || ($f29acb16f05b6a44$var$ResultType = {}));
const $f29acb16f05b6a44$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $f29acb16f05b6a44$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $f29acb16f05b6a44$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $f29acb16f05b6a44$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $f29acb16f05b6a44$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($f29acb16f05b6a44$var$isIndexRoute(route)) {
            let indexRoute = $f29acb16f05b6a44$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $f29acb16f05b6a44$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $f29acb16f05b6a44$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $f29acb16f05b6a44$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $f29acb16f05b6a44$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $f29acb16f05b6a44$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $f29acb16f05b6a44$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $f29acb16f05b6a44$var$flattenRoutes(routes);
    $f29acb16f05b6a44$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $f29acb16f05b6a44$export$30d21fd6d7295f52(pathname);
        matches = $f29acb16f05b6a44$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $f29acb16f05b6a44$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $f29acb16f05b6a44$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $f29acb16f05b6a44$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $f29acb16f05b6a44$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $f29acb16f05b6a44$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $f29acb16f05b6a44$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $f29acb16f05b6a44$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $f29acb16f05b6a44$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $f29acb16f05b6a44$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $f29acb16f05b6a44$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $f29acb16f05b6a44$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $f29acb16f05b6a44$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $f29acb16f05b6a44$var$paramRe = /^:[\w-]+$/;
const $f29acb16f05b6a44$var$dynamicSegmentValue = 3;
const $f29acb16f05b6a44$var$indexRouteValue = 2;
const $f29acb16f05b6a44$var$emptySegmentValue = 1;
const $f29acb16f05b6a44$var$staticSegmentValue = 10;
const $f29acb16f05b6a44$var$splatPenalty = -2;
const $f29acb16f05b6a44$var$isSplat = (s)=>s === "*";
function $f29acb16f05b6a44$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($f29acb16f05b6a44$var$isSplat)) initialScore += $f29acb16f05b6a44$var$splatPenalty;
    if (index) initialScore += $f29acb16f05b6a44$var$indexRouteValue;
    return segments.filter((s)=>!$f29acb16f05b6a44$var$isSplat(s)).reduce((score, segment)=>score + ($f29acb16f05b6a44$var$paramRe.test(segment) ? $f29acb16f05b6a44$var$dynamicSegmentValue : segment === "" ? $f29acb16f05b6a44$var$emptySegmentValue : $f29acb16f05b6a44$var$staticSegmentValue), initialScore);
}
function $f29acb16f05b6a44$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $f29acb16f05b6a44$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $f29acb16f05b6a44$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $f29acb16f05b6a44$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $f29acb16f05b6a44$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $f29acb16f05b6a44$export$a5c6d149b50c1d86($f29acb16f05b6a44$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $f29acb16f05b6a44$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $f29acb16f05b6a44$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $f29acb16f05b6a44$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $f29acb16f05b6a44$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $f29acb16f05b6a44$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $f29acb16f05b6a44$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $f29acb16f05b6a44$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $f29acb16f05b6a44$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $f29acb16f05b6a44$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $f29acb16f05b6a44$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $f29acb16f05b6a44$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $f29acb16f05b6a44$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $f29acb16f05b6a44$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $f29acb16f05b6a44$var$normalizeSearch(search),
        hash: $f29acb16f05b6a44$var$normalizeHash(hash)
    };
}
function $f29acb16f05b6a44$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $f29acb16f05b6a44$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $f29acb16f05b6a44$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $f29acb16f05b6a44$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $f29acb16f05b6a44$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $f29acb16f05b6a44$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $f29acb16f05b6a44$export$8ccf933b0513f8d0(toArg);
    else {
        to = $f29acb16f05b6a44$var$_extends({}, toArg);
        $f29acb16f05b6a44$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $f29acb16f05b6a44$var$getInvalidPathError("?", "pathname", "search", to));
        $f29acb16f05b6a44$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $f29acb16f05b6a44$var$getInvalidPathError("#", "pathname", "hash", to));
        $f29acb16f05b6a44$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $f29acb16f05b6a44$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $f29acb16f05b6a44$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $f29acb16f05b6a44$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $f29acb16f05b6a44$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $f29acb16f05b6a44$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $f29acb16f05b6a44$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $f29acb16f05b6a44$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $f29acb16f05b6a44$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $f29acb16f05b6a44$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $f29acb16f05b6a44$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $f29acb16f05b6a44$export$480182c6abbb2ff6(data, init) {
    return new $f29acb16f05b6a44$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $f29acb16f05b6a44$export$42a99a7a4bc0e76a extends Error {
}
class $f29acb16f05b6a44$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $f29acb16f05b6a44$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $f29acb16f05b6a44$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $f29acb16f05b6a44$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $f29acb16f05b6a44$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $f29acb16f05b6a44$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $f29acb16f05b6a44$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $f29acb16f05b6a44$var$unwrapTrackedPromise(value) {
    if (!$f29acb16f05b6a44$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $f29acb16f05b6a44$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $f29acb16f05b6a44$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $f29acb16f05b6a44$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $f29acb16f05b6a44$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $f29acb16f05b6a44$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $f29acb16f05b6a44$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $f29acb16f05b6a44$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $f29acb16f05b6a44$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $f29acb16f05b6a44$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $f29acb16f05b6a44$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $f29acb16f05b6a44$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $f29acb16f05b6a44$var$validMutationMethods = new Set($f29acb16f05b6a44$var$validMutationMethodsArr);
const $f29acb16f05b6a44$var$validRequestMethodsArr = [
    "get",
    ...$f29acb16f05b6a44$var$validMutationMethodsArr
];
const $f29acb16f05b6a44$var$validRequestMethods = new Set($f29acb16f05b6a44$var$validRequestMethodsArr);
const $f29acb16f05b6a44$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $f29acb16f05b6a44$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $f29acb16f05b6a44$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $f29acb16f05b6a44$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $f29acb16f05b6a44$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $f29acb16f05b6a44$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $f29acb16f05b6a44$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $f29acb16f05b6a44$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $f29acb16f05b6a44$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $f29acb16f05b6a44$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $f29acb16f05b6a44$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $f29acb16f05b6a44$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $f29acb16f05b6a44$var$defaultDataStrategy;
    let patchRoutesOnMissImpl = init.unstable_patchRoutesOnMiss;
    // Config driven behavior flags
    let future = $f29acb16f05b6a44$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $f29acb16f05b6a44$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnMissImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $f29acb16f05b6a44$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $f29acb16f05b6a44$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnMiss implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnMiss` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $f29acb16f05b6a44$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Map of pending patchRoutesOnMiss() promises (keyed by path/matches) so
    // that we only kick them off once for a given combo
    let pendingPatchRoutes = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $f29acb16f05b6a44$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $f29acb16f05b6a44$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $f29acb16f05b6a44$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$f29acb16f05b6a44$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $f29acb16f05b6a44$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $f29acb16f05b6a44$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $f29acb16f05b6a44$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $f29acb16f05b6a44$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $f29acb16f05b6a44$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $f29acb16f05b6a44$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $f29acb16f05b6a44$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($f29acb16f05b6a44$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $f29acb16f05b6a44$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $f29acb16f05b6a44$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $f29acb16f05b6a44$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $f29acb16f05b6a44$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $f29acb16f05b6a44$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $f29acb16f05b6a44$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $f29acb16f05b6a44$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $f29acb16f05b6a44$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $f29acb16f05b6a44$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $f29acb16f05b6a44$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $f29acb16f05b6a44$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $f29acb16f05b6a44$var$findNearestBoundary(matches).route.id,
            {
                type: $f29acb16f05b6a44$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $f29acb16f05b6a44$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($f29acb16f05b6a44$var$isErrorResult(result) && $f29acb16f05b6a44$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $f29acb16f05b6a44$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $f29acb16f05b6a44$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $f29acb16f05b6a44$var$_extends({
            matches: updatedMatches || matches
        }, $f29acb16f05b6a44$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $f29acb16f05b6a44$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $f29acb16f05b6a44$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $f29acb16f05b6a44$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $f29acb16f05b6a44$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $f29acb16f05b6a44$var$ResultType.error,
            error: $f29acb16f05b6a44$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches);
            result = results[0];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($f29acb16f05b6a44$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $f29acb16f05b6a44$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($f29acb16f05b6a44$var$isDeferredResult(result)) throw $f29acb16f05b6a44$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($f29acb16f05b6a44$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $f29acb16f05b6a44$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $f29acb16f05b6a44$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $f29acb16f05b6a44$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($f29acb16f05b6a44$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $f29acb16f05b6a44$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $f29acb16f05b6a44$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $f29acb16f05b6a44$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $f29acb16f05b6a44$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $f29acb16f05b6a44$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(request, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $f29acb16f05b6a44$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $f29acb16f05b6a44$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$f29acb16f05b6a44$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $f29acb16f05b6a44$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $f29acb16f05b6a44$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $f29acb16f05b6a44$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $f29acb16f05b6a44$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $f29acb16f05b6a44$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $f29acb16f05b6a44$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $f29acb16f05b6a44$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $f29acb16f05b6a44$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $f29acb16f05b6a44$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $f29acb16f05b6a44$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $f29acb16f05b6a44$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $f29acb16f05b6a44$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", fetchRequest, [
            match
        ], requestMatches);
        let actionResult = actionResults[0];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($f29acb16f05b6a44$var$isRedirectResult(actionResult) || $f29acb16f05b6a44$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $f29acb16f05b6a44$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($f29acb16f05b6a44$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $f29acb16f05b6a44$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $f29acb16f05b6a44$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($f29acb16f05b6a44$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($f29acb16f05b6a44$var$isDeferredResult(actionResult)) throw $f29acb16f05b6a44$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $f29acb16f05b6a44$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $f29acb16f05b6a44$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $f29acb16f05b6a44$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $f29acb16f05b6a44$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $f29acb16f05b6a44$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $f29acb16f05b6a44$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $f29acb16f05b6a44$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(revalidationRequest, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $f29acb16f05b6a44$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $f29acb16f05b6a44$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $f29acb16f05b6a44$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $f29acb16f05b6a44$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $f29acb16f05b6a44$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $f29acb16f05b6a44$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $f29acb16f05b6a44$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $f29acb16f05b6a44$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", fetchRequest, [
            match
        ], matches);
        let result = results[0];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($f29acb16f05b6a44$var$isDeferredResult(result)) result = await $f29acb16f05b6a44$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $f29acb16f05b6a44$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($f29acb16f05b6a44$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $f29acb16f05b6a44$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($f29acb16f05b6a44$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $f29acb16f05b6a44$export$3e9cee6b33872309(!$f29acb16f05b6a44$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $f29acb16f05b6a44$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $f29acb16f05b6a44$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $f29acb16f05b6a44$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $f29acb16f05b6a44$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($f29acb16f05b6a44$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $f29acb16f05b6a44$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $f29acb16f05b6a44$export$e19cd5f9376f8cee.Replace : $f29acb16f05b6a44$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $f29acb16f05b6a44$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($f29acb16f05b6a44$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $f29acb16f05b6a44$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $f29acb16f05b6a44$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $f29acb16f05b6a44$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches) {
        try {
            let results = await $f29acb16f05b6a44$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties);
            return await Promise.all(results.map((result, i)=>{
                if ($f29acb16f05b6a44$var$isRedirectHandlerResult(result)) {
                    let response = result.result;
                    return {
                        type: $f29acb16f05b6a44$var$ResultType.redirect,
                        response: $f29acb16f05b6a44$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                    };
                }
                return $f29acb16f05b6a44$var$convertHandlerResultToDataResult(result);
            }));
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            return matchesToLoad.map(()=>({
                    type: $f29acb16f05b6a44$var$ResultType.error,
                    error: e
                }));
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        let [loaderResults, ...fetcherResults] = await Promise.all([
            matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : [],
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) {
                    let fetcherRequest = $f29acb16f05b6a44$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                    return callDataStrategy("loader", fetcherRequest, [
                        f.match
                    ], f.matches).then((r)=>r[0]);
                } else return Promise.resolve({
                    type: $f29acb16f05b6a44$var$ResultType.error,
                    error: $f29acb16f05b6a44$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                });
            })
        ]);
        await Promise.all([
            $f29acb16f05b6a44$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $f29acb16f05b6a44$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.add(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $f29acb16f05b6a44$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $f29acb16f05b6a44$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $f29acb16f05b6a44$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $f29acb16f05b6a44$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $f29acb16f05b6a44$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $f29acb16f05b6a44$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $f29acb16f05b6a44$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $f29acb16f05b6a44$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $f29acb16f05b6a44$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $f29acb16f05b6a44$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $f29acb16f05b6a44$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $f29acb16f05b6a44$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function handleDiscoverRouteError(pathname, discoverResult) {
        return {
            boundaryId: $f29acb16f05b6a44$var$findNearestBoundary(discoverResult.partialMatches).route.id,
            error: $f29acb16f05b6a44$var$getInternalRouterError(400, {
                type: "route-discovery",
                pathname: pathname,
                message: discoverResult.error != null && "message" in discoverResult.error ? discoverResult.error : String(discoverResult.error)
            })
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $f29acb16f05b6a44$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$f29acb16f05b6a44$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnMissImpl) {
            if (!matches) {
                let fogMatches = $f29acb16f05b6a44$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else {
                let leafRoute = matches[matches.length - 1].route;
                if (leafRoute.path && (leafRoute.path === "*" || leafRoute.path.endsWith("/*"))) {
                    // If we matched a splat, it might only be because we haven't yet fetched
                    // the children that would match with a higher score, so let's fetch
                    // around and find out
                    let partialMatches = $f29acb16f05b6a44$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    return {
                        active: true,
                        matches: partialMatches
                    };
                }
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        let partialMatches = matches;
        let route = partialMatches.length > 0 ? partialMatches[partialMatches.length - 1].route : null;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            try {
                await $f29acb16f05b6a44$var$loadLazyRouteChildren(patchRoutesOnMissImpl, pathname, partialMatches, routesToUse, manifest, mapRouteProperties, pendingPatchRoutes, signal);
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $f29acb16f05b6a44$export$2708184779ceb39d(routesToUse, pathname, basename);
            let matchedSplat = false;
            if (newMatches) {
                let leafRoute = newMatches[newMatches.length - 1].route;
                if (leafRoute.index) // If we found an index route, we can stop
                return {
                    type: "success",
                    matches: newMatches
                };
                if (leafRoute.path && leafRoute.path.length > 0) {
                    if (leafRoute.path === "*") // If we found a splat route, we can't be sure there's not a
                    // higher-scoring route down some partial matches trail so we need
                    // to check that out
                    matchedSplat = true;
                    else // If we found a non-splat route, we can stop
                    return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            let newPartialMatches = $f29acb16f05b6a44$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // If we are no longer partially matching anything, this was either a
            // legit splat match above, or it's a 404.  Also avoid loops if the
            // second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.map((m)=>m.route.id).join("-") === newPartialMatches.map((m)=>m.route.id).join("-")) return {
                type: "success",
                matches: matchedSplat ? newMatches : null
            };
            partialMatches = newPartialMatches;
            route = partialMatches[partialMatches.length - 1].route;
            if (route.path === "*") // The splat is still our most accurate partial, so run with it
            return {
                type: "success",
                matches: partialMatches
            };
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $f29acb16f05b6a44$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $f29acb16f05b6a44$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $f29acb16f05b6a44$export$4d0306f8f6a4585b = Symbol("deferred");
function $f29acb16f05b6a44$export$3336b097a6fbc59a(routes, opts) {
    $f29acb16f05b6a44$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $f29acb16f05b6a44$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $f29acb16f05b6a44$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $f29acb16f05b6a44$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $f29acb16f05b6a44$var$createLocation("", $f29acb16f05b6a44$export$fe53371bee54353d(url), null, "default");
        let matches = $f29acb16f05b6a44$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$f29acb16f05b6a44$var$isValidMethod(method) && method !== "HEAD") {
            let error = $f29acb16f05b6a44$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $f29acb16f05b6a44$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $f29acb16f05b6a44$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $f29acb16f05b6a44$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($f29acb16f05b6a44$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $f29acb16f05b6a44$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, unstable_dataStrategy: unstable_dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $f29acb16f05b6a44$var$createLocation("", $f29acb16f05b6a44$export$fe53371bee54353d(url), null, "default");
        let matches = $f29acb16f05b6a44$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$f29acb16f05b6a44$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $f29acb16f05b6a44$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $f29acb16f05b6a44$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $f29acb16f05b6a44$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $f29acb16f05b6a44$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $f29acb16f05b6a44$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match);
        if ($f29acb16f05b6a44$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$f29acb16f05b6a44$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $f29acb16f05b6a44$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($f29acb16f05b6a44$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $f29acb16f05b6a44$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $f29acb16f05b6a44$var$isResponse(result) ? result : $f29acb16f05b6a44$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `HandlerResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($f29acb16f05b6a44$var$isHandlerResult(e) && $f29acb16f05b6a44$var$isResponse(e.result)) {
                if (e.type === $f29acb16f05b6a44$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($f29acb16f05b6a44$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $f29acb16f05b6a44$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $f29acb16f05b6a44$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[0];
            if (request.signal.aborted) $f29acb16f05b6a44$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($f29acb16f05b6a44$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($f29acb16f05b6a44$var$isDeferredResult(result)) {
            let error = $f29acb16f05b6a44$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $f29acb16f05b6a44$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($f29acb16f05b6a44$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($f29acb16f05b6a44$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $f29acb16f05b6a44$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $f29acb16f05b6a44$var$_extends({}, context, {
                statusCode: $f29acb16f05b6a44$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $f29acb16f05b6a44$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $f29acb16f05b6a44$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $f29acb16f05b6a44$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $f29acb16f05b6a44$var$isErrorResult(pendingActionResult[1]) ? $f29acb16f05b6a44$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $f29acb16f05b6a44$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $f29acb16f05b6a44$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $f29acb16f05b6a44$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $f29acb16f05b6a44$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $f29acb16f05b6a44$var$callDataStrategyImpl(unstable_dataStrategy || $f29acb16f05b6a44$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext);
        return await Promise.all(results.map((result, i)=>{
            if ($f29acb16f05b6a44$var$isRedirectHandlerResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $f29acb16f05b6a44$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($f29acb16f05b6a44$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            return $f29acb16f05b6a44$var$convertHandlerResultToDataResult(result);
        }));
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $f29acb16f05b6a44$export$fec11da027c70692(routes, context, error) {
    let newContext = $f29acb16f05b6a44$var$_extends({}, context, {
        statusCode: $f29acb16f05b6a44$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $f29acb16f05b6a44$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $f29acb16f05b6a44$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $f29acb16f05b6a44$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $f29acb16f05b6a44$export$cae722b0cc860f13(to ? to : ".", $f29acb16f05b6a44$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $f29acb16f05b6a44$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$f29acb16f05b6a44$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $f29acb16f05b6a44$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $f29acb16f05b6a44$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $f29acb16f05b6a44$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$f29acb16f05b6a44$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$f29acb16f05b6a44$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $f29acb16f05b6a44$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $f29acb16f05b6a44$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $f29acb16f05b6a44$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$f29acb16f05b6a44$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$f29acb16f05b6a44$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $f29acb16f05b6a44$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $f29acb16f05b6a44$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $f29acb16f05b6a44$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $f29acb16f05b6a44$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $f29acb16f05b6a44$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($f29acb16f05b6a44$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $f29acb16f05b6a44$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $f29acb16f05b6a44$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $f29acb16f05b6a44$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $f29acb16f05b6a44$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $f29acb16f05b6a44$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $f29acb16f05b6a44$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $f29acb16f05b6a44$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $f29acb16f05b6a44$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($f29acb16f05b6a44$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $f29acb16f05b6a44$var$shouldRevalidateLoader(match, $f29acb16f05b6a44$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $f29acb16f05b6a44$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $f29acb16f05b6a44$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $f29acb16f05b6a44$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $f29acb16f05b6a44$var$shouldRevalidateLoader(fetcherMatch, $f29acb16f05b6a44$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $f29acb16f05b6a44$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $f29acb16f05b6a44$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $f29acb16f05b6a44$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Idempotent utility to execute patchRoutesOnMiss() to lazily load route
 * definitions and update the routes/routeManifest
 */ async function $f29acb16f05b6a44$var$loadLazyRouteChildren(patchRoutesOnMissImpl, path, matches, routes, manifest, mapRouteProperties, pendingRouteChildren, signal) {
    let key = [
        path,
        ...matches.map((m)=>m.route.id)
    ].join("-");
    try {
        let pending = pendingRouteChildren.get(key);
        if (!pending) {
            pending = patchRoutesOnMissImpl({
                path: path,
                matches: matches,
                patch: (routeId, children)=>{
                    if (!signal.aborted) $f29acb16f05b6a44$var$patchRoutesImpl(routeId, children, routes, manifest, mapRouteProperties);
                }
            });
            pendingRouteChildren.set(key, pending);
        }
        if (pending && $f29acb16f05b6a44$var$isPromise(pending)) await pending;
    } finally{
        pendingRouteChildren.delete(key);
    }
}
function $f29acb16f05b6a44$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    if (routeId) {
        var _route$children;
        let route = manifest[routeId];
        $f29acb16f05b6a44$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        let dataChildren = $f29acb16f05b6a44$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            routeId,
            "patch",
            String(((_route$children = route.children) == null ? void 0 : _route$children.length) || "0")
        ], manifest);
        if (route.children) route.children.push(...dataChildren);
        else route.children = dataChildren;
    } else {
        let dataChildren = $f29acb16f05b6a44$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            "patch",
            String(routesToUse.length || "0")
        ], manifest);
        routesToUse.push(...dataChildren);
    }
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $f29acb16f05b6a44$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $f29acb16f05b6a44$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $f29acb16f05b6a44$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$f29acb16f05b6a44$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $f29acb16f05b6a44$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $f29acb16f05b6a44$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map((m)=>m.resolve()));
}
async function $f29acb16f05b6a44$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    let routeIdsToLoad = matchesToLoad.reduce((acc, m)=>acc.add(m.route.id), new Set());
    let loadedMatches = new Set();
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: matches.map((match)=>{
            let shouldLoad = routeIdsToLoad.has(match.route.id);
            // `resolve` encapsulates the route.lazy, executing the
            // loader/action, and mapping return values/thrown errors to a
            // HandlerResult.  Users can pass a callback to take fine-grained control
            // over the execution of the loader/action
            let resolve = (handlerOverride)=>{
                loadedMatches.add(match.route.id);
                return shouldLoad ? $f29acb16f05b6a44$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                    type: $f29acb16f05b6a44$var$ResultType.data,
                    result: undefined
                });
            };
            return $f29acb16f05b6a44$var$_extends({}, match, {
                shouldLoad: shouldLoad,
                resolve: resolve
            });
        }),
        request: request,
        params: matches[0].params,
        context: requestContext
    });
    // Throw if any loadRoute implementations not called since they are what
    // ensures a route is fully loaded
    matches.forEach((m)=>$f29acb16f05b6a44$export$3e9cee6b33872309(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded."));
    // Filter out any middleware-only matches for which we didn't need to run handlers
    return results.filter((_, i)=>routeIdsToLoad.has(matches[i].route.id));
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $f29acb16f05b6a44$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<HandlerResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise;
        if (handlerOverride) handlerPromise = handlerOverride((ctx)=>actualHandler(ctx));
        else handlerPromise = (async ()=>{
            try {
                let val = await actualHandler();
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $f29acb16f05b6a44$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await $f29acb16f05b6a44$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $f29acb16f05b6a44$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $f29acb16f05b6a44$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $f29acb16f05b6a44$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $f29acb16f05b6a44$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // HandlerResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $f29acb16f05b6a44$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $f29acb16f05b6a44$var$convertHandlerResultToDataResult(handlerResult) {
    let { result: result, type: type } = handlerResult;
    if ($f29acb16f05b6a44$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $f29acb16f05b6a44$var$ResultType.error,
                error: e
            };
        }
        if (type === $f29acb16f05b6a44$var$ResultType.error) return {
            type: $f29acb16f05b6a44$var$ResultType.error,
            error: new $f29acb16f05b6a44$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $f29acb16f05b6a44$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $f29acb16f05b6a44$var$ResultType.error) {
        if ($f29acb16f05b6a44$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $f29acb16f05b6a44$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown unstable_data() to ErrorResponse instances
            result = new $f29acb16f05b6a44$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $f29acb16f05b6a44$var$ResultType.error,
            error: result,
            statusCode: $f29acb16f05b6a44$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($f29acb16f05b6a44$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $f29acb16f05b6a44$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($f29acb16f05b6a44$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $f29acb16f05b6a44$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $f29acb16f05b6a44$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $f29acb16f05b6a44$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $f29acb16f05b6a44$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$f29acb16f05b6a44$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $f29acb16f05b6a44$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $f29acb16f05b6a44$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($f29acb16f05b6a44$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $f29acb16f05b6a44$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $f29acb16f05b6a44$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($f29acb16f05b6a44$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $f29acb16f05b6a44$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $f29acb16f05b6a44$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $f29acb16f05b6a44$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $f29acb16f05b6a44$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $f29acb16f05b6a44$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $f29acb16f05b6a44$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $f29acb16f05b6a44$export$3e9cee6b33872309(!$f29acb16f05b6a44$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($f29acb16f05b6a44$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $f29acb16f05b6a44$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $f29acb16f05b6a44$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($f29acb16f05b6a44$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $f29acb16f05b6a44$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $f29acb16f05b6a44$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $f29acb16f05b6a44$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($f29acb16f05b6a44$var$isErrorResult(result)) {
            let boundaryMatch = $f29acb16f05b6a44$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $f29acb16f05b6a44$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($f29acb16f05b6a44$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $f29acb16f05b6a44$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($f29acb16f05b6a44$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $f29acb16f05b6a44$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $f29acb16f05b6a44$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $f29acb16f05b6a44$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $f29acb16f05b6a44$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $f29acb16f05b6a44$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $f29acb16f05b6a44$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $f29acb16f05b6a44$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $f29acb16f05b6a44$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $f29acb16f05b6a44$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (type === "route-discovery") errorMessage = 'Unable to match URL "' + pathname + '" - the `unstable_patchRoutesOnMiss()` ' + ("function threw the following error:\n" + message);
        else if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $f29acb16f05b6a44$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $f29acb16f05b6a44$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($f29acb16f05b6a44$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $f29acb16f05b6a44$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(path) : path;
    return $f29acb16f05b6a44$export$fe53371bee54353d($f29acb16f05b6a44$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $f29acb16f05b6a44$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $f29acb16f05b6a44$var$isPromise(val) {
    return typeof val === "object" && val != null && "then" in val;
}
function $f29acb16f05b6a44$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $f29acb16f05b6a44$var$ResultType.data || result.type === $f29acb16f05b6a44$var$ResultType.error);
}
function $f29acb16f05b6a44$var$isRedirectHandlerResult(result) {
    return $f29acb16f05b6a44$var$isResponse(result.result) && $f29acb16f05b6a44$var$redirectStatusCodes.has(result.result.status);
}
function $f29acb16f05b6a44$var$isDeferredResult(result) {
    return result.type === $f29acb16f05b6a44$var$ResultType.deferred;
}
function $f29acb16f05b6a44$var$isErrorResult(result) {
    return result.type === $f29acb16f05b6a44$var$ResultType.error;
}
function $f29acb16f05b6a44$var$isRedirectResult(result) {
    return (result && result.type) === $f29acb16f05b6a44$var$ResultType.redirect;
}
function $f29acb16f05b6a44$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $f29acb16f05b6a44$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $f29acb16f05b6a44$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $f29acb16f05b6a44$var$isRedirectResponse(result) {
    if (!$f29acb16f05b6a44$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $f29acb16f05b6a44$var$isValidMethod(method) {
    return $f29acb16f05b6a44$var$validRequestMethods.has(method.toLowerCase());
}
function $f29acb16f05b6a44$var$isMutationMethod(method) {
    return $f29acb16f05b6a44$var$validMutationMethods.has(method.toLowerCase());
}
async function $f29acb16f05b6a44$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$f29acb16f05b6a44$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($f29acb16f05b6a44$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $f29acb16f05b6a44$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $f29acb16f05b6a44$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $f29acb16f05b6a44$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $f29acb16f05b6a44$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $f29acb16f05b6a44$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $f29acb16f05b6a44$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $f29acb16f05b6a44$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $f29acb16f05b6a44$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $f29acb16f05b6a44$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $f29acb16f05b6a44$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $f29acb16f05b6a44$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $f29acb16f05b6a44$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $f29acb16f05b6a44$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $f29acb16f05b6a44$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $f29acb16f05b6a44$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $f29acb16f05b6a44$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $f29acb16f05b6a44$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($f29acb16f05b6a44$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $f29acb16f05b6a44$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($f29acb16f05b6a44$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $f29acb16f05b6a44$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.26.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $4Iuzv = parcelRequire("4Iuzv");

function $175a2504a1bf07a5$var$_extends() {
    $175a2504a1bf07a5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $175a2504a1bf07a5$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $175a2504a1bf07a5$export$3add0d5dce533e2e = /*#__PURE__*/ $4Iuzv.createContext(null);
const $175a2504a1bf07a5$export$145dfa71566a64dc = /*#__PURE__*/ $4Iuzv.createContext(null);
const $175a2504a1bf07a5$var$AwaitContext = /*#__PURE__*/ $4Iuzv.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $175a2504a1bf07a5$export$26749e8557646306 = /*#__PURE__*/ $4Iuzv.createContext(null);
const $175a2504a1bf07a5$export$c7914228fb69b0f5 = /*#__PURE__*/ $4Iuzv.createContext(null);
const $175a2504a1bf07a5$export$9072aa6dd1f93057 = /*#__PURE__*/ $4Iuzv.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $175a2504a1bf07a5$var$RouteErrorContext = /*#__PURE__*/ $4Iuzv.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $175a2504a1bf07a5$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $4Iuzv.useContext($175a2504a1bf07a5$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $175a2504a1bf07a5$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $f29acb16f05b6a44$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $175a2504a1bf07a5$export$9c954a9d03d32f4a() {
    return $4Iuzv.useContext($175a2504a1bf07a5$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $175a2504a1bf07a5$export$45d76561a5302f2b() {
    !$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return $4Iuzv.useContext($175a2504a1bf07a5$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $175a2504a1bf07a5$export$1b3f31771c5d07c() {
    return $4Iuzv.useContext($175a2504a1bf07a5$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $175a2504a1bf07a5$export$6c330e8992e8a295(pattern) {
    !$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $175a2504a1bf07a5$export$45d76561a5302f2b();
    return $4Iuzv.useMemo(()=>(0, $f29acb16f05b6a44$export$81336c211d5ff295)(pattern, (0, $f29acb16f05b6a44$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $175a2504a1bf07a5$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $175a2504a1bf07a5$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $4Iuzv.useContext($175a2504a1bf07a5$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $4Iuzv.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $175a2504a1bf07a5$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $175a2504a1bf07a5$var$useNavigateStable() : $175a2504a1bf07a5$var$useNavigateUnstable();
}
function $175a2504a1bf07a5$var$useNavigateUnstable() {
    !$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let dataRouterContext = $4Iuzv.useContext($175a2504a1bf07a5$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $4Iuzv.useContext($175a2504a1bf07a5$export$26749e8557646306);
    let { matches: matches } = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $175a2504a1bf07a5$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $f29acb16f05b6a44$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $4Iuzv.useRef(false);
    $175a2504a1bf07a5$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $4Iuzv.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $f29acb16f05b6a44$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $f29acb16f05b6a44$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $175a2504a1bf07a5$var$OutletContext = /*#__PURE__*/ $4Iuzv.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $175a2504a1bf07a5$export$4138103a3ae699cc() {
    return $4Iuzv.useContext($175a2504a1bf07a5$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $175a2504a1bf07a5$export$a3be3530d8e40d0b(context) {
    let outlet = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $175a2504a1bf07a5$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $175a2504a1bf07a5$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $4Iuzv.useContext($175a2504a1bf07a5$export$26749e8557646306);
    let { matches: matches } = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $175a2504a1bf07a5$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $f29acb16f05b6a44$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $4Iuzv.useMemo(()=>(0, $f29acb16f05b6a44$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $175a2504a1bf07a5$export$5d3fca4a98652595(routes, locationArg) {
    return $175a2504a1bf07a5$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $175a2504a1bf07a5$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $4Iuzv.useContext($175a2504a1bf07a5$export$26749e8557646306);
    let { matches: parentMatches } = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $175a2504a1bf07a5$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $f29acb16f05b6a44$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $f29acb16f05b6a44$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $175a2504a1bf07a5$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $f29acb16f05b6a44$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $f29acb16f05b6a44$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $175a2504a1bf07a5$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $f29acb16f05b6a44$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $175a2504a1bf07a5$var$DefaultErrorComponent() {
    let error = $175a2504a1bf07a5$export$ed527bf60f6e05f2();
    let message = (0, $f29acb16f05b6a44$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $4Iuzv.createElement($4Iuzv.Fragment, null, /*#__PURE__*/ $4Iuzv.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $4Iuzv.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $4Iuzv.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $175a2504a1bf07a5$var$defaultErrorElement = /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$DefaultErrorComponent, null);
class $175a2504a1bf07a5$var$RenderErrorBoundary extends $4Iuzv.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $175a2504a1bf07a5$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $4Iuzv.useContext($175a2504a1bf07a5$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $175a2504a1bf07a5$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnMiss`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $175a2504a1bf07a5$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $175a2504a1bf07a5$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $4Iuzv.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $175a2504a1bf07a5$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($175a2504a1bf07a5$var$DataRouterHook || {});
var $175a2504a1bf07a5$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($175a2504a1bf07a5$var$DataRouterStateHook || {});
function $175a2504a1bf07a5$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $175a2504a1bf07a5$var$useDataRouterContext(hookName) {
    let ctx = $4Iuzv.useContext($175a2504a1bf07a5$export$3add0d5dce533e2e);
    !ctx && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return ctx;
}
function $175a2504a1bf07a5$var$useDataRouterState(hookName) {
    let state = $4Iuzv.useContext($175a2504a1bf07a5$export$145dfa71566a64dc);
    !state && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return state;
}
function $175a2504a1bf07a5$var$useRouteContext(hookName) {
    let route = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    !route && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $175a2504a1bf07a5$var$useCurrentRouteId(hookName) {
    let route = $175a2504a1bf07a5$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $175a2504a1bf07a5$export$5fc8298006ad9e58() {
    return $175a2504a1bf07a5$var$useCurrentRouteId($175a2504a1bf07a5$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $175a2504a1bf07a5$export$d0fd4b7106de2769() {
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $175a2504a1bf07a5$export$600dc272ed516c15() {
    let dataRouterContext = $175a2504a1bf07a5$var$useDataRouterContext($175a2504a1bf07a5$var$DataRouterHook.UseRevalidator);
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseRevalidator);
    return $4Iuzv.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $175a2504a1bf07a5$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseMatches);
    return $4Iuzv.useMemo(()=>matches.map((m)=>(0, $f29acb16f05b6a44$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $175a2504a1bf07a5$export$1448a5050d252c4d() {
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseLoaderData);
    let routeId = $175a2504a1bf07a5$var$useCurrentRouteId($175a2504a1bf07a5$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $175a2504a1bf07a5$export$fd5d37484eab868d(routeId) {
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $175a2504a1bf07a5$export$fdc00f3f26066d5e() {
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseActionData);
    let routeId = $175a2504a1bf07a5$var$useCurrentRouteId($175a2504a1bf07a5$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $175a2504a1bf07a5$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $4Iuzv.useContext($175a2504a1bf07a5$var$RouteErrorContext);
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseRouteError);
    let routeId = $175a2504a1bf07a5$var$useCurrentRouteId($175a2504a1bf07a5$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $175a2504a1bf07a5$export$78a72ddb39bdd145() {
    let value = $4Iuzv.useContext($175a2504a1bf07a5$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $175a2504a1bf07a5$export$17f53340677d5831() {
    let value = $4Iuzv.useContext($175a2504a1bf07a5$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $175a2504a1bf07a5$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $175a2504a1bf07a5$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $175a2504a1bf07a5$var$useDataRouterContext($175a2504a1bf07a5$var$DataRouterHook.UseBlocker);
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $4Iuzv.useState("");
    let blockerFunction = $4Iuzv.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $175a2504a1bf07a5$var$_extends({}, currentLocation, {
                pathname: (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $175a2504a1bf07a5$var$_extends({}, nextLocation, {
                pathname: (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $4Iuzv.useEffect(()=>{
        let key = String(++$175a2504a1bf07a5$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $4Iuzv.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $f29acb16f05b6a44$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $175a2504a1bf07a5$var$useNavigateStable() {
    let { router: router } = $175a2504a1bf07a5$var$useDataRouterContext($175a2504a1bf07a5$var$DataRouterHook.UseNavigateStable);
    let id = $175a2504a1bf07a5$var$useCurrentRouteId($175a2504a1bf07a5$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $4Iuzv.useRef(false);
    $175a2504a1bf07a5$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $4Iuzv.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $175a2504a1bf07a5$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $175a2504a1bf07a5$var$alreadyWarned = {};
function $175a2504a1bf07a5$var$warningOnce(key, cond, message) {
    if (!cond && !$175a2504a1bf07a5$var$alreadyWarned[key]) $175a2504a1bf07a5$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $175a2504a1bf07a5$var$START_TRANSITION = "startTransition";
const $175a2504a1bf07a5$var$startTransitionImpl = $4Iuzv[$175a2504a1bf07a5$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $175a2504a1bf07a5$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $4Iuzv.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4Iuzv.useCallback((newState)=>{
        if (v7_startTransition && $175a2504a1bf07a5$var$startTransitionImpl) $175a2504a1bf07a5$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $4Iuzv.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $4Iuzv.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $4Iuzv.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $4Iuzv.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $4Iuzv.createElement($4Iuzv.Fragment, null, /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $175a2504a1bf07a5$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $175a2504a1bf07a5$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $175a2504a1bf07a5$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $4Iuzv.useRef();
    if (historyRef.current == null) historyRef.current = (0, $f29acb16f05b6a44$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4Iuzv.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4Iuzv.useCallback((newState)=>{
        v7_startTransition && $175a2504a1bf07a5$var$startTransitionImpl ? $175a2504a1bf07a5$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4Iuzv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $175a2504a1bf07a5$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $4Iuzv.useContext($175a2504a1bf07a5$export$26749e8557646306);
    let { matches: matches } = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $175a2504a1bf07a5$export$45d76561a5302f2b();
    let navigate = $175a2504a1bf07a5$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $f29acb16f05b6a44$export$cae722b0cc860f13)(to, (0, $f29acb16f05b6a44$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $4Iuzv.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $175a2504a1bf07a5$export$910ae8079b2c2852(props) {
    return $175a2504a1bf07a5$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $175a2504a1bf07a5$export$e7b0ac011bb776c6(_props) {
    (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $175a2504a1bf07a5$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $f29acb16f05b6a44$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $4Iuzv.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $175a2504a1bf07a5$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $f29acb16f05b6a44$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $4Iuzv.useMemo(()=>{
        let trailingPathname = (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $175a2504a1bf07a5$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $175a2504a1bf07a5$export$5d3fca4a98652595($175a2504a1bf07a5$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $175a2504a1bf07a5$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$ResolveAwait, null, children));
}
var $175a2504a1bf07a5$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($175a2504a1bf07a5$var$AwaitRenderStatus || {});
const $175a2504a1bf07a5$var$neverSettledPromise = new Promise(()=>{});
class $175a2504a1bf07a5$var$AwaitErrorBoundary extends $4Iuzv.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $175a2504a1bf07a5$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $175a2504a1bf07a5$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $175a2504a1bf07a5$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $175a2504a1bf07a5$var$AwaitRenderStatus.error : "_data" in promise ? $175a2504a1bf07a5$var$AwaitRenderStatus.success : $175a2504a1bf07a5$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $175a2504a1bf07a5$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $175a2504a1bf07a5$var$AwaitRenderStatus.error && promise._error instanceof (0, $f29acb16f05b6a44$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $175a2504a1bf07a5$var$neverSettledPromise;
        if (status === $175a2504a1bf07a5$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $175a2504a1bf07a5$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $175a2504a1bf07a5$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $175a2504a1bf07a5$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $175a2504a1bf07a5$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $4Iuzv.createElement($4Iuzv.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $175a2504a1bf07a5$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $4Iuzv.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $4Iuzv.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $4Iuzv.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $175a2504a1bf07a5$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $175a2504a1bf07a5$export$e7b0ac011bb776c6) && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $175a2504a1bf07a5$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $175a2504a1bf07a5$export$daf73786167a7f72(matches) {
    return $175a2504a1bf07a5$var$_renderMatches(matches);
}
function $175a2504a1bf07a5$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $4Iuzv.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $4Iuzv.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $4Iuzv.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $175a2504a1bf07a5$export$f30f7e456d254e83(routes, opts) {
    return (0, $f29acb16f05b6a44$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $175a2504a1bf07a5$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $f29acb16f05b6a44$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $175a2504a1bf07a5$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss
    }).initialize();
}



function $c34e9f2261c19895$var$_extends() {
    $c34e9f2261c19895$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c34e9f2261c19895$var$_extends.apply(this, arguments);
}
function $c34e9f2261c19895$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $c34e9f2261c19895$var$defaultMethod = "get";
const $c34e9f2261c19895$var$defaultEncType = "application/x-www-form-urlencoded";
function $c34e9f2261c19895$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $c34e9f2261c19895$var$isButtonElement(object) {
    return $c34e9f2261c19895$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $c34e9f2261c19895$var$isFormElement(object) {
    return $c34e9f2261c19895$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $c34e9f2261c19895$var$isInputElement(object) {
    return $c34e9f2261c19895$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $c34e9f2261c19895$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $c34e9f2261c19895$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$c34e9f2261c19895$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $c34e9f2261c19895$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $c34e9f2261c19895$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $c34e9f2261c19895$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $c34e9f2261c19895$var$_formDataSupportsSubmitter = null;
function $c34e9f2261c19895$var$isFormDataSubmitterSupported() {
    if ($c34e9f2261c19895$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $c34e9f2261c19895$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $c34e9f2261c19895$var$_formDataSupportsSubmitter = true;
    }
    return $c34e9f2261c19895$var$_formDataSupportsSubmitter;
}
const $c34e9f2261c19895$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $c34e9f2261c19895$var$getFormEncType(encType) {
    if (encType != null && !$c34e9f2261c19895$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $c34e9f2261c19895$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($c34e9f2261c19895$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $c34e9f2261c19895$var$defaultMethod;
        encType = $c34e9f2261c19895$var$getFormEncType(target.getAttribute("enctype")) || $c34e9f2261c19895$var$defaultEncType;
        formData = new FormData(target);
    } else if ($c34e9f2261c19895$var$isButtonElement(target) || $c34e9f2261c19895$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $c34e9f2261c19895$var$defaultMethod;
        encType = $c34e9f2261c19895$var$getFormEncType(target.getAttribute("formenctype")) || $c34e9f2261c19895$var$getFormEncType(form.getAttribute("enctype")) || $c34e9f2261c19895$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$c34e9f2261c19895$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($c34e9f2261c19895$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $c34e9f2261c19895$var$defaultMethod;
        action = null;
        encType = $c34e9f2261c19895$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $c34e9f2261c19895$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $c34e9f2261c19895$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $c34e9f2261c19895$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $c34e9f2261c19895$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $c34e9f2261c19895$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $c34e9f2261c19895$export$1f3f55432a00e06d(routes, opts) {
    return (0, $f29acb16f05b6a44$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $c34e9f2261c19895$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $f29acb16f05b6a44$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $c34e9f2261c19895$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $175a2504a1bf07a5$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $c34e9f2261c19895$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $f29acb16f05b6a44$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $c34e9f2261c19895$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $f29acb16f05b6a44$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $c34e9f2261c19895$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $175a2504a1bf07a5$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $c34e9f2261c19895$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $c34e9f2261c19895$var$_extends({}, state, {
        errors: $c34e9f2261c19895$var$deserializeErrors(state.errors)
    });
    return state;
}
function $c34e9f2261c19895$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $f29acb16f05b6a44$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $c34e9f2261c19895$export$7ad602f0e94e62d1 = /*#__PURE__*/ $4Iuzv.createContext({
    isTransitioning: false
});
const $c34e9f2261c19895$export$148fd98d095596d4 = /*#__PURE__*/ $4Iuzv.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $c34e9f2261c19895$var$START_TRANSITION = "startTransition";
const $c34e9f2261c19895$var$startTransitionImpl = $4Iuzv[$c34e9f2261c19895$var$START_TRANSITION];
const $c34e9f2261c19895$var$FLUSH_SYNC = "flushSync";
const $c34e9f2261c19895$var$flushSyncImpl = $d0525dc7624af49b$exports[$c34e9f2261c19895$var$FLUSH_SYNC];
const $c34e9f2261c19895$var$USE_ID = "useId";
const $c34e9f2261c19895$var$useIdImpl = $4Iuzv[$c34e9f2261c19895$var$USE_ID];
function $c34e9f2261c19895$var$startTransitionSafe(cb) {
    if ($c34e9f2261c19895$var$startTransitionImpl) $c34e9f2261c19895$var$startTransitionImpl(cb);
    else cb();
}
function $c34e9f2261c19895$var$flushSyncSafe(cb) {
    if ($c34e9f2261c19895$var$flushSyncImpl) $c34e9f2261c19895$var$flushSyncImpl(cb);
    else cb();
}
class $c34e9f2261c19895$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $c34e9f2261c19895$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $4Iuzv.useState(router.state);
    let [pendingState, setPendingState] = $4Iuzv.useState();
    let [vtContext, setVtContext] = $4Iuzv.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $4Iuzv.useState();
    let [transition, setTransition] = $4Iuzv.useState();
    let [interruption, setInterruption] = $4Iuzv.useState();
    let fetcherData = $4Iuzv.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $4Iuzv.useCallback((cb)=>{
        if (v7_startTransition) $c34e9f2261c19895$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $4Iuzv.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $c34e9f2261c19895$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $c34e9f2261c19895$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $c34e9f2261c19895$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $c34e9f2261c19895$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $c34e9f2261c19895$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $4Iuzv.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $4Iuzv.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $c34e9f2261c19895$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $4Iuzv.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $4Iuzv.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $4Iuzv.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $4Iuzv.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $4Iuzv.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $4Iuzv.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $4Iuzv.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $4Iuzv.createElement($4Iuzv.Fragment, null, /*#__PURE__*/ $4Iuzv.createElement((0, $175a2504a1bf07a5$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $4Iuzv.createElement((0, $175a2504a1bf07a5$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $4Iuzv.createElement($c34e9f2261c19895$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $4Iuzv.createElement($c34e9f2261c19895$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $4Iuzv.createElement((0, $175a2504a1bf07a5$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $4Iuzv.createElement($c34e9f2261c19895$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $c34e9f2261c19895$var$MemoizedDataRoutes = /*#__PURE__*/ $4Iuzv.memo($c34e9f2261c19895$var$DataRoutes);
function $c34e9f2261c19895$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $175a2504a1bf07a5$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $c34e9f2261c19895$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $4Iuzv.useRef();
    if (historyRef.current == null) historyRef.current = (0, $f29acb16f05b6a44$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4Iuzv.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4Iuzv.useCallback((newState)=>{
        v7_startTransition && $c34e9f2261c19895$var$startTransitionImpl ? $c34e9f2261c19895$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4Iuzv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4Iuzv.createElement((0, $175a2504a1bf07a5$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $c34e9f2261c19895$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $4Iuzv.useRef();
    if (historyRef.current == null) historyRef.current = (0, $f29acb16f05b6a44$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4Iuzv.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4Iuzv.useCallback((newState)=>{
        v7_startTransition && $c34e9f2261c19895$var$startTransitionImpl ? $c34e9f2261c19895$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4Iuzv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4Iuzv.createElement((0, $175a2504a1bf07a5$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $c34e9f2261c19895$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $4Iuzv.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4Iuzv.useCallback((newState)=>{
        v7_startTransition && $c34e9f2261c19895$var$startTransitionImpl ? $c34e9f2261c19895$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4Iuzv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4Iuzv.createElement((0, $175a2504a1bf07a5$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $c34e9f2261c19895$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $c34e9f2261c19895$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $c34e9f2261c19895$export$a6c7ac8248d6e38a = /*#__PURE__*/ $4Iuzv.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $c34e9f2261c19895$var$_objectWithoutPropertiesLoose(_ref7, $c34e9f2261c19895$var$_excluded);
    let { basename: basename } = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $c34e9f2261c19895$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($c34e9f2261c19895$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $175a2504a1bf07a5$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $c34e9f2261c19895$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $4Iuzv.createElement("a", $c34e9f2261c19895$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $c34e9f2261c19895$export$b0d92dbee9b5b60d = /*#__PURE__*/ $4Iuzv.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $c34e9f2261c19895$var$_objectWithoutPropertiesLoose(_ref8, $c34e9f2261c19895$var$_excluded2);
    let path = (0, $175a2504a1bf07a5$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $175a2504a1bf07a5$export$45d76561a5302f2b)();
    let routerState = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $c34e9f2261c19895$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $4Iuzv.createElement($c34e9f2261c19895$export$a6c7ac8248d6e38a, $c34e9f2261c19895$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $c34e9f2261c19895$export$a7fed597f4b8afd8 = /*#__PURE__*/ $4Iuzv.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $c34e9f2261c19895$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $c34e9f2261c19895$var$_objectWithoutPropertiesLoose(_ref9, $c34e9f2261c19895$var$_excluded3);
    let submit = $c34e9f2261c19895$export$47c85c6e3a081d3();
    let formAction = $c34e9f2261c19895$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $4Iuzv.createElement("form", $c34e9f2261c19895$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $c34e9f2261c19895$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $c34e9f2261c19895$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $c34e9f2261c19895$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($c34e9f2261c19895$var$DataRouterHook || ($c34e9f2261c19895$var$DataRouterHook = {}));
var $c34e9f2261c19895$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($c34e9f2261c19895$var$DataRouterStateHook || ($c34e9f2261c19895$var$DataRouterStateHook = {}));
// Internal hooks
function $c34e9f2261c19895$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $c34e9f2261c19895$var$useDataRouterContext(hookName) {
    let ctx = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$3add0d5dce533e2e));
    !ctx && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return ctx;
}
function $c34e9f2261c19895$var$useDataRouterState(hookName) {
    let state = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$145dfa71566a64dc));
    !state && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $c34e9f2261c19895$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $175a2504a1bf07a5$export$9770f232ac06a008)();
    let location = (0, $175a2504a1bf07a5$export$45d76561a5302f2b)();
    let path = (0, $175a2504a1bf07a5$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $4Iuzv.useCallback((event)=>{
        if ($c34e9f2261c19895$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $f29acb16f05b6a44$export$fe53371bee54353d)(location) === (0, $f29acb16f05b6a44$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $c34e9f2261c19895$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $4Iuzv.useRef($c34e9f2261c19895$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $4Iuzv.useRef(false);
    let location = (0, $175a2504a1bf07a5$export$45d76561a5302f2b)();
    let searchParams = $4Iuzv.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $c34e9f2261c19895$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $175a2504a1bf07a5$export$9770f232ac06a008)();
    let setSearchParams = $4Iuzv.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $c34e9f2261c19895$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $c34e9f2261c19895$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $c34e9f2261c19895$var$fetcherId = 0;
let $c34e9f2261c19895$var$getUniqueFetcherId = ()=>"__" + String(++$c34e9f2261c19895$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $c34e9f2261c19895$export$47c85c6e3a081d3() {
    let { router: router } = $c34e9f2261c19895$var$useDataRouterContext($c34e9f2261c19895$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$26749e8557646306));
    let currentRouteId = (0, $175a2504a1bf07a5$export$5fc8298006ad9e58)();
    return $4Iuzv.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $c34e9f2261c19895$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $c34e9f2261c19895$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $c34e9f2261c19895$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $c34e9f2261c19895$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$26749e8557646306));
    let routeContext = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$9072aa6dd1f93057));
    !routeContext && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $c34e9f2261c19895$var$_extends({}, (0, $175a2504a1bf07a5$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $175a2504a1bf07a5$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $f29acb16f05b6a44$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $f29acb16f05b6a44$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $c34e9f2261c19895$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $c34e9f2261c19895$var$useDataRouterContext($c34e9f2261c19895$var$DataRouterHook.UseFetcher);
    let state = $c34e9f2261c19895$var$useDataRouterState($c34e9f2261c19895$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $4Iuzv.useContext($c34e9f2261c19895$export$148fd98d095596d4);
    let route = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    !route && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $c34e9f2261c19895$var$useIdImpl ? $c34e9f2261c19895$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $4Iuzv.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($c34e9f2261c19895$var$getUniqueFetcherId());
    // Registration/cleanup
    $4Iuzv.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $4Iuzv.useCallback((href, opts)=>{
        !routeId && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $c34e9f2261c19895$export$47c85c6e3a081d3();
    let submit = $4Iuzv.useCallback((target, opts)=>{
        submitImpl(target, $c34e9f2261c19895$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $4Iuzv.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $4Iuzv.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $4Iuzv.createElement($c34e9f2261c19895$export$a7fed597f4b8afd8, $c34e9f2261c19895$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $f29acb16f05b6a44$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $4Iuzv.useMemo(()=>$c34e9f2261c19895$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $c34e9f2261c19895$export$fa996778a3a31087() {
    let state = $c34e9f2261c19895$var$useDataRouterState($c34e9f2261c19895$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $c34e9f2261c19895$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $c34e9f2261c19895$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $c34e9f2261c19895$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $c34e9f2261c19895$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $c34e9f2261c19895$var$useDataRouterContext($c34e9f2261c19895$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $c34e9f2261c19895$var$useDataRouterState($c34e9f2261c19895$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$26749e8557646306));
    let location = (0, $175a2504a1bf07a5$export$45d76561a5302f2b)();
    let matches = (0, $175a2504a1bf07a5$export$2378eb7f5ff86053)();
    let navigation = (0, $175a2504a1bf07a5$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $4Iuzv.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $c34e9f2261c19895$var$usePageHide($4Iuzv.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $c34e9f2261c19895$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $c34e9f2261c19895$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($c34e9f2261c19895$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4Iuzv.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $c34e9f2261c19895$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $c34e9f2261c19895$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4Iuzv.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($c34e9f2261c19895$var$_extends({}, location, {
                    pathname: (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($c34e9f2261c19895$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4Iuzv.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $c34e9f2261c19895$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $4Iuzv.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $c34e9f2261c19895$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $4Iuzv.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $c34e9f2261c19895$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $175a2504a1bf07a5$export$b273b3273281a049)(when);
    $4Iuzv.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $4Iuzv.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $c34e9f2261c19895$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $4Iuzv.useContext($c34e9f2261c19895$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let { basename: basename } = $c34e9f2261c19895$var$useDataRouterContext($c34e9f2261c19895$var$DataRouterHook.useViewTransitionState);
    let path = (0, $175a2504a1bf07a5$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $f29acb16f05b6a44$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $f29acb16f05b6a44$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


var $e739f47ff36c4788$exports = {};
$e739f47ff36c4788$exports = new URL("plate.a4168512.svg", import.meta.url).toString();


var $5f9a00396a8cbcc9$exports = {};
$5f9a00396a8cbcc9$exports = new URL("groce.2b068bb4.svg", import.meta.url).toString();



var $fmRNI = parcelRequire("fmRNI");

var $4Iuzv = parcelRequire("4Iuzv");
var $10715d3f0d22f08b$exports = {};
"use strict";

$10715d3f0d22f08b$exports = (parcelRequire("agd5q"));


var $25d342665550a083$var$__defProp = Object.defineProperty;
var $25d342665550a083$var$__defProps = Object.defineProperties;
var $25d342665550a083$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $25d342665550a083$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $25d342665550a083$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $25d342665550a083$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $25d342665550a083$var$__defNormalProp = (obj, key, value)=>key in obj ? $25d342665550a083$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $25d342665550a083$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($25d342665550a083$var$__hasOwnProp.call(b, prop)) $25d342665550a083$var$__defNormalProp(a, prop, b[prop]);
    if ($25d342665550a083$var$__getOwnPropSymbols) {
        for (var prop of $25d342665550a083$var$__getOwnPropSymbols(b))if ($25d342665550a083$var$__propIsEnum.call(b, prop)) $25d342665550a083$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $25d342665550a083$var$__spreadProps = (a, b)=>$25d342665550a083$var$__defProps(a, $25d342665550a083$var$__getOwnPropDescs(b));
var $25d342665550a083$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($25d342665550a083$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $25d342665550a083$var$__getOwnPropSymbols) {
        for (var prop of $25d342665550a083$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $25d342665550a083$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $25d342665550a083$var$React = // prettier-ignore
// @ts-ignore
"default" in $4Iuzv ? $4Iuzv["default"] : $4Iuzv;
// src/components/Context.ts
var $25d342665550a083$var$ContextKey = Symbol.for(`react-redux-context`);
var $25d342665550a083$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $25d342665550a083$var$getContext() {
    var _a;
    if (!$25d342665550a083$var$React.createContext) return {};
    const contextMap = (_a = $25d342665550a083$var$gT[$25d342665550a083$var$ContextKey]) != null ? _a : $25d342665550a083$var$gT[$25d342665550a083$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($25d342665550a083$var$React.createContext);
    if (!realContext) {
        realContext = $25d342665550a083$var$React.createContext(null);
        contextMap.set($25d342665550a083$var$React.createContext, realContext);
    }
    return realContext;
}
var $25d342665550a083$export$cc80c08dc91f1c00 = /* @__PURE__ */ $25d342665550a083$var$getContext();
// src/utils/useSyncExternalStore.ts
var $25d342665550a083$var$notInitialized = ()=>{
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $25d342665550a083$var$createReduxContextHook(context = $25d342665550a083$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $25d342665550a083$var$React.useContext(context);
        return contextValue;
    };
}
var $25d342665550a083$var$useReduxContext = /* @__PURE__ */ $25d342665550a083$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $25d342665550a083$var$useSyncExternalStoreWithSelector = $25d342665550a083$var$notInitialized;
var $25d342665550a083$var$initializeUseSelector = (fn)=>{
    $25d342665550a083$var$useSyncExternalStoreWithSelector = fn;
};
var $25d342665550a083$var$refEquality = (a, b)=>a === b;
function $25d342665550a083$export$2b53f90d2bd1cbfb(context = $25d342665550a083$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $25d342665550a083$export$cc80c08dc91f1c00 ? $25d342665550a083$var$useReduxContext : $25d342665550a083$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $25d342665550a083$var$refEquality, devModeChecks: devModeChecks = {} } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: stabilityCheck, identityFunctionCheck: identityFunctionCheck } = useReduxContext2();
        const firstRun = $25d342665550a083$var$React.useRef(true);
        const wrappedSelector = $25d342665550a083$var$React.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        const selectedState = $25d342665550a083$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $25d342665550a083$var$React.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $25d342665550a083$export$2105062e25df4afe = /* @__PURE__ */ $25d342665550a083$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $25d342665550a083$var$REACT_ELEMENT_TYPE = Symbol.for("react.element");
var $25d342665550a083$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
var $25d342665550a083$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
var $25d342665550a083$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
var $25d342665550a083$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var $25d342665550a083$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider");
var $25d342665550a083$var$REACT_CONTEXT_TYPE = Symbol.for("react.context");
var $25d342665550a083$var$REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
var $25d342665550a083$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
var $25d342665550a083$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
var $25d342665550a083$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
var $25d342665550a083$var$REACT_MEMO_TYPE = Symbol.for("react.memo");
var $25d342665550a083$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $25d342665550a083$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
var $25d342665550a083$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
var $25d342665550a083$var$ForwardRef = $25d342665550a083$var$REACT_FORWARD_REF_TYPE;
var $25d342665550a083$var$Memo = $25d342665550a083$var$REACT_MEMO_TYPE;
function $25d342665550a083$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $25d342665550a083$var$REACT_FRAGMENT_TYPE || type === $25d342665550a083$var$REACT_PROFILER_TYPE || type === $25d342665550a083$var$REACT_STRICT_MODE_TYPE || type === $25d342665550a083$var$REACT_SUSPENSE_TYPE || type === $25d342665550a083$var$REACT_SUSPENSE_LIST_TYPE || type === $25d342665550a083$var$REACT_OFFSCREEN_TYPE) return true;
    if (typeof type === "object" && type !== null) {
        if (type.$$typeof === $25d342665550a083$var$REACT_LAZY_TYPE || type.$$typeof === $25d342665550a083$var$REACT_MEMO_TYPE || type.$$typeof === $25d342665550a083$var$REACT_PROVIDER_TYPE || type.$$typeof === $25d342665550a083$var$REACT_CONTEXT_TYPE || type.$$typeof === $25d342665550a083$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $25d342665550a083$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $25d342665550a083$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const $$typeof = object.$$typeof;
        switch($$typeof){
            case $25d342665550a083$var$REACT_ELEMENT_TYPE:
                {
                    const type = object.type;
                    switch(type){
                        case $25d342665550a083$var$REACT_FRAGMENT_TYPE:
                        case $25d342665550a083$var$REACT_PROFILER_TYPE:
                        case $25d342665550a083$var$REACT_STRICT_MODE_TYPE:
                        case $25d342665550a083$var$REACT_SUSPENSE_TYPE:
                        case $25d342665550a083$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                const $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $25d342665550a083$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $25d342665550a083$var$REACT_CONTEXT_TYPE:
                                    case $25d342665550a083$var$REACT_FORWARD_REF_TYPE:
                                    case $25d342665550a083$var$REACT_LAZY_TYPE:
                                    case $25d342665550a083$var$REACT_MEMO_TYPE:
                                    case $25d342665550a083$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $25d342665550a083$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $25d342665550a083$var$isContextConsumer(object) {
    return $25d342665550a083$var$typeOf(object) === $25d342665550a083$var$REACT_CONTEXT_TYPE;
}
function $25d342665550a083$var$isMemo(object) {
    return $25d342665550a083$var$typeOf(object) === $25d342665550a083$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $25d342665550a083$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $25d342665550a083$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $25d342665550a083$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $25d342665550a083$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $25d342665550a083$var$verify(mapStateToProps, "mapStateToProps");
    $25d342665550a083$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $25d342665550a083$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $25d342665550a083$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $25d342665550a083$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $25d342665550a083$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $25d342665550a083$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $25d342665550a083$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $25d342665550a083$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $25d342665550a083$var$verifyPlainObject(value, displayName, methodName) {
    if (!$25d342665550a083$var$isPlainObject(value)) $25d342665550a083$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $25d342665550a083$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $25d342665550a083$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $25d342665550a083$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $25d342665550a083$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $25d342665550a083$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $25d342665550a083$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $25d342665550a083$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $25d342665550a083$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $25d342665550a083$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $25d342665550a083$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $25d342665550a083$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $25d342665550a083$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $25d342665550a083$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $25d342665550a083$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $25d342665550a083$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $25d342665550a083$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $25d342665550a083$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $25d342665550a083$var$__spreadValues($25d342665550a083$var$__spreadValues($25d342665550a083$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $25d342665550a083$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $25d342665550a083$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$25d342665550a083$var$defaultMergeProps : typeof mergeProps === "function" ? $25d342665550a083$var$wrapMergePropsFunc(mergeProps) : $25d342665550a083$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $25d342665550a083$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $25d342665550a083$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $25d342665550a083$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $25d342665550a083$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $25d342665550a083$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $25d342665550a083$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $25d342665550a083$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $25d342665550a083$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $25d342665550a083$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $25d342665550a083$var$isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $25d342665550a083$var$useIsomorphicLayoutEffect = $25d342665550a083$var$canUseDOM || $25d342665550a083$var$isReactNative ? $25d342665550a083$var$React.useLayoutEffect : $25d342665550a083$var$React.useEffect;
// src/utils/shallowEqual.ts
function $25d342665550a083$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $25d342665550a083$export$d36bdfa510afb180(objA, objB) {
    if ($25d342665550a083$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$25d342665550a083$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $25d342665550a083$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $25d342665550a083$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $25d342665550a083$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $25d342665550a083$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $25d342665550a083$var$TYPE_STATICS = {
    [$25d342665550a083$var$ForwardRef]: $25d342665550a083$var$FORWARD_REF_STATICS,
    [$25d342665550a083$var$Memo]: $25d342665550a083$var$MEMO_STATICS
};
function $25d342665550a083$var$getStatics(component) {
    if ($25d342665550a083$var$isMemo(component)) return $25d342665550a083$var$MEMO_STATICS;
    return $25d342665550a083$var$TYPE_STATICS[component["$$typeof"]] || $25d342665550a083$var$REACT_STATICS;
}
var $25d342665550a083$var$defineProperty = Object.defineProperty;
var $25d342665550a083$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $25d342665550a083$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $25d342665550a083$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $25d342665550a083$var$getPrototypeOf = Object.getPrototypeOf;
var $25d342665550a083$var$objectPrototype = Object.prototype;
function $25d342665550a083$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($25d342665550a083$var$objectPrototype) {
            const inheritedComponent = $25d342665550a083$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $25d342665550a083$var$objectPrototype) $25d342665550a083$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $25d342665550a083$var$getOwnPropertyNames(sourceComponent);
        if ($25d342665550a083$var$getOwnPropertySymbols) keys = keys.concat($25d342665550a083$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $25d342665550a083$var$getStatics(targetComponent);
        const sourceStatics = $25d342665550a083$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$25d342665550a083$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $25d342665550a083$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $25d342665550a083$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $25d342665550a083$var$useSyncExternalStore = $25d342665550a083$var$notInitialized;
var $25d342665550a083$var$initializeConnect = (fn)=>{
    $25d342665550a083$var$useSyncExternalStore = fn;
};
var $25d342665550a083$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $25d342665550a083$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $25d342665550a083$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $25d342665550a083$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $25d342665550a083$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $25d342665550a083$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $25d342665550a083$var$strictEqual(a, b) {
    return a === b;
}
var $25d342665550a083$var$hasWarnedAboutDeprecatedPureOption = false;
function $25d342665550a083$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $25d342665550a083$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $25d342665550a083$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $25d342665550a083$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $25d342665550a083$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $25d342665550a083$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $25d342665550a083$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $25d342665550a083$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $25d342665550a083$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $25d342665550a083$var$React.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $25d342665550a083$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $25d342665550a083$var$React.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $25d342665550a083$var$React.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $25d342665550a083$var$React.useMemo(()=>{
                return $25d342665550a083$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $25d342665550a083$var$React.useMemo(()=>{
                if (!shouldHandleStateChanges) return $25d342665550a083$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $25d342665550a083$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $25d342665550a083$var$React.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $25d342665550a083$var$__spreadProps($25d342665550a083$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $25d342665550a083$var$React.useRef(void 0);
            const lastWrapperProps = $25d342665550a083$var$React.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $25d342665550a083$var$React.useRef(void 0);
            const renderIsScheduled = $25d342665550a083$var$React.useRef(false);
            const isMounted = $25d342665550a083$var$React.useRef(false);
            const latestSubscriptionCallbackError = $25d342665550a083$var$React.useRef(void 0);
            $25d342665550a083$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $25d342665550a083$var$React.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $25d342665550a083$var$React.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $25d342665550a083$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $25d342665550a083$var$useIsomorphicLayoutEffectWithArgs($25d342665550a083$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $25d342665550a083$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $25d342665550a083$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $25d342665550a083$var$React.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $25d342665550a083$var$React.createElement(WrappedComponent, $25d342665550a083$var$__spreadProps($25d342665550a083$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $25d342665550a083$var$React.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $25d342665550a083$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $25d342665550a083$var$React.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $25d342665550a083$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $25d342665550a083$var$React.createElement(Connect, $25d342665550a083$var$__spreadProps($25d342665550a083$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $25d342665550a083$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $25d342665550a083$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $25d342665550a083$export$64605811ab45167f = $25d342665550a083$var$connect;
// src/components/Provider.tsx
function $25d342665550a083$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", identityFunctionCheck: identityFunctionCheck = "once" }) {
    const contextValue = $25d342665550a083$var$React.useMemo(()=>{
        const subscription = $25d342665550a083$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    const previousState = $25d342665550a083$var$React.useMemo(()=>store.getState(), [
        store
    ]);
    $25d342665550a083$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $25d342665550a083$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $25d342665550a083$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $25d342665550a083$export$2881499e37b75b9a = $25d342665550a083$var$Provider;
// src/hooks/useStore.ts
function $25d342665550a083$export$671dba69185d0304(context = $25d342665550a083$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $25d342665550a083$export$cc80c08dc91f1c00 ? $25d342665550a083$var$useReduxContext : // @ts-ignore
    $25d342665550a083$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $25d342665550a083$export$6ccbb43953eebf8 = /* @__PURE__ */ $25d342665550a083$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $25d342665550a083$export$bc9b55530897c558(context = $25d342665550a083$export$cc80c08dc91f1c00) {
    const useStore2 = context === $25d342665550a083$export$cc80c08dc91f1c00 ? $25d342665550a083$export$6ccbb43953eebf8 : $25d342665550a083$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $25d342665550a083$export$8ad76b76a4c905f8 = /* @__PURE__ */ $25d342665550a083$export$bc9b55530897c558();
// src/exports.ts
var $25d342665550a083$export$712ea50be43a7858 = $25d342665550a083$var$defaultNoopBatch;
// src/index.ts
$25d342665550a083$var$initializeUseSelector((0, $10715d3f0d22f08b$exports.useSyncExternalStoreWithSelector));
$25d342665550a083$var$initializeConnect($4Iuzv.useSyncExternalStore);



var $5aRSq = parcelRequire("5aRSq");

var $bfad34029b885b2b$exports = {};
$bfad34029b885b2b$exports = new URL("xmark.c0ff6290.png", import.meta.url).toString();


const $971c77a649e8448f$var$Login = ({ onClose: onClose, isLogin: isLogin })=>{
    const loginStyle = {
        transform: isLogin ? "translateX(0%)" : "translateX(100%)",
        transition: "transform ease-out .3s"
    };
    return /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
        className: "black-overlay",
        style: {
            opacity: isLogin ? 1 : 0,
            visibility: isLogin ? "visible" : "hidden"
        },
        onClick: onClose,
        children: /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
            className: "white-loginbar",
            onClick: (evt)=>evt.stopPropagation(),
            style: loginStyle,
            children: /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                className: "login-signUp-cont",
                children: [
                    /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                        className: "login-or-create-acc",
                        children: [
                            /*#__PURE__*/ (0, $5aRSq.jsx)("a", {
                                className: "login-signUp-close-btn",
                                onClick: onClose,
                                children: /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                                    className: "xmark-login-page",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($bfad34029b885b2b$exports)))
                                })
                            }),
                            /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                                className: "login-head-top",
                                children: "Login"
                            }),
                            /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                                className: "new-acc-creation-div",
                                children: [
                                    "or ",
                                    /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                        className: "creat-an-acc-text",
                                        children: "create an account"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                        className: "login-signUp-form",
                        children: [
                            /*#__PURE__*/ (0, $5aRSq.jsx)("input", {
                                className: "input-login-email-phone",
                                autoCapitalize: "off",
                                placeholder: "Email address or Phone Number",
                                type: "text",
                                required: true
                            }),
                            /*#__PURE__*/ (0, $5aRSq.jsx)("button", {
                                className: "login-btn-or",
                                children: "Login"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $971c77a649e8448f$export$2e2bcd8739ae039 = $971c77a649e8448f$var$Login;


var $663b786ac8c2fc36$exports = {};
$663b786ac8c2fc36$exports = new URL("offers.a7cdf18c.png", import.meta.url).toString();


const $cf5a5aeeefcd27c2$var$Header = ()=>{
    const [showLogin, setShowLogin] = (0, $4Iuzv.useState)(false);
    const { loggedInUser: loggedInUser } = (0, $4Iuzv.useContext)((0, $fmRNI.default));
    // Subscribing to the store using a Selector
    const cartItems = (0, $25d342665550a083$export$2105062e25df4afe)((store)=>store.cart.items);
    const handleLoginClick = (event)=>{
        event.preventDefault();
        setShowLogin(true);
    };
    return /*#__PURE__*/ (0, $5aRSq.jsxs)((0, $5aRSq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $5aRSq.jsx)((0, $971c77a649e8448f$export$2e2bcd8739ae039), {
                onClose: ()=>setShowLogin(false),
                isLogin: showLogin
            }),
            /*#__PURE__*/ (0, $5aRSq.jsxs)("header", {
                children: [
                    /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                        className: "logo-container",
                        children: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $c34e9f2261c19895$export$a6c7ac8248d6e38a), {
                            to: "/",
                            reloadDocument: true,
                            style: {
                                textDecoration: "none"
                            },
                            children: /*#__PURE__*/ (0, $5aRSq.jsxs)("span", {
                                className: "brown",
                                children: [
                                    "\u0916\u092E\u094D\u092E\u093E ",
                                    /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                        className: "brown",
                                        children: "\u0918\u0923\u0940 \u0938\u093E !"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsxs)("span", {
                        className: "raj",
                        children: [
                            /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                className: "green",
                                children: "FIND"
                            }),
                            " YOUR FAVORITE",
                            " ",
                            /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                className: "pink",
                                children: "RAJASTHANI"
                            }),
                            " FOOD"
                        ]
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                        className: "nav-items",
                        children: /*#__PURE__*/ (0, $5aRSq.jsxs)("ul", {
                            className: "navOptions",
                            children: [
                                /*#__PURE__*/ (0, $5aRSq.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $c34e9f2261c19895$export$a6c7ac8248d6e38a), {
                                        to: "/",
                                        children: "Home"
                                    })
                                }),
                                /*#__PURE__*/ (0, $5aRSq.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $c34e9f2261c19895$export$a6c7ac8248d6e38a), {
                                        to: "/offers",
                                        children: /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                                            className: "offerContainer",
                                            children: [
                                                /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                                                    className: "offerPng",
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($663b786ac8c2fc36$exports)))
                                                }),
                                                /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                                    children: "Offers"
                                                }),
                                                /*#__PURE__*/ (0, $5aRSq.jsx)("sup", {
                                                    className: "newOffer",
                                                    children: " NEW "
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $5aRSq.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $c34e9f2261c19895$export$a6c7ac8248d6e38a), {
                                        to: "/grocery",
                                        children: /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                                            className: "grocerySection",
                                            children: [
                                                /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                                    className: "grocery_String",
                                                    children: "Grocery"
                                                }),
                                                /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                                                    className: "groceryImg",
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($5f9a00396a8cbcc9$exports))),
                                                    alt: "grocery Image"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $5aRSq.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $c34e9f2261c19895$export$a6c7ac8248d6e38a), {
                                        to: "/about",
                                        children: "About Us"
                                    })
                                }),
                                /*#__PURE__*/ (0, $5aRSq.jsx)("li", {
                                    className: "sign-in-li",
                                    children: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $c34e9f2261c19895$export$a6c7ac8248d6e38a), {
                                        onClick: handleLoginClick,
                                        children: "Sign In"
                                    })
                                }),
                                /*#__PURE__*/ (0, $5aRSq.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $c34e9f2261c19895$export$a6c7ac8248d6e38a), {
                                        to: "/cart",
                                        children: /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                                            className: "cart",
                                            children: [
                                                /*#__PURE__*/ (0, $5aRSq.jsxs)("span", {
                                                    className: "plate_cart",
                                                    children: [
                                                        /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                                                            className: "plateSvg",
                                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($e739f47ff36c4788$exports)))
                                                        }),
                                                        /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                                            className: "plate_count",
                                                            children: cartItems.length
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                                    className: "cartString",
                                                    children: "Cart"
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $cf5a5aeeefcd27c2$export$2e2bcd8739ae039 = $cf5a5aeeefcd27c2$var$Header;



var $5aRSq = parcelRequire("5aRSq");

var $5aRSq = parcelRequire("5aRSq");
var $c6e05221391e2cee$exports = {};
$c6e05221391e2cee$exports = new URL("star.818656f0.svg", import.meta.url).toString();


const $1449da937569f1f7$export$31adfacaf07ffe63 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
const $1449da937569f1f7$export$b77c1aa4fb57bd1c = "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=26.8947446&lng=75.8301169&restaurantId=";
const $1449da937569f1f7$export$6174cf629c5f054e = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_288,h_360/";



const $f7341c77353892c0$var$RestaurantCard = ({ resData: resData })=>{
    const { info: info, analytics: analytics, cta: cta, widgetId: widgetId } = resData;
    const { cloudinaryImageId: cloudinaryImageId, name: name, avgRating: avgRating, sla: sla, cuisines: cuisines, areaName: areaName, costForTwo: costForTwo } = info;
    return /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
        "data-testid": "#resCard",
        className: "res-card",
        children: /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
            className: "card_box",
            children: [
                /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                    className: "foodImg",
                    src: (0, $1449da937569f1f7$export$31adfacaf07ffe63) + cloudinaryImageId
                }),
                /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                    className: "content",
                    children: [
                        /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                            className: "res_name",
                            children: name
                        }),
                        /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                            className: "starRating_duration",
                            children: [
                                /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($c6e05221391e2cee$exports)))
                                }),
                                /*#__PURE__*/ (0, $5aRSq.jsxs)("span", {
                                    className: "rating",
                                    children: [
                                        avgRating,
                                        " \u2022"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                                    className: "duration",
                                    children: sla?.slaString
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                            className: "xy1 fn",
                            children: [
                                cuisines.join(", "),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                            className: "xy1",
                            children: areaName
                        }),
                        /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                            className: "price",
                            children: costForTwo
                        })
                    ]
                })
            ]
        })
    });
};
const $f7341c77353892c0$export$ccb02a230af14023 = (RestaurantCard)=>{
    return (props)=>{
        const { resData: resData } = props;
        const isOpen = resData?.info?.availability?.opened;
        return /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $5aRSq.jsx)("label", {
                    className: "promoted",
                    children: isOpen ? "Open Now" : "Closed"
                }),
                /*#__PURE__*/ (0, $5aRSq.jsx)(RestaurantCard, {
                    ...props
                })
            ]
        });
    };
};
var $f7341c77353892c0$export$2e2bcd8739ae039 = $f7341c77353892c0$var$RestaurantCard;



var $4Iuzv = parcelRequire("4Iuzv");

var $5aRSq = parcelRequire("5aRSq");

const $9a0dfef7d616d4f6$var$ShimmerUI = ()=>{
    return /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
        className: "shimmer-ui-container",
        children: [
            /*#__PURE__*/ (0, $5aRSq.jsx)("h1", {
                className: "loading",
                children: "Looking for great food near you ..."
            }),
            /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                className: "shimmer_container",
                children: [
                    /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                        className: "shimmer-card"
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                        className: "shimmer-card"
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                        className: "shimmer-card"
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                        className: "shimmer-card"
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                        className: "shimmer-card"
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                        className: "shimmer-card"
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                        className: "shimmer-card"
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                        className: "shimmer-card"
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                        className: "shimmer-card"
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                        className: "shimmer-card"
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                        className: "shimmer-card"
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                        className: "shimmer-card"
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                        className: "shimmer-card"
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                        className: "shimmer-card"
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                        className: "shimmer-card"
                    })
                ]
            })
        ]
    });
};
var $9a0dfef7d616d4f6$export$2e2bcd8739ae039 = $9a0dfef7d616d4f6$var$ShimmerUI;




var $4Iuzv = parcelRequire("4Iuzv");
const $e3dee1ed6350a35d$var$useOnlineStatus = ()=>{
    const [onlineStatus, setOnlineStatus] = (0, $4Iuzv.useState)(true);
    // check if online
    (0, $4Iuzv.useEffect)(()=>{
        window.addEventListener("offline", ()=>{
            setOnlineStatus(false);
        });
        window.addEventListener("online", ()=>{
            setOnlineStatus(true);
        });
    }, []);
    return onlineStatus;
};
var $e3dee1ed6350a35d$export$2e2bcd8739ae039 = $e3dee1ed6350a35d$var$useOnlineStatus;


var $662481e488545f0b$exports = {};
$662481e488545f0b$exports = new URL("cross1.26f17a82.svg", import.meta.url).toString();


var $454ff7dd5f9d8bae$exports = {};
$454ff7dd5f9d8bae$exports = new URL("filter.79d99e8c.svg", import.meta.url).toString();




var $52bfc5d66a3993b2$exports = {};
$52bfc5d66a3993b2$exports = new URL("previousArrow.e511afba.png", import.meta.url).toString();


var $b8eec414d829e0cb$exports = {};
$b8eec414d829e0cb$exports = new URL("nextArrow.cba488e2.png", import.meta.url).toString();


const $fbae3e930d5c7be3$var$AppBody = ()=>{
    // Local state variable - Super powerful variable ~ listofRestaurants is state variable why bcoz react is keeping an eye on it, track it. whenever it updates react will trigger its diff algorithm.
    const [listofRestaurants, setListOfRestaurant] = (0, $4Iuzv.useState)([]);
    const [filteredRestaurants, setFilteredRestaurant] = (0, $4Iuzv.useState)([]);
    const [searchText, setSearchText] = (0, $4Iuzv.useState)("");
    const [foodCategoryImg, setFoodCategoryImg] = (0, $4Iuzv.useState)([]);
    const RestaurantCardPromoted = (0, $f7341c77353892c0$export$ccb02a230af14023)((0, $f7341c77353892c0$export$2e2bcd8739ae039));
    const [isActive, setActive] = (0, $4Iuzv.useState)(false);
    const [isVeg, setVeg] = (0, $4Iuzv.useState)(false);
    const [isFastDelivery, setFastDelivery] = (0, $4Iuzv.useState)(false);
    const [isLessThan300, setLessThan300] = (0, $4Iuzv.useState)(false);
    const [buttonCount, setButtonCount] = (0, $4Iuzv.useState)(0);
    const [slider, moveSlider] = (0, $4Iuzv.useState)(0);
    // Styling when state changes
    const buttonStyle = {
        backgroundColor: "white",
        border: "1px solid rgba(2, 6, 12, 0.15)"
    };
    const activeButtonStyle = {
        backgroundColor: "rgb(240, 240, 245)",
        border: "1px solid rgba(6, 6, 6, 0.75)"
    };
    const activeFilterStyle = {
        backgroundColor: "rgba(2, 6, 12, 0.15)"
    };
    const withX = {
        display: "flex"
    };
    const withoutX = {
        display: "none"
    };
    // Clear all filters
    const clearFilter = ()=>{
        setButtonCount(0);
        setActive(false);
        setVeg(false);
        setFastDelivery(false);
        setLessThan300(false);
        setFilteredRestaurant(listofRestaurants);
    };
    // Fiter logic functions
    const filter4Rating = ()=>{
        setActive(!isActive);
        setButtonCount(isActive ? buttonCount - 1 : buttonCount + 1);
        if (isActive) setFilteredRestaurant(listofRestaurants);
        else {
            const ratingFilteredList = filteredRestaurants.filter((res)=>res.info.avgRating > 4);
            setFilteredRestaurant(ratingFilteredList);
        }
    };
    const filterFastDelivery = ()=>{
        setFastDelivery(!isFastDelivery);
        setButtonCount(isFastDelivery ? buttonCount - 1 : buttonCount + 1);
        if (isFastDelivery) setFilteredRestaurant(listofRestaurants);
        else {
            const fastDeliveryTimeResList = filteredRestaurants.filter((res)=>res.info.sla.deliveryTime < 26);
            setFilteredRestaurant(fastDeliveryTimeResList);
        }
    };
    const filterLessThan300 = ()=>{
        setLessThan300(!isLessThan300);
        setButtonCount(isLessThan300 ? buttonCount - 1 : buttonCount + 1);
        if (isLessThan300) setFilteredRestaurant(listofRestaurants);
        else {
            const lessThan300List = filteredRestaurants.filter((res)=>{
                const costInNumber = parseInt(res.info.costForTwo.match(/\d+/)[0]);
                return !isNaN(costInNumber) && costInNumber < 300;
            });
            setFilteredRestaurant(lessThan300List);
        }
    };
    const filterVeg = ()=>{
        setVeg(!isVeg);
        setButtonCount(isVeg ? buttonCount - 1 : buttonCount + 1);
        if (isVeg) setFilteredRestaurant(listofRestaurants);
        else {
            const vegRestaurants1 = filteredRestaurants.filter((res)=>res.info?.name.toLowerCase().includes("veg"));
            const vegRestaurants2 = filteredRestaurants.filter((res)=>res.info?.veg);
            const pureVegList = [
                ...vegRestaurants1,
                ...vegRestaurants2
            ];
            setFilteredRestaurant(pureVegList);
        }
    };
    const fetchData = async ()=>{
        // getRestaurants()
        const data = await fetch("https://www.swiggy.com/dapi/restaurants/list/v5?lat=26.8947446&lng=75.8301169&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING");
        const json = await data.json();
        setListOfRestaurant(json?.data?.cards[1]?.card?.card?.gridElements?.infoWithStyle?.restaurants);
        setFilteredRestaurant(json?.data?.cards[1]?.card?.card?.gridElements?.infoWithStyle?.restaurants);
        const filteredImg = json.data.cards[0].card.card.imageGridCards.info;
        setFoodCategoryImg(filteredImg);
    };
    (0, $4Iuzv.useEffect)(()=>{
        // called once after initial render (empty dependency array) and of re-render of AppBody component
        fetchData();
    }, []);
    const onlineStatus = (0, $e3dee1ed6350a35d$export$2e2bcd8739ae039)();
    if (onlineStatus === false) return /*#__PURE__*/ (0, $5aRSq.jsx)("h1", {
        className: "netStatus",
        children: "Looks like you are offline!! Please check your internet connection."
    });
    const slideToPrevious = ()=>{
        moveSlider(slider - 3);
    };
    const slideToNext = ()=>{
        slider < 9 && moveSlider(slider + 3);
    };
    // Returning JSX
    return listofRestaurants.length === 0 ? /*#__PURE__*/ (0, $5aRSq.jsx)((0, $9a0dfef7d616d4f6$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
        className: "bodySection",
        children: [
            /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                className: "whatsOnYourMind",
                children: [
                    /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                        className: "food-cat-heading",
                        children: [
                            /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                className: "home-page-heading",
                                children: "What's on your mind?"
                            }),
                            /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                                className: "pn-button-container",
                                children: [
                                    /*#__PURE__*/ (0, $5aRSq.jsx)("button", {
                                        onClick: slideToPrevious,
                                        children: /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                                            className: "previousBtn",
                                            children: /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($52bfc5d66a3993b2$exports))),
                                                className: "pn-arrow",
                                                alt: "previous button"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $5aRSq.jsx)("button", {
                                        onClick: slideToNext,
                                        children: /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                                            className: "nextBtn",
                                            children: /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($b8eec414d829e0cb$exports))),
                                                className: "pn-arrow",
                                                alt: "next button"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                        className: "fcat-img-container",
                        children: foodCategoryImg.map((img)=>/*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                className: "cont-for-each-img",
                                style: {
                                    transform: `translateX(-${slider * 100}%)`
                                },
                                children: /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                                    className: "f-cat-img",
                                    src: (0, $1449da937569f1f7$export$6174cf629c5f054e) + img.imageId
                                })
                            }, img.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("hr", {
                className: "hrline"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                className: "search-filter-section",
                children: [
                    /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                        className: "search",
                        children: [
                            /*#__PURE__*/ (0, $5aRSq.jsx)("input", {
                                type: "text",
                                placeholder: "Search for restaurants and food",
                                className: "searchBox",
                                "data-testid": "searchInput",
                                value: searchText,
                                onChange: (e)=>{
                                    setSearchText(e.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0, $5aRSq.jsx)("button", {
                                className: "search_btn",
                                onClick: ()=>{
                                    // Filter the restaurant cards and update the UI
                                    if (searchText.length > 0) {
                                        const searchFilteredList = listofRestaurants.filter((res)=>res.info?.name.toLowerCase().includes(searchText.toLowerCase()) || res.info?.cuisines.join().toLowerCase().includes(searchText.toLowerCase()));
                                        setFilteredRestaurant(searchFilteredList);
                                    }
                                },
                                children: "Search"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                        className: "filter",
                        children: [
                            /*#__PURE__*/ (0, $5aRSq.jsxs)("button", {
                                className: "filterCountBtn",
                                style: isActive || isVeg || isLessThan300 || isFastDelivery ? activeFilterStyle : buttonStyle,
                                children: [
                                    (isActive || isVeg || isLessThan300 || isFastDelivery) && /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                        className: "filterCount",
                                        children: buttonCount
                                    }),
                                    /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                                        children: "Filter"
                                    }),
                                    /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                        className: "show_filter",
                                        children: /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($454ff7dd5f9d8bae$exports)))
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $5aRSq.jsxs)("button", {
                                className: "filter-btn",
                                onClick: filter4Rating,
                                style: isActive ? activeButtonStyle : buttonStyle,
                                children: [
                                    "Rating 4.0+",
                                    /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                        className: "xSign",
                                        style: isActive ? withX : withoutX,
                                        children: /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($662481e488545f0b$exports))),
                                            alt: "cross Sign"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $5aRSq.jsxs)("button", {
                                onClick: filterFastDelivery,
                                style: isFastDelivery ? activeButtonStyle : buttonStyle,
                                children: [
                                    "Fast Delivery",
                                    isFastDelivery && /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                        className: "xSign",
                                        children: /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($662481e488545f0b$exports))),
                                            alt: "cross Sign"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $5aRSq.jsxs)("button", {
                                onClick: filterLessThan300,
                                style: isLessThan300 ? activeButtonStyle : buttonStyle,
                                children: [
                                    "Less than Rs. 300",
                                    isLessThan300 && /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                        className: "xSign",
                                        children: /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($662481e488545f0b$exports))),
                                            alt: "cross Sign"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $5aRSq.jsxs)("button", {
                                onClick: filterVeg,
                                style: isVeg ? activeButtonStyle : buttonStyle,
                                children: [
                                    "Pure Veg",
                                    isVeg && /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                        className: "xSign",
                                        children: /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($662481e488545f0b$exports))),
                                            alt: "cross Sign"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $5aRSq.jsx)("button", {
                                className: "clearAllFilter",
                                onClick: clearFilter,
                                children: "Clear all filters"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("hr", {
                className: "hrline"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("h2", {
                className: "jaipurRes home-page-heading",
                children: "Restaurants with online food delivery in Jaipur"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                className: "res-container",
                children: [
                    filteredRestaurants.length === 0 && /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                        className: "notFindText",
                        children: [
                            "Sorry we couldn't find any matches for",
                            " ",
                            /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                className: "search-text-item",
                                children: searchText
                            }),
                            " !! Search for restaurants or its dishes"
                        ]
                    }),
                    filteredRestaurants.map((restaurant)=>/*#__PURE__*/ (0, $5aRSq.jsx)((0, $c34e9f2261c19895$export$a6c7ac8248d6e38a), {
                            style: {
                                textDecoration: "none",
                                color: "unset"
                            },
                            to: "/menu/" + restaurant.info.id,
                            children: restaurant.info.availability.opened ? /*#__PURE__*/ (0, $5aRSq.jsx)(RestaurantCardPromoted, {
                                resData: restaurant
                            }) : /*#__PURE__*/ (0, $5aRSq.jsx)((0, $f7341c77353892c0$export$2e2bcd8739ae039), {
                                resData: restaurant
                            })
                        }, restaurant.info.id))
                ]
            })
        ]
    });
};
var $fbae3e930d5c7be3$export$2e2bcd8739ae039 = $fbae3e930d5c7be3$var$AppBody;



var $5aRSq = parcelRequire("5aRSq");


const $a87d1ec7246dc632$var$Footer = ()=>{
    const onlineStatus = (0, $e3dee1ed6350a35d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $5aRSq.jsx)("footer", {
        children: /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
            className: "footerPart",
            children: [
                /*#__PURE__*/ (0, $5aRSq.jsx)("a", {
                    href: "#",
                    children: "FAQ"
                }),
                /*#__PURE__*/ (0, $5aRSq.jsx)("a", {
                    href: "#",
                    children: "Contact Us"
                }),
                /*#__PURE__*/ (0, $5aRSq.jsx)("a", {
                    href: "#",
                    children: "Offer Terms"
                }),
                /*#__PURE__*/ (0, $5aRSq.jsx)("a", {
                    href: "#",
                    children: "Partner with us"
                }),
                /*#__PURE__*/ (0, $5aRSq.jsx)("a", {
                    href: "#",
                    children: "Refund & Cancellation"
                }),
                /*#__PURE__*/ (0, $5aRSq.jsx)("a", {
                    href: "#",
                    children: "\xa92024 KhammaGhani"
                }),
                /*#__PURE__*/ (0, $5aRSq.jsxs)("a", {
                    href: "#",
                    children: [
                        "Online Status: ",
                        onlineStatus ? "\u2705" : "\uD83D\uDD34"
                    ]
                })
            ]
        })
    });
};
var $a87d1ec7246dc632$export$2e2bcd8739ae039 = $a87d1ec7246dc632$var$Footer;



var $5aRSq = parcelRequire("5aRSq");

var $4Iuzv = parcelRequire("4Iuzv");

var $5aRSq = parcelRequire("5aRSq");

var $4Iuzv = parcelRequire("4Iuzv");

class $6337111be43e59aa$var$UserClass extends (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).Component {
    constructor(props){
        super(props);
        this.state = {
            userInfo: {
                name: "Dummy user",
                location: "Default",
                avatar_url: "image",
                repos_url: "link"
            }
        };
    }
    async componentDidMount() {
        const response = await fetch("https://api.github.com/users/marwalabhi");
        const json = await response.json(); // read response body and parse the JSON: .json= body reading method
        // response.json() - parse the response as JSON object
        this.setState({
            userInfo: json
        });
    }
    componentDidUpdate() {
    // console.log("Comoponent Did Update");
    }
    componentWillUnmount() {
    // console.log("Comoponent Will Unmount");
    }
    render() {
        const { name: name, location: location, avatar_url: avatar_url, html_url: html_url, login: login } = this.state.userInfo;
        return /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
            className: "user-card",
            children: [
                /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                    className: "userImg",
                    src: avatar_url
                }),
                /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                    className: "card_content",
                    children: [
                        /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                            className: "git",
                            children: [
                                "Name: ",
                                name
                            ]
                        }),
                        /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                            className: "git",
                            children: [
                                "Location: ",
                                location
                            ]
                        }),
                        /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                            className: "git",
                            children: "Contact: marwalabhi987@gmail.com"
                        }),
                        /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                            className: "git",
                            children: [
                                "Repos Link:",
                                " ",
                                /*#__PURE__*/ (0, $5aRSq.jsx)("a", {
                                    href: html_url,
                                    target: "_blank",
                                    className: "g-link-style-repo",
                                    rel: "noopener noreferrer",
                                    children: "Go to GitHub"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
var $6337111be43e59aa$export$2e2bcd8739ae039 = $6337111be43e59aa$var$UserClass;




var $fmRNI = parcelRequire("fmRNI");
// Class based component used for learning purposes
class $3d797a4fd66ccc9e$var$About extends (0, $4Iuzv.Component) {
    constructor(props){
        super(props);
    // console.log("Parent Constructor");
    }
    componentDidMount() {
    // console.log("Parent Component did mount");
    }
    render() {
        return /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
            className: "about--section",
            children: [
                /*#__PURE__*/ (0, $5aRSq.jsx)("h1", {
                    className: "aboutUs",
                    children: "About Us"
                }),
                /*#__PURE__*/ (0, $5aRSq.jsx)("h2", {
                    className: "des",
                    children: "Order rajasthani food from all over rajasthan"
                }),
                /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                    className: "loggedInUN",
                    children: [
                        "Logged In User:",
                        /*#__PURE__*/ (0, $5aRSq.jsx)((0, $fmRNI.default).Consumer, {
                            children: ({ loggedInUser: loggedInUser, setUserName: setUserName })=>/*#__PURE__*/ (0, $5aRSq.jsx)("h3", {
                                    className: "uname",
                                    children: loggedInUser
                                })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                    className: "inputUserName",
                    children: /*#__PURE__*/ (0, $5aRSq.jsxs)("label", {
                        children: [
                            "Enter the UserName:",
                            " ",
                            /*#__PURE__*/ (0, $5aRSq.jsx)((0, $fmRNI.default).Consumer, {
                                children: ({ setUserName: setUserName, loggedInUser: loggedInUser })=>/*#__PURE__*/ (0, $5aRSq.jsx)("input", {
                                        type: "text",
                                        value: loggedInUser,
                                        onChange: (e)=>setUserName(e.target.value)
                                    })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                    children: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $6337111be43e59aa$export$2e2bcd8739ae039), {})
                })
            ]
        });
    }
}
var $3d797a4fd66ccc9e$export$2e2bcd8739ae039 = $3d797a4fd66ccc9e$var$About;



var $5aRSq = parcelRequire("5aRSq");

var $4Iuzv = parcelRequire("4Iuzv");

function $644d395bf2a96561$var$Panel({ title: title, children: children, isActive: isActive, onShow: onShow }) {
    return /*#__PURE__*/ (0, $5aRSq.jsxs)("section", {
        className: "panel",
        children: [
            /*#__PURE__*/ (0, $5aRSq.jsx)("h3", {
                children: title
            }),
            isActive ? /*#__PURE__*/ (0, $5aRSq.jsx)("p", {
                children: children
            }) : /*#__PURE__*/ (0, $5aRSq.jsx)("button", {
                onClick: onShow,
                children: "Show"
            })
        ]
    });
}
const $644d395bf2a96561$var$Offers = ()=>{
    // closest common parent
    const [activeIndex, setActiveIndex] = (0, $4Iuzv.useState)(0);
    return /*#__PURE__*/ (0, $5aRSq.jsxs)((0, $5aRSq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $5aRSq.jsx)("h2", {
                className: "head_section",
                children: "Offers Section of your app"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("h3", {
                className: "head_section",
                children: "Coming Soon"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("label", {
                children: "Name: "
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("input", {
                type: "text",
                placeholder: "enter name"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("label", {
                children: "Address: "
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("input", {
                type: "text",
                placeholder: "enter address"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)($644d395bf2a96561$var$Panel, {
                title: "About",
                isActive: activeIndex === 0,
                onShow: ()=>setActiveIndex(0),
                children: "With a population of about 2 million, Almaty is Kazakhstan's largest city. From 1929 to 1997, it was its capital city."
            }),
            /*#__PURE__*/ (0, $5aRSq.jsxs)($644d395bf2a96561$var$Panel, {
                title: "Accordian used in menu category",
                isActive: activeIndex === 1,
                onShow: ()=>setActiveIndex(1),
                children: [
                    "The name comes from ",
                    /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                        lang: "kk-KZ",
                        children: "\u0430\u043B\u043C\u0430"
                    }),
                    ', the Kazakh word for "apple" and is often translated as "full of apples". In fact, the region surrounding Almaty is thought to be the ancestral home of the apple, and the wild ',
                    /*#__PURE__*/ (0, $5aRSq.jsx)("i", {
                        lang: "la",
                        children: "Malus sieversii"
                    }),
                    " is considered a likely candidate for the ancestor of the modern domestic apple."
                ]
            })
        ]
    });
};
var $644d395bf2a96561$export$2e2bcd8739ae039 = $644d395bf2a96561$var$Offers;



var $5aRSq = parcelRequire("5aRSq");


const $7f01531221b306d8$var$Error = ()=>{
    const err = (0, $175a2504a1bf07a5$export$ed527bf60f6e05f2)();
    console.log(err);
    return /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
        className: "e-error-container",
        children: [
            /*#__PURE__*/ (0, $5aRSq.jsx)("h1", {
                children: "Oops!"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "e-err-msg-wrong",
                children: "Something went wrong!"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsxs)("h3", {
                children: [
                    err.status,
                    ": ",
                    err.statusText
                ]
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("h5", {
                children: err.data
            })
        ]
    });
};
var $7f01531221b306d8$export$2e2bcd8739ae039 = $7f01531221b306d8$var$Error;



var $5aRSq = parcelRequire("5aRSq");

var $5aRSq = parcelRequire("5aRSq");

const $e58ede3959b42f38$var$MenuShimmerUI = ()=>{
    return /*#__PURE__*/ (0, $5aRSq.jsx)("h1", {
        className: "menu-page-load-shimmer",
        children: "Loading restaurant details ..."
    });
};
var $e58ede3959b42f38$export$2e2bcd8739ae039 = $e58ede3959b42f38$var$MenuShimmerUI;



var $4Iuzv = parcelRequire("4Iuzv");


var $4Iuzv = parcelRequire("4Iuzv");

const $6a9db8a30167c416$var$useRestaurantMenu = (resId)=>{
    const [resMenu, setResMenu] = (0, $4Iuzv.useState)(null);
    (0, $4Iuzv.useEffect)(()=>{
        fetchMenu();
    }, []);
    const fetchMenu = async ()=>{
        const data = await fetch((0, $1449da937569f1f7$export$b77c1aa4fb57bd1c) + resId);
        const json = await data.json();
        setResMenu(json.data);
    };
    return resMenu;
};
var $6a9db8a30167c416$export$2e2bcd8739ae039 = $6a9db8a30167c416$var$useRestaurantMenu;



var $5aRSq = parcelRequire("5aRSq");

var $5aRSq = parcelRequire("5aRSq");


// src/utils/formatProdErrorMessage.ts
function $b0c9b171c350de9c$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $b0c9b171c350de9c$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $b0c9b171c350de9c$var$symbol_observable_default = $b0c9b171c350de9c$var$$$observable;
// src/utils/actionTypes.ts
var $b0c9b171c350de9c$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $b0c9b171c350de9c$var$ActionTypes = {
    INIT: `@@redux/INIT${$b0c9b171c350de9c$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$b0c9b171c350de9c$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$b0c9b171c350de9c$var$randomString()}`
};
var $b0c9b171c350de9c$export$4219e499db7ca678 = $b0c9b171c350de9c$var$ActionTypes;
// src/utils/isPlainObject.ts
function $b0c9b171c350de9c$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $b0c9b171c350de9c$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($b0c9b171c350de9c$var$isDate(val)) return "date";
    if ($b0c9b171c350de9c$var$isError(val)) return "error";
    const constructorName = $b0c9b171c350de9c$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $b0c9b171c350de9c$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $b0c9b171c350de9c$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $b0c9b171c350de9c$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $b0c9b171c350de9c$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $b0c9b171c350de9c$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(1));
        return enhancer($b0c9b171c350de9c$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$b0c9b171c350de9c$export$53b83ca8eaab0383(action)) throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $b0c9b171c350de9c$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$b0c9b171c350de9c$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $b0c9b171c350de9c$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$b0c9b171c350de9c$var$symbol_observable_default]: observable
    };
    return store;
}
function $b0c9b171c350de9c$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $b0c9b171c350de9c$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $b0c9b171c350de9c$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $b0c9b171c350de9c$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $b0c9b171c350de9c$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$b0c9b171c350de9c$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$b0c9b171c350de9c$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $b0c9b171c350de9c$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $b0c9b171c350de9c$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $b0c9b171c350de9c$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $b0c9b171c350de9c$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(13));
    });
}
function $b0c9b171c350de9c$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $b0c9b171c350de9c$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $b0c9b171c350de9c$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $b0c9b171c350de9c$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $b0c9b171c350de9c$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $b0c9b171c350de9c$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $b0c9b171c350de9c$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $b0c9b171c350de9c$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $b0c9b171c350de9c$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $b0c9b171c350de9c$export$b956e38827fca970(action) {
    return $b0c9b171c350de9c$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $7e93f60b48cb9fdf$var$__defProp = Object.defineProperty;
var $7e93f60b48cb9fdf$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $7e93f60b48cb9fdf$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7e93f60b48cb9fdf$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $7e93f60b48cb9fdf$var$__defNormalProp = (obj, key, value)=>key in obj ? $7e93f60b48cb9fdf$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7e93f60b48cb9fdf$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($7e93f60b48cb9fdf$var$__hasOwnProp.call(b, prop)) $7e93f60b48cb9fdf$var$__defNormalProp(a, prop, b[prop]);
    if ($7e93f60b48cb9fdf$var$__getOwnPropSymbols) {
        for (var prop of $7e93f60b48cb9fdf$var$__getOwnPropSymbols(b))if ($7e93f60b48cb9fdf$var$__propIsEnum.call(b, prop)) $7e93f60b48cb9fdf$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $7e93f60b48cb9fdf$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $7e93f60b48cb9fdf$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $7e93f60b48cb9fdf$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $7e93f60b48cb9fdf$var$errors = [];
function $7e93f60b48cb9fdf$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $7e93f60b48cb9fdf$var$getPrototypeOf = Object.getPrototypeOf;
function $7e93f60b48cb9fdf$export$541ac630993a4c84(value) {
    return !!value && !!value[$7e93f60b48cb9fdf$var$DRAFT_STATE];
}
function $7e93f60b48cb9fdf$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $7e93f60b48cb9fdf$var$isPlainObject(value) || Array.isArray(value) || !!value[$7e93f60b48cb9fdf$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$7e93f60b48cb9fdf$export$6ee2082928bcb0ee]) || $7e93f60b48cb9fdf$var$isMap(value) || $7e93f60b48cb9fdf$var$isSet(value);
}
var $7e93f60b48cb9fdf$var$objectCtorString = Object.prototype.constructor.toString();
function $7e93f60b48cb9fdf$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $7e93f60b48cb9fdf$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $7e93f60b48cb9fdf$var$objectCtorString;
}
function $7e93f60b48cb9fdf$export$22e8af3f75a010e3(value) {
    if (!$7e93f60b48cb9fdf$export$541ac630993a4c84(value)) $7e93f60b48cb9fdf$var$die(15, value);
    return value[$7e93f60b48cb9fdf$var$DRAFT_STATE].base_;
}
function $7e93f60b48cb9fdf$var$each(obj, iter) {
    if ($7e93f60b48cb9fdf$var$getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $7e93f60b48cb9fdf$var$getArchtype(thing) {
    const state = thing[$7e93f60b48cb9fdf$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $7e93f60b48cb9fdf$var$isMap(thing) ? 2 /* Map */  : $7e93f60b48cb9fdf$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $7e93f60b48cb9fdf$var$has(thing, prop) {
    return $7e93f60b48cb9fdf$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $7e93f60b48cb9fdf$var$get(thing, prop) {
    return $7e93f60b48cb9fdf$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $7e93f60b48cb9fdf$var$set(thing, propOrOldValue, value) {
    const t = $7e93f60b48cb9fdf$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $7e93f60b48cb9fdf$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $7e93f60b48cb9fdf$var$isMap(target) {
    return target instanceof Map;
}
function $7e93f60b48cb9fdf$var$isSet(target) {
    return target instanceof Set;
}
function $7e93f60b48cb9fdf$var$latest(state) {
    return state.copy_ || state.base_;
}
function $7e93f60b48cb9fdf$var$shallowCopy(base, strict) {
    if ($7e93f60b48cb9fdf$var$isMap(base)) return new Map(base);
    if ($7e93f60b48cb9fdf$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $7e93f60b48cb9fdf$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$7e93f60b48cb9fdf$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($7e93f60b48cb9fdf$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $7e93f60b48cb9fdf$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $7e93f60b48cb9fdf$var$__spreadValues({}, base);
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $7e93f60b48cb9fdf$export$792f3d81ea979f55(obj, deep = false) {
    if ($7e93f60b48cb9fdf$var$isFrozen(obj) || $7e93f60b48cb9fdf$export$541ac630993a4c84(obj) || !$7e93f60b48cb9fdf$export$16e3aed3edb85946(obj)) return obj;
    if ($7e93f60b48cb9fdf$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $7e93f60b48cb9fdf$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>$7e93f60b48cb9fdf$export$792f3d81ea979f55(value, true));
    return obj;
}
function $7e93f60b48cb9fdf$var$dontMutateFrozenCollections() {
    $7e93f60b48cb9fdf$var$die(2);
}
function $7e93f60b48cb9fdf$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $7e93f60b48cb9fdf$var$plugins = {};
function $7e93f60b48cb9fdf$var$getPlugin(pluginKey) {
    const plugin = $7e93f60b48cb9fdf$var$plugins[pluginKey];
    if (!plugin) $7e93f60b48cb9fdf$var$die(0, pluginKey);
    return plugin;
}
function $7e93f60b48cb9fdf$var$loadPlugin(pluginKey, implementation) {
    if (!$7e93f60b48cb9fdf$var$plugins[pluginKey]) $7e93f60b48cb9fdf$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $7e93f60b48cb9fdf$var$currentScope;
function $7e93f60b48cb9fdf$var$getCurrentScope() {
    return $7e93f60b48cb9fdf$var$currentScope;
}
function $7e93f60b48cb9fdf$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $7e93f60b48cb9fdf$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $7e93f60b48cb9fdf$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $7e93f60b48cb9fdf$var$revokeScope(scope) {
    $7e93f60b48cb9fdf$var$leaveScope(scope);
    scope.drafts_.forEach($7e93f60b48cb9fdf$var$revokeDraft);
    scope.drafts_ = null;
}
function $7e93f60b48cb9fdf$var$leaveScope(scope) {
    if (scope === $7e93f60b48cb9fdf$var$currentScope) $7e93f60b48cb9fdf$var$currentScope = scope.parent_;
}
function $7e93f60b48cb9fdf$var$enterScope(immer2) {
    return $7e93f60b48cb9fdf$var$currentScope = $7e93f60b48cb9fdf$var$createScope($7e93f60b48cb9fdf$var$currentScope, immer2);
}
function $7e93f60b48cb9fdf$var$revokeDraft(draft) {
    const state = draft[$7e93f60b48cb9fdf$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $7e93f60b48cb9fdf$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$7e93f60b48cb9fdf$var$DRAFT_STATE].modified_) {
            $7e93f60b48cb9fdf$var$revokeScope(scope);
            $7e93f60b48cb9fdf$var$die(4);
        }
        if ($7e93f60b48cb9fdf$export$16e3aed3edb85946(result)) {
            result = $7e93f60b48cb9fdf$var$finalize(scope, result);
            if (!scope.parent_) $7e93f60b48cb9fdf$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $7e93f60b48cb9fdf$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$7e93f60b48cb9fdf$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $7e93f60b48cb9fdf$var$finalize(scope, baseDraft, []);
    $7e93f60b48cb9fdf$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $7e93f60b48cb9fdf$export$45b790e32b2810ee ? result : void 0;
}
function $7e93f60b48cb9fdf$var$finalize(rootScope, value, path) {
    if ($7e93f60b48cb9fdf$var$isFrozen(value)) return value;
    const state = value[$7e93f60b48cb9fdf$var$DRAFT_STATE];
    if (!state) {
        $7e93f60b48cb9fdf$var$each(value, (key, childValue)=>$7e93f60b48cb9fdf$var$finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $7e93f60b48cb9fdf$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $7e93f60b48cb9fdf$var$each(resultEach, (key, childValue)=>$7e93f60b48cb9fdf$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $7e93f60b48cb9fdf$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $7e93f60b48cb9fdf$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $7e93f60b48cb9fdf$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($7e93f60b48cb9fdf$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$7e93f60b48cb9fdf$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $7e93f60b48cb9fdf$var$finalize(rootScope, childValue, path);
        $7e93f60b48cb9fdf$var$set(targetObject, prop, res);
        if ($7e93f60b48cb9fdf$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($7e93f60b48cb9fdf$export$16e3aed3edb85946(childValue) && !$7e93f60b48cb9fdf$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $7e93f60b48cb9fdf$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) $7e93f60b48cb9fdf$var$maybeFreeze(rootScope, childValue);
    }
}
function $7e93f60b48cb9fdf$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $7e93f60b48cb9fdf$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $7e93f60b48cb9fdf$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $7e93f60b48cb9fdf$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $7e93f60b48cb9fdf$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $7e93f60b48cb9fdf$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $7e93f60b48cb9fdf$var$objectTraps = {
    get (state, prop) {
        if (prop === $7e93f60b48cb9fdf$var$DRAFT_STATE) return state;
        const source = $7e93f60b48cb9fdf$var$latest(state);
        if (!$7e93f60b48cb9fdf$var$has(source, prop)) return $7e93f60b48cb9fdf$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$7e93f60b48cb9fdf$export$16e3aed3edb85946(value)) return value;
        if (value === $7e93f60b48cb9fdf$var$peek(state.base_, prop)) {
            $7e93f60b48cb9fdf$var$prepareCopy(state);
            return state.copy_[prop] = $7e93f60b48cb9fdf$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $7e93f60b48cb9fdf$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($7e93f60b48cb9fdf$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $7e93f60b48cb9fdf$var$getDescriptorFromProto($7e93f60b48cb9fdf$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $7e93f60b48cb9fdf$var$peek($7e93f60b48cb9fdf$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($7e93f60b48cb9fdf$var$is(value, current2) && (value !== void 0 || $7e93f60b48cb9fdf$var$has(state.base_, prop))) return true;
            $7e93f60b48cb9fdf$var$prepareCopy(state);
            $7e93f60b48cb9fdf$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($7e93f60b48cb9fdf$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $7e93f60b48cb9fdf$var$prepareCopy(state);
            $7e93f60b48cb9fdf$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $7e93f60b48cb9fdf$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $7e93f60b48cb9fdf$var$die(11);
    },
    getPrototypeOf (state) {
        return $7e93f60b48cb9fdf$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $7e93f60b48cb9fdf$var$die(12);
    }
};
var $7e93f60b48cb9fdf$var$arrayTraps = {};
$7e93f60b48cb9fdf$var$each($7e93f60b48cb9fdf$var$objectTraps, (key, fn)=>{
    $7e93f60b48cb9fdf$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$7e93f60b48cb9fdf$var$arrayTraps.deleteProperty = function(state, prop) {
    return $7e93f60b48cb9fdf$var$arrayTraps.set.call(this, state, prop, void 0);
};
$7e93f60b48cb9fdf$var$arrayTraps.set = function(state, prop, value) {
    return $7e93f60b48cb9fdf$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $7e93f60b48cb9fdf$var$peek(draft, prop) {
    const state = draft[$7e93f60b48cb9fdf$var$DRAFT_STATE];
    const source = state ? $7e93f60b48cb9fdf$var$latest(state) : draft;
    return source[prop];
}
function $7e93f60b48cb9fdf$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $7e93f60b48cb9fdf$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $7e93f60b48cb9fdf$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $7e93f60b48cb9fdf$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $7e93f60b48cb9fdf$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $7e93f60b48cb9fdf$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $7e93f60b48cb9fdf$var$markChanged(state.parent_);
    }
}
function $7e93f60b48cb9fdf$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $7e93f60b48cb9fdf$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $7e93f60b48cb9fdf$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $7e93f60b48cb9fdf$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $7e93f60b48cb9fdf$var$die(7);
            let result;
            if ($7e93f60b48cb9fdf$export$16e3aed3edb85946(base)) {
                const scope = $7e93f60b48cb9fdf$var$enterScope(this);
                const proxy = $7e93f60b48cb9fdf$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $7e93f60b48cb9fdf$var$revokeScope(scope);
                    else $7e93f60b48cb9fdf$var$leaveScope(scope);
                }
                $7e93f60b48cb9fdf$var$usePatchesInScope(scope, patchListener);
                return $7e93f60b48cb9fdf$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $7e93f60b48cb9fdf$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $7e93f60b48cb9fdf$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $7e93f60b48cb9fdf$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $7e93f60b48cb9fdf$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$7e93f60b48cb9fdf$export$16e3aed3edb85946(base)) $7e93f60b48cb9fdf$var$die(8);
        if ($7e93f60b48cb9fdf$export$541ac630993a4c84(base)) base = $7e93f60b48cb9fdf$export$97aac956da55dae9(base);
        const scope = $7e93f60b48cb9fdf$var$enterScope(this);
        const proxy = $7e93f60b48cb9fdf$var$createProxy(base, void 0);
        proxy[$7e93f60b48cb9fdf$var$DRAFT_STATE].isManual_ = true;
        $7e93f60b48cb9fdf$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$7e93f60b48cb9fdf$var$DRAFT_STATE];
        if (!state || !state.isManual_) $7e93f60b48cb9fdf$var$die(9);
        const { scope_: scope } = state;
        $7e93f60b48cb9fdf$var$usePatchesInScope(scope, patchListener);
        return $7e93f60b48cb9fdf$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $7e93f60b48cb9fdf$var$getPlugin("Patches").applyPatches_;
        if ($7e93f60b48cb9fdf$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $7e93f60b48cb9fdf$var$createProxy(value, parent) {
    const draft = $7e93f60b48cb9fdf$var$isMap(value) ? $7e93f60b48cb9fdf$var$getPlugin("MapSet").proxyMap_(value, parent) : $7e93f60b48cb9fdf$var$isSet(value) ? $7e93f60b48cb9fdf$var$getPlugin("MapSet").proxySet_(value, parent) : $7e93f60b48cb9fdf$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $7e93f60b48cb9fdf$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $7e93f60b48cb9fdf$export$97aac956da55dae9(value) {
    if (!$7e93f60b48cb9fdf$export$541ac630993a4c84(value)) $7e93f60b48cb9fdf$var$die(10, value);
    return $7e93f60b48cb9fdf$var$currentImpl(value);
}
function $7e93f60b48cb9fdf$var$currentImpl(value) {
    if (!$7e93f60b48cb9fdf$export$16e3aed3edb85946(value) || $7e93f60b48cb9fdf$var$isFrozen(value)) return value;
    const state = value[$7e93f60b48cb9fdf$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $7e93f60b48cb9fdf$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $7e93f60b48cb9fdf$var$shallowCopy(value, true);
    $7e93f60b48cb9fdf$var$each(copy, (key, childValue)=>{
        $7e93f60b48cb9fdf$var$set(copy, key, $7e93f60b48cb9fdf$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $7e93f60b48cb9fdf$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $7e93f60b48cb9fdf$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $7e93f60b48cb9fdf$var$get(base_, key);
            const value = $7e93f60b48cb9fdf$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $7e93f60b48cb9fdf$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $7e93f60b48cb9fdf$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $7e93f60b48cb9fdf$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $7e93f60b48cb9fdf$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $7e93f60b48cb9fdf$var$die(errorOffset + 3);
                base = $7e93f60b48cb9fdf$var$get(base, p);
                if (typeof base !== "object") $7e93f60b48cb9fdf$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $7e93f60b48cb9fdf$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $7e93f60b48cb9fdf$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $7e93f60b48cb9fdf$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$7e93f60b48cb9fdf$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($7e93f60b48cb9fdf$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($7e93f60b48cb9fdf$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($7e93f60b48cb9fdf$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($7e93f60b48cb9fdf$var$has(obj, $7e93f60b48cb9fdf$export$6ee2082928bcb0ee)) cloned[$7e93f60b48cb9fdf$export$6ee2082928bcb0ee] = obj[$7e93f60b48cb9fdf$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($7e93f60b48cb9fdf$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $7e93f60b48cb9fdf$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $7e93f60b48cb9fdf$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$7e93f60b48cb9fdf$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $7e93f60b48cb9fdf$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $7e93f60b48cb9fdf$var$latest(this[$7e93f60b48cb9fdf$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $7e93f60b48cb9fdf$var$latest(this[$7e93f60b48cb9fdf$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$7e93f60b48cb9fdf$var$latest(state).has(key) || $7e93f60b48cb9fdf$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $7e93f60b48cb9fdf$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $7e93f60b48cb9fdf$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($7e93f60b48cb9fdf$var$latest(state).size) {
                prepareMapCopy(state);
                $7e93f60b48cb9fdf$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $7e93f60b48cb9fdf$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            $7e93f60b48cb9fdf$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $7e93f60b48cb9fdf$var$latest(state).get(key);
            if (state.finalized_ || !$7e93f60b48cb9fdf$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $7e93f60b48cb9fdf$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $7e93f60b48cb9fdf$var$latest(this[$7e93f60b48cb9fdf$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($7e93f60b48cb9fdf$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$7e93f60b48cb9fdf$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $7e93f60b48cb9fdf$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $7e93f60b48cb9fdf$var$latest(this[$7e93f60b48cb9fdf$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $7e93f60b48cb9fdf$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $7e93f60b48cb9fdf$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($7e93f60b48cb9fdf$var$latest(state).size) {
                prepareSetCopy(state);
                $7e93f60b48cb9fdf$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($7e93f60b48cb9fdf$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($7e93f60b48cb9fdf$export$16e3aed3edb85946(value)) {
                    const draft = $7e93f60b48cb9fdf$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $7e93f60b48cb9fdf$var$die(3, JSON.stringify($7e93f60b48cb9fdf$var$latest(state)));
    }
    $7e93f60b48cb9fdf$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $7e93f60b48cb9fdf$var$immer = new $7e93f60b48cb9fdf$export$aaadc6ff0f822719();
var $7e93f60b48cb9fdf$export$b46cabe22e78bc00 = $7e93f60b48cb9fdf$var$immer.produce;
var $7e93f60b48cb9fdf$export$4da66d41c9492c78 = $7e93f60b48cb9fdf$var$immer.produceWithPatches.bind($7e93f60b48cb9fdf$var$immer);
var $7e93f60b48cb9fdf$export$573f26f60825c493 = $7e93f60b48cb9fdf$var$immer.setAutoFreeze.bind($7e93f60b48cb9fdf$var$immer);
var $7e93f60b48cb9fdf$export$333ce65961cbe047 = $7e93f60b48cb9fdf$var$immer.setUseStrictShallowCopy.bind($7e93f60b48cb9fdf$var$immer);
var $7e93f60b48cb9fdf$export$a8b8e03e6bbe5473 = $7e93f60b48cb9fdf$var$immer.applyPatches.bind($7e93f60b48cb9fdf$var$immer);
var $7e93f60b48cb9fdf$export$3c3214997190395f = $7e93f60b48cb9fdf$var$immer.createDraft.bind($7e93f60b48cb9fdf$var$immer);
var $7e93f60b48cb9fdf$export$c60f5e69c521b528 = $7e93f60b48cb9fdf$var$immer.finishDraft.bind($7e93f60b48cb9fdf$var$immer);
function $7e93f60b48cb9fdf$export$c05b21e3257751e5(value) {
    return value;
}
function $7e93f60b48cb9fdf$export$20f911b3f8cf0b74(value) {
    return value;
}


var $be917d30338e5bfc$var$__defProp = Object.defineProperty;
var $be917d30338e5bfc$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $be917d30338e5bfc$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $be917d30338e5bfc$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $be917d30338e5bfc$var$__defNormalProp = (obj, key, value)=>key in obj ? $be917d30338e5bfc$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $be917d30338e5bfc$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($be917d30338e5bfc$var$__hasOwnProp.call(b, prop)) $be917d30338e5bfc$var$__defNormalProp(a, prop, b[prop]);
    if ($be917d30338e5bfc$var$__getOwnPropSymbols) {
        for (var prop of $be917d30338e5bfc$var$__getOwnPropSymbols(b))if ($be917d30338e5bfc$var$__propIsEnum.call(b, prop)) $be917d30338e5bfc$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $be917d30338e5bfc$var$__publicField = (obj, key, value)=>{
    $be917d30338e5bfc$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $be917d30338e5bfc$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $be917d30338e5bfc$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $be917d30338e5bfc$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $be917d30338e5bfc$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($be917d30338e5bfc$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $be917d30338e5bfc$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $be917d30338e5bfc$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $be917d30338e5bfc$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $be917d30338e5bfc$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $be917d30338e5bfc$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $be917d30338e5bfc$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $be917d30338e5bfc$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $be917d30338e5bfc$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $be917d30338e5bfc$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $be917d30338e5bfc$var$__spreadValues($be917d30338e5bfc$var$__spreadValues({}, $be917d30338e5bfc$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $be917d30338e5bfc$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $be917d30338e5bfc$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $be917d30338e5bfc$var$$REVISION = 0;
var $be917d30338e5bfc$var$CURRENT_TRACKER = null;
var $be917d30338e5bfc$var$Cell = class {
    constructor(initialValue, isEqual = $be917d30338e5bfc$var$tripleEq){
        $be917d30338e5bfc$var$__publicField(this, "revision", $be917d30338e5bfc$var$$REVISION);
        $be917d30338e5bfc$var$__publicField(this, "_value");
        $be917d30338e5bfc$var$__publicField(this, "_lastValue");
        $be917d30338e5bfc$var$__publicField(this, "_isEqual", $be917d30338e5bfc$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $be917d30338e5bfc$var$CURRENT_TRACKER == null || $be917d30338e5bfc$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$be917d30338e5bfc$var$$REVISION;
    }
};
function $be917d30338e5bfc$var$tripleEq(a, b) {
    return a === b;
}
var $be917d30338e5bfc$var$TrackingCache = class {
    constructor(fn){
        $be917d30338e5bfc$var$__publicField(this, "_cachedValue");
        $be917d30338e5bfc$var$__publicField(this, "_cachedRevision", -1);
        $be917d30338e5bfc$var$__publicField(this, "_deps", []);
        $be917d30338e5bfc$var$__publicField(this, "hits", 0);
        $be917d30338e5bfc$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $be917d30338e5bfc$var$CURRENT_TRACKER;
            $be917d30338e5bfc$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $be917d30338e5bfc$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $be917d30338e5bfc$var$CURRENT_TRACKER == null || $be917d30338e5bfc$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $be917d30338e5bfc$var$getValue(cell) {
    if (!(cell instanceof $be917d30338e5bfc$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $be917d30338e5bfc$var$setValue(storage, value) {
    if (!(storage instanceof $be917d30338e5bfc$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $be917d30338e5bfc$var$createCell(initialValue, isEqual = $be917d30338e5bfc$var$tripleEq) {
    return new $be917d30338e5bfc$var$Cell(initialValue, isEqual);
}
function $be917d30338e5bfc$var$createCache(fn) {
    $be917d30338e5bfc$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $be917d30338e5bfc$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $be917d30338e5bfc$var$neverEq = (a, b)=>false;
function $be917d30338e5bfc$var$createTag() {
    return $be917d30338e5bfc$var$createCell(null, $be917d30338e5bfc$var$neverEq);
}
function $be917d30338e5bfc$var$dirtyTag(tag, value) {
    $be917d30338e5bfc$var$setValue(tag, value);
}
var $be917d30338e5bfc$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $be917d30338e5bfc$var$createTag();
    $be917d30338e5bfc$var$getValue(tag);
};
var $be917d30338e5bfc$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $be917d30338e5bfc$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $be917d30338e5bfc$var$REDUX_PROXY_LABEL = Symbol();
var $be917d30338e5bfc$var$nextId = 0;
var $be917d30338e5bfc$var$proto = Object.getPrototypeOf({});
var $be917d30338e5bfc$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $be917d30338e5bfc$var$__publicField(this, "proxy", new Proxy(this, $be917d30338e5bfc$var$objectProxyHandler));
        $be917d30338e5bfc$var$__publicField(this, "tag", $be917d30338e5bfc$var$createTag());
        $be917d30338e5bfc$var$__publicField(this, "tags", {});
        $be917d30338e5bfc$var$__publicField(this, "children", {});
        $be917d30338e5bfc$var$__publicField(this, "collectionTag", null);
        $be917d30338e5bfc$var$__publicField(this, "id", $be917d30338e5bfc$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $be917d30338e5bfc$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $be917d30338e5bfc$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $be917d30338e5bfc$var$createNode(childValue);
                if (childNode.tag) $be917d30338e5bfc$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $be917d30338e5bfc$var$createTag();
                    tag.value = childValue;
                }
                $be917d30338e5bfc$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $be917d30338e5bfc$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $be917d30338e5bfc$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $be917d30338e5bfc$var$__publicField(this, "proxy", new Proxy([
            this
        ], $be917d30338e5bfc$var$arrayProxyHandler));
        $be917d30338e5bfc$var$__publicField(this, "tag", $be917d30338e5bfc$var$createTag());
        $be917d30338e5bfc$var$__publicField(this, "tags", {});
        $be917d30338e5bfc$var$__publicField(this, "children", {});
        $be917d30338e5bfc$var$__publicField(this, "collectionTag", null);
        $be917d30338e5bfc$var$__publicField(this, "id", $be917d30338e5bfc$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $be917d30338e5bfc$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $be917d30338e5bfc$var$consumeCollection(node);
        return $be917d30338e5bfc$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $be917d30338e5bfc$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $be917d30338e5bfc$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $be917d30338e5bfc$var$objectProxyHandler.has(node, prop);
    }
};
function $be917d30338e5bfc$var$createNode(value) {
    if (Array.isArray(value)) return new $be917d30338e5bfc$var$ArrayTreeNode(value);
    return new $be917d30338e5bfc$var$ObjectTreeNode(value);
}
function $be917d30338e5bfc$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $be917d30338e5bfc$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $be917d30338e5bfc$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $be917d30338e5bfc$var$dirtyCollection(node);
            $be917d30338e5bfc$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $be917d30338e5bfc$var$updateNode(childNode, newChildValue);
        else {
            $be917d30338e5bfc$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $be917d30338e5bfc$var$deleteNode(node) {
    if (node.tag) $be917d30338e5bfc$var$dirtyTag(node.tag, null);
    $be917d30338e5bfc$var$dirtyCollection(node);
    for(const key in node.tags)$be917d30338e5bfc$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$be917d30338e5bfc$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $be917d30338e5bfc$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $be917d30338e5bfc$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $be917d30338e5bfc$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $be917d30338e5bfc$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $be917d30338e5bfc$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $be917d30338e5bfc$export$3f025202a230c6dd = (a, b)=>a === b;
function $be917d30338e5bfc$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $be917d30338e5bfc$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $be917d30338e5bfc$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $be917d30338e5bfc$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $be917d30338e5bfc$var$createSingletonCache(comparator) : $be917d30338e5bfc$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $be917d30338e5bfc$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $be917d30338e5bfc$export$c8f9cf88d9fdee55(func) {
    const node = $be917d30338e5bfc$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $be917d30338e5bfc$var$createCacheKeyComparator($be917d30338e5bfc$export$3f025202a230c6dd);
    const cache = $be917d30338e5bfc$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $be917d30338e5bfc$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $be917d30338e5bfc$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $be917d30338e5bfc$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $be917d30338e5bfc$var$StrongRef;
var $be917d30338e5bfc$var$UNTERMINATED = 0;
var $be917d30338e5bfc$var$TERMINATED = 1;
function $be917d30338e5bfc$var$createCacheNode() {
    return {
        s: $be917d30338e5bfc$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $be917d30338e5bfc$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $be917d30338e5bfc$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $be917d30338e5bfc$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $be917d30338e5bfc$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $be917d30338e5bfc$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $be917d30338e5bfc$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $be917d30338e5bfc$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $be917d30338e5bfc$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $be917d30338e5bfc$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $be917d30338e5bfc$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $be917d30338e5bfc$var$__spreadValues($be917d30338e5bfc$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $be917d30338e5bfc$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $be917d30338e5bfc$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $be917d30338e5bfc$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $be917d30338e5bfc$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $be917d30338e5bfc$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $be917d30338e5bfc$export$595d22ed68ca2841 = /* @__PURE__ */ $be917d30338e5bfc$export$5943f4447f6ef248($be917d30338e5bfc$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $be917d30338e5bfc$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $be917d30338e5bfc$export$595d22ed68ca2841)=>{
    $be917d30338e5bfc$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$be917d30338e5bfc$export$75979cfcd91bf38f
});


// src/index.ts
function $b9d54142851513e7$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $b9d54142851513e7$export$dd164f5517779f15 = $b9d54142851513e7$var$createThunkMiddleware();
var $b9d54142851513e7$export$16d06542a1949d9e = $b9d54142851513e7$var$createThunkMiddleware;


var $5671edd534fa79c4$exports = {};
// shim for using process in browser
var $5671edd534fa79c4$var$process = $5671edd534fa79c4$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $5671edd534fa79c4$var$cachedSetTimeout;
var $5671edd534fa79c4$var$cachedClearTimeout;
function $5671edd534fa79c4$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $5671edd534fa79c4$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $5671edd534fa79c4$var$cachedSetTimeout = setTimeout;
        else $5671edd534fa79c4$var$cachedSetTimeout = $5671edd534fa79c4$var$defaultSetTimout;
    } catch (e) {
        $5671edd534fa79c4$var$cachedSetTimeout = $5671edd534fa79c4$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $5671edd534fa79c4$var$cachedClearTimeout = clearTimeout;
        else $5671edd534fa79c4$var$cachedClearTimeout = $5671edd534fa79c4$var$defaultClearTimeout;
    } catch (e) {
        $5671edd534fa79c4$var$cachedClearTimeout = $5671edd534fa79c4$var$defaultClearTimeout;
    }
})();
function $5671edd534fa79c4$var$runTimeout(fun) {
    if ($5671edd534fa79c4$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($5671edd534fa79c4$var$cachedSetTimeout === $5671edd534fa79c4$var$defaultSetTimout || !$5671edd534fa79c4$var$cachedSetTimeout) && setTimeout) {
        $5671edd534fa79c4$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $5671edd534fa79c4$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $5671edd534fa79c4$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $5671edd534fa79c4$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $5671edd534fa79c4$var$runClearTimeout(marker) {
    if ($5671edd534fa79c4$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($5671edd534fa79c4$var$cachedClearTimeout === $5671edd534fa79c4$var$defaultClearTimeout || !$5671edd534fa79c4$var$cachedClearTimeout) && clearTimeout) {
        $5671edd534fa79c4$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $5671edd534fa79c4$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $5671edd534fa79c4$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $5671edd534fa79c4$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $5671edd534fa79c4$var$queue = [];
var $5671edd534fa79c4$var$draining = false;
var $5671edd534fa79c4$var$currentQueue;
var $5671edd534fa79c4$var$queueIndex = -1;
function $5671edd534fa79c4$var$cleanUpNextTick() {
    if (!$5671edd534fa79c4$var$draining || !$5671edd534fa79c4$var$currentQueue) return;
    $5671edd534fa79c4$var$draining = false;
    if ($5671edd534fa79c4$var$currentQueue.length) $5671edd534fa79c4$var$queue = $5671edd534fa79c4$var$currentQueue.concat($5671edd534fa79c4$var$queue);
    else $5671edd534fa79c4$var$queueIndex = -1;
    if ($5671edd534fa79c4$var$queue.length) $5671edd534fa79c4$var$drainQueue();
}
function $5671edd534fa79c4$var$drainQueue() {
    if ($5671edd534fa79c4$var$draining) return;
    var timeout = $5671edd534fa79c4$var$runTimeout($5671edd534fa79c4$var$cleanUpNextTick);
    $5671edd534fa79c4$var$draining = true;
    var len = $5671edd534fa79c4$var$queue.length;
    while(len){
        $5671edd534fa79c4$var$currentQueue = $5671edd534fa79c4$var$queue;
        $5671edd534fa79c4$var$queue = [];
        while(++$5671edd534fa79c4$var$queueIndex < len)if ($5671edd534fa79c4$var$currentQueue) $5671edd534fa79c4$var$currentQueue[$5671edd534fa79c4$var$queueIndex].run();
        $5671edd534fa79c4$var$queueIndex = -1;
        len = $5671edd534fa79c4$var$queue.length;
    }
    $5671edd534fa79c4$var$currentQueue = null;
    $5671edd534fa79c4$var$draining = false;
    $5671edd534fa79c4$var$runClearTimeout(timeout);
}
$5671edd534fa79c4$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $5671edd534fa79c4$var$queue.push(new $5671edd534fa79c4$var$Item(fun, args));
    if ($5671edd534fa79c4$var$queue.length === 1 && !$5671edd534fa79c4$var$draining) $5671edd534fa79c4$var$runTimeout($5671edd534fa79c4$var$drainQueue);
};
// v8 likes predictible objects
function $5671edd534fa79c4$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$5671edd534fa79c4$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$5671edd534fa79c4$var$process.title = "browser";
$5671edd534fa79c4$var$process.browser = true;
$5671edd534fa79c4$var$process.env = {};
$5671edd534fa79c4$var$process.argv = [];
$5671edd534fa79c4$var$process.version = ""; // empty string to avoid regexp issues
$5671edd534fa79c4$var$process.versions = {};
function $5671edd534fa79c4$var$noop() {}
$5671edd534fa79c4$var$process.on = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.addListener = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.once = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.off = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.removeListener = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.removeAllListeners = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.emit = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.prependListener = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.prependOnceListener = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.listeners = function(name) {
    return [];
};
$5671edd534fa79c4$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$5671edd534fa79c4$var$process.cwd = function() {
    return "/";
};
$5671edd534fa79c4$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$5671edd534fa79c4$var$process.umask = function() {
    return 0;
};


var $0005262392d89a41$var$__defProp = Object.defineProperty;
var $0005262392d89a41$var$__defProps = Object.defineProperties;
var $0005262392d89a41$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $0005262392d89a41$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $0005262392d89a41$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0005262392d89a41$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $0005262392d89a41$var$__defNormalProp = (obj, key, value)=>key in obj ? $0005262392d89a41$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0005262392d89a41$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($0005262392d89a41$var$__hasOwnProp.call(b, prop)) $0005262392d89a41$var$__defNormalProp(a, prop, b[prop]);
    if ($0005262392d89a41$var$__getOwnPropSymbols) {
        for (var prop of $0005262392d89a41$var$__getOwnPropSymbols(b))if ($0005262392d89a41$var$__propIsEnum.call(b, prop)) $0005262392d89a41$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $0005262392d89a41$var$__spreadProps = (a, b)=>$0005262392d89a41$var$__defProps(a, $0005262392d89a41$var$__getOwnPropDescs(b));
var $0005262392d89a41$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($0005262392d89a41$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $0005262392d89a41$var$__getOwnPropSymbols) {
        for (var prop of $0005262392d89a41$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $0005262392d89a41$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $0005262392d89a41$var$__publicField = (obj, key, value)=>$0005262392d89a41$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var $0005262392d89a41$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $be917d30338e5bfc$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $7e93f60b48cb9fdf$export$541ac630993a4c84)(value) ? (0, $7e93f60b48cb9fdf$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $0005262392d89a41$export$a5d3c27355e35910 = /* @__PURE__ */ $0005262392d89a41$export$aab6de9e3dbb1473((0, $be917d30338e5bfc$export$8402dc26d96f6902));
var $0005262392d89a41$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $b0c9b171c350de9c$export$f672e0b6f7222cd7;
    return (0, $b0c9b171c350de9c$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $0005262392d89a41$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $0005262392d89a41$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $0005262392d89a41$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($0005262392d89a41$export$378fa86b259c0280(0));
            return $0005262392d89a41$var$__spreadValues($0005262392d89a41$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $b0c9b171c350de9c$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $0005262392d89a41$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $0005262392d89a41$var$hasMatchFunction(action);
}
function $0005262392d89a41$export$ebd532f9034651f3(action) {
    return (0, $b0c9b171c350de9c$export$b956e38827fca970)(action) && Object.keys(action).every($0005262392d89a41$var$isValidKey);
}
function $0005262392d89a41$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $0005262392d89a41$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $0005262392d89a41$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $0005262392d89a41$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
function $0005262392d89a41$var$find(iterable, comparator) {
    for (const entry of iterable){
        if (comparator(entry)) return entry;
    }
    return void 0;
}
var $0005262392d89a41$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $0005262392d89a41$var$freezeDraftable(val) {
    return (0, $7e93f60b48cb9fdf$export$16e3aed3edb85946)(val) ? (0, $7e93f60b48cb9fdf$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $0005262392d89a41$var$emplace(map, key, handler) {
    if (map.has(key)) {
        let value = map.get(key);
        if (handler.update) {
            value = handler.update(value, key, map);
            map.set(key, value);
        }
        return value;
    }
    if (!handler.insert) throw new Error($0005262392d89a41$export$378fa86b259c0280(10));
    const inserted = handler.insert(key, map);
    map.set(key, inserted);
    return inserted;
}
// src/immutableStateInvariantMiddleware.ts
function $0005262392d89a41$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $0005262392d89a41$var$trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = $0005262392d89a41$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return $0005262392d89a41$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $0005262392d89a41$var$trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $0005262392d89a41$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $0005262392d89a41$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $0005262392d89a41$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $0005262392d89a41$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $0005262392d89a41$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $b0c9b171c350de9c$export$53b83ca8eaab0383)(val);
}
function $0005262392d89a41$export$ada5dca0b571bc7(value, path = "", isSerializable = $0005262392d89a41$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $0005262392d89a41$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $0005262392d89a41$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $0005262392d89a41$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$0005262392d89a41$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $0005262392d89a41$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $0005262392d89a41$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $0005262392d89a41$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $0005262392d89a41$export$1908877435b1d5e9();
        if (thunk) {
            if ($0005262392d89a41$var$isBoolean(thunk)) middlewareArray.push((0, $b9d54142851513e7$export$dd164f5517779f15));
            else middlewareArray.push((0, $b9d54142851513e7$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $0005262392d89a41$export$8fb31c0f05df007b = "RTK_autoBatch";
var $0005262392d89a41$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$0005262392d89a41$export$8fb31c0f05df007b]: true
            }
        });
var $0005262392d89a41$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $0005262392d89a41$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $0005262392d89a41$var$createQueueWithTimer(10);
var $0005262392d89a41$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? $0005262392d89a41$var$rAF : options.type === "callback" ? options.queueNotification : $0005262392d89a41$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$0005262392d89a41$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $0005262392d89a41$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $0005262392d89a41$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($0005262392d89a41$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $0005262392d89a41$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $0005262392d89a41$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $b0c9b171c350de9c$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $b0c9b171c350de9c$export$66e4520cdb265d18)(reducer);
    else throw new Error($0005262392d89a41$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    let finalCompose = (0, $b0c9b171c350de9c$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $0005262392d89a41$var$composeWithDevTools($0005262392d89a41$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $b0c9b171c350de9c$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $0005262392d89a41$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $b0c9b171c350de9c$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $0005262392d89a41$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($0005262392d89a41$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($0005262392d89a41$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $0005262392d89a41$var$isStateFunction(x) {
    return typeof x === "function";
}
function $0005262392d89a41$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $0005262392d89a41$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($0005262392d89a41$var$isStateFunction(initialState)) getInitialState = ()=>$0005262392d89a41$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $0005262392d89a41$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $7e93f60b48cb9fdf$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $7e93f60b48cb9fdf$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw new Error($0005262392d89a41$export$378fa86b259c0280(9));
                    }
                    return result;
                } else return (0, $7e93f60b48cb9fdf$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $0005262392d89a41$var$matches = (matcher, action)=>{
    if ($0005262392d89a41$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $0005262392d89a41$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$0005262392d89a41$var$matches(matcher, action));
    };
}
function $0005262392d89a41$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$0005262392d89a41$var$matches(matcher, action));
    };
}
function $0005262392d89a41$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $0005262392d89a41$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $0005262392d89a41$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$0005262392d89a41$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$0005262392d89a41$var$isAsyncThunkArray(asyncThunks)) return $0005262392d89a41$export$872dec21e9a69476()(asyncThunks[0]);
    return $0005262392d89a41$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $0005262392d89a41$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$0005262392d89a41$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$0005262392d89a41$var$isAsyncThunkArray(asyncThunks)) return $0005262392d89a41$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $0005262392d89a41$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $0005262392d89a41$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $0005262392d89a41$export$9dd1fb32974da385($0005262392d89a41$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$0005262392d89a41$var$isAsyncThunkArray(asyncThunks)) return $0005262392d89a41$export$fcc3388fb56de601()(asyncThunks[0]);
    return $0005262392d89a41$export$9dd1fb32974da385($0005262392d89a41$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $0005262392d89a41$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$0005262392d89a41$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$0005262392d89a41$var$isAsyncThunkArray(asyncThunks)) return $0005262392d89a41$export$1da80a6ef1307441()(asyncThunks[0]);
    return $0005262392d89a41$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $0005262392d89a41$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$0005262392d89a41$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$0005262392d89a41$var$isAsyncThunkArray(asyncThunks)) return $0005262392d89a41$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $0005262392d89a41$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $0005262392d89a41$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $0005262392d89a41$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $0005262392d89a41$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $0005262392d89a41$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $0005262392d89a41$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $0005262392d89a41$var$__publicField(this, "_type");
    }
};
var $0005262392d89a41$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $0005262392d89a41$var$__publicField(this, "_type");
    }
};
var $0005262392d89a41$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $0005262392d89a41$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $0005262392d89a41$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $0005262392d89a41$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $0005262392d89a41$var$__spreadProps($0005262392d89a41$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $0005262392d89a41$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $0005262392d89a41$var$__spreadProps($0005262392d89a41$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $0005262392d89a41$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $0005262392d89a41$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $0005262392d89a41$var$__spreadProps($0005262392d89a41$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $0005262392d89a41$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($0005262392d89a41$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $0005262392d89a41$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $0005262392d89a41$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $0005262392d89a41$var$RejectWithValue) throw result;
                                if (result instanceof $0005262392d89a41$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $0005262392d89a41$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($0005262392d89a41$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $0005262392d89a41$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $0005262392d89a41$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $0005262392d89a41$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $0005262392d89a41$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $0005262392d89a41$export$343355ed40c51c46 = {
    [$0005262392d89a41$var$asyncThunkSymbol]: $0005262392d89a41$export$6abd22dc03e5063f
};
var $0005262392d89a41$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($0005262392d89a41$export$23a094319a4b586 || {});
function $0005262392d89a41$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $0005262392d89a41$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$0005262392d89a41$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($0005262392d89a41$export$378fa86b259c0280(11));
        typeof $5671edd534fa79c4$exports;
        const reducers = (typeof options.reducers === "function" ? options.reducers($0005262392d89a41$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($0005262392d89a41$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($0005262392d89a41$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $0005262392d89a41$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($0005262392d89a41$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $0005262392d89a41$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $0005262392d89a41$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $0005262392d89a41$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $0005262392d89a41$var$__spreadValues($0005262392d89a41$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $0005262392d89a41$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $0005262392d89a41$var$emplace(injectedSelectorCache, injected, {
                    insert: ()=>/* @__PURE__ */ new WeakMap()
                });
                return $0005262392d89a41$var$emplace(selectorCache, selectState, {
                    insert: ()=>{
                        var _a2;
                        const map = {};
                        for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $0005262392d89a41$var$wrapSelector(selector, selectState, getInitialState, injected);
                        return map;
                    }
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $0005262392d89a41$var$__spreadProps($0005262392d89a41$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $0005262392d89a41$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $0005262392d89a41$var$__spreadValues($0005262392d89a41$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $0005262392d89a41$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $0005262392d89a41$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $0005262392d89a41$export$affdea4146de9cf5();
function $0005262392d89a41$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $0005262392d89a41$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $0005262392d89a41$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$0005262392d89a41$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($0005262392d89a41$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $0005262392d89a41$export$309c7a02b0b0bc62(type, prepareCallback) : $0005262392d89a41$export$309c7a02b0b0bc62(type));
}
function $0005262392d89a41$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $0005262392d89a41$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $0005262392d89a41$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($0005262392d89a41$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $0005262392d89a41$var$noop,
        pending: pending || $0005262392d89a41$var$noop,
        rejected: rejected || $0005262392d89a41$var$noop,
        settled: settled || $0005262392d89a41$var$noop
    });
}
function $0005262392d89a41$var$noop() {}
// src/entities/entity_state.ts
function $0005262392d89a41$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $0005262392d89a41$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($0005262392d89a41$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $0005262392d89a41$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $0005262392d89a41$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $0005262392d89a41$var$isDraftTyped = (0, $7e93f60b48cb9fdf$export$541ac630993a4c84);
function $0005262392d89a41$var$createSingleArgumentStateOperator(mutator) {
    const operator = $0005262392d89a41$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $0005262392d89a41$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $0005262392d89a41$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($0005262392d89a41$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $7e93f60b48cb9fdf$export$b46cabe22e78bc00)(state, runMutator);
    };
}
function $0005262392d89a41$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $0005262392d89a41$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $0005262392d89a41$var$getCurrent(value) {
    return (0, $7e93f60b48cb9fdf$export$541ac630993a4c84)(value) ? (0, $7e93f60b48cb9fdf$export$97aac956da55dae9)(value) : value;
}
function $0005262392d89a41$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $0005262392d89a41$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $0005262392d89a41$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const updated = [];
    for (const entity of newEntities){
        const id = $0005262392d89a41$var$selectIdValue(entity, selectId);
        if (existingIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $0005262392d89a41$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $0005262392d89a41$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $0005262392d89a41$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $0005262392d89a41$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $0005262392d89a41$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $0005262392d89a41$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $0005262392d89a41$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $0005262392d89a41$var$__spreadValues($0005262392d89a41$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$0005262392d89a41$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $0005262392d89a41$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $0005262392d89a41$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $0005262392d89a41$var$createStateOperator(addOneMutably),
        addMany: $0005262392d89a41$var$createStateOperator(addManyMutably),
        setOne: $0005262392d89a41$var$createStateOperator(setOneMutably),
        setMany: $0005262392d89a41$var$createStateOperator(setManyMutably),
        setAll: $0005262392d89a41$var$createStateOperator(setAllMutably),
        updateOne: $0005262392d89a41$var$createStateOperator(updateOneMutably),
        updateMany: $0005262392d89a41$var$createStateOperator(updateManyMutably),
        upsertOne: $0005262392d89a41$var$createStateOperator(upsertOneMutably),
        upsertMany: $0005262392d89a41$var$createStateOperator(upsertManyMutably),
        removeOne: $0005262392d89a41$var$createStateOperator(removeOneMutably),
        removeMany: $0005262392d89a41$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $0005262392d89a41$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $0005262392d89a41$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $0005262392d89a41$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $0005262392d89a41$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $0005262392d89a41$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $0005262392d89a41$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $0005262392d89a41$var$getCurrent(state.ids));
        const models = newEntities.filter((model)=>!existingKeys.has($0005262392d89a41$var$selectIdValue(model, selectId)));
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $0005262392d89a41$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities)delete state.entities[selectId(item)];
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $0005262392d89a41$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $0005262392d89a41$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (updated.length) updateManyMutably(updated, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $0005262392d89a41$var$getCurrent(state.entities);
        const currentIds = $0005262392d89a41$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $0005262392d89a41$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $0005262392d89a41$var$createStateOperator(addOneMutably),
        updateOne: $0005262392d89a41$var$createStateOperator(updateOneMutably),
        upsertOne: $0005262392d89a41$var$createStateOperator(upsertOneMutably),
        setOne: $0005262392d89a41$var$createStateOperator(setOneMutably),
        setMany: $0005262392d89a41$var$createStateOperator(setManyMutably),
        setAll: $0005262392d89a41$var$createStateOperator(setAllMutably),
        addMany: $0005262392d89a41$var$createStateOperator(addManyMutably),
        updateMany: $0005262392d89a41$var$createStateOperator(updateManyMutably),
        upsertMany: $0005262392d89a41$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $0005262392d89a41$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $0005262392d89a41$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $0005262392d89a41$var$createSortedStateAdapter(selectId, sortComparer) : $0005262392d89a41$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $0005262392d89a41$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $0005262392d89a41$var$createSelectorsFactory();
    return $0005262392d89a41$var$__spreadValues($0005262392d89a41$var$__spreadValues($0005262392d89a41$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $0005262392d89a41$var$task = "task";
var $0005262392d89a41$var$listener = "listener";
var $0005262392d89a41$var$completed = "completed";
var $0005262392d89a41$var$cancelled = "cancelled";
var $0005262392d89a41$var$taskCancelled = `task-${$0005262392d89a41$var$cancelled}`;
var $0005262392d89a41$var$taskCompleted = `task-${$0005262392d89a41$var$completed}`;
var $0005262392d89a41$var$listenerCancelled = `${$0005262392d89a41$var$listener}-${$0005262392d89a41$var$cancelled}`;
var $0005262392d89a41$var$listenerCompleted = `${$0005262392d89a41$var$listener}-${$0005262392d89a41$var$completed}`;
var $0005262392d89a41$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $0005262392d89a41$var$__publicField(this, "name", "TaskAbortError");
        $0005262392d89a41$var$__publicField(this, "message");
        this.message = `${$0005262392d89a41$var$task} ${$0005262392d89a41$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $0005262392d89a41$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new Error($0005262392d89a41$export$378fa86b259c0280(32));
};
var $0005262392d89a41$var$noop2 = ()=>{};
var $0005262392d89a41$var$catchRejection = (promise, onError = $0005262392d89a41$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $0005262392d89a41$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var $0005262392d89a41$var$abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $0005262392d89a41$var$validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason: reason } = signal;
        throw new $0005262392d89a41$export$cb1bdac908fed7f(reason);
    }
};
function $0005262392d89a41$var$raceWithSignal(signal, promise) {
    let cleanup = $0005262392d89a41$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $0005262392d89a41$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $0005262392d89a41$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $0005262392d89a41$var$noop2;
    });
}
var $0005262392d89a41$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $0005262392d89a41$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $0005262392d89a41$var$createPause = (signal)=>{
    return (promise)=>{
        return $0005262392d89a41$var$catchRejection($0005262392d89a41$var$raceWithSignal(signal, promise).then((output)=>{
            $0005262392d89a41$var$validateActive(signal);
            return output;
        }));
    };
};
var $0005262392d89a41$var$createDelay = (signal)=>{
    const pause = $0005262392d89a41$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $0005262392d89a41$var$assign } = Object;
var $0005262392d89a41$var$INTERNAL_NIL_TOKEN = {};
var $0005262392d89a41$var$alm = "listenerMiddleware";
var $0005262392d89a41$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$0005262392d89a41$var$addAbortSignalListener(parentAbortSignal, ()=>$0005262392d89a41$var$abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $0005262392d89a41$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $0005262392d89a41$var$runTask(async ()=>{
            $0005262392d89a41$var$validateActive(parentAbortSignal);
            $0005262392d89a41$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $0005262392d89a41$var$createPause(childAbortController.signal),
                delay: $0005262392d89a41$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $0005262392d89a41$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>$0005262392d89a41$var$abortControllerWithReason(childAbortController, $0005262392d89a41$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($0005262392d89a41$var$noop2));
        return {
            result: $0005262392d89a41$var$createPause(parentAbortSignal)(result),
            cancel () {
                $0005262392d89a41$var$abortControllerWithReason(childAbortController, $0005262392d89a41$var$taskCancelled);
            }
        };
    };
};
var $0005262392d89a41$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $0005262392d89a41$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $0005262392d89a41$var$raceWithSignal(signal, Promise.race(promises));
            $0005262392d89a41$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$0005262392d89a41$var$catchRejection(take(predicate, timeout));
};
var $0005262392d89a41$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $0005262392d89a41$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($0005262392d89a41$export$378fa86b259c0280(21));
    $0005262392d89a41$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $0005262392d89a41$var$createListenerEntry = /* @__PURE__ */ $0005262392d89a41$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $0005262392d89a41$var$getListenerEntryPropsFrom(options);
    const id = $0005262392d89a41$export$ac4959f4f1338dfc();
    const entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($0005262392d89a41$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$0005262392d89a41$var$createListenerEntry
});
var $0005262392d89a41$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        $0005262392d89a41$var$abortControllerWithReason(controller, $0005262392d89a41$var$listenerCancelled);
    });
};
var $0005262392d89a41$var$createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach($0005262392d89a41$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $0005262392d89a41$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $0005262392d89a41$export$f03a6b845d3fb58b = /* @__PURE__ */ $0005262392d89a41$var$assign(/* @__PURE__ */ $0005262392d89a41$export$309c7a02b0b0bc62(`${$0005262392d89a41$var$alm}/add`), {
    withTypes: ()=>$0005262392d89a41$export$f03a6b845d3fb58b
});
var $0005262392d89a41$export$b1b8022855fb2b71 = /* @__PURE__ */ $0005262392d89a41$export$309c7a02b0b0bc62(`${$0005262392d89a41$var$alm}/removeAll`);
var $0005262392d89a41$export$b03e9483f936dccb = /* @__PURE__ */ $0005262392d89a41$var$assign(/* @__PURE__ */ $0005262392d89a41$export$309c7a02b0b0bc62(`${$0005262392d89a41$var$alm}/remove`), {
    withTypes: ()=>$0005262392d89a41$export$b03e9483f936dccb
});
var $0005262392d89a41$var$defaultErrorHandler = (...args)=>{
    console.error(`${$0005262392d89a41$var$alm}/error`, ...args);
};
var $0005262392d89a41$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra: extra, onError: onError = $0005262392d89a41$var$defaultErrorHandler } = middlewareOptions;
    $0005262392d89a41$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $0005262392d89a41$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        let entry = $0005262392d89a41$var$find(Array.from(listenerMap.values()), (existingEntry)=>existingEntry.effect === options.effect);
        if (!entry) entry = $0005262392d89a41$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $0005262392d89a41$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const { type: type, effect: effect, predicate: predicate } = $0005262392d89a41$var$getListenerEntryPropsFrom(options);
        const entry = $0005262392d89a41$var$find(Array.from(listenerMap.values()), (entry2)=>{
            const matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $0005262392d89a41$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $0005262392d89a41$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $0005262392d89a41$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $0005262392d89a41$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $0005262392d89a41$var$createDelay(internalTaskController.signal),
                pause: $0005262392d89a41$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $0005262392d89a41$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            $0005262392d89a41$var$abortControllerWithReason(controller, $0005262392d89a41$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    $0005262392d89a41$var$abortControllerWithReason(internalTaskController, $0005262392d89a41$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $0005262392d89a41$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $0005262392d89a41$export$cb1bdac908fed7f)) $0005262392d89a41$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            $0005262392d89a41$var$abortControllerWithReason(internalTaskController, $0005262392d89a41$var$listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $0005262392d89a41$var$createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $b0c9b171c350de9c$export$b956e38827fca970)(action)) return next(action);
                if ($0005262392d89a41$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($0005262392d89a41$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($0005262392d89a41$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $0005262392d89a41$var$INTERNAL_NIL_TOKEN) throw new Error($0005262392d89a41$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $0005262392d89a41$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $0005262392d89a41$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $0005262392d89a41$var$createMiddlewareEntry = (middleware)=>({
        id: $0005262392d89a41$export$ac4959f4f1338dfc(),
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $0005262392d89a41$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $0005262392d89a41$export$4bb1606a79445586 = ()=>{
    const instanceId = $0005262392d89a41$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($0005262392d89a41$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            let entry = $0005262392d89a41$var$find(Array.from(middlewareMap.values()), (entry2)=>entry2.middleware === middleware2);
            if (!entry) entry = $0005262392d89a41$var$createMiddlewareEntry(middleware2);
            middlewareMap.set(entry.id, entry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$0005262392d89a41$var$emplace(entry.applied, api, {
                insert: ()=>entry.middleware(api)
            }));
        return (0, $b0c9b171c350de9c$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $0005262392d89a41$export$9dd1fb32974da385(withMiddleware, $0005262392d89a41$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $0005262392d89a41$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $0005262392d89a41$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$0005262392d89a41$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $0005262392d89a41$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $0005262392d89a41$var$isStateProxy = (value)=>!!value && !!value[$0005262392d89a41$var$ORIGINAL_STATE];
var $0005262392d89a41$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $0005262392d89a41$var$createStateProxy = (state, reducerMap)=>$0005262392d89a41$var$emplace($0005262392d89a41$var$stateProxyMap, state, {
        insert: ()=>new Proxy(state, {
                get: (target, prop, receiver)=>{
                    if (prop === $0005262392d89a41$var$ORIGINAL_STATE) return target;
                    const result = Reflect.get(target, prop, receiver);
                    if (typeof result === "undefined") {
                        const reducer = reducerMap[prop.toString()];
                        if (reducer) {
                            const reducerResult = reducer(void 0, {
                                type: $0005262392d89a41$export$ac4959f4f1338dfc()
                            });
                            if (typeof reducerResult === "undefined") throw new Error($0005262392d89a41$export$378fa86b259c0280(24));
                            return reducerResult;
                        }
                    }
                    return result;
                }
            })
    });
var $0005262392d89a41$var$original = (state)=>{
    if (!$0005262392d89a41$var$isStateProxy(state)) throw new Error($0005262392d89a41$export$378fa86b259c0280(25));
    return state[$0005262392d89a41$var$ORIGINAL_STATE];
};
var $0005262392d89a41$var$noopReducer = (state = {})=>state;
function $0005262392d89a41$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($0005262392d89a41$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $b0c9b171c350de9c$export$66e4520cdb265d18)(reducerMap) : $0005262392d89a41$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $5671edd534fa79c4$exports;
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($0005262392d89a41$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap), ...args);
        };
    }, {
        original: $0005262392d89a41$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $0005262392d89a41$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


const $4323df77636d026f$var$cartSlice = (0, $0005262392d89a41$export$4d8d9bd83c24ae8b)({
    name: "cart",
    initialState: {
        items: []
    },
    reducers: {
        addItem: (state, action)=>{
            // mutating the state over here
            const itemId = action.payload?.card?.info?.id;
            const existingItem = state.items.find((item)=>item.item?.card?.info?.id === itemId);
            if (existingItem) existingItem.quantity += 1; // Increment quan if item exists
            else state.items.push({
                item: action.payload,
                quantity: 1
            }); // Add new item with quantity 1
        },
        removeItem: (state, action)=>{
            const itemId = action.payload?.card?.info?.id;
            const existingItem = state.items.find((item)=>item.item?.card?.info?.id === itemId);
            if (existingItem) {
                if (existingItem.quantity > 1) existingItem.quantity -= 1; // Decrement quan if more than 1
                else state.items = state.items.filter((item)=>item.item?.card?.info?.id !== itemId);
            }
        },
        clearCart: (state, action)=>{
            state.items.length = 0;
        }
    }
});
const { addItem: $4323df77636d026f$export$fb9705de59d96855, removeItem: $4323df77636d026f$export$fe2d9b4e03920b4c, clearCart: $4323df77636d026f$export$810121176e3e3671 } = $4323df77636d026f$var$cartSlice.actions;
var // and reducer from the slice
$4323df77636d026f$export$2e2bcd8739ae039 = $4323df77636d026f$var$cartSlice.reducer;



var $085b7c82b58373cc$exports = {};
$085b7c82b58373cc$exports = new URL("menuItemStar.81719e4e.svg", import.meta.url).toString();


var $f13efcae6dc3d7af$exports = {};
$f13efcae6dc3d7af$exports = new URL("best-seller-badge-icon.41aaf93d.png", import.meta.url).toString();


const $e00d0c219b1d09a2$var$ItemList = ({ menuItem: menuItem, isCartView: isCartView })=>{
    const dispatch = (0, $25d342665550a083$export$8ad76b76a4c905f8)();
    const cartItems = (0, $25d342665550a083$export$2105062e25df4afe)((store)=>store.cart.items);
    // Check item quantity in the cart
    const getItemQuantity = (itemId)=>{
        const cartItem = cartItems.find((item)=>item?.item?.card?.info?.id === itemId);
        return cartItem ? cartItem.quantity : 0;
    };
    const handleAddItem = (item)=>{
        // dispatch an action
        dispatch((0, $4323df77636d026f$export$fb9705de59d96855)(item));
    };
    const handleRemoveItem = (item)=>{
        dispatch((0, $4323df77636d026f$export$fe2d9b4e03920b4c)(item));
    };
    return /*#__PURE__*/ (0, $5aRSq.jsx)((0, $5aRSq.Fragment), {
        children: menuItem?.length == 0 ? /*#__PURE__*/ (0, $5aRSq.jsx)((0, $5aRSq.Fragment), {}) : menuItem.map((item, index)=>{
            const itemData = isCartView ? item.item : item;
            const itemQuantity = isCartView ? item.quantity : getItemQuantity(itemData?.card?.info?.id);
            return /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                        className: "accBody",
                        children: /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                            className: "dish_Container",
                            children: [
                                /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                                    className: "dish_details",
                                    children: [
                                        /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                                            className: "dish-detail-badge-cont",
                                            children: [
                                                /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                                                    className: "vegnonveg-icon-svg-like",
                                                    children: itemData.card.info.isVeg ? /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                                                        className: "veg-icon-menu",
                                                        children: "VEG"
                                                    }) : /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                                                        className: "nonveg-icon-menu",
                                                        children: "NON-VEG"
                                                    })
                                                }),
                                                itemData?.card?.info?.isBestseller && /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                                                    className: "best-seller-badge",
                                                    children: [
                                                        /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                                                            className: "best-seller-befor-badge",
                                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($f13efcae6dc3d7af$exports)))
                                                        }),
                                                        itemData?.card?.info?.ribbon?.text
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                            className: "dish-name-title",
                                            children: itemData?.card?.info?.name
                                        }),
                                        /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                            className: "dishPrice",
                                            children: /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                                children: itemData.card.info.price ? itemData?.card?.info?.price / 100 : itemData?.card?.info?.defaultPrice / 100
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                                            className: "rating-container",
                                            children: [
                                                itemData?.card?.info?.ratings?.aggregatedRating?.rating && /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                                    className: "star-container-menu",
                                                    children: /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($085b7c82b58373cc$exports)))
                                                    })
                                                }),
                                                itemData?.card?.info?.ratings?.aggregatedRating?.rating && /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                                    className: "rating-int",
                                                    children: itemData?.card?.info?.ratings?.aggregatedRating?.rating
                                                }),
                                                itemData?.card?.info?.ratings?.aggregatedRating?.rating && /*#__PURE__*/ (0, $5aRSq.jsxs)("span", {
                                                    className: "rating-count-con",
                                                    children: [
                                                        "(",
                                                        itemData?.card?.info?.ratings?.aggregatedRating?.ratingCountV2,
                                                        ")"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $5aRSq.jsx)("p", {
                                            className: "dishDescription",
                                            children: itemData?.card?.info?.description
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                                    className: "dishImage",
                                    children: [
                                        /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                                            className: "isImage",
                                            children: itemData?.card?.info?.imageId && /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                                                src: (0, $1449da937569f1f7$export$31adfacaf07ffe63) + itemData?.card?.info?.imageId,
                                                loading: "lazy",
                                                role: "presentation",
                                                decoding: "async",
                                                fetchpriority: "high"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                                            className: "addButtonContainer",
                                            children: isCartView || itemQuantity > 0 ? /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                                                className: "i-quantity-controller",
                                                children: [
                                                    /*#__PURE__*/ (0, $5aRSq.jsx)("button", {
                                                        className: "i_minus_btn",
                                                        onClick: ()=>handleRemoveItem(itemData),
                                                        children: "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                                        className: "i-item-quantity",
                                                        children: itemQuantity
                                                    }),
                                                    /*#__PURE__*/ (0, $5aRSq.jsx)("button", {
                                                        className: "i_plus_btn",
                                                        onClick: ()=>handleAddItem(itemData),
                                                        children: "+"
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $5aRSq.jsx)("button", {
                                                className: "add_btn",
                                                onClick: ()=>handleAddItem(itemData),
                                                children: "ADD"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    index + 1 < menuItem.length && /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                        className: "categoryHRLine"
                    })
                ]
            }, itemData?.card?.info?.id);
        })
    });
};
var $e00d0c219b1d09a2$export$2e2bcd8739ae039 = $e00d0c219b1d09a2$var$ItemList;


var $e5a6dce907aebd1c$exports = {};
$e5a6dce907aebd1c$exports = new URL("arrow.f5b241c3.svg", import.meta.url).toString();




var $4Iuzv = parcelRequire("4Iuzv");
const $db38a3044875d9ad$var$ItemCategory = "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory";
const $db38a3044875d9ad$var$NestedItemCategory = "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory";
const $db38a3044875d9ad$var$MenuCategory = ({ data: data, showItems: showItems, setShowIndex: setShowIndex, setFalse: setFalse })=>{
    const [categoryIndex, setCategoryIndex] = (0, $4Iuzv.useState)(0);
    const handleClick = (index)=>{
        setCategoryIndex(index);
        setShowIndex();
        setFalse();
    };
    const count = data?.card?.itemCards?.length || data?.categories?.length;
    const dataType = data?.card["@type"];
    const { itemCards: itemCards } = data?.card["@type"] === $db38a3044875d9ad$var$ItemCategory && data.card;
    const nestedItemCards = data.card["@type"] === $db38a3044875d9ad$var$NestedItemCategory && data?.card?.categories?.length > 0 ? data?.card?.categories.map((d)=>d.itemCards) : [];
    return dataType === $db38a3044875d9ad$var$ItemCategory ? /*#__PURE__*/ (0, $5aRSq.jsx)("section", {
        className: "resMenuCategory",
        children: /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
            className: "accordian",
            children: [
                /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                    className: "accordianHeader",
                    children: /*#__PURE__*/ (0, $5aRSq.jsxs)("button", {
                        onClick: ()=>handleClick(0),
                        className: "category_btn",
                        children: [
                            /*#__PURE__*/ (0, $5aRSq.jsxs)("span", {
                                className: "categoryName",
                                children: [
                                    data?.card?.title,
                                    " ",
                                    dataType === $db38a3044875d9ad$var$ItemCategory && "(" + count + ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                className: "icon",
                                children: /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e5a6dce907aebd1c$exports)))
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                    className: "menuCategoryBody",
                    children: showItems && /*#__PURE__*/ (0, $5aRSq.jsx)((0, $e00d0c219b1d09a2$export$2e2bcd8739ae039), {
                        menuItem: itemCards,
                        button: true
                    })
                })
            ]
        })
    }) : dataType === $db38a3044875d9ad$var$NestedItemCategory && /*#__PURE__*/ (0, $5aRSq.jsx)("section", {
        className: "nestedCategory",
        children: /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
            className: "accordian main_container",
            children: [
                /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                    className: "nes-cat-titleName-head",
                    children: /*#__PURE__*/ (0, $5aRSq.jsx)("h2", {
                        className: "categoryName nestedCatName",
                        children: data?.card?.title
                    })
                }),
                data?.card?.categories?.map((nestedCategory, index)=>/*#__PURE__*/ (0, $5aRSq.jsxs)((0, $5aRSq.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                                children: /*#__PURE__*/ (0, $5aRSq.jsxs)("button", {
                                    onClick: ()=>handleClick(index),
                                    className: "category_btn",
                                    children: [
                                        /*#__PURE__*/ (0, $5aRSq.jsxs)("h3", {
                                            className: "nested-cat-item-head",
                                            children: [
                                                nestedCategory?.title,
                                                " ",
                                                dataType === $db38a3044875d9ad$var$NestedItemCategory && "(" + nestedCategory?.itemCards.length + ")"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                            className: "icon",
                                            children: /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($e5a6dce907aebd1c$exports)))
                                            })
                                        })
                                    ]
                                })
                            }, nestedCategory.id),
                            /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                                className: "menuCategoryBody",
                                children: [
                                    showItems && categoryIndex === index && /*#__PURE__*/ (0, $5aRSq.jsx)((0, $e00d0c219b1d09a2$export$2e2bcd8739ae039), {
                                        menuItem: nestedItemCards[categoryIndex],
                                        button: true
                                    }),
                                    index + 1 < data?.card?.categories?.length && /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                                        className: "hr_line"
                                    })
                                ]
                            })
                        ]
                    }))
            ]
        })
    });
};
var $db38a3044875d9ad$export$2e2bcd8739ae039 = $db38a3044875d9ad$var$MenuCategory;



var $4fe9e7ad98bba7b7$exports = {};
$4fe9e7ad98bba7b7$exports = new URL("pureVeg.91e17ad4.svg", import.meta.url).toString();




const $2c1fa16701f2ffe3$var$RestaurantMenu = ()=>{
    const { resId: resId } = (0, $175a2504a1bf07a5$export$99eaa27ddbbb95ef)();
    const [showIndex, setShowIndex] = (0, $4Iuzv.useState)(0);
    const [isfalse, setFalse] = (0, $4Iuzv.useState)(true);
    // Passing resId to Custom hook to fetch restaurant details and returns it
    const resMenu = (0, $6a9db8a30167c416$export$2e2bcd8739ae039)(resId);
    // return !resMenu ? (<MenuShimmerUI />) : ();
    if (resMenu === null) return /*#__PURE__*/ (0, $5aRSq.jsx)((0, $e58ede3959b42f38$export$2e2bcd8739ae039), {});
    const { name: name, cuisines: cuisines, costForTwoMessage: costForTwoMessage, areaName: areaName, locality: locality, cloudinaryImageId: cloudinaryImageId, avgRating: avgRating, labels: labels, sla: sla, totalRatingsString: totalRatingsString } = resMenu?.cards[2]?.card?.card?.info;
    const { info: info } = resMenu.cards[2].card.card;
    // const { itemCards = [] } = true ?
    // resInfo?.cards[4]?.groupedCard?.cardGroupMap?.REGULAR?.cards[2]?.card?.card :
    // resInfo?.cards[4]?.groupedCard?.cardGroupMap?.REGULAR?.cards[2]?.card?.card?.categories[0];
    const allCards = resMenu?.cards[4]?.groupedCard?.cardGroupMap?.REGULAR?.cards;
    const ItemCategory = "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory";
    const NestedItemCategory = "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory";
    const itemCategies = allCards.filter((c)=>c.card?.card?.["@type"] === ItemCategory || c.card?.card?.["@type"] === NestedItemCategory);
    // console.log(resMenu);
    // console.log(allCards);
    // console.log("Filtered: ", itemCategies);
    // const itemCardNew = menuItem.itemCards || menuItem.categories[0].itemCards;
    return /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
        className: "menu-page-cont",
        children: [
            /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                className: "res-menu-header",
                children: [
                    /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                        className: "res-details-menu",
                        children: [
                            /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                                className: "res-name-menu",
                                children: [
                                    " ",
                                    name
                                ]
                            }),
                            /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                                className: "sevices",
                                children: [
                                    /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                                        className: "outlet-section-head",
                                        children: [
                                            /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                                className: "outlet-font",
                                                children: "Outlet "
                                            }),
                                            areaName
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $5aRSq.jsxs)("p", {
                                        className: "cuisine",
                                        children: [
                                            cuisines.join(", "),
                                            " - ",
                                            costForTwoMessage
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                                        className: "rating-cont-res-info",
                                        children: [
                                            /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                                className: "star-svg-cont-res",
                                                children: /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($c6e05221391e2cee$exports)))
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $5aRSq.jsxs)("span", {
                                                className: "avg-rating-str",
                                                children: [
                                                    avgRating,
                                                    " (",
                                                    totalRatingsString,
                                                    ")"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                                        className: "res-address-cont",
                                        children: [
                                            /*#__PURE__*/ (0, $5aRSq.jsxs)("span", {
                                                className: "address-label",
                                                children: [
                                                    labels[1]?.title,
                                                    ":"
                                                ]
                                            }),
                                            " ",
                                            labels[1]?.message
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                                        className: "delivery-time-str-resInfo",
                                        children: [
                                            "Deliverable in",
                                            " " + sla.slaString
                                        ]
                                    }),
                                    info?.veg || info?.name.toLowerCase().includes("veg") ? /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                                        className: "p-pure-veg-badge-cont",
                                        children: /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($4fe9e7ad98bba7b7$exports))),
                                            className: "p-pure-veg-badge"
                                        })
                                    }) : /*#__PURE__*/ (0, $5aRSq.jsx)((0, $5aRSq.Fragment), {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                        className: "res-img-menu-design-cont",
                        children: /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                            className: "res-img-in-menu",
                            src: (0, $1449da937569f1f7$export$31adfacaf07ffe63) + cloudinaryImageId
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $5aRSq.jsx)("h2", {
                        className: "menuHead",
                        children: "MENU"
                    }),
                    itemCategies.map((category, index)=>// Controlled component
                        /*#__PURE__*/ (0, $5aRSq.jsx)((0, $db38a3044875d9ad$export$2e2bcd8739ae039), {
                            data: category?.card,
                            showItems: index === showIndex && isfalse,
                            setShowIndex: ()=>setShowIndex(index),
                            setFalse: ()=>setFalse(isfalse && index === showIndex ? false : true)
                        }, category?.card?.card?.title))
                ]
            })
        ]
    });
};
var $2c1fa16701f2ffe3$export$2e2bcd8739ae039 = $2c1fa16701f2ffe3$var$RestaurantMenu;




var $fmRNI = parcelRequire("fmRNI");



const $f333c53e020a5411$var$appStore = (0, $0005262392d89a41$export$7d8a5b498da695ac)({
    reducer: {
        cart: (0, $4323df77636d026f$export$2e2bcd8739ae039)
    }
});
var $f333c53e020a5411$export$2e2bcd8739ae039 = $f333c53e020a5411$var$appStore;



var $5aRSq = parcelRequire("5aRSq");




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $1d9b556137794272$var$extendStatics = function(d, b) {
    $1d9b556137794272$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $1d9b556137794272$var$extendStatics(d, b);
};
function $1d9b556137794272$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $1d9b556137794272$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $1d9b556137794272$export$18ce0697a983be9b = function() {
    $1d9b556137794272$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1d9b556137794272$export$18ce0697a983be9b.apply(this, arguments);
};
function $1d9b556137794272$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $1d9b556137794272$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $1d9b556137794272$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $1d9b556137794272$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $1d9b556137794272$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $1d9b556137794272$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $1d9b556137794272$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $1d9b556137794272$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $1d9b556137794272$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $1d9b556137794272$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $1d9b556137794272$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $1d9b556137794272$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $1d9b556137794272$export$45d3717a4c69092e(o, m, p);
}
function $1d9b556137794272$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $1d9b556137794272$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $1d9b556137794272$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($1d9b556137794272$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $1d9b556137794272$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $1d9b556137794272$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $1d9b556137794272$export$10c90e4f7922046c(v) {
    return this instanceof $1d9b556137794272$export$10c90e4f7922046c ? (this.v = v, this) : new $1d9b556137794272$export$10c90e4f7922046c(v);
}
function $1d9b556137794272$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $1d9b556137794272$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $1d9b556137794272$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $1d9b556137794272$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $1d9b556137794272$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $1d9b556137794272$export$19a8beecd37a4c45 === "function" ? $1d9b556137794272$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $1d9b556137794272$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $1d9b556137794272$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $1d9b556137794272$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1d9b556137794272$export$45d3717a4c69092e(result, mod, k);
    }
    $1d9b556137794272$var$__setModuleDefault(result, mod);
    return result;
}
function $1d9b556137794272$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $1d9b556137794272$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $1d9b556137794272$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $1d9b556137794272$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $1d9b556137794272$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $1d9b556137794272$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $1d9b556137794272$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $1d9b556137794272$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $1d9b556137794272$export$2e2bcd8739ae039 = {
    __extends: $1d9b556137794272$export$a8ba968b8961cb8a,
    __assign: $1d9b556137794272$export$18ce0697a983be9b,
    __rest: $1d9b556137794272$export$3c9a16f847548506,
    __decorate: $1d9b556137794272$export$29e00dfd3077644b,
    __param: $1d9b556137794272$export$d5ad3fd78186038f,
    __metadata: $1d9b556137794272$export$f1db080c865becb9,
    __awaiter: $1d9b556137794272$export$1050f835b63b671e,
    __generator: $1d9b556137794272$export$67ebef60e6f28a6,
    __createBinding: $1d9b556137794272$export$45d3717a4c69092e,
    __exportStar: $1d9b556137794272$export$f33643c0debef087,
    __values: $1d9b556137794272$export$19a8beecd37a4c45,
    __read: $1d9b556137794272$export$8d051b38c9118094,
    __spread: $1d9b556137794272$export$afc72e2116322959,
    __spreadArrays: $1d9b556137794272$export$6388937ca91ccae8,
    __spreadArray: $1d9b556137794272$export$1216008129fb82ed,
    __await: $1d9b556137794272$export$10c90e4f7922046c,
    __asyncGenerator: $1d9b556137794272$export$e427f37a30a4de9b,
    __asyncDelegator: $1d9b556137794272$export$bbd80228419bb833,
    __asyncValues: $1d9b556137794272$export$e3b29a3d6162315f,
    __makeTemplateObject: $1d9b556137794272$export$4fb47efe1390b86f,
    __importStar: $1d9b556137794272$export$c21735bcef00d192,
    __importDefault: $1d9b556137794272$export$da59b14a69baef04,
    __classPrivateFieldGet: $1d9b556137794272$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $1d9b556137794272$export$d40a35129aaff81f,
    __classPrivateFieldIn: $1d9b556137794272$export$81fdc39f203e4e04,
    __addDisposableResource: $1d9b556137794272$export$88ac25d8e944e405,
    __disposeResources: $1d9b556137794272$export$8f076105dc360e92
};


function $aa177298e59cad41$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $aee56ff00fae488f$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $aee56ff00fae488f$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $aa177298e59cad41$export$2e2bcd8739ae039)(function(prop) {
    return $aee56ff00fae488f$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $4Iuzv = parcelRequire("4Iuzv");
var $28ad59042aff93bc$exports = {};
//
$28ad59042aff93bc$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $a31acf44aa55d0c2$export$71ad59f2e432cfe8 = "-ms-";
var $a31acf44aa55d0c2$export$2c0f367103c8d01c = "-moz-";
var $a31acf44aa55d0c2$export$39dfd62a25e0fe93 = "-webkit-";
var $a31acf44aa55d0c2$export$a29989082612d0d9 = "comm";
var $a31acf44aa55d0c2$export$aa3a2e812ca8570d = "rule";
var $a31acf44aa55d0c2$export$527d108ccf083c2b = "decl";
var $a31acf44aa55d0c2$export$d3d35020fa5b54f0 = "@page";
var $a31acf44aa55d0c2$export$500415a86c544f73 = "@media";
var $a31acf44aa55d0c2$export$a763edbf796b780a = "@import";
var $a31acf44aa55d0c2$export$2790aeb8b4e5c826 = "@charset";
var $a31acf44aa55d0c2$export$1cc683e23b84b133 = "@viewport";
var $a31acf44aa55d0c2$export$9447a5efea57e862 = "@supports";
var $a31acf44aa55d0c2$export$ef011b4e114b1fba = "@document";
var $a31acf44aa55d0c2$export$6aad947bda0f3f46 = "@namespace";
var $a31acf44aa55d0c2$export$b44a8529a35fcb60 = "@keyframes";
var $a31acf44aa55d0c2$export$2c16de31893252e6 = "@font-face";
var $a31acf44aa55d0c2$export$3d846dd52e150c6f = "@counter-style";
var $a31acf44aa55d0c2$export$22314bfbb57653fe = "@font-feature-values";
var $a31acf44aa55d0c2$export$d773506282b3cfe6 = "@layer";
var $a31acf44aa55d0c2$export$1c5a554c78c0cd12 = "@scope";
var $a31acf44aa55d0c2$export$2335f513bbd82c6d = Math.abs;
var $a31acf44aa55d0c2$export$6788812c4e6611e6 = String.fromCharCode;
var $a31acf44aa55d0c2$export$e6e34fd1f2686227 = Object.assign;
function $a31acf44aa55d0c2$export$d6af199866bfb566(e, r) {
    return $a31acf44aa55d0c2$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $a31acf44aa55d0c2$export$a9db5e087081082d(e, 0)) << 2 ^ $a31acf44aa55d0c2$export$a9db5e087081082d(e, 1)) << 2 ^ $a31acf44aa55d0c2$export$a9db5e087081082d(e, 2)) << 2 ^ $a31acf44aa55d0c2$export$a9db5e087081082d(e, 3) : 0;
}
function $a31acf44aa55d0c2$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $a31acf44aa55d0c2$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $a31acf44aa55d0c2$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $a31acf44aa55d0c2$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $a31acf44aa55d0c2$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $a31acf44aa55d0c2$export$36776f635604f274(e) {
    return e.length;
}
function $a31acf44aa55d0c2$export$f9084667e487ed46(e) {
    return e.length;
}
function $a31acf44aa55d0c2$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $a31acf44aa55d0c2$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $a31acf44aa55d0c2$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$a31acf44aa55d0c2$export$4659b591c19bdf3d(e, r);
    });
}
var $a31acf44aa55d0c2$export$53f1d5ea8de3d7c = 1;
var $a31acf44aa55d0c2$export$4e0c71f277ca26b3 = 1;
var $a31acf44aa55d0c2$export$f24224f1c91d8156 = 0;
var $a31acf44aa55d0c2$export$5880b8b5730aff45 = 0;
var $a31acf44aa55d0c2$export$c0306caf338ac095 = 0;
var $a31acf44aa55d0c2$export$30a86d91af8ff6e6 = "";
function $a31acf44aa55d0c2$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $a31acf44aa55d0c2$export$53f1d5ea8de3d7c,
        column: $a31acf44aa55d0c2$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $a31acf44aa55d0c2$export$784d13d8ee351f07(e, r) {
    return $a31acf44aa55d0c2$export$e6e34fd1f2686227($a31acf44aa55d0c2$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $a31acf44aa55d0c2$export$590e8b2c435046d9(e) {
    while(e.root)e = $a31acf44aa55d0c2$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $a31acf44aa55d0c2$export$10d8903dec122b9d(e, e.siblings);
}
function $a31acf44aa55d0c2$export$eba6f6f03b0a92e7() {
    return $a31acf44aa55d0c2$export$c0306caf338ac095;
}
function $a31acf44aa55d0c2$export$232faf9add678146() {
    $a31acf44aa55d0c2$export$c0306caf338ac095 = $a31acf44aa55d0c2$export$5880b8b5730aff45 > 0 ? $a31acf44aa55d0c2$export$a9db5e087081082d($a31acf44aa55d0c2$export$30a86d91af8ff6e6, --$a31acf44aa55d0c2$export$5880b8b5730aff45) : 0;
    if ($a31acf44aa55d0c2$export$4e0c71f277ca26b3--, $a31acf44aa55d0c2$export$c0306caf338ac095 === 10) $a31acf44aa55d0c2$export$4e0c71f277ca26b3 = 1, $a31acf44aa55d0c2$export$53f1d5ea8de3d7c--;
    return $a31acf44aa55d0c2$export$c0306caf338ac095;
}
function $a31acf44aa55d0c2$export$48cfd1e771a65c4f() {
    $a31acf44aa55d0c2$export$c0306caf338ac095 = $a31acf44aa55d0c2$export$5880b8b5730aff45 < $a31acf44aa55d0c2$export$f24224f1c91d8156 ? $a31acf44aa55d0c2$export$a9db5e087081082d($a31acf44aa55d0c2$export$30a86d91af8ff6e6, $a31acf44aa55d0c2$export$5880b8b5730aff45++) : 0;
    if ($a31acf44aa55d0c2$export$4e0c71f277ca26b3++, $a31acf44aa55d0c2$export$c0306caf338ac095 === 10) $a31acf44aa55d0c2$export$4e0c71f277ca26b3 = 1, $a31acf44aa55d0c2$export$53f1d5ea8de3d7c++;
    return $a31acf44aa55d0c2$export$c0306caf338ac095;
}
function $a31acf44aa55d0c2$export$4d3fb11e950abb9e() {
    return $a31acf44aa55d0c2$export$a9db5e087081082d($a31acf44aa55d0c2$export$30a86d91af8ff6e6, $a31acf44aa55d0c2$export$5880b8b5730aff45);
}
function $a31acf44aa55d0c2$export$e88cb2efb12ae807() {
    return $a31acf44aa55d0c2$export$5880b8b5730aff45;
}
function $a31acf44aa55d0c2$export$58adb3bec8346d0f(e, r) {
    return $a31acf44aa55d0c2$export$2f35ab04d2335697($a31acf44aa55d0c2$export$30a86d91af8ff6e6, e, r);
}
function $a31acf44aa55d0c2$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $a31acf44aa55d0c2$export$2de70f21292aac9e(e) {
    return $a31acf44aa55d0c2$export$53f1d5ea8de3d7c = $a31acf44aa55d0c2$export$4e0c71f277ca26b3 = 1, $a31acf44aa55d0c2$export$f24224f1c91d8156 = $a31acf44aa55d0c2$export$36776f635604f274($a31acf44aa55d0c2$export$30a86d91af8ff6e6 = e), $a31acf44aa55d0c2$export$5880b8b5730aff45 = 0, [];
}
function $a31acf44aa55d0c2$export$45918ac1574455b1(e) {
    return $a31acf44aa55d0c2$export$30a86d91af8ff6e6 = "", e;
}
function $a31acf44aa55d0c2$export$410ac95b9ec204b8(e) {
    return $a31acf44aa55d0c2$export$87c2784dc9fc4ab($a31acf44aa55d0c2$export$58adb3bec8346d0f($a31acf44aa55d0c2$export$5880b8b5730aff45 - 1, $a31acf44aa55d0c2$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $a31acf44aa55d0c2$export$660b2ee2d4fb4eff(e) {
    return $a31acf44aa55d0c2$export$45918ac1574455b1($a31acf44aa55d0c2$export$5f8c09e3ae6f64e1($a31acf44aa55d0c2$export$2de70f21292aac9e(e)));
}
function $a31acf44aa55d0c2$export$7af1228ff777d175(e) {
    while($a31acf44aa55d0c2$export$c0306caf338ac095 = $a31acf44aa55d0c2$export$4d3fb11e950abb9e())if ($a31acf44aa55d0c2$export$c0306caf338ac095 < 33) $a31acf44aa55d0c2$export$48cfd1e771a65c4f();
    else break;
    return $a31acf44aa55d0c2$export$9e1725a4cfeada27(e) > 2 || $a31acf44aa55d0c2$export$9e1725a4cfeada27($a31acf44aa55d0c2$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $a31acf44aa55d0c2$export$5f8c09e3ae6f64e1(e) {
    while($a31acf44aa55d0c2$export$48cfd1e771a65c4f())switch($a31acf44aa55d0c2$export$9e1725a4cfeada27($a31acf44aa55d0c2$export$c0306caf338ac095)){
        case 0:
            $a31acf44aa55d0c2$export$10d8903dec122b9d($a31acf44aa55d0c2$export$c2ab62c7bf24634($a31acf44aa55d0c2$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $a31acf44aa55d0c2$export$10d8903dec122b9d($a31acf44aa55d0c2$export$410ac95b9ec204b8($a31acf44aa55d0c2$export$c0306caf338ac095), e);
            break;
        default:
            $a31acf44aa55d0c2$export$10d8903dec122b9d($a31acf44aa55d0c2$export$6788812c4e6611e6($a31acf44aa55d0c2$export$c0306caf338ac095), e);
    }
    return e;
}
function $a31acf44aa55d0c2$export$955ba06d119e085e(e, r) {
    while(--r && $a31acf44aa55d0c2$export$48cfd1e771a65c4f())if ($a31acf44aa55d0c2$export$c0306caf338ac095 < 48 || $a31acf44aa55d0c2$export$c0306caf338ac095 > 102 || $a31acf44aa55d0c2$export$c0306caf338ac095 > 57 && $a31acf44aa55d0c2$export$c0306caf338ac095 < 65 || $a31acf44aa55d0c2$export$c0306caf338ac095 > 70 && $a31acf44aa55d0c2$export$c0306caf338ac095 < 97) break;
    return $a31acf44aa55d0c2$export$58adb3bec8346d0f(e, $a31acf44aa55d0c2$export$e88cb2efb12ae807() + (r < 6 && $a31acf44aa55d0c2$export$4d3fb11e950abb9e() == 32 && $a31acf44aa55d0c2$export$48cfd1e771a65c4f() == 32));
}
function $a31acf44aa55d0c2$export$c889f2fcc19dbf12(e) {
    while($a31acf44aa55d0c2$export$48cfd1e771a65c4f())switch($a31acf44aa55d0c2$export$c0306caf338ac095){
        case e:
            return $a31acf44aa55d0c2$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $a31acf44aa55d0c2$export$c889f2fcc19dbf12($a31acf44aa55d0c2$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $a31acf44aa55d0c2$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $a31acf44aa55d0c2$export$48cfd1e771a65c4f();
            break;
    }
    return $a31acf44aa55d0c2$export$5880b8b5730aff45;
}
function $a31acf44aa55d0c2$export$4254d4e2b3745c4c(e, r) {
    while($a31acf44aa55d0c2$export$48cfd1e771a65c4f())if (e + $a31acf44aa55d0c2$export$c0306caf338ac095 === 57) break;
    else if (e + $a31acf44aa55d0c2$export$c0306caf338ac095 === 84 && $a31acf44aa55d0c2$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $a31acf44aa55d0c2$export$58adb3bec8346d0f(r, $a31acf44aa55d0c2$export$5880b8b5730aff45 - 1) + "*" + $a31acf44aa55d0c2$export$6788812c4e6611e6(e === 47 ? e : $a31acf44aa55d0c2$export$48cfd1e771a65c4f());
}
function $a31acf44aa55d0c2$export$c2ab62c7bf24634(e) {
    while(!$a31acf44aa55d0c2$export$9e1725a4cfeada27($a31acf44aa55d0c2$export$4d3fb11e950abb9e()))$a31acf44aa55d0c2$export$48cfd1e771a65c4f();
    return $a31acf44aa55d0c2$export$58adb3bec8346d0f(e, $a31acf44aa55d0c2$export$5880b8b5730aff45);
}
function $a31acf44aa55d0c2$export$ef7acd7185315e22(e) {
    return $a31acf44aa55d0c2$export$45918ac1574455b1($a31acf44aa55d0c2$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $a31acf44aa55d0c2$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $a31acf44aa55d0c2$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = c;
    var y = s;
    var j = n;
    var z = k;
    while(w)switch(h = g, g = $a31acf44aa55d0c2$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $a31acf44aa55d0c2$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($a31acf44aa55d0c2$export$f8e21b1e77979a08(z += $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed($a31acf44aa55d0c2$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $a31acf44aa55d0c2$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $a31acf44aa55d0c2$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $a31acf44aa55d0c2$export$7af1228ff777d175(h);
            break;
        case 92:
            z += $a31acf44aa55d0c2$export$955ba06d119e085e($a31acf44aa55d0c2$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($a31acf44aa55d0c2$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $a31acf44aa55d0c2$export$10d8903dec122b9d($a31acf44aa55d0c2$export$4a34f930e789283c($a31acf44aa55d0c2$export$4254d4e2b3745c4c($a31acf44aa55d0c2$export$48cfd1e771a65c4f(), $a31acf44aa55d0c2$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * b:
            u[f++] = $a31acf44aa55d0c2$export$36776f635604f274(z) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (p > 0 && $a31acf44aa55d0c2$export$36776f635604f274(z) - l) $a31acf44aa55d0c2$export$10d8903dec122b9d(p > 32 ? $a31acf44aa55d0c2$export$f8483753829ec8f3(z + ";", n, a, l - 1, i) : $a31acf44aa55d0c2$export$f8483753829ec8f3($a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(z, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $a31acf44aa55d0c2$export$10d8903dec122b9d(j = $a31acf44aa55d0c2$export$3307ffa7023ede1e(z, r, a, f, o, c, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $a31acf44aa55d0c2$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && $a31acf44aa55d0c2$export$a9db5e087081082d(z, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $a31acf44aa55d0c2$export$98e6a39c04603d36(e, j, j, n && $a31acf44aa55d0c2$export$10d8903dec122b9d($a31acf44aa55d0c2$export$3307ffa7023ede1e(e, j, j, 0, 0, c, u, k, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                $a31acf44aa55d0c2$export$98e6a39c04603d36(z, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $a31acf44aa55d0c2$export$36776f635604f274(z), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $a31acf44aa55d0c2$export$232faf9add678146() == 125) continue;
            }
            switch(z += $a31acf44aa55d0c2$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($a31acf44aa55d0c2$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($a31acf44aa55d0c2$export$4d3fb11e950abb9e() === 45) z += $a31acf44aa55d0c2$export$410ac95b9ec204b8($a31acf44aa55d0c2$export$48cfd1e771a65c4f());
                    v = $a31acf44aa55d0c2$export$4d3fb11e950abb9e(), o = l = $a31acf44aa55d0c2$export$36776f635604f274(k = z += $a31acf44aa55d0c2$export$c2ab62c7bf24634($a31acf44aa55d0c2$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $a31acf44aa55d0c2$export$36776f635604f274(z) == 2) b = 0;
            }
    }
    return s;
}
function $a31acf44aa55d0c2$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $a31acf44aa55d0c2$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var k = 0, m = $a31acf44aa55d0c2$export$2f35ab04d2335697(e, p + 1, p = $a31acf44aa55d0c2$export$2335f513bbd82c6d(d = u[w])), x = e; k < b; ++k)if (x = $a31acf44aa55d0c2$export$87c2784dc9fc4ab(d > 0 ? h[k] + " " + m : $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(m, /&\f/g, h[k]))) f[g++] = x;
    return $a31acf44aa55d0c2$export$35059013cd4a06db(e, r, a, s === 0 ? $a31acf44aa55d0c2$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $a31acf44aa55d0c2$export$4a34f930e789283c(e, r, a, c) {
    return $a31acf44aa55d0c2$export$35059013cd4a06db(e, r, a, $a31acf44aa55d0c2$export$a29989082612d0d9, $a31acf44aa55d0c2$export$6788812c4e6611e6($a31acf44aa55d0c2$export$eba6f6f03b0a92e7()), $a31acf44aa55d0c2$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $a31acf44aa55d0c2$export$f8483753829ec8f3(e, r, a, n, c) {
    return $a31acf44aa55d0c2$export$35059013cd4a06db(e, r, a, $a31acf44aa55d0c2$export$527d108ccf083c2b, $a31acf44aa55d0c2$export$2f35ab04d2335697(e, 0, n), $a31acf44aa55d0c2$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $a31acf44aa55d0c2$export$82e9f45cca5ba907(n, c, s) {
    switch($a31acf44aa55d0c2$export$d6af199866bfb566(n, c)){
        case 5103:
            return $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $a31acf44aa55d0c2$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + n + $a31acf44aa55d0c2$export$2c0f367103c8d01c + n + $a31acf44aa55d0c2$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($a31acf44aa55d0c2$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + n + $a31acf44aa55d0c2$export$71ad59f2e432cfe8 + $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + n + $a31acf44aa55d0c2$export$71ad59f2e432cfe8 + $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + n + $a31acf44aa55d0c2$export$71ad59f2e432cfe8 + $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + n + $a31acf44aa55d0c2$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + n + $a31acf44aa55d0c2$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + n + $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + "box-$1$2" + $a31acf44aa55d0c2$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + n + $a31acf44aa55d0c2$export$71ad59f2e432cfe8 + "flex-item-" + $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$a31acf44aa55d0c2$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $a31acf44aa55d0c2$export$71ad59f2e432cfe8 + "grid-row-" + $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + n + $a31acf44aa55d0c2$export$71ad59f2e432cfe8 + "flex-line-pack" + $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + n + $a31acf44aa55d0c2$export$71ad59f2e432cfe8 + $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + n + $a31acf44aa55d0c2$export$71ad59f2e432cfe8 + $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + "box-" + $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n, "-grow", "") + $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + n + $a31acf44aa55d0c2$export$71ad59f2e432cfe8 + $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed($a31acf44aa55d0c2$export$77ad94ebf1c2b9ed($a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed($a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + "box-pack:$3" + $a31acf44aa55d0c2$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$a31acf44aa55d0c2$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $a31acf44aa55d0c2$export$71ad59f2e432cfe8 + "grid-column-align" + $a31acf44aa55d0c2$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $a31acf44aa55d0c2$export$71ad59f2e432cfe8 + $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $a31acf44aa55d0c2$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$a31acf44aa55d0c2$export$f8e21b1e77979a08(n + (s = s[c].value), "span", 0) ? n : $a31acf44aa55d0c2$export$71ad59f2e432cfe8 + $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $a31acf44aa55d0c2$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$a31acf44aa55d0c2$export$f8e21b1e77979a08(s, "span", 0) ? $a31acf44aa55d0c2$export$4659b591c19bdf3d(s, /\d+/) : +$a31acf44aa55d0c2$export$4659b591c19bdf3d(s, /\d+/) - +$a31acf44aa55d0c2$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $a31acf44aa55d0c2$export$71ad59f2e432cfe8 + $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $a31acf44aa55d0c2$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $a31acf44aa55d0c2$export$71ad59f2e432cfe8 + $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed($a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($a31acf44aa55d0c2$export$36776f635604f274(n) - 1 - c > 6) switch($a31acf44aa55d0c2$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($a31acf44aa55d0c2$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $a31acf44aa55d0c2$export$2c0f367103c8d01c + ($a31acf44aa55d0c2$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$a31acf44aa55d0c2$export$f8e21b1e77979a08(n, "stretch", 0) ? $a31acf44aa55d0c2$export$82e9f45cca5ba907($a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $a31acf44aa55d0c2$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $a31acf44aa55d0c2$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($a31acf44aa55d0c2$export$a9db5e087081082d(n, c + 6) === 121) return $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n, ":", ":" + $a31acf44aa55d0c2$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($a31acf44aa55d0c2$export$a9db5e087081082d(n, $a31acf44aa55d0c2$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + ($a31acf44aa55d0c2$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $a31acf44aa55d0c2$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n, ":", ":" + $a31acf44aa55d0c2$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $a31acf44aa55d0c2$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $a31acf44aa55d0c2$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $a31acf44aa55d0c2$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $a31acf44aa55d0c2$export$a763edbf796b780a:
        case $a31acf44aa55d0c2$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $a31acf44aa55d0c2$export$a29989082612d0d9:
            return "";
        case $a31acf44aa55d0c2$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $a31acf44aa55d0c2$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $a31acf44aa55d0c2$export$aa3a2e812ca8570d:
            if (!$a31acf44aa55d0c2$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $a31acf44aa55d0c2$export$36776f635604f274(a = $a31acf44aa55d0c2$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $a31acf44aa55d0c2$export$5a7767152ae0305f(e) {
    var r = $a31acf44aa55d0c2$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $a31acf44aa55d0c2$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $a31acf44aa55d0c2$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $a31acf44aa55d0c2$export$527d108ccf083c2b:
                n.return = $a31acf44aa55d0c2$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $a31acf44aa55d0c2$export$b44a8529a35fcb60:
                return $a31acf44aa55d0c2$export$dfdc1655ccc5b9cb([
                    $a31acf44aa55d0c2$export$784d13d8ee351f07(n, {
                        value: $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $a31acf44aa55d0c2$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $a31acf44aa55d0c2$export$aa3a2e812ca8570d:
                if (n.length) return $a31acf44aa55d0c2$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($a31acf44aa55d0c2$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $a31acf44aa55d0c2$export$590e8b2c435046d9($a31acf44aa55d0c2$export$784d13d8ee351f07(n, {
                                props: [
                                    $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $a31acf44aa55d0c2$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $a31acf44aa55d0c2$export$590e8b2c435046d9($a31acf44aa55d0c2$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $a31acf44aa55d0c2$export$e6e34fd1f2686227(n, {
                                props: $a31acf44aa55d0c2$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $a31acf44aa55d0c2$export$590e8b2c435046d9($a31acf44aa55d0c2$export$784d13d8ee351f07(n, {
                                props: [
                                    $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $a31acf44aa55d0c2$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $a31acf44aa55d0c2$export$590e8b2c435046d9($a31acf44aa55d0c2$export$784d13d8ee351f07(n, {
                                props: [
                                    $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $a31acf44aa55d0c2$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $a31acf44aa55d0c2$export$590e8b2c435046d9($a31acf44aa55d0c2$export$784d13d8ee351f07(n, {
                                props: [
                                    $a31acf44aa55d0c2$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $a31acf44aa55d0c2$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $a31acf44aa55d0c2$export$590e8b2c435046d9($a31acf44aa55d0c2$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $a31acf44aa55d0c2$export$e6e34fd1f2686227(n, {
                                props: $a31acf44aa55d0c2$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $a31acf44aa55d0c2$export$76a88f7de6507443(e) {
    switch(e.type){
        case $a31acf44aa55d0c2$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $a31acf44aa55d0c2$export$1be1fc439b849fdf($a31acf44aa55d0c2$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($a31acf44aa55d0c2$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $a31acf44aa55d0c2$export$2f35ab04d2335697(r, 1, $a31acf44aa55d0c2$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $a31acf44aa55d0c2$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $a31acf44aa55d0c2$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $a31acf44aa55d0c2$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $aec789f165bd39af$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $88daf2a39afbf88c$var$f = ("undefined" != typeof $5671edd534fa79c4$exports && void 0 !== $5671edd534fa79c4$exports.env && undefined, "data-styled"), $88daf2a39afbf88c$var$m = "active", $88daf2a39afbf88c$var$y = "data-styled-version", $88daf2a39afbf88c$export$83d89fbfd8236492 = "6.1.13", $88daf2a39afbf88c$var$g = "/*!sc*/\n", $88daf2a39afbf88c$var$S = "undefined" != typeof window && "HTMLElement" in window, $88daf2a39afbf88c$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $5671edd534fa79c4$exports && $5671edd534fa79c4$exports.env, "undefined" != typeof $5671edd534fa79c4$exports && $5671edd534fa79c4$exports.env, false)), $88daf2a39afbf88c$var$b = {}, $88daf2a39afbf88c$var$E = /invalid hook call/i, $88daf2a39afbf88c$var$N = new Set, $88daf2a39afbf88c$var$P = function(t, n) {
    var o, s, i, a, e;
}, $88daf2a39afbf88c$var$_ = Object.freeze([]), $88daf2a39afbf88c$var$C = Object.freeze({});
function $88daf2a39afbf88c$var$I(e, t, n) {
    return void 0 === n && (n = $88daf2a39afbf88c$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $88daf2a39afbf88c$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $88daf2a39afbf88c$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $88daf2a39afbf88c$var$D = /(^-|-$)/g;
function $88daf2a39afbf88c$var$R(e) {
    return e.replace($88daf2a39afbf88c$var$O, "-").replace($88daf2a39afbf88c$var$D, "");
}
var $88daf2a39afbf88c$var$T = /(a)(d)/gi, $88daf2a39afbf88c$var$k = 52, $88daf2a39afbf88c$var$j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $88daf2a39afbf88c$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $88daf2a39afbf88c$var$k; t = t / $88daf2a39afbf88c$var$k | 0)n = $88daf2a39afbf88c$var$j(t % $88daf2a39afbf88c$var$k) + n;
    return ($88daf2a39afbf88c$var$j(t % $88daf2a39afbf88c$var$k) + n).replace($88daf2a39afbf88c$var$T, "$1-$2");
}
var $88daf2a39afbf88c$var$V, $88daf2a39afbf88c$var$F = 5381, $88daf2a39afbf88c$var$M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $88daf2a39afbf88c$var$z = function(e) {
    return $88daf2a39afbf88c$var$M($88daf2a39afbf88c$var$F, e);
};
function $88daf2a39afbf88c$var$$(e) {
    return $88daf2a39afbf88c$var$x($88daf2a39afbf88c$var$z(e) >>> 0);
}
function $88daf2a39afbf88c$var$B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $88daf2a39afbf88c$var$L(e) {
    return "string" == typeof e && true;
}
var $88daf2a39afbf88c$var$G = "function" == typeof Symbol && Symbol.for, $88daf2a39afbf88c$var$Y = $88daf2a39afbf88c$var$G ? Symbol.for("react.memo") : 60115, $88daf2a39afbf88c$var$W = $88daf2a39afbf88c$var$G ? Symbol.for("react.forward_ref") : 60112, $88daf2a39afbf88c$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $88daf2a39afbf88c$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $88daf2a39afbf88c$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $88daf2a39afbf88c$var$J = (($88daf2a39afbf88c$var$V = {})[$88daf2a39afbf88c$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $88daf2a39afbf88c$var$V[$88daf2a39afbf88c$var$Y] = $88daf2a39afbf88c$var$U, $88daf2a39afbf88c$var$V);
function $88daf2a39afbf88c$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $88daf2a39afbf88c$var$Y ? $88daf2a39afbf88c$var$U : "$$typeof" in e ? $88daf2a39afbf88c$var$J[e.$$typeof] : $88daf2a39afbf88c$var$q;
}
var $88daf2a39afbf88c$var$Z = Object.defineProperty, $88daf2a39afbf88c$var$K = Object.getOwnPropertyNames, $88daf2a39afbf88c$var$Q = Object.getOwnPropertySymbols, $88daf2a39afbf88c$var$ee = Object.getOwnPropertyDescriptor, $88daf2a39afbf88c$var$te = Object.getPrototypeOf, $88daf2a39afbf88c$var$ne = Object.prototype;
function $88daf2a39afbf88c$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($88daf2a39afbf88c$var$ne) {
            var o = $88daf2a39afbf88c$var$te(t);
            o && o !== $88daf2a39afbf88c$var$ne && $88daf2a39afbf88c$var$oe(e, o, n);
        }
        var r = $88daf2a39afbf88c$var$K(t);
        $88daf2a39afbf88c$var$Q && (r = r.concat($88daf2a39afbf88c$var$Q(t)));
        for(var s = $88daf2a39afbf88c$var$X(e), i = $88daf2a39afbf88c$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $88daf2a39afbf88c$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $88daf2a39afbf88c$var$ee(t, c);
                try {
                    $88daf2a39afbf88c$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $88daf2a39afbf88c$var$re(e) {
    return "function" == typeof e;
}
function $88daf2a39afbf88c$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $88daf2a39afbf88c$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $88daf2a39afbf88c$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $88daf2a39afbf88c$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $88daf2a39afbf88c$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$88daf2a39afbf88c$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $88daf2a39afbf88c$var$le(e[o], t[o]);
    else if ($88daf2a39afbf88c$var$ce(t)) for(var o in t)e[o] = $88daf2a39afbf88c$var$le(e[o], t[o]);
    return e;
}
function $88daf2a39afbf88c$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $88daf2a39afbf88c$var$pe = {};
function $88daf2a39afbf88c$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $88daf2a39afbf88c$var$he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $88daf2a39afbf88c$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $88daf2a39afbf88c$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($88daf2a39afbf88c$var$g);
        return t;
    }, e;
}(), $88daf2a39afbf88c$var$me = 1073741824, $88daf2a39afbf88c$var$ye = new Map, $88daf2a39afbf88c$var$ve = new Map, $88daf2a39afbf88c$var$ge = 1, $88daf2a39afbf88c$var$Se = function(e) {
    if ($88daf2a39afbf88c$var$ye.has(e)) return $88daf2a39afbf88c$var$ye.get(e);
    for(; $88daf2a39afbf88c$var$ve.has($88daf2a39afbf88c$var$ge);)$88daf2a39afbf88c$var$ge++;
    var t = $88daf2a39afbf88c$var$ge++;
    return $88daf2a39afbf88c$var$ye.set(e, t), $88daf2a39afbf88c$var$ve.set(t, e), t;
}, $88daf2a39afbf88c$var$we = function(e, t) {
    $88daf2a39afbf88c$var$ge = t + 1, $88daf2a39afbf88c$var$ye.set(e, t), $88daf2a39afbf88c$var$ve.set(t, e);
}, $88daf2a39afbf88c$var$be = "style[".concat($88daf2a39afbf88c$var$f, "][").concat($88daf2a39afbf88c$var$y, '="').concat($88daf2a39afbf88c$export$83d89fbfd8236492, '"]'), $88daf2a39afbf88c$var$Ee = new RegExp("^".concat($88daf2a39afbf88c$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $88daf2a39afbf88c$var$Ne = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $88daf2a39afbf88c$var$Pe = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($88daf2a39afbf88c$var$g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($88daf2a39afbf88c$var$Ee);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($88daf2a39afbf88c$var$we(u, l), $88daf2a39afbf88c$var$Ne(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
}, $88daf2a39afbf88c$var$_e = function(e) {
    for(var t = document.querySelectorAll($88daf2a39afbf88c$var$be), n = 0, o = t.length; n < o; n++){
        var r = t[n];
        r && r.getAttribute($88daf2a39afbf88c$var$f) !== $88daf2a39afbf88c$var$m && ($88daf2a39afbf88c$var$Pe(e, r), r.parentNode && r.parentNode.removeChild(r));
    }
};
function $88daf2a39afbf88c$var$Ce() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $88daf2a39afbf88c$var$Ie = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($88daf2a39afbf88c$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($88daf2a39afbf88c$var$f, $88daf2a39afbf88c$var$m), o.setAttribute($88daf2a39afbf88c$var$y, $88daf2a39afbf88c$export$83d89fbfd8236492);
    var i = $88daf2a39afbf88c$var$Ce();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $88daf2a39afbf88c$var$Ae = function() {
    function e(e) {
        this.element = $88daf2a39afbf88c$var$Ie(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $88daf2a39afbf88c$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $88daf2a39afbf88c$var$Oe = function() {
    function e(e) {
        this.element = $88daf2a39afbf88c$var$Ie(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $88daf2a39afbf88c$var$De = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $88daf2a39afbf88c$var$Re = $88daf2a39afbf88c$var$S, $88daf2a39afbf88c$var$Te = {
    isServer: !$88daf2a39afbf88c$var$S,
    useCSSOMInjection: !$88daf2a39afbf88c$var$w
}, $88daf2a39afbf88c$var$ke = function() {
    function e(e, n, o) {
        void 0 === e && (e = $88daf2a39afbf88c$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $1d9b556137794272$export$18ce0697a983be9b)((0, $1d9b556137794272$export$18ce0697a983be9b)({}, $88daf2a39afbf88c$var$Te), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $88daf2a39afbf88c$var$S && $88daf2a39afbf88c$var$Re && ($88daf2a39afbf88c$var$Re = !1, $88daf2a39afbf88c$var$_e(this)), $88daf2a39afbf88c$var$ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $88daf2a39afbf88c$var$ve.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || !s.size || 0 === i.length) return "continue";
                    var a = "".concat($88daf2a39afbf88c$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($88daf2a39afbf88c$var$g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $88daf2a39afbf88c$var$Se(e);
    }, e.prototype.rehydrate = function() {
        !this.server && $88daf2a39afbf88c$var$S && $88daf2a39afbf88c$var$_e(this);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $1d9b556137794272$export$18ce0697a983be9b)((0, $1d9b556137794272$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $88daf2a39afbf88c$var$De(n) : t ? new $88daf2a39afbf88c$var$Ae(n) : new $88daf2a39afbf88c$var$Oe(n);
        }(this.options), new $88daf2a39afbf88c$var$fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($88daf2a39afbf88c$var$Se(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($88daf2a39afbf88c$var$Se(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($88daf2a39afbf88c$var$Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $88daf2a39afbf88c$var$je = /&/g, $88daf2a39afbf88c$var$xe = /^\s*\/\/.*$/gm;
function $88daf2a39afbf88c$var$Ve(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $88daf2a39afbf88c$var$Ve(e.children, t)), e;
    });
}
function $88daf2a39afbf88c$var$Fe(e) {
    var t, n, o, r = void 0 === e ? $88daf2a39afbf88c$var$C : e, s = r.options, i = void 0 === s ? $88daf2a39afbf88c$var$C : s, a = r.plugins, c = void 0 === a ? $88daf2a39afbf88c$var$_ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $a31acf44aa55d0c2$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($88daf2a39afbf88c$var$je, n).replace(o, l));
    }), i.prefix && u.push($a31acf44aa55d0c2$export$e08c7d021b829b7a), u.push($a31acf44aa55d0c2$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($88daf2a39afbf88c$var$xe, ""), l = $a31acf44aa55d0c2$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $88daf2a39afbf88c$var$Ve(l, i.namespace));
        var p = [];
        return $a31acf44aa55d0c2$export$dfdc1655ccc5b9cb(l, $a31acf44aa55d0c2$export$5a7767152ae0305f(u.concat($a31acf44aa55d0c2$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $88daf2a39afbf88c$var$he(15), $88daf2a39afbf88c$var$M(e, t.name);
    }, $88daf2a39afbf88c$var$F).toString() : "", p;
}
var $88daf2a39afbf88c$var$Me = new $88daf2a39afbf88c$var$ke, $88daf2a39afbf88c$var$ze = $88daf2a39afbf88c$var$Fe(), $88daf2a39afbf88c$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $88daf2a39afbf88c$var$Me,
    stylis: $88daf2a39afbf88c$var$ze
}), $88daf2a39afbf88c$export$91317688fc694efa = $88daf2a39afbf88c$export$8c190ef828af4c86.Consumer, $88daf2a39afbf88c$var$Le = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createContext(void 0);
function $88daf2a39afbf88c$var$Ge() {
    return (0, $4Iuzv.useContext)($88daf2a39afbf88c$export$8c190ef828af4c86);
}
function $88daf2a39afbf88c$export$a473771da2f0ff7c(e) {
    var t = (0, $4Iuzv.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $88daf2a39afbf88c$var$Ge().styleSheet, l = (0, $4Iuzv.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $4Iuzv.useMemo)(function() {
        return $88daf2a39afbf88c$var$Fe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $4Iuzv.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($28ad59042aff93bc$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $4Iuzv.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement($88daf2a39afbf88c$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement($88daf2a39afbf88c$var$Le.Provider, {
        value: u
    }, e.children));
}
var $88daf2a39afbf88c$var$We = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $88daf2a39afbf88c$var$ze);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $88daf2a39afbf88c$var$ue(this, function() {
            throw $88daf2a39afbf88c$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $88daf2a39afbf88c$var$ze), this.name + e.hash;
    }, e;
}(), $88daf2a39afbf88c$var$qe = function(e) {
    return e >= "A" && e <= "Z";
};
function $88daf2a39afbf88c$var$He(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $88daf2a39afbf88c$var$qe(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $88daf2a39afbf88c$var$Ue = function(e) {
    return null == e || !1 === e || "" === e;
}, $88daf2a39afbf88c$var$Je = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$88daf2a39afbf88c$var$Ue(i) && (Array.isArray(i) && i.isCss || $88daf2a39afbf88c$var$re(i) ? r.push("".concat($88daf2a39afbf88c$var$He(s), ":"), i, ";") : $88daf2a39afbf88c$var$ce(i) ? r.push.apply(r, (0, $1d9b556137794272$export$1216008129fb82ed)((0, $1d9b556137794272$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $88daf2a39afbf88c$var$Je(i), !1), [
            "}"
        ], !1)) : r.push("".concat($88daf2a39afbf88c$var$He(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $aec789f165bd39af$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $88daf2a39afbf88c$var$Xe(e, t, n, o) {
    if ($88daf2a39afbf88c$var$Ue(e)) return [];
    if ($88daf2a39afbf88c$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($88daf2a39afbf88c$var$re(e)) {
        if (!$88daf2a39afbf88c$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $88daf2a39afbf88c$var$Xe(r, t, n, o);
    }
    var s;
    return e instanceof $88daf2a39afbf88c$var$We ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $88daf2a39afbf88c$var$ce(e) ? $88daf2a39afbf88c$var$Je(e) : Array.isArray(e) ? Array.prototype.concat.apply($88daf2a39afbf88c$var$_, e.map(function(e) {
        return $88daf2a39afbf88c$var$Xe(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $88daf2a39afbf88c$var$Ze(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($88daf2a39afbf88c$var$re(n) && !$88daf2a39afbf88c$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $88daf2a39afbf88c$var$Ke = $88daf2a39afbf88c$var$z($88daf2a39afbf88c$export$83d89fbfd8236492), $88daf2a39afbf88c$var$Qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $88daf2a39afbf88c$var$Ze(e), this.componentId = t, this.baseHash = $88daf2a39afbf88c$var$M($88daf2a39afbf88c$var$Ke, t), this.baseStyle = n, $88daf2a39afbf88c$var$ke.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $88daf2a39afbf88c$var$ie(o, this.staticRulesId);
            else {
                var r = $88daf2a39afbf88c$var$ae($88daf2a39afbf88c$var$Xe(this.rules, e, t, n)), s = $88daf2a39afbf88c$var$x($88daf2a39afbf88c$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $88daf2a39afbf88c$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $88daf2a39afbf88c$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $88daf2a39afbf88c$var$ae($88daf2a39afbf88c$var$Xe(u, e, t, n));
                    a = $88daf2a39afbf88c$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $88daf2a39afbf88c$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $88daf2a39afbf88c$var$ie(o, d);
            }
        }
        return o;
    }, e;
}(), $88daf2a39afbf88c$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createContext(void 0), $88daf2a39afbf88c$export$b631efc24e9d5e2f = $88daf2a39afbf88c$export$2c657da244d00bd6.Consumer;
function $88daf2a39afbf88c$export$93d4e7f90805808f() {
    var e = (0, $4Iuzv.useContext)($88daf2a39afbf88c$export$2c657da244d00bd6);
    if (!e) throw $88daf2a39afbf88c$var$he(18);
    return e;
}
function $88daf2a39afbf88c$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).useContext($88daf2a39afbf88c$export$2c657da244d00bd6), r = (0, $4Iuzv.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $88daf2a39afbf88c$var$he(14);
            if ($88daf2a39afbf88c$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $88daf2a39afbf88c$var$he(8);
            return n ? (0, $1d9b556137794272$export$18ce0697a983be9b)((0, $1d9b556137794272$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement($88daf2a39afbf88c$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $88daf2a39afbf88c$var$rt = {}, $88daf2a39afbf88c$var$st = new Set;
function $88daf2a39afbf88c$var$it(e, r, s) {
    var i = $88daf2a39afbf88c$export$7ba318d8d2f06c76(e), a = e, c = !$88daf2a39afbf88c$var$L(e), p = r.attrs, d = void 0 === p ? $88daf2a39afbf88c$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $88daf2a39afbf88c$var$R(e);
        $88daf2a39afbf88c$var$rt[n] = ($88daf2a39afbf88c$var$rt[n] || 0) + 1;
        var o = "".concat(n, "-").concat($88daf2a39afbf88c$var$$($88daf2a39afbf88c$export$83d89fbfd8236492 + n + $88daf2a39afbf88c$var$rt[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $88daf2a39afbf88c$var$L(e) ? "styled.".concat(e) : "Styled(".concat($88daf2a39afbf88c$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($88daf2a39afbf88c$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $88daf2a39afbf88c$var$Qe(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).useContext($88daf2a39afbf88c$export$2c657da244d00bd6), m = $88daf2a39afbf88c$var$Ge(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $88daf2a39afbf88c$var$I(r, f, c) || $88daf2a39afbf88c$var$C, g = function(e, n, o) {
                for(var r, s = (0, $1d9b556137794272$export$18ce0697a983be9b)((0, $1d9b556137794272$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $88daf2a39afbf88c$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $88daf2a39afbf88c$var$ie(s[c], a[c]) : "style" === c ? (0, $1d9b556137794272$export$18ce0697a983be9b)((0, $1d9b556137794272$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $88daf2a39afbf88c$var$ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $88daf2a39afbf88c$var$Ge(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = $88daf2a39afbf88c$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$88daf2a39afbf88c$var$L(S) && !$88daf2a39afbf88c$var$A.has(S) ? "class" : "className"] = N, w.ref = s, (0, $4Iuzv.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $88daf2a39afbf88c$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$88daf2a39afbf88c$var$le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $88daf2a39afbf88c$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $88daf2a39afbf88c$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $88daf2a39afbf88c$var$at(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $88daf2a39afbf88c$var$ct = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $88daf2a39afbf88c$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($88daf2a39afbf88c$var$re(t) || $88daf2a39afbf88c$var$ce(t)) return $88daf2a39afbf88c$var$ct($88daf2a39afbf88c$var$Xe($88daf2a39afbf88c$var$at($88daf2a39afbf88c$var$_, (0, $1d9b556137794272$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $88daf2a39afbf88c$var$Xe(r) : $88daf2a39afbf88c$var$ct($88daf2a39afbf88c$var$Xe($88daf2a39afbf88c$var$at(r, n)));
}
function $88daf2a39afbf88c$var$ut(n, o, r) {
    if (void 0 === r && (r = $88daf2a39afbf88c$var$C), !o) throw $88daf2a39afbf88c$var$he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $88daf2a39afbf88c$export$dbf350e5966cf602.apply(void 0, (0, $1d9b556137794272$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $88daf2a39afbf88c$var$ut(n, o, (0, $1d9b556137794272$export$18ce0697a983be9b)((0, $1d9b556137794272$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $88daf2a39afbf88c$var$ut(n, o, (0, $1d9b556137794272$export$18ce0697a983be9b)((0, $1d9b556137794272$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $88daf2a39afbf88c$var$pt = function(e) {
    return $88daf2a39afbf88c$var$ut($88daf2a39afbf88c$var$it, e);
}, $88daf2a39afbf88c$export$2e2bcd8739ae039 = $88daf2a39afbf88c$var$pt;
$88daf2a39afbf88c$var$A.forEach(function(e) {
    $88daf2a39afbf88c$export$2e2bcd8739ae039[e] = $88daf2a39afbf88c$var$pt(e);
});
var $88daf2a39afbf88c$var$ht = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $88daf2a39afbf88c$var$Ze(e), $88daf2a39afbf88c$var$ke.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($88daf2a39afbf88c$var$ae($88daf2a39afbf88c$var$Xe(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $88daf2a39afbf88c$var$ke.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $88daf2a39afbf88c$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $88daf2a39afbf88c$export$dbf350e5966cf602.apply(void 0, (0, $1d9b556137794272$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($88daf2a39afbf88c$var$$(JSON.stringify(i))), c = new $88daf2a39afbf88c$var$ht(i, a);
    var l = function(e) {
        var t = $88daf2a39afbf88c$var$Ge(), n = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).useContext($88daf2a39afbf88c$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $88daf2a39afbf88c$var$b, o, s);
        else {
            var i = (0, $1d9b556137794272$export$18ce0697a983be9b)((0, $1d9b556137794272$export$18ce0697a983be9b)({}, n), {
                theme: $88daf2a39afbf88c$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).memo(l);
}
function $88daf2a39afbf88c$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $88daf2a39afbf88c$var$ae($88daf2a39afbf88c$export$dbf350e5966cf602.apply(void 0, (0, $1d9b556137794272$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $88daf2a39afbf88c$var$$(r);
    return new $88daf2a39afbf88c$var$We(s, r);
}
function $88daf2a39afbf88c$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).forwardRef(function(n, r) {
        var s = $88daf2a39afbf88c$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).useContext($88daf2a39afbf88c$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement(e, (0, $1d9b556137794272$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($88daf2a39afbf88c$var$B(e), ")"), $88daf2a39afbf88c$var$oe(n, e);
}
var $88daf2a39afbf88c$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $88daf2a39afbf88c$var$Ce(), o = $88daf2a39afbf88c$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($88daf2a39afbf88c$var$f, '="true"'),
                "".concat($88daf2a39afbf88c$var$y, '="').concat($88daf2a39afbf88c$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $88daf2a39afbf88c$var$he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $88daf2a39afbf88c$var$he(2);
            var r = e.instance.toString();
            if (!r) return [];
            var s = ((n = {})[$88daf2a39afbf88c$var$f] = "", n[$88daf2a39afbf88c$var$y] = $88daf2a39afbf88c$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: r
            }, n), i = $88daf2a39afbf88c$var$Ce();
            return i && (s.nonce = i), [
                (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement("style", (0, $1d9b556137794272$export$18ce0697a983be9b)({}, s, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $88daf2a39afbf88c$var$ke({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $88daf2a39afbf88c$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement($88daf2a39afbf88c$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $88daf2a39afbf88c$var$he(3);
    }, e;
}(), $88daf2a39afbf88c$export$5c87cfe6c475f500 = {
    StyleSheet: $88daf2a39afbf88c$var$ke,
    mainSheet: $88daf2a39afbf88c$var$Me
};
var $88daf2a39afbf88c$var$St = "__sc-".concat($88daf2a39afbf88c$var$f, "__");


parcelRequire("4Iuzv");
parcelRequire("fmRNI");
const $6380ab133b56ea42$var$Styling = (0, $88daf2a39afbf88c$export$2e2bcd8739ae039).div`
  background-color: #fff;
  border-radius: 8px;
  border: 2px solid grey;
  color: purple;
  padding: 20px;
  cursor: pointer;
  font-weight: 580;
`;
const $6380ab133b56ea42$var$Cart = ()=>{
    const cartItems = (0, $25d342665550a083$export$2105062e25df4afe)((store)=>store.cart.items);
    const dispatch = (0, $25d342665550a083$export$8ad76b76a4c905f8)();
    const handleClearCart = ()=>{
        dispatch((0, $4323df77636d026f$export$810121176e3e3671)());
    };
    const prices = cartItems.map((item)=>item.item.card.info.price ? item.item.card.info.price / 100 : item.item.card.info.defaultPrice / 100);
    const quantities = cartItems.map((item)=>item.quantity);
    const totalPrice = prices.reduce((acc, curr, index)=>{
        return acc + curr * quantities[index];
    }, 0);
    return /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
        className: "cartDesign",
        children: [
            /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                className: "c-cart-head-contaier",
                children: [
                    /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                        className: "c-your-cart-heading",
                        children: "Your Cart"
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)("button", {
                        className: "clear_btn",
                        onClick: handleClearCart,
                        children: "Clear Cart"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("hr", {
                className: "cartHrLine"
            }),
            cartItems.length === 0 ? /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "c-empty-Cart",
                children: "Your Cart is empty Add items to the cart !"
            }) : /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                className: "addedItems",
                children: [
                    /*#__PURE__*/ (0, $5aRSq.jsx)((0, $e00d0c219b1d09a2$export$2e2bcd8739ae039), {
                        menuItem: cartItems,
                        isCartView: true
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)($6380ab133b56ea42$var$Styling, {
                        children: /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                            className: "c-to-pay-cont ",
                            children: [
                                /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                    className: "c-to-pay-heading ",
                                    children: "TO PAY"
                                }),
                                /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                                    className: "c-total-price-value font-inter",
                                    children: totalPrice
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $6380ab133b56ea42$export$2e2bcd8739ae039 = $6380ab133b56ea42$var$Cart;




const $fd878d1a2b2f022b$var$Grocery = /*#__PURE__*/ (0, $4Iuzv.lazy)(()=>(parcelRequire("eHry9")));
const $fd878d1a2b2f022b$var$Applayout = ()=>{
    const [userName, setUserName] = (0, $4Iuzv.useState)();
    // authentication
    (0, $4Iuzv.useEffect)(()=>{
        // Make an API call and send username and password
        const data = {
            name: "Abhishek Marwal"
        };
        setUserName(data.name);
    }, []);
    return /*#__PURE__*/ (0, $5aRSq.jsx)((0, $25d342665550a083$export$2881499e37b75b9a), {
        store: (0, $f333c53e020a5411$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $fmRNI.default).Provider, {
            value: {
                loggedInUser: userName,
                setUserName: setUserName
            },
            children: /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                className: "app",
                children: [
                    /*#__PURE__*/ (0, $5aRSq.jsx)((0, $cf5a5aeeefcd27c2$export$2e2bcd8739ae039), {}),
                    " ",
                    /*#__PURE__*/ (0, $5aRSq.jsx)((0, $175a2504a1bf07a5$export$910ae8079b2c2852), {}),
                    /*#__PURE__*/ (0, $5aRSq.jsx)((0, $a87d1ec7246dc632$export$2e2bcd8739ae039), {})
                ]
            })
        })
    });
};
const $fd878d1a2b2f022b$var$appRouter = (0, $c34e9f2261c19895$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $5aRSq.jsx)($fd878d1a2b2f022b$var$Applayout, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $fbae3e930d5c7be3$export$2e2bcd8739ae039), {})
            },
            {
                path: "/about",
                element: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $3d797a4fd66ccc9e$export$2e2bcd8739ae039), {})
            },
            {
                path: "/offers",
                element: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $644d395bf2a96561$export$2e2bcd8739ae039), {})
            },
            {
                path: "/grocery",
                element: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $4Iuzv.Suspense), {
                    fallback: /*#__PURE__*/ (0, $5aRSq.jsx)("h1", {
                        children: " Loading.."
                    }),
                    children: /*#__PURE__*/ (0, $5aRSq.jsx)($fd878d1a2b2f022b$var$Grocery, {})
                })
            },
            {
                path: "/menu/:resId",
                element: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $2c1fa16701f2ffe3$export$2e2bcd8739ae039), {})
            },
            {
                path: "/cart",
                element: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $6380ab133b56ea42$export$2e2bcd8739ae039), {})
            }
        ],
        errorElement: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $7f01531221b306d8$export$2e2bcd8739ae039), {})
    }
]);
const $fd878d1a2b2f022b$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($21fa618cfc67d6ae$exports))).createRoot(document.getElementById("root"));
$fd878d1a2b2f022b$var$root.render(/*#__PURE__*/ (0, $5aRSq.jsx)((0, $c34e9f2261c19895$export$323e4fc2fa4753fb), {
    router: $fd878d1a2b2f022b$var$appRouter
}));


//# sourceMappingURL=index.e94310b9.js.map
